/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAgentServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediary(model: string | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediaryCode(model: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getAgentIdByUserId(): Observable<string>;
    /**
     * @return Success
     */
    getAgentByUserId(): Observable<Intermediary>;
    /**
     * @return Success
     */
    getAgentNameByUserId(): Observable<string>;
    /**
     * @return Success
     */
    getAgentDetailsByUserId(): Observable<AgentDetailsModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    isWema(model: string | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    getIntermediary(model: string | null | undefined): Observable<Intermediary>;
    /**
     * @param userId (optional)
     * @return Success
     */
    getIntermediaryReferralCodes(userId: string | null | undefined): Observable<NameValueModel[]>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeAgentPayment(transactionRef: string | null | undefined): Observable<PolicyDetails>;
}

@Injectable()
export class AgentServiceServiceProxy implements IAgentServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediary(model: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/IsValidIntermediary?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidIntermediary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidIntermediary(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsValidIntermediary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediaryCode(model: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/IsValidIntermediaryCode?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidIntermediaryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidIntermediaryCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsValidIntermediaryCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentIdByUserId(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetAgentIdByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentIdByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentIdByUserId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentIdByUserId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentByUserId(): Observable<Intermediary> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetAgentByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentByUserId(<any>response_);
                } catch (e) {
                    return <Observable<Intermediary>><any>_observableThrow(e);
                }
            } else
                return <Observable<Intermediary>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentByUserId(response: HttpResponseBase): Observable<Intermediary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Intermediary.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Intermediary>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentNameByUserId(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetAgentNameByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentNameByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentNameByUserId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentNameByUserId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentDetailsByUserId(): Observable<AgentDetailsModel> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetAgentDetailsByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetailsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetailsByUserId(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetailsByUserId(response: HttpResponseBase): Observable<AgentDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailsModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailsModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    isWema(model: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/IsWema?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsWema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsWema(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsWema(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    getIntermediary(model: string | null | undefined): Observable<Intermediary> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetIntermediary?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediary(<any>response_);
                } catch (e) {
                    return <Observable<Intermediary>><any>_observableThrow(e);
                }
            } else
                return <Observable<Intermediary>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediary(response: HttpResponseBase): Observable<Intermediary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Intermediary.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Intermediary>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getIntermediaryReferralCodes(userId: string | null | undefined): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/GetIntermediaryReferralCodes?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediaryReferralCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediaryReferralCodes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediaryReferralCodes(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeAgentPayment(transactionRef: string | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/AgentService/FinalizeAgentPayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeAgentPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeAgentPayment(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeAgentPayment(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }
}

export interface IBancassuranceServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeads(model: CreateGtBankLeadDto[] | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLead(model: CreateGtBankLeadDto | null | undefined): Observable<boolean>;
}

@Injectable()
export class BancassuranceServiceServiceProxy implements IBancassuranceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeads(model: CreateGtBankLeadDto[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BancassuranceService/PostBancassureLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLeads(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLeads(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLead(model: CreateGtBankLeadDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BancassuranceService/PostBancassureLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLead(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IBringBoxServiceServiceProxy {
    /**
     * @param brianBox (optional)
     * @return Success
     */
    postBringBoxRequisitions(brianBox: BrianBoxRequisitionsModel | null | undefined): Observable<string>;
    /**
     * @param brianBox (optional)
     * @return Success
     */
    postBringBeneficiary(brianBox: BrianBoxBeneficiaryModel | null | undefined): Observable<string>;
}

@Injectable()
export class BringBoxServiceServiceProxy implements IBringBoxServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param brianBox (optional)
     * @return Success
     */
    postBringBoxRequisitions(brianBox: BrianBoxRequisitionsModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BringBoxService/PostBringBoxRequisitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brianBox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBringBoxRequisitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBringBoxRequisitions(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostBringBoxRequisitions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param brianBox (optional)
     * @return Success
     */
    postBringBeneficiary(brianBox: BrianBoxBeneficiaryModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BringBoxService/PostBringBeneficiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brianBox);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBringBeneficiary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBringBeneficiary(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostBringBeneficiary(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IBuyProductServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postClaim(model: ClaimsModel | null | undefined): Observable<string>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getMotorTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewMotorTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getMotorTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<MotorTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTravelTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewTravelTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getTravelTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<TravelTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getLifeRenewalTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewLifeRenewalTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getLifeRenewalTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<LifeRenewalTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHomeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHomeTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHomeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HomeTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getOfficeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewOfficeTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getOfficeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<OfficeTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getShopTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewShopTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getShopTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<ShopTransactionResponse>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getPersonalAccidentTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewPersonalAccidentTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getPersonalAccidentTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<PersonalAccidentTransactionResponse>;
    /**
     * @return Success
     */
    getLocationName(locationId: string): Observable<string>;
    /**
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQ(): Observable<boolean>;
    /**
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTQ(): Observable<boolean>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTQByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    setAdminBaseUrl(): Observable<void>;
    /**
     * @return Success
     */
    postDailyAsyncRequest(): Observable<string>;
    /**
     * @return Success
     */
    postRecurringAsyncRequest(): Observable<string>;
    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    verifyVehicleByPolicyNumber(policyNumber: string | null | undefined): Observable<NewVehiclePolicyDetails>;
    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    verifyVehicleByRegistrationNumber(registrationNumber: string | null | undefined): Observable<NewVehiclePolicyDetails>;
    /**
     * @param phone (optional)
     * @param message (optional)
     * @return Success
     */
    sendSms(phone: string | null | undefined, message: string | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    doEbusinesReceiptingForTravel(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getRaveCredentials(): Observable<RaveCredentials>;
    /**
     * @param clientId (optional)
     * @return Success
     */
    getClientApplication(clientId: string | null | undefined): Observable<ClientApplication>;
    /**
     * @param transactionFlwRef (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForRecurring(transactionFlwRef: string | null | undefined, transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param userName (optional)
     * @param password (optional)
     * @return Success
     */
    login(userName: string | null | undefined, password: string | null | undefined): Observable<string>;
    /**
     * @param cQR_REF (optional)
     * @param amount (optional)
     * @param cQR_NARRATIVE (optional)
     * @param cQR_PAYEE (optional)
     * @param policy (optional)
     * @param dataFrom (optional)
     * @param policyType (optional)
     * @return Success
     */
    getPolicyEnquiry(cQR_REF: string | null | undefined, amount: string | null | undefined, actiono: string, cQR_NARRATIVE: string | null | undefined, cQR_PAYEE: string | null | undefined, policy: string | null | undefined, dataFrom: string | null | undefined, policyType: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getBusinessClasses(): Observable<BusinessClass[]>;
    /**
     * @return Success
     */
    getClasses(): Observable<Class[]>;
    /**
     * @return Success
     */
    getProducts(): Observable<GetProductResult[]>;
    /**
     * @param name (optional)
     * @return Success
     */
    getProductByName(name: string | null | undefined): Observable<GetProductResult>;
    /**
     * @param email (optional)
     * @return Success
     */
    getClientByEmail(email: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param phone (optional)
     * @return Success
     */
    getClientByPhone(phone: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param numberPlate (optional)
     * @return Success
     */
    getVehicleDetails(numberPlate: string | null | undefined): Observable<FinalResponseModel>;
    /**
     * @return Success
     */
    getPersonalAccidentRates(): Observable<NameAmountModel[]>;
    /**
     * @return Success
     */
    getTitles(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getClientCategories(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getCountries(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getNonSchengenCountries(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getStatesForCountry(countryId: string): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getAllLgas(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getLgasForState(stateId: string): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getMaritalStatus(): Observable<NameValueModel[]>;
    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number>;
    /**
     * @return Success
     */
    getBodyTypes(): Observable<string[]>;
    /**
     * @return Success
     */
    getManufactureYear(): Observable<string[]>;
    /**
     * @param makeYear (optional)
     * @return Success
     */
    getVehicleMake(makeYear: string | null | undefined): Observable<string[]>;
    /**
     * @param vehicleMake (optional)
     * @param vehicleYear (optional)
     * @return Success
     */
    getVehicleMakeModel(vehicleMake: string | null | undefined, vehicleYear: string | null | undefined): Observable<string[]>;
    /**
     * @return Success
     */
    getColorList(): Observable<string[]>;
    /**
     * @return Success
     */
    getPolicySearchValues(): Observable<NameValueModel[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    clientRequest(model: CheckClientRequest | null | undefined): Observable<GetClientResult>;
    /**
     * @param firstName (optional)
     * @param lastName (optional)
     * @param middleName (optional)
     * @param gender (optional)
     * @param genderId (optional)
     * @param pryEmail (optional)
     * @param secEmail (optional)
     * @param businessOrOccupation (optional)
     * @param categoryWorth (optional)
     * @param employerPhoneNo (optional)
     * @param preferredCommMode (optional)
     * @param domiciledCountry (optional)
     * @param regDate (optional)
     * @param regNumber (optional)
     * @param dlNo (optional)
     * @param dlExpiryDate (optional)
     * @param yearsOfDrvExperience (optional)
     * @param fax (optional)
     * @param image (optional)
     * @param passportNo (optional)
     * @param physicalAddrs (optional)
     * @param pin (optional)
     * @param postalAddrs (optional)
     * @param oldAccntNo (optional)
     * @param proposer (optional)
     * @param signature (optional)
     * @param smsTel (optional)
     * @param altTel (optional)
     * @param town (optional)
     * @param website (optional)
     * @param workPermit (optional)
     * @param zipCode (optional)
     * @param clientCategoryId (optional)
     * @param titleId (optional)
     * @param title (optional)
     * @param userId (optional)
     * @param maritalStatusId (optional)
     * @return Success
     */
    getClientDetails(firstName: string | null | undefined, lastName: string | null | undefined, middleName: string | null | undefined, dateOfBirth: Date, gender: string | null | undefined, genderId: string | null | undefined, pryEmail: string | null | undefined, secEmail: string | null | undefined, businessOrOccupation: string | null | undefined, categoryWorth: string | null | undefined, dateOfEmpl: Date, employerPhoneNo: string | null | undefined, preferredCommMode: string | null | undefined, domiciledCountry: string | null | undefined, regDate: Date | null | undefined, regNumber: string | null | undefined, dlNo: string | null | undefined, dlExpiryDate: Date | null | undefined, yearsOfDrvExperience: number | null | undefined, fax: string | null | undefined, image: string | null | undefined, passportNo: string | null | undefined, physicalAddrs: string | null | undefined, pin: string | null | undefined, postalAddrs: string | null | undefined, oldAccntNo: string | null | undefined, proposer: string | null | undefined, salMinRange: number, salMaxRange: number, signature: string | null | undefined, smsTel: string | null | undefined, altTel: string | null | undefined, town: string | null | undefined, website: string | null | undefined, workPermit: string | null | undefined, zipCode: string | null | undefined, clientCategoryId: string | null | undefined, titleId: string | null | undefined, title: string | null | undefined, userId: number | null | undefined, maritalStatusId: string | null | undefined): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param model (optional)
     * @return Success
     */
    postMotorSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeads(model: CreateGtBankLeadDto[] | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLead(model: CreateGtBankLeadDto | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postShopSchedule(model: ShopScheduleRequest | null | undefined): Observable<ShopScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postHomeSchedule(model: HomeScheduleRequest | null | undefined): Observable<HomeScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postOfficeSchedule(model: OfficeScheduleRequest | null | undefined): Observable<OfficeScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postPersonalAccidentSchedule(model: PersonalAccidentScheduleRequest | null | undefined): Observable<PersonalAccidentScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediary(model: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getAgentIdByUserId(): Observable<string>;
    /**
     * @return Success
     */
    getAgentByUserId(): Observable<Intermediary>;
    /**
     * @return Success
     */
    getAgentNameByUserId(): Observable<string>;
    /**
     * @return Success
     */
    getAgentDetailsByUserId(): Observable<AgentDetailsModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    isWema(model: string | null | undefined): Observable<boolean>;
    /**
     * @param userId (optional)
     * @return Success
     */
    getIntermediaryReferralCodes(userId: string | null | undefined): Observable<NameValueModel[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    postClientProfilling(model: ClientPolicyByEmailModel | null | undefined): Observable<boolean>;
    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendVerificationLinkToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean>;
    /**
     * @param transactionRef (optional)
     * @param paymentChannel (optional)
     * @return Success
     */
    updatePaymentChannel(transactionRef: string | null | undefined, paymentChannel: PaymentChannel | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentChannel(transactionRef: string | null | undefined): Observable<RevalidationModel>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeWemaBankPayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPayment(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    vehicleVerificationByPolicyNumber(policyNumber: string | null | undefined): Observable<VehicleVerificationDetails>;
    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    vehicleVerificationByRegistrationNumber(registrationNumber: string | null | undefined): Observable<VehicleVerificationDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerPayment(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeAgentPayment(transactionRef: string | null | undefined): Observable<PolicyDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerConfirmPay(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionDetailsConfirmPay(transactionRef: string | null | undefined): Observable<LifeRenewalTranDto>;
    /**
     * @param accountNumber (optional)
     * @return Success
     */
    getMerchantsConfirmPay(accountNumber: string | null | undefined): Observable<MerchantDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    emailCertificateUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    postMarineSchedule(model: MarineScheduleDto | null | undefined): Observable<MarineScheduleDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTravelSchedule(model: TravelScheduleRequest | null | undefined): Observable<TravelScheduleRequest>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMarineSchedule(transactionRef: string | null | undefined): Observable<MarineScheduleDto>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMotorSchedule(transactionRef: string | null | undefined): Observable<MotorScheduleDto>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTravelSchedule(transactionRef: string | null | undefined): Observable<TravelScheduleDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    postRiskDetails(model: MotorScheduleDto | null | undefined): Observable<void>;
    /**
     * @param model (optional)
     * @return Success
     */
    sendPaydirectAndQuickTellerReceipt(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param id (optional)
     * @return Success
     */
    policyCancellation(id: string | null | undefined): Observable<string>;
    /**
     * @param id (optional)
     * @return Success
     */
    policyEndorsementFlexsure(id: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    policyEndorsementRetailer(id: number): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromFlexsureToNIID(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromTQToNIID(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromRetailerToNIID(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getClientPolicies(policyNo: string | null | undefined): Observable<ClientPolicies>;
    /**
     * @param clientCmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientCmail: string | null | undefined): Observable<ClientPoliciesByEmail>;
    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientInfoByEmail(clientEmail: string | null | undefined): Observable<ClientPolicyByEmailModel>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getPolicyPayments(policyNo: string | null | undefined): Observable<PolicyPayments>;
    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyEndorsement(model: VehicleEndorsementRequest | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    travelPolicyDetails(model: PolicySearchModel | null | undefined): Observable<TravelPolicyDetails_TravelPolicyDetailsModel>;
    /**
     * @return Success
     */
    getAutoRegMotorDetails(): Observable<boolean>;
    /**
     * @return Success
     */
    getProductSingleSubClassCoverType(id: string): Observable<ProductSubClassCoverTypesModelFinal>;
    /**
     * @return Success
     */
    getProductSubClassCoverTypes(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]>;
    /**
     * @return Success
     */
    getCoverTypePremiumRate(productId: string): Observable<PremiumRateResult[]>;
    /**
     * @return Success
     */
    computeFixedPremium(subclassSectCovtypeId: string): Observable<number>;
    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: PremiumModel | null | undefined): Observable<number>;
    /**
     * @param model (optional)
     * @return Success
     */
    computeTravelPremium(model: TravelPremiumModel | null | undefined): Observable<TravelRateResult>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceipt(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getReceipt(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getMotorCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getHomeCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getOfficeCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getShopCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getPersonalAccidentCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param dateOfBirth (optional)
     * @param amount (optional)
     * @return Success
     */
    getAnnuityRate(dateOfBirth: string | null | undefined, amount: string | null | undefined, isMale: boolean): Observable<AnnuityResponseModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLifePolicyRenewalDetails(model: LifePolicyRenewalRequest | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran>;
    /**
     * @return Success
     */
    pushAllLifeTransactionsFromFlexsureToTQ(): Observable<boolean>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    pushSingleLifeTransactionsFromFlexsureToTQ(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForLifeRenewal(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    revalidateConfirmPayForLifeRenewal(transactionRef: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    rePushAllConfirmPayForLifeRenewal(): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPaymentForLifeRenewal(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @return Success
     */
    pushFailedLifeRenewalToTQ(): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postWhistleBlower(model: WhistleBlowerModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeadToCrm(model: CreateGtBankLeadDto | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLeadRequestToCrm(model: LeadRequestModel | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postIncident(model: IncidentModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postQuote(model: QuoteModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postChangeRequest(model: ChangeRequestModel | null | undefined): Observable<string>;
}

@Injectable()
export class BuyProductServiceProxy implements IBuyProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postClaim(model: ClaimsModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostClaim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClaim(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostClaim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getMotorTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewMotorTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMotorTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewMotorTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewMotorTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorTransactionsWithRange(response: HttpResponseBase): Observable<ViewMotorTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewMotorTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewMotorTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getMotorTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<MotorTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMotorTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<MotorTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorTransactionDetails(response: HttpResponseBase): Observable<MotorTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTravelTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewTravelTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTravelTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewTravelTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewTravelTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelTransactionsWithRange(response: HttpResponseBase): Observable<ViewTravelTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewTravelTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewTravelTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getTravelTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<TravelTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTravelTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<TravelTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelTransactionDetails(response: HttpResponseBase): Observable<TravelTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getLifeRenewalTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewLifeRenewalTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLifeRenewalTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewLifeRenewalTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewLifeRenewalTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalTransactionsWithRange(response: HttpResponseBase): Observable<ViewLifeRenewalTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewLifeRenewalTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewLifeRenewalTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getLifeRenewalTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<LifeRenewalTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLifeRenewalTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalTransactionDetails(response: HttpResponseBase): Observable<LifeRenewalTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHomeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHomeTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetHomeTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewHomeTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewHomeTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeTransactionsWithRange(response: HttpResponseBase): Observable<ViewHomeTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewHomeTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewHomeTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHomeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HomeTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetHomeTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<HomeTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeTransactionDetails(response: HttpResponseBase): Observable<HomeTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getOfficeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewOfficeTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetOfficeTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewOfficeTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewOfficeTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeTransactionsWithRange(response: HttpResponseBase): Observable<ViewOfficeTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewOfficeTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewOfficeTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getOfficeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<OfficeTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetOfficeTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<OfficeTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeTransactionDetails(response: HttpResponseBase): Observable<OfficeTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getShopTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewShopTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetShopTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewShopTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewShopTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopTransactionsWithRange(response: HttpResponseBase): Observable<ViewShopTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewShopTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewShopTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getShopTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<ShopTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetShopTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<ShopTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopTransactionDetails(response: HttpResponseBase): Observable<ShopTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopTransactionResponse>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getPersonalAccidentTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewPersonalAccidentTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPersonalAccidentTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewPersonalAccidentTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewPersonalAccidentTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentTransactionsWithRange(response: HttpResponseBase): Observable<ViewPersonalAccidentTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewPersonalAccidentTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewPersonalAccidentTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getPersonalAccidentTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<PersonalAccidentTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPersonalAccidentTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentTransactionDetails(response: HttpResponseBase): Observable<PersonalAccidentTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentTransactionResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getLocationName(locationId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLocationName?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQ(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushTravelTransactionFromFlexsureToTQ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushTravelTransactionFromFlexsureToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushTravelTransactionFromFlexsureToTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushTravelTransactionFromFlexsureToTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTQ(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushMotorTransactionFromFlexsureToTQ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorTransactionFromFlexsureToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorTransactionFromFlexsureToTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorTransactionFromFlexsureToTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushTravelTransactionFromFlexsureToTQByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushTravelTransactionFromFlexsureToTQByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushTravelTransactionFromFlexsureToTQByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushTravelTransactionFromFlexsureToTQByPolicyNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTQByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushMotorTransactionFromFlexsureToTQByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorTransactionFromFlexsureToTQByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorTransactionFromFlexsureToTQByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorTransactionFromFlexsureToTQByPolicyNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    setAdminBaseUrl(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/SetAdminBaseUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAdminBaseUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAdminBaseUrl(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAdminBaseUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    postDailyAsyncRequest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostDailyAsyncRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDailyAsyncRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDailyAsyncRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostDailyAsyncRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    postRecurringAsyncRequest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostRecurringAsyncRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRecurringAsyncRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRecurringAsyncRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostRecurringAsyncRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAdminBasePath";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminBasePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminBasePath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminBasePath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    verifyVehicleByPolicyNumber(policyNumber: string | null | undefined): Observable<NewVehiclePolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VerifyVehicleByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyVehicleByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyVehicleByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyVehicleByPolicyNumber(response: HttpResponseBase): Observable<NewVehiclePolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NewVehiclePolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewVehiclePolicyDetails>(<any>null);
    }

    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    verifyVehicleByRegistrationNumber(registrationNumber: string | null | undefined): Observable<NewVehiclePolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VerifyVehicleByRegistrationNumber?";
        if (registrationNumber !== undefined && registrationNumber !== null)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyVehicleByRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyVehicleByRegistrationNumber(<any>response_);
                } catch (e) {
                    return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyVehicleByRegistrationNumber(response: HttpResponseBase): Observable<NewVehiclePolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NewVehiclePolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewVehiclePolicyDetails>(<any>null);
    }

    /**
     * @param phone (optional)
     * @param message (optional)
     * @return Success
     */
    sendSms(phone: string | null | undefined, message: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/SendSmsAsync?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    doEbusinesReceiptingForTravel(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/DoEbusinesReceiptingForTravel?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoEbusinesReceiptingForTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoEbusinesReceiptingForTravel(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDoEbusinesReceiptingForTravel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getRaveCredentials(): Observable<RaveCredentials> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetRaveCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaveCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaveCredentials(<any>response_);
                } catch (e) {
                    return <Observable<RaveCredentials>><any>_observableThrow(e);
                }
            } else
                return <Observable<RaveCredentials>><any>_observableThrow(response_);
        }));
    }

    protected processGetRaveCredentials(response: HttpResponseBase): Observable<RaveCredentials> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaveCredentials.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaveCredentials>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @return Success
     */
    getClientApplication(clientId: string | null | undefined): Observable<ClientApplication> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientApplication?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientApplication(<any>response_);
                } catch (e) {
                    return <Observable<ClientApplication>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientApplication>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientApplication(response: HttpResponseBase): Observable<ClientApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientApplication.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientApplication>(<any>null);
    }

    /**
     * @param transactionFlwRef (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForRecurring(transactionFlwRef: string | null | undefined, transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeFlutterwavePaymentForRecurring?";
        if (transactionFlwRef !== undefined && transactionFlwRef !== null)
            url_ += "transactionFlwRef=" + encodeURIComponent("" + transactionFlwRef) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePaymentForRecurring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePaymentForRecurring(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePaymentForRecurring(response: HttpResponseBase): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param userName (optional)
     * @param password (optional)
     * @return Success
     */
    login(userName: string | null | undefined, password: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/Login?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param cQR_REF (optional)
     * @param amount (optional)
     * @param cQR_NARRATIVE (optional)
     * @param cQR_PAYEE (optional)
     * @param policy (optional)
     * @param dataFrom (optional)
     * @param policyType (optional)
     * @return Success
     */
    getPolicyEnquiry(cQR_REF: string | null | undefined, amount: string | null | undefined, actiono: string, cQR_NARRATIVE: string | null | undefined, cQR_PAYEE: string | null | undefined, policy: string | null | undefined, dataFrom: string | null | undefined, policyType: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPolicyEnquiry?";
        if (cQR_REF !== undefined && cQR_REF !== null)
            url_ += "CQR_REF=" + encodeURIComponent("" + cQR_REF) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (actiono === undefined || actiono === null)
            throw new Error("The parameter 'actiono' must be defined and cannot be null.");
        else
            url_ += "Actiono=" + encodeURIComponent("" + actiono) + "&";
        if (cQR_NARRATIVE !== undefined && cQR_NARRATIVE !== null)
            url_ += "CQR_NARRATIVE=" + encodeURIComponent("" + cQR_NARRATIVE) + "&";
        if (cQR_PAYEE !== undefined && cQR_PAYEE !== null)
            url_ += "CQR_PAYEE=" + encodeURIComponent("" + cQR_PAYEE) + "&";
        if (policy !== undefined && policy !== null)
            url_ += "Policy=" + encodeURIComponent("" + policy) + "&";
        if (dataFrom !== undefined && dataFrom !== null)
            url_ += "DataFrom=" + encodeURIComponent("" + dataFrom) + "&";
        if (policyType !== undefined && policyType !== null)
            url_ += "PolicyType=" + encodeURIComponent("" + policyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyEnquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyEnquiry(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicyEnquiry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getBusinessClasses(): Observable<BusinessClass[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetBusinessClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessClasses(<any>response_);
                } catch (e) {
                    return <Observable<BusinessClass[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessClass[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBusinessClasses(response: HttpResponseBase): Observable<BusinessClass[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessClass.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessClass[]>(<any>null);
    }

    /**
     * @return Success
     */
    getClasses(): Observable<Class[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClasses(<any>response_);
                } catch (e) {
                    return <Observable<Class[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Class[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClasses(response: HttpResponseBase): Observable<Class[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Class.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Class[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProducts(): Observable<GetProductResult[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(<any>response_);
                } catch (e) {
                    return <Observable<GetProductResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<GetProductResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProductResult.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductResult[]>(<any>null);
    }

    /**
     * @param name (optional)
     * @return Success
     */
    getProductByName(name: string | null | undefined): Observable<GetProductResult> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetProductByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByName(<any>response_);
                } catch (e) {
                    return <Observable<GetProductResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductByName(response: HttpResponseBase): Observable<GetProductResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProductResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductResult>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getClientByEmail(email: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByEmail(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByEmail(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param phone (optional)
     * @return Success
     */
    getClientByPhone(phone: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientByPhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByPhone(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByPhone(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param numberPlate (optional)
     * @return Success
     */
    getVehicleDetails(numberPlate: string | null | undefined): Observable<FinalResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetVehicleDetails?";
        if (numberPlate !== undefined && numberPlate !== null)
            url_ += "numberPlate=" + encodeURIComponent("" + numberPlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleDetails(<any>response_);
                } catch (e) {
                    return <Observable<FinalResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinalResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleDetails(response: HttpResponseBase): Observable<FinalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FinalResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinalResponseModel>(<any>null);
    }

    /**
     * @return Success
     */
    getPersonalAccidentRates(): Observable<NameAmountModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPersonalAccidentRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentRates(<any>response_);
                } catch (e) {
                    return <Observable<NameAmountModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameAmountModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentRates(response: HttpResponseBase): Observable<NameAmountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameAmountModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameAmountModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTitles(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitles(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTitles(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getClientCategories(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCategories(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientCategories(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenders(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenders(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCountries(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNonSchengenCountries(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetNonSchengenCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonSchengenCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonSchengenCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNonSchengenCountries(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStatesForCountry(countryId: string): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetStatesForCountry?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesForCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesForCountry(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatesForCountry(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLgas(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAllLgas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLgas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLgas(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLgas(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLgasForState(stateId: string): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLgasForState?";
        if (stateId === undefined || stateId === null)
            throw new Error("The parameter 'stateId' must be defined and cannot be null.");
        else
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLgasForState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLgasForState(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLgasForState(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMaritalStatus(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMaritalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaritalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaritalStatus(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMaritalStatus(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/ComputeThirdPartyMotorPremium?";
        if (bodyType !== undefined && bodyType !== null)
            url_ += "bodyType=" + encodeURIComponent("" + bodyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeThirdPartyMotorPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeThirdPartyMotorPremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeThirdPartyMotorPremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getBodyTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetBodyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBodyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBodyTypes(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBodyTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getManufactureYear(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetManufactureYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManufactureYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManufactureYear(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetManufactureYear(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param makeYear (optional)
     * @return Success
     */
    getVehicleMake(makeYear: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetVehicleMake?";
        if (makeYear !== undefined && makeYear !== null)
            url_ += "makeYear=" + encodeURIComponent("" + makeYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleMake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleMake(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleMake(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param vehicleMake (optional)
     * @param vehicleYear (optional)
     * @return Success
     */
    getVehicleMakeModel(vehicleMake: string | null | undefined, vehicleYear: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetVehicleMakeModel?";
        if (vehicleMake !== undefined && vehicleMake !== null)
            url_ += "VehicleMake=" + encodeURIComponent("" + vehicleMake) + "&";
        if (vehicleYear !== undefined && vehicleYear !== null)
            url_ += "VehicleYear=" + encodeURIComponent("" + vehicleYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleMakeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleMakeModel(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleMakeModel(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getColorList(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetColorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorList(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetColorList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPolicySearchValues(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPolicySearchValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicySearchValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicySearchValues(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicySearchValues(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    clientRequest(model: CheckClientRequest | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/ClientRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientRequest(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processClientRequest(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param firstName (optional)
     * @param lastName (optional)
     * @param middleName (optional)
     * @param gender (optional)
     * @param genderId (optional)
     * @param pryEmail (optional)
     * @param secEmail (optional)
     * @param businessOrOccupation (optional)
     * @param categoryWorth (optional)
     * @param employerPhoneNo (optional)
     * @param preferredCommMode (optional)
     * @param domiciledCountry (optional)
     * @param regDate (optional)
     * @param regNumber (optional)
     * @param dlNo (optional)
     * @param dlExpiryDate (optional)
     * @param yearsOfDrvExperience (optional)
     * @param fax (optional)
     * @param image (optional)
     * @param passportNo (optional)
     * @param physicalAddrs (optional)
     * @param pin (optional)
     * @param postalAddrs (optional)
     * @param oldAccntNo (optional)
     * @param proposer (optional)
     * @param signature (optional)
     * @param smsTel (optional)
     * @param altTel (optional)
     * @param town (optional)
     * @param website (optional)
     * @param workPermit (optional)
     * @param zipCode (optional)
     * @param clientCategoryId (optional)
     * @param titleId (optional)
     * @param title (optional)
     * @param userId (optional)
     * @param maritalStatusId (optional)
     * @return Success
     */
    getClientDetails(firstName: string | null | undefined, lastName: string | null | undefined, middleName: string | null | undefined, dateOfBirth: Date, gender: string | null | undefined, genderId: string | null | undefined, pryEmail: string | null | undefined, secEmail: string | null | undefined, businessOrOccupation: string | null | undefined, categoryWorth: string | null | undefined, dateOfEmpl: Date, employerPhoneNo: string | null | undefined, preferredCommMode: string | null | undefined, domiciledCountry: string | null | undefined, regDate: Date | null | undefined, regNumber: string | null | undefined, dlNo: string | null | undefined, dlExpiryDate: Date | null | undefined, yearsOfDrvExperience: number | null | undefined, fax: string | null | undefined, image: string | null | undefined, passportNo: string | null | undefined, physicalAddrs: string | null | undefined, pin: string | null | undefined, postalAddrs: string | null | undefined, oldAccntNo: string | null | undefined, proposer: string | null | undefined, salMinRange: number, salMaxRange: number, signature: string | null | undefined, smsTel: string | null | undefined, altTel: string | null | undefined, town: string | null | undefined, website: string | null | undefined, workPermit: string | null | undefined, zipCode: string | null | undefined, clientCategoryId: string | null | undefined, titleId: string | null | undefined, title: string | null | undefined, userId: number | null | undefined, maritalStatusId: string | null | undefined): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientDetails?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (dateOfBirth === undefined || dateOfBirth === null)
            throw new Error("The parameter 'dateOfBirth' must be defined and cannot be null.");
        else
            url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (genderId !== undefined && genderId !== null)
            url_ += "GenderId=" + encodeURIComponent("" + genderId) + "&";
        if (pryEmail !== undefined && pryEmail !== null)
            url_ += "PryEmail=" + encodeURIComponent("" + pryEmail) + "&";
        if (secEmail !== undefined && secEmail !== null)
            url_ += "SecEmail=" + encodeURIComponent("" + secEmail) + "&";
        if (businessOrOccupation !== undefined && businessOrOccupation !== null)
            url_ += "BusinessOrOccupation=" + encodeURIComponent("" + businessOrOccupation) + "&";
        if (categoryWorth !== undefined && categoryWorth !== null)
            url_ += "CategoryWorth=" + encodeURIComponent("" + categoryWorth) + "&";
        if (dateOfEmpl === undefined || dateOfEmpl === null)
            throw new Error("The parameter 'dateOfEmpl' must be defined and cannot be null.");
        else
            url_ += "DateOfEmpl=" + encodeURIComponent(dateOfEmpl ? "" + dateOfEmpl.toJSON() : "") + "&";
        if (employerPhoneNo !== undefined && employerPhoneNo !== null)
            url_ += "EmployerPhoneNo=" + encodeURIComponent("" + employerPhoneNo) + "&";
        if (preferredCommMode !== undefined && preferredCommMode !== null)
            url_ += "PreferredCommMode=" + encodeURIComponent("" + preferredCommMode) + "&";
        if (domiciledCountry !== undefined && domiciledCountry !== null)
            url_ += "DomiciledCountry=" + encodeURIComponent("" + domiciledCountry) + "&";
        if (regDate !== undefined && regDate !== null)
            url_ += "RegDate=" + encodeURIComponent(regDate ? "" + regDate.toJSON() : "") + "&";
        if (regNumber !== undefined && regNumber !== null)
            url_ += "RegNumber=" + encodeURIComponent("" + regNumber) + "&";
        if (dlNo !== undefined && dlNo !== null)
            url_ += "DlNo=" + encodeURIComponent("" + dlNo) + "&";
        if (dlExpiryDate !== undefined && dlExpiryDate !== null)
            url_ += "DlExpiryDate=" + encodeURIComponent(dlExpiryDate ? "" + dlExpiryDate.toJSON() : "") + "&";
        if (yearsOfDrvExperience !== undefined && yearsOfDrvExperience !== null)
            url_ += "YearsOfDrvExperience=" + encodeURIComponent("" + yearsOfDrvExperience) + "&";
        if (fax !== undefined && fax !== null)
            url_ += "Fax=" + encodeURIComponent("" + fax) + "&";
        if (image !== undefined && image !== null)
            url_ += "Image=" + encodeURIComponent("" + image) + "&";
        if (passportNo !== undefined && passportNo !== null)
            url_ += "PassportNo=" + encodeURIComponent("" + passportNo) + "&";
        if (physicalAddrs !== undefined && physicalAddrs !== null)
            url_ += "PhysicalAddrs=" + encodeURIComponent("" + physicalAddrs) + "&";
        if (pin !== undefined && pin !== null)
            url_ += "Pin=" + encodeURIComponent("" + pin) + "&";
        if (postalAddrs !== undefined && postalAddrs !== null)
            url_ += "PostalAddrs=" + encodeURIComponent("" + postalAddrs) + "&";
        if (oldAccntNo !== undefined && oldAccntNo !== null)
            url_ += "OldAccntNo=" + encodeURIComponent("" + oldAccntNo) + "&";
        if (proposer !== undefined && proposer !== null)
            url_ += "Proposer=" + encodeURIComponent("" + proposer) + "&";
        if (salMinRange === undefined || salMinRange === null)
            throw new Error("The parameter 'salMinRange' must be defined and cannot be null.");
        else
            url_ += "SalMinRange=" + encodeURIComponent("" + salMinRange) + "&";
        if (salMaxRange === undefined || salMaxRange === null)
            throw new Error("The parameter 'salMaxRange' must be defined and cannot be null.");
        else
            url_ += "SalMaxRange=" + encodeURIComponent("" + salMaxRange) + "&";
        if (signature !== undefined && signature !== null)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&";
        if (smsTel !== undefined && smsTel !== null)
            url_ += "SmsTel=" + encodeURIComponent("" + smsTel) + "&";
        if (altTel !== undefined && altTel !== null)
            url_ += "AltTel=" + encodeURIComponent("" + altTel) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (website !== undefined && website !== null)
            url_ += "Website=" + encodeURIComponent("" + website) + "&";
        if (workPermit !== undefined && workPermit !== null)
            url_ += "WorkPermit=" + encodeURIComponent("" + workPermit) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (clientCategoryId !== undefined && clientCategoryId !== null)
            url_ += "ClientCategoryId=" + encodeURIComponent("" + clientCategoryId) + "&";
        if (titleId !== undefined && titleId !== null)
            url_ += "TitleId=" + encodeURIComponent("" + titleId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (maritalStatusId !== undefined && maritalStatusId !== null)
            url_ += "MaritalStatusId=" + encodeURIComponent("" + maritalStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientDetails(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientDetails(response: HttpResponseBase): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postMotorSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostMotorSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMotorSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMotorSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostMotorSchedule(response: HttpResponseBase): Observable<MotorScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeads(model: CreateGtBankLeadDto[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostBancassureLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLeads(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLeads(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLead(model: CreateGtBankLeadDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostBancassureLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLead(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postShopSchedule(model: ShopScheduleRequest | null | undefined): Observable<ShopScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostShopSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostShopSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostShopSchedule(<any>response_);
                } catch (e) {
                    return <Observable<ShopScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostShopSchedule(response: HttpResponseBase): Observable<ShopScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postHomeSchedule(model: HomeScheduleRequest | null | undefined): Observable<HomeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostHomeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostHomeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostHomeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<HomeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostHomeSchedule(response: HttpResponseBase): Observable<HomeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postOfficeSchedule(model: OfficeScheduleRequest | null | undefined): Observable<OfficeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostOfficeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOfficeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOfficeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<OfficeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostOfficeSchedule(response: HttpResponseBase): Observable<OfficeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postPersonalAccidentSchedule(model: PersonalAccidentScheduleRequest | null | undefined): Observable<PersonalAccidentScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostPersonalAccidentSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPersonalAccidentSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPersonalAccidentSchedule(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostPersonalAccidentSchedule(response: HttpResponseBase): Observable<PersonalAccidentScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    isValidIntermediary(model: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/IsValidIntermediary?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidIntermediary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidIntermediary(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsValidIntermediary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentIdByUserId(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAgentIdByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentIdByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentIdByUserId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentIdByUserId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentByUserId(): Observable<Intermediary> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAgentByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentByUserId(<any>response_);
                } catch (e) {
                    return <Observable<Intermediary>><any>_observableThrow(e);
                }
            } else
                return <Observable<Intermediary>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentByUserId(response: HttpResponseBase): Observable<Intermediary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Intermediary.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Intermediary>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentNameByUserId(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAgentNameByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentNameByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentNameByUserId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentNameByUserId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAgentDetailsByUserId(): Observable<AgentDetailsModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAgentDetailsByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetailsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetailsByUserId(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetailsByUserId(response: HttpResponseBase): Observable<AgentDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailsModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailsModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    isWema(model: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/IsWema?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsWema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsWema(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsWema(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getIntermediaryReferralCodes(userId: string | null | undefined): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetIntermediaryReferralCodes?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediaryReferralCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediaryReferralCodes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediaryReferralCodes(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postClientProfilling(model: ClientPolicyByEmailModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostClientProfilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostClientProfilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClientProfilling(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostClientProfilling(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendVerificationLinkToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/SendVerificationLinkToClient?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationLinkToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationLinkToClient(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationLinkToClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @param paymentChannel (optional)
     * @return Success
     */
    updatePaymentChannel(transactionRef: string | null | undefined, paymentChannel: PaymentChannel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/UpdatePaymentChannel?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentChannel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentChannel(transactionRef: string | null | undefined): Observable<RevalidationModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPaymentChannel?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentChannel(<any>response_);
                } catch (e) {
                    return <Observable<RevalidationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevalidationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentChannel(response: HttpResponseBase): Observable<RevalidationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RevalidationModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevalidationModel>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeFlutterwavePayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePayment(response: HttpResponseBase): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeWemaBankPayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeWemaBankPayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeWemaBankPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeWemaBankPayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeWemaBankPayment(response: HttpResponseBase): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPayment(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeInterswitchPayment?";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeInterswitchPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeInterswitchPayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeInterswitchPayment(response: HttpResponseBase): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    vehicleVerificationByPolicyNumber(policyNumber: string | null | undefined): Observable<VehicleVerificationDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VehicleVerificationByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehicleVerificationByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehicleVerificationByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<VehicleVerificationDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleVerificationDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVehicleVerificationByPolicyNumber(response: HttpResponseBase): Observable<VehicleVerificationDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = VehicleVerificationDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleVerificationDetails>(<any>null);
    }

    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    vehicleVerificationByRegistrationNumber(registrationNumber: string | null | undefined): Observable<VehicleVerificationDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VehicleVerificationByRegistrationNumber?";
        if (registrationNumber !== undefined && registrationNumber !== null)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehicleVerificationByRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehicleVerificationByRegistrationNumber(<any>response_);
                } catch (e) {
                    return <Observable<VehicleVerificationDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleVerificationDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVehicleVerificationByRegistrationNumber(response: HttpResponseBase): Observable<VehicleVerificationDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = VehicleVerificationDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleVerificationDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerPayment(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizePartnerPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerPayment(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerPayment(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeAgentPayment(transactionRef: string | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeAgentPayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeAgentPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeAgentPayment(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeAgentPayment(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizePartnerUssd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerUssd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerUssd(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerUssd(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerConfirmPay(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizePartnerConfirmPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerConfirmPay(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionDetailsConfirmPay(transactionRef: string | null | undefined): Observable<LifeRenewalTranDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTransactionDetailsConfirmPay?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailsConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailsConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTranDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTranDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailsConfirmPay(response: HttpResponseBase): Observable<LifeRenewalTranDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTranDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTranDto>(<any>null);
    }

    /**
     * @param accountNumber (optional)
     * @return Success
     */
    getMerchantsConfirmPay(accountNumber: string | null | undefined): Observable<MerchantDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMerchantsConfirmPay?";
        if (accountNumber !== undefined && accountNumber !== null)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMerchantsConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMerchantsConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<MerchantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMerchantsConfirmPay(response: HttpResponseBase): Observable<MerchantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MerchantDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchantDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    emailCertificateUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/EmailCertificateUssd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailCertificateUssd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailCertificateUssd(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processEmailCertificateUssd(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postMarineSchedule(model: MarineScheduleDto | null | undefined): Observable<MarineScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostMarineSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMarineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMarineSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MarineScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarineScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processPostMarineSchedule(response: HttpResponseBase): Observable<MarineScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MarineScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarineScheduleDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postTravelSchedule(model: TravelScheduleRequest | null | undefined): Observable<TravelScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostTravelSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTravelSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTravelSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostTravelSchedule(response: HttpResponseBase): Observable<TravelScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleRequest>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMarineSchedule(transactionRef: string | null | undefined): Observable<MarineScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMarineSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarineSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MarineScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarineScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMarineSchedule(response: HttpResponseBase): Observable<MarineScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MarineScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarineScheduleDto>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMotorSchedule(transactionRef: string | null | undefined): Observable<MotorScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMotorSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorSchedule(response: HttpResponseBase): Observable<MotorScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleDto>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTravelSchedule(transactionRef: string | null | undefined): Observable<TravelScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTravelSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelSchedule(response: HttpResponseBase): Observable<TravelScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postRiskDetails(model: MotorScheduleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostRiskDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRiskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRiskDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPostRiskDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    sendPaydirectAndQuickTellerReceipt(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/SendPaydirectAndQuickTellerReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaydirectAndQuickTellerReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaydirectAndQuickTellerReceipt(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendPaydirectAndQuickTellerReceipt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    policyCancellation(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PolicyCancellation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyCancellation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyCancellation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    policyEndorsementFlexsure(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PolicyEndorsementFlexsure?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyEndorsementFlexsure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyEndorsementFlexsure(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyEndorsementFlexsure(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    policyEndorsementRetailer(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PolicyEndorsementRetailer?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyEndorsementRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyEndorsementRetailer(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyEndorsementRetailer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromFlexsureToNIID(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushMotorPoliciesFromFlexsureToNIID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromFlexsureToNIID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromFlexsureToNIID(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromFlexsureToNIID(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromTQToNIID(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushMotorPoliciesFromTQToNIID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromTQToNIID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromTQToNIID(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromTQToNIID(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromRetailerToNIID(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushMotorPoliciesFromRetailerToNIID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromRetailerToNIID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromRetailerToNIID(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromRetailerToNIID(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getClientPolicies(policyNo: string | null | undefined): Observable<ClientPolicies> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientPolicies?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPolicies(<any>response_);
                } catch (e) {
                    return <Observable<ClientPolicies>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPolicies>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPolicies(response: HttpResponseBase): Observable<ClientPolicies> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPolicies.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPolicies>(<any>null);
    }

    /**
     * @param clientCmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientCmail: string | null | undefined): Observable<ClientPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientPoliciesByEmail?";
        if (clientCmail !== undefined && clientCmail !== null)
            url_ += "clientCmail=" + encodeURIComponent("" + clientCmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPoliciesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPoliciesByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPoliciesByEmail(response: HttpResponseBase): Observable<ClientPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPoliciesByEmail>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientInfoByEmail(clientEmail: string | null | undefined): Observable<ClientPolicyByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetClientInfoByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientInfoByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientInfoByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPolicyByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPolicyByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientInfoByEmail(response: HttpResponseBase): Observable<ClientPolicyByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPolicyByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPolicyByEmailModel>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getPolicyPayments(policyNo: string | null | undefined): Observable<PolicyPayments> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPolicyPayments?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyPayments(<any>response_);
                } catch (e) {
                    return <Observable<PolicyPayments>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyPayments>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicyPayments(response: HttpResponseBase): Observable<PolicyPayments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyPayments.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyPayments>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VehiclePolicyCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclePolicyCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclePolicyCancellation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclePolicyCancellation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyEndorsement(model: VehicleEndorsementRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/VehiclePolicyEndorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclePolicyEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclePolicyEndorsement(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclePolicyEndorsement(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    travelPolicyDetails(model: PolicySearchModel | null | undefined): Observable<TravelPolicyDetails_TravelPolicyDetailsModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/TravelPolicyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTravelPolicyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTravelPolicyDetails(<any>response_);
                } catch (e) {
                    return <Observable<TravelPolicyDetails_TravelPolicyDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelPolicyDetails_TravelPolicyDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processTravelPolicyDetails(response: HttpResponseBase): Observable<TravelPolicyDetails_TravelPolicyDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelPolicyDetails_TravelPolicyDetailsModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelPolicyDetails_TravelPolicyDetailsModel>(<any>null);
    }

    /**
     * @return Success
     */
    getAutoRegMotorDetails(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAutoRegMotorDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoRegMotorDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoRegMotorDetails(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoRegMotorDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSingleSubClassCoverType(id: string): Observable<ProductSubClassCoverTypesModelFinal> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetProductSingleSubClassCoverType?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSingleSubClassCoverType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSingleSubClassCoverType(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSingleSubClassCoverType(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductSubClassCoverTypesModelFinal.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSubClassCoverTypes(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetProductSubClassCoverTypes?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSubClassCoverTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSubClassCoverTypes(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSubClassCoverTypes(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductSubClassCoverTypesModelFinal.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCoverTypePremiumRate(productId: string): Observable<PremiumRateResult[]> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetCoverTypePremiumRate?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverTypePremiumRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverTypePremiumRate(<any>response_);
                } catch (e) {
                    return <Observable<PremiumRateResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PremiumRateResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverTypePremiumRate(response: HttpResponseBase): Observable<PremiumRateResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PremiumRateResult.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PremiumRateResult[]>(<any>null);
    }

    /**
     * @return Success
     */
    computeFixedPremium(subclassSectCovtypeId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/ComputeFixedPremium?";
        if (subclassSectCovtypeId === undefined || subclassSectCovtypeId === null)
            throw new Error("The parameter 'subclassSectCovtypeId' must be defined and cannot be null.");
        else
            url_ += "subclassSectCovtypeId=" + encodeURIComponent("" + subclassSectCovtypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeFixedPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeFixedPremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeFixedPremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: PremiumModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/ComputePremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputePremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputePremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputePremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    computeTravelPremium(model: TravelPremiumModel | null | undefined): Observable<TravelRateResult> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/ComputeTravelPremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeTravelPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeTravelPremium(<any>response_);
                } catch (e) {
                    return <Observable<TravelRateResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelRateResult>><any>_observableThrow(response_);
        }));
    }

    protected processComputeTravelPremium(response: HttpResponseBase): Observable<TravelRateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelRateResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelRateResult>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceipt(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLifeRenewalReceipt?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getReceipt(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetReceipt?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getMotorCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetMotorCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetTravelCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getHomeCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetHomeCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getOfficeCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetOfficeCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getShopCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetShopCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getPersonalAccidentCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetPersonalAccidentCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetLifePolicyRenewalDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifePolicyRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifePolicyRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifePolicyRenewalDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param dateOfBirth (optional)
     * @param amount (optional)
     * @return Success
     */
    getAnnuityRate(dateOfBirth: string | null | undefined, amount: string | null | undefined, isMale: boolean): Observable<AnnuityResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/GetAnnuityRate?";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent("" + dateOfBirth) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (isMale === undefined || isMale === null)
            throw new Error("The parameter 'isMale' must be defined and cannot be null.");
        else
            url_ += "isMale=" + encodeURIComponent("" + isMale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityRate(<any>response_);
                } catch (e) {
                    return <Observable<AnnuityResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnuityResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityRate(response: HttpResponseBase): Observable<AnnuityResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AnnuityResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnuityResponseModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLifePolicyRenewalDetails(model: LifePolicyRenewalRequest | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostLifePolicyRenewalDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLifePolicyRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLifePolicyRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processPostLifePolicyRenewalDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostLifeRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLifeRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLifeRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTran>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTran>><any>_observableThrow(response_);
        }));
    }

    protected processPostLifeRenewalSchedule(response: HttpResponseBase): Observable<LifeRenewalTran> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTran.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTran>(<any>null);
    }

    /**
     * @return Success
     */
    pushAllLifeTransactionsFromFlexsureToTQ(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushAllLifeTransactionsFromFlexsureToTQ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushAllLifeTransactionsFromFlexsureToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushAllLifeTransactionsFromFlexsureToTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushAllLifeTransactionsFromFlexsureToTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    pushSingleLifeTransactionsFromFlexsureToTQ(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushSingleLifeTransactionsFromFlexsureToTQ?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushSingleLifeTransactionsFromFlexsureToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushSingleLifeTransactionsFromFlexsureToTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushSingleLifeTransactionsFromFlexsureToTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForLifeRenewal(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeFlutterwavePaymentForLifeRenewal?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePaymentForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePaymentForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePaymentForLifeRenewal(response: HttpResponseBase): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    revalidateConfirmPayForLifeRenewal(transactionRef: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/RevalidateConfirmPayForLifeRenewal?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevalidateConfirmPayForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevalidateConfirmPayForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRevalidateConfirmPayForLifeRenewal(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    rePushAllConfirmPayForLifeRenewal(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/RePushAllConfirmPayForLifeRenewal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRePushAllConfirmPayForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRePushAllConfirmPayForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRePushAllConfirmPayForLifeRenewal(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPaymentForLifeRenewal(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/FinalizeInterswitchPaymentForLifeRenewal?";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeInterswitchPaymentForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeInterswitchPaymentForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeInterswitchPaymentForLifeRenewal(response: HttpResponseBase): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    pushFailedLifeRenewalToTQ(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PushFailedLifeRenewalToTQ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushFailedLifeRenewalToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushFailedLifeRenewalToTQ(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushFailedLifeRenewalToTQ(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postWhistleBlower(model: WhistleBlowerModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostWhistleBlower";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostWhistleBlower(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostWhistleBlower(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostWhistleBlower(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeadToCrm(model: CreateGtBankLeadDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostBancassureLeadToCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLeadToCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLeadToCrm(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLeadToCrm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLeadRequestToCrm(model: LeadRequestModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostLeadRequestToCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLeadRequestToCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLeadRequestToCrm(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostLeadRequestToCrm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postIncident(model: IncidentModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostIncident(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostIncident(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postQuote(model: QuoteModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostQuote(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostQuote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postChangeRequest(model: ChangeRequestModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuyProduct/PostChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostChangeRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IClientServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postClientProfilling(model: ClientPolicyByEmailModel | null | undefined): Observable<boolean>;
    /**
     * @param email (optional)
     * @return Success
     */
    getClientByEmail(email: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendemailToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean>;
    /**
     * @param phone (optional)
     * @return Success
     */
    getClientByPhone(phone: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param model (optional)
     * @return Success
     */
    clientRequest(model: CheckClientRequest | null | undefined): Observable<GetClientResult>;
    /**
     * @param firstName (optional)
     * @param lastName (optional)
     * @param middleName (optional)
     * @param gender (optional)
     * @param genderId (optional)
     * @param pryEmail (optional)
     * @param secEmail (optional)
     * @param businessOrOccupation (optional)
     * @param categoryWorth (optional)
     * @param employerPhoneNo (optional)
     * @param preferredCommMode (optional)
     * @param domiciledCountry (optional)
     * @param regDate (optional)
     * @param regNumber (optional)
     * @param dlNo (optional)
     * @param dlExpiryDate (optional)
     * @param yearsOfDrvExperience (optional)
     * @param fax (optional)
     * @param image (optional)
     * @param passportNo (optional)
     * @param physicalAddrs (optional)
     * @param pin (optional)
     * @param postalAddrs (optional)
     * @param oldAccntNo (optional)
     * @param proposer (optional)
     * @param signature (optional)
     * @param smsTel (optional)
     * @param altTel (optional)
     * @param town (optional)
     * @param website (optional)
     * @param workPermit (optional)
     * @param zipCode (optional)
     * @param clientCategoryId (optional)
     * @param titleId (optional)
     * @param title (optional)
     * @param userId (optional)
     * @param maritalStatusId (optional)
     * @return Success
     */
    getClientDetails(firstName: string | null | undefined, lastName: string | null | undefined, middleName: string | null | undefined, dateOfBirth: Date, gender: string | null | undefined, genderId: string | null | undefined, pryEmail: string | null | undefined, secEmail: string | null | undefined, businessOrOccupation: string | null | undefined, categoryWorth: string | null | undefined, dateOfEmpl: Date, employerPhoneNo: string | null | undefined, preferredCommMode: string | null | undefined, domiciledCountry: string | null | undefined, regDate: Date | null | undefined, regNumber: string | null | undefined, dlNo: string | null | undefined, dlExpiryDate: Date | null | undefined, yearsOfDrvExperience: number | null | undefined, fax: string | null | undefined, image: string | null | undefined, passportNo: string | null | undefined, physicalAddrs: string | null | undefined, pin: string | null | undefined, postalAddrs: string | null | undefined, oldAccntNo: string | null | undefined, proposer: string | null | undefined, salMinRange: number, salMaxRange: number, signature: string | null | undefined, smsTel: string | null | undefined, altTel: string | null | undefined, town: string | null | undefined, website: string | null | undefined, workPermit: string | null | undefined, zipCode: string | null | undefined, clientCategoryId: string | null | undefined, titleId: string | null | undefined, title: string | null | undefined, userId: number | null | undefined, maritalStatusId: string | null | undefined): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getClientPolicies(policyNo: string | null | undefined): Observable<ClientPolicies>;
    /**
     * @param clientDetailDto (optional)
     * @return Success
     */
    createClientProfilling(clientDetailDto: ClientProfilingRequest | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param clientCmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientCmail: string | null | undefined): Observable<ClientPoliciesByEmail>;
    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientInfoByEmail(clientEmail: string | null | undefined): Observable<ClientPolicyByEmailModel>;
    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientProfileByEmail(clientEmail: string | null | undefined): Observable<ClientProfileByEmail>;
    /**
     * @param id (optional)
     * @return Success
     */
    getClientById(id: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param email (optional)
     * @param phone (optional)
     * @return Success
     */
    getClientByBoth(email: string | null | undefined, phone: string | null | undefined): Observable<GetClientResult>;
    /**
     * @param email (optional)
     * @param passportNo (optional)
     * @return Success
     */
    getClientByEmailAndPassportNo(email: string | null | undefined, passportNo: string | null | undefined): Observable<GetClientResult>;
}

@Injectable()
export class ClientServiceServiceProxy implements IClientServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postClientProfilling(model: ClientPolicyByEmailModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/PostClientProfilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostClientProfilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClientProfilling(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostClientProfilling(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getClientByEmail(email: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByEmail(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByEmail(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendemailToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/SendemailToClient?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendemailToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendemailToClient(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendemailToClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phone (optional)
     * @return Success
     */
    getClientByPhone(phone: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientByPhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByPhone(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByPhone(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    clientRequest(model: CheckClientRequest | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/ClientRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientRequest(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processClientRequest(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param firstName (optional)
     * @param lastName (optional)
     * @param middleName (optional)
     * @param gender (optional)
     * @param genderId (optional)
     * @param pryEmail (optional)
     * @param secEmail (optional)
     * @param businessOrOccupation (optional)
     * @param categoryWorth (optional)
     * @param employerPhoneNo (optional)
     * @param preferredCommMode (optional)
     * @param domiciledCountry (optional)
     * @param regDate (optional)
     * @param regNumber (optional)
     * @param dlNo (optional)
     * @param dlExpiryDate (optional)
     * @param yearsOfDrvExperience (optional)
     * @param fax (optional)
     * @param image (optional)
     * @param passportNo (optional)
     * @param physicalAddrs (optional)
     * @param pin (optional)
     * @param postalAddrs (optional)
     * @param oldAccntNo (optional)
     * @param proposer (optional)
     * @param signature (optional)
     * @param smsTel (optional)
     * @param altTel (optional)
     * @param town (optional)
     * @param website (optional)
     * @param workPermit (optional)
     * @param zipCode (optional)
     * @param clientCategoryId (optional)
     * @param titleId (optional)
     * @param title (optional)
     * @param userId (optional)
     * @param maritalStatusId (optional)
     * @return Success
     */
    getClientDetails(firstName: string | null | undefined, lastName: string | null | undefined, middleName: string | null | undefined, dateOfBirth: Date, gender: string | null | undefined, genderId: string | null | undefined, pryEmail: string | null | undefined, secEmail: string | null | undefined, businessOrOccupation: string | null | undefined, categoryWorth: string | null | undefined, dateOfEmpl: Date, employerPhoneNo: string | null | undefined, preferredCommMode: string | null | undefined, domiciledCountry: string | null | undefined, regDate: Date | null | undefined, regNumber: string | null | undefined, dlNo: string | null | undefined, dlExpiryDate: Date | null | undefined, yearsOfDrvExperience: number | null | undefined, fax: string | null | undefined, image: string | null | undefined, passportNo: string | null | undefined, physicalAddrs: string | null | undefined, pin: string | null | undefined, postalAddrs: string | null | undefined, oldAccntNo: string | null | undefined, proposer: string | null | undefined, salMinRange: number, salMaxRange: number, signature: string | null | undefined, smsTel: string | null | undefined, altTel: string | null | undefined, town: string | null | undefined, website: string | null | undefined, workPermit: string | null | undefined, zipCode: string | null | undefined, clientCategoryId: string | null | undefined, titleId: string | null | undefined, title: string | null | undefined, userId: number | null | undefined, maritalStatusId: string | null | undefined): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientDetails?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (dateOfBirth === undefined || dateOfBirth === null)
            throw new Error("The parameter 'dateOfBirth' must be defined and cannot be null.");
        else
            url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (genderId !== undefined && genderId !== null)
            url_ += "GenderId=" + encodeURIComponent("" + genderId) + "&";
        if (pryEmail !== undefined && pryEmail !== null)
            url_ += "PryEmail=" + encodeURIComponent("" + pryEmail) + "&";
        if (secEmail !== undefined && secEmail !== null)
            url_ += "SecEmail=" + encodeURIComponent("" + secEmail) + "&";
        if (businessOrOccupation !== undefined && businessOrOccupation !== null)
            url_ += "BusinessOrOccupation=" + encodeURIComponent("" + businessOrOccupation) + "&";
        if (categoryWorth !== undefined && categoryWorth !== null)
            url_ += "CategoryWorth=" + encodeURIComponent("" + categoryWorth) + "&";
        if (dateOfEmpl === undefined || dateOfEmpl === null)
            throw new Error("The parameter 'dateOfEmpl' must be defined and cannot be null.");
        else
            url_ += "DateOfEmpl=" + encodeURIComponent(dateOfEmpl ? "" + dateOfEmpl.toJSON() : "") + "&";
        if (employerPhoneNo !== undefined && employerPhoneNo !== null)
            url_ += "EmployerPhoneNo=" + encodeURIComponent("" + employerPhoneNo) + "&";
        if (preferredCommMode !== undefined && preferredCommMode !== null)
            url_ += "PreferredCommMode=" + encodeURIComponent("" + preferredCommMode) + "&";
        if (domiciledCountry !== undefined && domiciledCountry !== null)
            url_ += "DomiciledCountry=" + encodeURIComponent("" + domiciledCountry) + "&";
        if (regDate !== undefined && regDate !== null)
            url_ += "RegDate=" + encodeURIComponent(regDate ? "" + regDate.toJSON() : "") + "&";
        if (regNumber !== undefined && regNumber !== null)
            url_ += "RegNumber=" + encodeURIComponent("" + regNumber) + "&";
        if (dlNo !== undefined && dlNo !== null)
            url_ += "DlNo=" + encodeURIComponent("" + dlNo) + "&";
        if (dlExpiryDate !== undefined && dlExpiryDate !== null)
            url_ += "DlExpiryDate=" + encodeURIComponent(dlExpiryDate ? "" + dlExpiryDate.toJSON() : "") + "&";
        if (yearsOfDrvExperience !== undefined && yearsOfDrvExperience !== null)
            url_ += "YearsOfDrvExperience=" + encodeURIComponent("" + yearsOfDrvExperience) + "&";
        if (fax !== undefined && fax !== null)
            url_ += "Fax=" + encodeURIComponent("" + fax) + "&";
        if (image !== undefined && image !== null)
            url_ += "Image=" + encodeURIComponent("" + image) + "&";
        if (passportNo !== undefined && passportNo !== null)
            url_ += "PassportNo=" + encodeURIComponent("" + passportNo) + "&";
        if (physicalAddrs !== undefined && physicalAddrs !== null)
            url_ += "PhysicalAddrs=" + encodeURIComponent("" + physicalAddrs) + "&";
        if (pin !== undefined && pin !== null)
            url_ += "Pin=" + encodeURIComponent("" + pin) + "&";
        if (postalAddrs !== undefined && postalAddrs !== null)
            url_ += "PostalAddrs=" + encodeURIComponent("" + postalAddrs) + "&";
        if (oldAccntNo !== undefined && oldAccntNo !== null)
            url_ += "OldAccntNo=" + encodeURIComponent("" + oldAccntNo) + "&";
        if (proposer !== undefined && proposer !== null)
            url_ += "Proposer=" + encodeURIComponent("" + proposer) + "&";
        if (salMinRange === undefined || salMinRange === null)
            throw new Error("The parameter 'salMinRange' must be defined and cannot be null.");
        else
            url_ += "SalMinRange=" + encodeURIComponent("" + salMinRange) + "&";
        if (salMaxRange === undefined || salMaxRange === null)
            throw new Error("The parameter 'salMaxRange' must be defined and cannot be null.");
        else
            url_ += "SalMaxRange=" + encodeURIComponent("" + salMaxRange) + "&";
        if (signature !== undefined && signature !== null)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&";
        if (smsTel !== undefined && smsTel !== null)
            url_ += "SmsTel=" + encodeURIComponent("" + smsTel) + "&";
        if (altTel !== undefined && altTel !== null)
            url_ += "AltTel=" + encodeURIComponent("" + altTel) + "&";
        if (town !== undefined && town !== null)
            url_ += "Town=" + encodeURIComponent("" + town) + "&";
        if (website !== undefined && website !== null)
            url_ += "Website=" + encodeURIComponent("" + website) + "&";
        if (workPermit !== undefined && workPermit !== null)
            url_ += "WorkPermit=" + encodeURIComponent("" + workPermit) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (clientCategoryId !== undefined && clientCategoryId !== null)
            url_ += "ClientCategoryId=" + encodeURIComponent("" + clientCategoryId) + "&";
        if (titleId !== undefined && titleId !== null)
            url_ += "TitleId=" + encodeURIComponent("" + titleId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (maritalStatusId !== undefined && maritalStatusId !== null)
            url_ += "MaritalStatusId=" + encodeURIComponent("" + maritalStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientDetails(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientDetails(response: HttpResponseBase): Observable<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getClientPolicies(policyNo: string | null | undefined): Observable<ClientPolicies> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientPolicies?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPolicies(<any>response_);
                } catch (e) {
                    return <Observable<ClientPolicies>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPolicies>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPolicies(response: HttpResponseBase): Observable<ClientPolicies> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPolicies.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPolicies>(<any>null);
    }

    /**
     * @param clientDetailDto (optional)
     * @return Success
     */
    createClientProfilling(clientDetailDto: ClientProfilingRequest | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/CreateClientProfilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientDetailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientProfilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientProfilling(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateClientProfilling(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param clientCmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientCmail: string | null | undefined): Observable<ClientPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientPoliciesByEmail?";
        if (clientCmail !== undefined && clientCmail !== null)
            url_ += "clientCmail=" + encodeURIComponent("" + clientCmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPoliciesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPoliciesByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPoliciesByEmail(response: HttpResponseBase): Observable<ClientPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPoliciesByEmail>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientInfoByEmail(clientEmail: string | null | undefined): Observable<ClientPolicyByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientInfoByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientInfoByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientInfoByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPolicyByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPolicyByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientInfoByEmail(response: HttpResponseBase): Observable<ClientPolicyByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPolicyByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPolicyByEmailModel>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientProfileByEmail(clientEmail: string | null | undefined): Observable<ClientProfileByEmail> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientProfileByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientProfileByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientProfileByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientProfileByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientProfileByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientProfileByEmail(response: HttpResponseBase): Observable<ClientProfileByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientProfileByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientProfileByEmail>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getClientById(id: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientById(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientById(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param email (optional)
     * @param phone (optional)
     * @return Success
     */
    getClientByBoth(email: string | null | undefined, phone: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientByBoth?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByBoth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByBoth(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByBoth(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }

    /**
     * @param email (optional)
     * @param passportNo (optional)
     * @return Success
     */
    getClientByEmailAndPassportNo(email: string | null | undefined, passportNo: string | null | undefined): Observable<GetClientResult> {
        let url_ = this.baseUrl + "/api/services/app/ClientService/GetClientByEmailAndPassportNo?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (passportNo !== undefined && passportNo !== null)
            url_ += "passportNo=" + encodeURIComponent("" + passportNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByEmailAndPassportNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByEmailAndPassportNo(<any>response_);
                } catch (e) {
                    return <Observable<GetClientResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientByEmailAndPassportNo(response: HttpResponseBase): Observable<GetClientResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetClientResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientResult>(<any>null);
    }
}

export interface IConfirmPayServiceServiceProxy {
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getCheckPolicyNumber(policyNo: string | null | undefined): Observable<PolicyCheckDto>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetails(agentCode: string | null | undefined): Observable<AgentProfillingDetail>;
    /**
     * @param debitNo (optional)
     * @return Success
     */
    getDebitDetails(debitNo: string | null | undefined): Observable<DebitDetailDto>;
    /**
     * @param debitNo (optional)
     * @return Success
     */
    getTravelScheduleWithDebitDetails(debitNo: string | null | undefined): Observable<ConfirmpayTravelscheduleDto>;
    /**
     * @param debitNo (optional)
     * @return Success
     */
    getMotorScheduleWithDebitDetails(debitNo: string | null | undefined): Observable<ConfirmpayMotorcheduleDto>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionDetailsConfirmPay(transactionRef: string | null | undefined): Observable<LifeRenewalTranDto>;
    /**
     * @param accountNumber (optional)
     * @return Success
     */
    getMerchantsConfirmPay(accountNumber: string | null | undefined): Observable<MerchantDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerConfirmPay(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    revalidateConfirmPayForLifeRenewal(transactionRef: string | null | undefined): Observable<string>;
    /**
     * @param requesDto (optional)
     * @return Success
     */
    postTravelScheduleConfirmPay(requesDto: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto>;
    /**
     * @param requesDto (optional)
     * @return Success
     */
    postMotorScheduleConfirmPay(requesDto: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    genealBusinessFinalized(model: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto>;
}

@Injectable()
export class ConfirmPayServiceServiceProxy implements IConfirmPayServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getCheckPolicyNumber(policyNo: string | null | undefined): Observable<PolicyCheckDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetCheckPolicyNumber?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<PolicyCheckDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyCheckDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckPolicyNumber(response: HttpResponseBase): Observable<PolicyCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyCheckDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyCheckDto>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetails(agentCode: string | null | undefined): Observable<AgentProfillingDetail> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetAgentDetails?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetails(<any>response_);
                } catch (e) {
                    return <Observable<AgentProfillingDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentProfillingDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetails(response: HttpResponseBase): Observable<AgentProfillingDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentProfillingDetail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentProfillingDetail>(<any>null);
    }

    /**
     * @param debitNo (optional)
     * @return Success
     */
    getDebitDetails(debitNo: string | null | undefined): Observable<DebitDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetDebitDetails?";
        if (debitNo !== undefined && debitNo !== null)
            url_ += "debitNo=" + encodeURIComponent("" + debitNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDebitDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDebitDetails(<any>response_);
                } catch (e) {
                    return <Observable<DebitDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DebitDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDebitDetails(response: HttpResponseBase): Observable<DebitDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DebitDetailDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitDetailDto>(<any>null);
    }

    /**
     * @param debitNo (optional)
     * @return Success
     */
    getTravelScheduleWithDebitDetails(debitNo: string | null | undefined): Observable<ConfirmpayTravelscheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetTravelScheduleWithDebitDetails?";
        if (debitNo !== undefined && debitNo !== null)
            url_ += "debitNo=" + encodeURIComponent("" + debitNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelScheduleWithDebitDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelScheduleWithDebitDetails(<any>response_);
                } catch (e) {
                    return <Observable<ConfirmpayTravelscheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfirmpayTravelscheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelScheduleWithDebitDetails(response: HttpResponseBase): Observable<ConfirmpayTravelscheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfirmpayTravelscheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmpayTravelscheduleDto>(<any>null);
    }

    /**
     * @param debitNo (optional)
     * @return Success
     */
    getMotorScheduleWithDebitDetails(debitNo: string | null | undefined): Observable<ConfirmpayMotorcheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetMotorScheduleWithDebitDetails?";
        if (debitNo !== undefined && debitNo !== null)
            url_ += "debitNo=" + encodeURIComponent("" + debitNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorScheduleWithDebitDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorScheduleWithDebitDetails(<any>response_);
                } catch (e) {
                    return <Observable<ConfirmpayMotorcheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfirmpayMotorcheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorScheduleWithDebitDetails(response: HttpResponseBase): Observable<ConfirmpayMotorcheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfirmpayMotorcheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmpayMotorcheduleDto>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetLifePolicyRenewalDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifePolicyRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifePolicyRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifePolicyRenewalDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionDetailsConfirmPay(transactionRef: string | null | undefined): Observable<LifeRenewalTranDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetTransactionDetailsConfirmPay?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailsConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailsConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTranDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTranDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailsConfirmPay(response: HttpResponseBase): Observable<LifeRenewalTranDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTranDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTranDto>(<any>null);
    }

    /**
     * @param accountNumber (optional)
     * @return Success
     */
    getMerchantsConfirmPay(accountNumber: string | null | undefined): Observable<MerchantDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GetMerchantsConfirmPay?";
        if (accountNumber !== undefined && accountNumber !== null)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMerchantsConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMerchantsConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<MerchantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerchantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMerchantsConfirmPay(response: HttpResponseBase): Observable<MerchantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MerchantDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerchantDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/PostLifeRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLifeRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLifeRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTran>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTran>><any>_observableThrow(response_);
        }));
    }

    protected processPostLifeRenewalSchedule(response: HttpResponseBase): Observable<LifeRenewalTran> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTran.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTran>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerConfirmPay(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/FinalizePartnerConfirmPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerConfirmPay(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    revalidateConfirmPayForLifeRenewal(transactionRef: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/RevalidateConfirmPayForLifeRenewal?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevalidateConfirmPayForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevalidateConfirmPayForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRevalidateConfirmPayForLifeRenewal(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param requesDto (optional)
     * @return Success
     */
    postTravelScheduleConfirmPay(requesDto: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/PostTravelScheduleConfirmPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTravelScheduleConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTravelScheduleConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTranDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTranDto>><any>_observableThrow(response_);
        }));
    }

    protected processPostTravelScheduleConfirmPay(response: HttpResponseBase): Observable<LifeRenewalTranDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTranDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTranDto>(<any>null);
    }

    /**
     * @param requesDto (optional)
     * @return Success
     */
    postMotorScheduleConfirmPay(requesDto: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/PostMotorScheduleConfirmPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMotorScheduleConfirmPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMotorScheduleConfirmPay(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTranDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTranDto>><any>_observableThrow(response_);
        }));
    }

    protected processPostMotorScheduleConfirmPay(response: HttpResponseBase): Observable<LifeRenewalTranDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTranDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTranDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    genealBusinessFinalized(model: DebitDetailRequesDto | null | undefined): Observable<LifeRenewalTranDto> {
        let url_ = this.baseUrl + "/api/services/app/ConfirmPayService/GenealBusinessFinalized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenealBusinessFinalized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenealBusinessFinalized(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTranDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTranDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenealBusinessFinalized(response: HttpResponseBase): Observable<LifeRenewalTranDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTranDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTranDto>(<any>null);
    }
}

export interface ICrmServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postWhistleBlower(model: WhistleBlowerModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeadToCrm(model: CreateGtBankLeadDto | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLeadRequestToCrm(model: LeadRequestModel | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postIncident(model: IncidentModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postQuote(model: QuoteModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postChangeRequest(model: ChangeRequestModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postClaim(model: ClaimsModel | null | undefined): Observable<string>;
}

@Injectable()
export class CrmServiceServiceProxy implements ICrmServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postWhistleBlower(model: WhistleBlowerModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostWhistleBlower";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostWhistleBlower(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostWhistleBlower(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostWhistleBlower(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postBancassureLeadToCrm(model: CreateGtBankLeadDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostBancassureLeadToCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostBancassureLeadToCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBancassureLeadToCrm(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostBancassureLeadToCrm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLeadRequestToCrm(model: LeadRequestModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostLeadRequestToCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLeadRequestToCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLeadRequestToCrm(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostLeadRequestToCrm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postIncident(model: IncidentModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostIncident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostIncident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostIncident(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostIncident(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postQuote(model: QuoteModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostQuote(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostQuote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postChangeRequest(model: ChangeRequestModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostChangeRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostChangeRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postClaim(model: ClaimsModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CrmService/PostClaim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClaim(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostClaim(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IDeferredAnnuityServiceProxy {
    /**
     * @return Success
     */
    computeQuote(): Observable<number>;
    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]>;
    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductOptions(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getProductTerms(): Observable<NameValueModel[]>;
    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getRates(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<DeferredAnnuityRate>;
    /**
     * @return Success
     */
    getRetirementAge(): Observable<NameValueModel[]>;
}

@Injectable()
export class DeferredAnnuityServiceProxy implements IDeferredAnnuityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    computeQuote(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/computeQuote";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeQuote(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/GetPaymentFrequencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentFrequencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentFrequencies(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentFrequencies(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductOptions(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/getProductOptions?";
        if (rate === undefined || rate === null)
            throw new Error("The parameter 'rate' must be defined and cannot be null.");
        else
            url_ += "Rate=" + encodeURIComponent("" + rate) + "&";
        if (yearsTerm === undefined || yearsTerm === null)
            throw new Error("The parameter 'yearsTerm' must be defined and cannot be null.");
        else
            url_ += "YearsTerm=" + encodeURIComponent("" + yearsTerm) + "&";
        if (premiumFrequency !== undefined && premiumFrequency !== null)
            url_ += "PremiumFrequency=" + encodeURIComponent("" + premiumFrequency) + "&";
        if (coverType !== undefined && coverType !== null)
            url_ += "CoverType=" + encodeURIComponent("" + coverType) + "&";
        if (age === undefined || age === null)
            throw new Error("The parameter 'age' must be defined and cannot be null.");
        else
            url_ += "Age=" + encodeURIComponent("" + age) + "&";
        if (rateCode !== undefined && rateCode !== null)
            url_ += "RateCode=" + encodeURIComponent("" + rateCode) + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (retirementAge === undefined || retirementAge === null)
            throw new Error("The parameter 'retirementAge' must be defined and cannot be null.");
        else
            url_ += "RetirementAge=" + encodeURIComponent("" + retirementAge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOptions(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductOptions(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProductTerms(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/GetProductTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTerms(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductTerms(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getRates(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<DeferredAnnuityRate> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/GetRates?";
        if (rate === undefined || rate === null)
            throw new Error("The parameter 'rate' must be defined and cannot be null.");
        else
            url_ += "Rate=" + encodeURIComponent("" + rate) + "&";
        if (yearsTerm === undefined || yearsTerm === null)
            throw new Error("The parameter 'yearsTerm' must be defined and cannot be null.");
        else
            url_ += "YearsTerm=" + encodeURIComponent("" + yearsTerm) + "&";
        if (premiumFrequency !== undefined && premiumFrequency !== null)
            url_ += "PremiumFrequency=" + encodeURIComponent("" + premiumFrequency) + "&";
        if (coverType !== undefined && coverType !== null)
            url_ += "CoverType=" + encodeURIComponent("" + coverType) + "&";
        if (age === undefined || age === null)
            throw new Error("The parameter 'age' must be defined and cannot be null.");
        else
            url_ += "Age=" + encodeURIComponent("" + age) + "&";
        if (rateCode !== undefined && rateCode !== null)
            url_ += "RateCode=" + encodeURIComponent("" + rateCode) + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (retirementAge === undefined || retirementAge === null)
            throw new Error("The parameter 'retirementAge' must be defined and cannot be null.");
        else
            url_ += "RetirementAge=" + encodeURIComponent("" + retirementAge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRates(<any>response_);
                } catch (e) {
                    return <Observable<DeferredAnnuityRate>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeferredAnnuityRate>><any>_observableThrow(response_);
        }));
    }

    protected processGetRates(response: HttpResponseBase): Observable<DeferredAnnuityRate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DeferredAnnuityRate.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeferredAnnuityRate>(<any>null);
    }

    /**
     * @return Success
     */
    getRetirementAge(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/DeferredAnnuity/GetRetirementAge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetirementAge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetirementAge(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetirementAge(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }
}

export interface IEduShieldProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postEduShieldSchedule(model: EduShieldScheduleRequest | null | undefined): Observable<EduShieldScheduleRequest>;
}

@Injectable()
export class EduShieldProductServiceServiceProxy implements IEduShieldProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postEduShieldSchedule(model: EduShieldScheduleRequest | null | undefined): Observable<EduShieldScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/EduShieldProductService/PostEduShieldSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEduShieldSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEduShieldSchedule(<any>response_);
                } catch (e) {
                    return <Observable<EduShieldScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<EduShieldScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostEduShieldSchedule(response: HttpResponseBase): Observable<EduShieldScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EduShieldScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EduShieldScheduleRequest>(<any>null);
    }
}

export interface IEllaMobileServiceServiceProxy {
    /**
     * @return Success
     */
    getUserById(id: number): Observable<MobileUserLoginDetails>;
    /**
     * @param email (optional)
     * @return Success
     */
    getUserDetailsAfterLoginByEmail(email: string | null | undefined): Observable<MobileUserLoginDetails>;
    /**
     * @return Success
     */
    getRoleById(id: number): Observable<RoleDto>;
    /**
     * @param multipleBiz (optional)
     * @return Success
     */
    createConfirmPayMultiple(multipleBiz: MultipleNewBusinessDto | null | undefined): Observable<ConfirmResponseDto>;
    /**
     * @param single (optional)
     * @return Success
     */
    createConfirmPaySingle(single: SingleBusinessDto | null | undefined): Observable<ConfirmResponseDto>;
    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientEmail: string | null | undefined): Observable<ClientPoliciesByEmail>;
    /**
     * @param clientEmail (optional)
     * @param product (optional)
     * @param dateToPull (optional)
     * @return Success
     */
    getClientPaymentHistoryByEmail(clientEmail: string | null | undefined, product: string | null | undefined, dateToPull: Date | null | undefined): Observable<ClientPaymentHistory[]>;
    /**
     * @param agentEmail (optional)
     * @return Success
     */
    getAgentPoliciesListByEmail(agentEmail: string | null | undefined): Observable<AgentListPoliciesByEmail>;
}

@Injectable()
export class EllaMobileServiceServiceProxy implements IEllaMobileServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    getUserById(id: number): Observable<MobileUserLoginDetails> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetUserById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(<any>response_);
                } catch (e) {
                    return <Observable<MobileUserLoginDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileUserLoginDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<MobileUserLoginDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MobileUserLoginDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileUserLoginDetails>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getUserDetailsAfterLoginByEmail(email: string | null | undefined): Observable<MobileUserLoginDetails> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetUserDetailsAfterLoginByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetailsAfterLoginByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetailsAfterLoginByEmail(<any>response_);
                } catch (e) {
                    return <Observable<MobileUserLoginDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileUserLoginDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDetailsAfterLoginByEmail(response: HttpResponseBase): Observable<MobileUserLoginDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MobileUserLoginDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileUserLoginDetails>(<any>null);
    }

    /**
     * @return Success
     */
    getRoleById(id: number): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetRoleById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleById(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleById(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param multipleBiz (optional)
     * @return Success
     */
    createConfirmPayMultiple(multipleBiz: MultipleNewBusinessDto | null | undefined): Observable<ConfirmResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/CreateConfirmPayMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(multipleBiz);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConfirmPayMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConfirmPayMultiple(<any>response_);
                } catch (e) {
                    return <Observable<ConfirmResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfirmResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateConfirmPayMultiple(response: HttpResponseBase): Observable<ConfirmResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfirmResponseDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmResponseDto>(<any>null);
    }

    /**
     * @param single (optional)
     * @return Success
     */
    createConfirmPaySingle(single: SingleBusinessDto | null | undefined): Observable<ConfirmResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/CreateConfirmPaySingle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(single);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConfirmPaySingle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConfirmPaySingle(<any>response_);
                } catch (e) {
                    return <Observable<ConfirmResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfirmResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateConfirmPaySingle(response: HttpResponseBase): Observable<ConfirmResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfirmResponseDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmResponseDto>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @return Success
     */
    getClientPoliciesByEmail(clientEmail: string | null | undefined): Observable<ClientPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetClientPoliciesByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPoliciesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPoliciesByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPoliciesByEmail(response: HttpResponseBase): Observable<ClientPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPoliciesByEmail>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @param product (optional)
     * @param dateToPull (optional)
     * @return Success
     */
    getClientPaymentHistoryByEmail(clientEmail: string | null | undefined, product: string | null | undefined, dateToPull: Date | null | undefined): Observable<ClientPaymentHistory[]> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetClientPaymentHistoryByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (product !== undefined && product !== null)
            url_ += "product=" + encodeURIComponent("" + product) + "&";
        if (dateToPull !== undefined && dateToPull !== null)
            url_ += "dateToPull=" + encodeURIComponent(dateToPull ? "" + dateToPull.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPaymentHistoryByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPaymentHistoryByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPaymentHistory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPaymentHistory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPaymentHistoryByEmail(response: HttpResponseBase): Observable<ClientPaymentHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPaymentHistory.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPaymentHistory[]>(<any>null);
    }

    /**
     * @param agentEmail (optional)
     * @return Success
     */
    getAgentPoliciesListByEmail(agentEmail: string | null | undefined): Observable<AgentListPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/EllaMobileService/GetAgentPoliciesListByEmail?";
        if (agentEmail !== undefined && agentEmail !== null)
            url_ += "agentEmail=" + encodeURIComponent("" + agentEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentPoliciesListByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentPoliciesListByEmail(<any>response_);
                } catch (e) {
                    return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentPoliciesListByEmail(response: HttpResponseBase): Observable<AgentListPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentListPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentListPoliciesByEmail>(<any>null);
    }
}

export interface IEndorsementServiceServiceProxy {
    /**
     * @param id (optional)
     * @return Success
     */
    policyEndorsementFlexsure(id: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    policyEndorsementRetailer(id: number): Observable<string>;
    /**
     * @return Success
     */
    deletePolicyEndoresement(paymentResultId: string): Observable<void>;
}

@Injectable()
export class EndorsementServiceServiceProxy implements IEndorsementServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    policyEndorsementFlexsure(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EndorsementService/PolicyEndorsementFlexsure?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyEndorsementFlexsure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyEndorsementFlexsure(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyEndorsementFlexsure(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    policyEndorsementRetailer(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EndorsementService/PolicyEndorsementRetailer?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyEndorsementRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyEndorsementRetailer(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyEndorsementRetailer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    deletePolicyEndoresement(paymentResultId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EndorsementService/DeletePolicyEndoresement?";
        if (paymentResultId === undefined || paymentResultId === null)
            throw new Error("The parameter 'paymentResultId' must be defined and cannot be null.");
        else
            url_ += "paymentResultId=" + encodeURIComponent("" + paymentResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePolicyEndoresement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePolicyEndoresement(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePolicyEndoresement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IFinalizeConfirmPayServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    finalizeConfirmpayPayment(model: ConfirmFinalizeModel | null | undefined): Observable<PolicyDetails>;
}

@Injectable()
export class FinalizeConfirmPayServiceServiceProxy implements IFinalizeConfirmPayServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizeConfirmpayPayment(model: ConfirmFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/FinalizeConfirmPayService/FinalizeConfirmpayPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeConfirmpayPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeConfirmpayPayment(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeConfirmpayPayment(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }
}

export interface IFlexibleEndowmentServiceProxy {
    /**
     * @return Success
     */
    computeQuote(): Observable<number>;
    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]>;
    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductOptions(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]>;
    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductTerms(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]>;
}

@Injectable()
export class FlexibleEndowmentServiceProxy implements IFlexibleEndowmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    computeQuote(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FlexibleEndowment/computeQuote";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeQuote(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/FlexibleEndowment/GetPaymentFrequencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentFrequencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentFrequencies(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentFrequencies(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductOptions(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/FlexibleEndowment/getProductOptions?";
        if (rate === undefined || rate === null)
            throw new Error("The parameter 'rate' must be defined and cannot be null.");
        else
            url_ += "Rate=" + encodeURIComponent("" + rate) + "&";
        if (yearsTerm === undefined || yearsTerm === null)
            throw new Error("The parameter 'yearsTerm' must be defined and cannot be null.");
        else
            url_ += "YearsTerm=" + encodeURIComponent("" + yearsTerm) + "&";
        if (premiumFrequency !== undefined && premiumFrequency !== null)
            url_ += "PremiumFrequency=" + encodeURIComponent("" + premiumFrequency) + "&";
        if (coverType !== undefined && coverType !== null)
            url_ += "CoverType=" + encodeURIComponent("" + coverType) + "&";
        if (age === undefined || age === null)
            throw new Error("The parameter 'age' must be defined and cannot be null.");
        else
            url_ += "Age=" + encodeURIComponent("" + age) + "&";
        if (rateCode !== undefined && rateCode !== null)
            url_ += "RateCode=" + encodeURIComponent("" + rateCode) + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (retirementAge === undefined || retirementAge === null)
            throw new Error("The parameter 'retirementAge' must be defined and cannot be null.");
        else
            url_ += "RetirementAge=" + encodeURIComponent("" + retirementAge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOptions(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductOptions(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param premiumFrequency (optional)
     * @param coverType (optional)
     * @param rateCode (optional)
     * @param gender (optional)
     * @return Success
     */
    getProductTerms(rate: number, yearsTerm: number, premiumFrequency: string | null | undefined, coverType: string | null | undefined, age: number, rateCode: string | null | undefined, gender: string | null | undefined, retirementAge: number): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/FlexibleEndowment/GetProductTerms?";
        if (rate === undefined || rate === null)
            throw new Error("The parameter 'rate' must be defined and cannot be null.");
        else
            url_ += "Rate=" + encodeURIComponent("" + rate) + "&";
        if (yearsTerm === undefined || yearsTerm === null)
            throw new Error("The parameter 'yearsTerm' must be defined and cannot be null.");
        else
            url_ += "YearsTerm=" + encodeURIComponent("" + yearsTerm) + "&";
        if (premiumFrequency !== undefined && premiumFrequency !== null)
            url_ += "PremiumFrequency=" + encodeURIComponent("" + premiumFrequency) + "&";
        if (coverType !== undefined && coverType !== null)
            url_ += "CoverType=" + encodeURIComponent("" + coverType) + "&";
        if (age === undefined || age === null)
            throw new Error("The parameter 'age' must be defined and cannot be null.");
        else
            url_ += "Age=" + encodeURIComponent("" + age) + "&";
        if (rateCode !== undefined && rateCode !== null)
            url_ += "RateCode=" + encodeURIComponent("" + rateCode) + "&";
        if (gender !== undefined && gender !== null)
            url_ += "Gender=" + encodeURIComponent("" + gender) + "&";
        if (retirementAge === undefined || retirementAge === null)
            throw new Error("The parameter 'retirementAge' must be defined and cannot be null.");
        else
            url_ += "RetirementAge=" + encodeURIComponent("" + retirementAge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTerms(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductTerms(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }
}

export interface IGadgetProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postGadgetSchedule(model: GadgetScheduleRequest | null | undefined): Observable<GadgetScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getGadgetTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewGadgetTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getGadgetTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<GadgetTransactionResponse>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadGadget(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<GadgetScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmGadgetUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<GadgetScheduleRequest>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getGadgetCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
}

@Injectable()
export class GadgetProductServiceServiceProxy implements IGadgetProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postGadgetSchedule(model: GadgetScheduleRequest | null | undefined): Observable<GadgetScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/PostGadgetSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostGadgetSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostGadgetSchedule(<any>response_);
                } catch (e) {
                    return <Observable<GadgetScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<GadgetScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostGadgetSchedule(response: HttpResponseBase): Observable<GadgetScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GadgetScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GadgetScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getGadgetTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewGadgetTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/GetGadgetTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGadgetTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGadgetTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewGadgetTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewGadgetTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGadgetTransactionsWithRange(response: HttpResponseBase): Observable<ViewGadgetTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewGadgetTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewGadgetTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getGadgetTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<GadgetTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/GetGadgetTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGadgetTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGadgetTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<GadgetTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GadgetTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetGadgetTransactionDetails(response: HttpResponseBase): Observable<GadgetTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GadgetTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GadgetTransactionResponse>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadGadget(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<GadgetScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/UploadGadgetAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadGadget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadGadget(<any>response_);
                } catch (e) {
                    return <Observable<GadgetScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<GadgetScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadGadget(response: HttpResponseBase): Observable<GadgetScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GadgetScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GadgetScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmGadgetUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<GadgetScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/ConfirmGadgetUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmGadgetUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmGadgetUpload(<any>response_);
                } catch (e) {
                    return <Observable<GadgetScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<GadgetScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmGadgetUpload(response: HttpResponseBase): Observable<GadgetScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GadgetScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GadgetScheduleRequest>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getGadgetCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/GetGadgetCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGadgetCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGadgetCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetGadgetCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GadgetProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IHealthProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postCovidSchedule(model: CovidScheduleRequest | null | undefined): Observable<CovidScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getCovidTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewCovidTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getCovidTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<CovidTransactionResponse>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadCovid(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<CovidScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmCovidUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<CovidScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dRelationship (optional)
     * @param dAddress (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dRelationship: string | null | undefined, dAddress: string | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getCovidCertificate(tr: string | null | undefined): Observable<void>;
}

@Injectable()
export class HealthProductServiceServiceProxy implements IHealthProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postCovidSchedule(model: CovidScheduleRequest | null | undefined): Observable<CovidScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/PostCovidSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCovidSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCovidSchedule(<any>response_);
                } catch (e) {
                    return <Observable<CovidScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<CovidScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostCovidSchedule(response: HttpResponseBase): Observable<CovidScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CovidScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CovidScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getCovidTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewCovidTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/GetCovidTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCovidTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCovidTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewCovidTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewCovidTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCovidTransactionsWithRange(response: HttpResponseBase): Observable<ViewCovidTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewCovidTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewCovidTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getCovidTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<CovidTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/GetCovidTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCovidTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCovidTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<CovidTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CovidTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCovidTransactionDetails(response: HttpResponseBase): Observable<CovidTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CovidTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CovidTransactionResponse>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadCovid(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<CovidScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/UploadCovidAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCovid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCovid(<any>response_);
                } catch (e) {
                    return <Observable<CovidScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<CovidScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCovid(response: HttpResponseBase): Observable<CovidScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CovidScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CovidScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmCovidUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<CovidScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/ConfirmCovidUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmCovidUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmCovidUpload(<any>response_);
                } catch (e) {
                    return <Observable<CovidScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<CovidScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmCovidUpload(response: HttpResponseBase): Observable<CovidScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CovidScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CovidScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dRelationship (optional)
     * @param dAddress (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dRelationship: string | null | undefined, dAddress: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dRelationship !== undefined && dRelationship !== null)
            url_ += "dRelationship=" + encodeURIComponent("" + dRelationship) + "&";
        if (dAddress !== undefined && dAddress !== null)
            url_ += "dAddress=" + encodeURIComponent("" + dAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/OptOut?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOptOut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processOptOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getCovidCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthProductService/GetCovidCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCovidCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCovidCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetCovidCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IHospitalCashProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postHospitalCashSchedule(model: HospitalCashScheduleRequest | null | undefined): Observable<HospitalCashScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHospitalCashTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHospitalCashTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHospitalCashTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HospitalCashTransactionResponse>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadHospitalCash(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<HospitalCashScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmHospitalCashUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<HospitalCashScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dRelationship (optional)
     * @param dAddress (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dRelationship: string | null | undefined, dAddress: string | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getHospitalCashCertificate(tr: string | null | undefined): Observable<void>;
}

@Injectable()
export class HospitalCashProductServiceServiceProxy implements IHospitalCashProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postHospitalCashSchedule(model: HospitalCashScheduleRequest | null | undefined): Observable<HospitalCashScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/PostHospitalCashSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostHospitalCashSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostHospitalCashSchedule(<any>response_);
                } catch (e) {
                    return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostHospitalCashSchedule(response: HttpResponseBase): Observable<HospitalCashScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HospitalCashScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HospitalCashScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHospitalCashTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHospitalCashTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/GetHospitalCashTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalCashTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalCashTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewHospitalCashTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewHospitalCashTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHospitalCashTransactionsWithRange(response: HttpResponseBase): Observable<ViewHospitalCashTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewHospitalCashTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewHospitalCashTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHospitalCashTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HospitalCashTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/GetHospitalCashTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalCashTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalCashTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<HospitalCashTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HospitalCashTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetHospitalCashTransactionDetails(response: HttpResponseBase): Observable<HospitalCashTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HospitalCashTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HospitalCashTransactionResponse>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadHospitalCash(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<HospitalCashScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/UploadHospitalCashAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadHospitalCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadHospitalCash(<any>response_);
                } catch (e) {
                    return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadHospitalCash(response: HttpResponseBase): Observable<HospitalCashScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HospitalCashScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HospitalCashScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmHospitalCashUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<HospitalCashScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/ConfirmHospitalCashUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmHospitalCashUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmHospitalCashUpload(<any>response_);
                } catch (e) {
                    return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HospitalCashScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmHospitalCashUpload(response: HttpResponseBase): Observable<HospitalCashScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HospitalCashScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HospitalCashScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dRelationship (optional)
     * @param dAddress (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dRelationship: string | null | undefined, dAddress: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dRelationship !== undefined && dRelationship !== null)
            url_ += "dRelationship=" + encodeURIComponent("" + dRelationship) + "&";
        if (dAddress !== undefined && dAddress !== null)
            url_ += "dAddress=" + encodeURIComponent("" + dAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/OptOut?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOptOut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processOptOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getHospitalCashCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HospitalCashProductService/GetHospitalCashCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalCashCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalCashCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetHospitalCashCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IHouseholdProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postHomeSchedule(model: HomeScheduleRequest | null | undefined): Observable<HomeScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHomeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHomeTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHomeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HomeTransactionResponse>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getHomeCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadHome(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<HomeScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmHomeUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<HomeScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param homeScheduleRequest (optional)
     * @return Success
     */
    postEllaMobileHomeSchedule(homeScheduleRequest: HomeScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
}

@Injectable()
export class HouseholdProductServiceServiceProxy implements IHouseholdProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postHomeSchedule(model: HomeScheduleRequest | null | undefined): Observable<HomeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/PostHomeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostHomeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostHomeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<HomeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostHomeSchedule(response: HttpResponseBase): Observable<HomeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getHomeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewHomeTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/GetHomeTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewHomeTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewHomeTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeTransactionsWithRange(response: HttpResponseBase): Observable<ViewHomeTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewHomeTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewHomeTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getHomeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<HomeTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/GetHomeTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<HomeTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeTransactionDetails(response: HttpResponseBase): Observable<HomeTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeTransactionResponse>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getHomeCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/GetHomeCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadHome(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<HomeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/UploadHomeAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadHome(<any>response_);
                } catch (e) {
                    return <Observable<HomeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadHome(response: HttpResponseBase): Observable<HomeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmHomeUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<HomeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/ConfirmHomeUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmHomeUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmHomeUpload(<any>response_);
                } catch (e) {
                    return <Observable<HomeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmHomeUpload(response: HttpResponseBase): Observable<HomeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HomeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param homeScheduleRequest (optional)
     * @return Success
     */
    postEllaMobileHomeSchedule(homeScheduleRequest: HomeScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/HouseholdProductService/PostEllaMobileHomeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(homeScheduleRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileHomeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileHomeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileHomeSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }
}

export interface IIntermediaryServiceProxy {
    /**
     * @param input (optional)
     * @return Success
     */
    createIntermediary(input: CreateIntermediaryDto | null | undefined): Observable<MessageOut>;
    /**
     * @return Success
     */
    getWebsiteBasePath(): Observable<string>;
    /**
     * @return Success
     */
    getIntermediaryByUserId(userId: number): Observable<IntermediaryDto>;
    /**
     * @return Success
     */
    getIntermediariesWithRelated(): Observable<IntermediaryDto[]>;
    /**
     * @return Success
     */
    getWemaResellerLink(): Observable<string>;
    /**
     * @return Success
     */
    getIntermediaryWalletDetails(intermediaryId: number): Observable<IntermediaryWalletModel>;
    /**
     * @return Success
     */
    createNew(): Observable<User>;
    /**
     * @param model (optional)
     * @return Success
     */
    sendVerificationLink(model: AgentVerificationLinkModel | null | undefined): Observable<boolean>;
    /**
     * @param id (optional)
     * @return Success
     */
    resendVerificationLink(id: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getntermediaryTypes(): Observable<IntermediaryTypeDto[]>;
    /**
     * @return Success
     */
    getTitles(): Observable<TitleDto[]>;
    /**
     * @return Success
     */
    getIntermediaryDetails(intermediaryId: string): Observable<IntermediaryDetailsModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    postIntermediarySale(model: IntermediaryTransactionModelNew | null | undefined): Observable<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param model (optional)
     * @return Success
     */
    postIntermediaryPayment(model: IntermediaryTransactionModel | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    intermediaryCommission(model: IntermediaryTransactionModelNew | null | undefined): Observable<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByPolicyByDate(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses>;
    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByPolicy(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses>;
    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByDate(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses>;
    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatus(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDashboard(agentCode: string | null | undefined): Observable<AgentDashboardDto>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetails(agentCode: string | null | undefined): Observable<AgentProfillingDetail>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetailsAndCadre(agentCode: string | null | undefined): Observable<AgentProfillingDetailCader>;
    /**
     * @param model (optional)
     * @return Success
     */
    postAgentProfilling(model: AgentDetailByEmailModel | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postAgentProfilingForMobile(model: AgentDetailByEmailModel | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param email (optional)
     * @return Success
     */
    getForgetPassword(email: string | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    getGenerateNewOtp(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    postCreateNewPassword(model: ChangePasswordWithOtp | null | undefined): Observable<string>;
    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendVerificationLinkToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string>;
    /**
     * @param agentCmail (optional)
     * @return Success
     */
    getAgentPoliciesListByEmail(agentCmail: string | null | undefined): Observable<AgentListPoliciesByEmail>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentPoliciesDueDateByAgenctCode(agentCode: string | null | undefined): Observable<AgentListPoliciesByEmail>;
    /**
     * @return Success
     */
    get(id: string): Observable<IntermediaryDto>;
    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateIntermediaryDto | null | undefined): Observable<IntermediaryDto>;
    /**
     * @param input (optional)
     * @return Success
     */
    update(input: IntermediaryDto | null | undefined): Observable<IntermediaryDto>;
    /**
     * @return Success
     */
    delete(id: string): Observable<void>;
}

@Injectable()
export class IntermediaryServiceProxy implements IIntermediaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param input (optional)
     * @return Success
     */
    createIntermediary(input: CreateIntermediaryDto | null | undefined): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CreateIntermediary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIntermediary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIntermediary(<any>response_);
                } catch (e) {
                    return <Observable<MessageOut>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageOut>><any>_observableThrow(response_);
        }));
    }

    protected processCreateIntermediary(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageOut>(<any>null);
    }

    /**
     * @return Success
     */
    getWebsiteBasePath(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetWebsiteBasePath";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebsiteBasePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebsiteBasePath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetWebsiteBasePath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getIntermediaryByUserId(userId: number): Observable<IntermediaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetIntermediaryByUserId?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediaryByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediaryByUserId(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediaryByUserId(response: HttpResponseBase): Observable<IntermediaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getIntermediariesWithRelated(): Observable<IntermediaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetIntermediariesWithRelated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediariesWithRelated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediariesWithRelated(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediariesWithRelated(response: HttpResponseBase): Observable<IntermediaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntermediaryDto.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWemaResellerLink(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetWemaResellerLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWemaResellerLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWemaResellerLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetWemaResellerLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getIntermediaryWalletDetails(intermediaryId: number): Observable<IntermediaryWalletModel> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetIntermediaryWalletDetails?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined and cannot be null.");
        else
            url_ += "intermediaryId=" + encodeURIComponent("" + intermediaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediaryWalletDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediaryWalletDetails(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryWalletModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryWalletModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediaryWalletDetails(response: HttpResponseBase): Observable<IntermediaryWalletModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryWalletModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryWalletModel>(<any>null);
    }

    /**
     * @return Success
     */
    createNew(): Observable<User> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CreateNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(<any>response_);
                } catch (e) {
                    return <Observable<User>><any>_observableThrow(e);
                }
            } else
                return <Observable<User>><any>_observableThrow(response_);
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    sendVerificationLink(model: AgentVerificationLinkModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/SendVerificationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationLink(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationLink(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    resendVerificationLink(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/ResendVerificationLink?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendVerificationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendVerificationLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processResendVerificationLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getntermediaryTypes(): Observable<IntermediaryTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetntermediaryTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetntermediaryTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetntermediaryTypes(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetntermediaryTypes(response: HttpResponseBase): Observable<IntermediaryTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntermediaryTypeDto.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTitles(): Observable<TitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitles(<any>response_);
                } catch (e) {
                    return <Observable<TitleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TitleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTitles(response: HttpResponseBase): Observable<TitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TitleDto.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getIntermediaryDetails(intermediaryId: string): Observable<IntermediaryDetailsModel> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetIntermediaryDetails?";
        if (intermediaryId === undefined || intermediaryId === null)
            throw new Error("The parameter 'intermediaryId' must be defined and cannot be null.");
        else
            url_ += "intermediaryId=" + encodeURIComponent("" + intermediaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntermediaryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntermediaryDetails(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntermediaryDetails(response: HttpResponseBase): Observable<IntermediaryDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryDetailsModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDetailsModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postIntermediarySale(model: IntermediaryTransactionModelNew | null | undefined): Observable<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/PostIntermediarySale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostIntermediarySale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostIntermediarySale(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostIntermediarySale(response: HttpResponseBase): Observable<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postIntermediaryPayment(model: IntermediaryTransactionModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/PostIntermediaryPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostIntermediaryPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostIntermediaryPayment(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostIntermediaryPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    intermediaryCommission(model: IntermediaryTransactionModelNew | null | undefined): Observable<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/IntermediaryCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntermediaryCommission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntermediaryCommission(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processIntermediaryCommission(response: HttpResponseBase): Observable<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByPolicyByDate(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CheckCommissionStatusByPolicyByDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyByDateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCommissionStatusByPolicyByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCommissionStatusByPolicyByDate(<any>response_);
                } catch (e) {
                    return <Observable<AgentCommissionResponses>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentCommissionResponses>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCommissionStatusByPolicyByDate(response: HttpResponseBase): Observable<AgentCommissionResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentCommissionResponses.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentCommissionResponses>(<any>null);
    }

    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByPolicy(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CheckCommissionStatusByPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyByDateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCommissionStatusByPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCommissionStatusByPolicy(<any>response_);
                } catch (e) {
                    return <Observable<AgentCommissionResponses>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentCommissionResponses>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCommissionStatusByPolicy(response: HttpResponseBase): Observable<AgentCommissionResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentCommissionResponses.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentCommissionResponses>(<any>null);
    }

    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatusByDate(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CheckCommissionStatusByDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyByDateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCommissionStatusByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCommissionStatusByDate(<any>response_);
                } catch (e) {
                    return <Observable<AgentCommissionResponses>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentCommissionResponses>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCommissionStatusByDate(response: HttpResponseBase): Observable<AgentCommissionResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentCommissionResponses.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentCommissionResponses>(<any>null);
    }

    /**
     * @param policyByDateDto (optional)
     * @return Success
     */
    checkCommissionStatus(policyByDateDto: CheckCommissionStatusByPolicyByDateDto | null | undefined): Observable<AgentCommissionResponses> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/CheckCommissionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(policyByDateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCommissionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCommissionStatus(<any>response_);
                } catch (e) {
                    return <Observable<AgentCommissionResponses>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentCommissionResponses>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCommissionStatus(response: HttpResponseBase): Observable<AgentCommissionResponses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentCommissionResponses.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentCommissionResponses>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDashboard(agentCode: string | null | undefined): Observable<AgentDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAgentDashboard?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDashboard(<any>response_);
                } catch (e) {
                    return <Observable<AgentDashboardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDashboardDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDashboard(response: HttpResponseBase): Observable<AgentDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDashboardDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDashboardDto>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetails(agentCode: string | null | undefined): Observable<AgentProfillingDetail> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAgentDetails?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetails(<any>response_);
                } catch (e) {
                    return <Observable<AgentProfillingDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentProfillingDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetails(response: HttpResponseBase): Observable<AgentProfillingDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentProfillingDetail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentProfillingDetail>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentDetailsAndCadre(agentCode: string | null | undefined): Observable<AgentProfillingDetailCader> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAgentDetailsAndCadre?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetailsAndCadre(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetailsAndCadre(<any>response_);
                } catch (e) {
                    return <Observable<AgentProfillingDetailCader>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentProfillingDetailCader>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetailsAndCadre(response: HttpResponseBase): Observable<AgentProfillingDetailCader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentProfillingDetailCader.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentProfillingDetailCader>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postAgentProfilling(model: AgentDetailByEmailModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/PostAgentProfilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAgentProfilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAgentProfilling(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPostAgentProfilling(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postAgentProfilingForMobile(model: AgentDetailByEmailModel | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/PostAgentProfilingForMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAgentProfilingForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAgentProfilingForMobile(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostAgentProfilingForMobile(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getForgetPassword(email: string | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetForgetPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForgetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForgetPassword(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetForgetPassword(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    getGenerateNewOtp(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetGenerateNewOtp?";
        if (tQSYSCODE !== undefined && tQSYSCODE !== null)
            url_ += "TQSYSCODE=" + encodeURIComponent("" + tQSYSCODE) + "&";
        if (aCCOUNTTYPE !== undefined && aCCOUNTTYPE !== null)
            url_ += "ACCOUNTTYPE=" + encodeURIComponent("" + aCCOUNTTYPE) + "&";
        if (aGENTTYPE !== undefined && aGENTTYPE !== null)
            url_ += "AGENTTYPE=" + encodeURIComponent("" + aGENTTYPE) + "&";
        if (aGENTCODE !== undefined && aGENTCODE !== null)
            url_ += "AGENTCODE=" + encodeURIComponent("" + aGENTCODE) + "&";
        if (aDDRESS !== undefined && aDDRESS !== null)
            url_ += "ADDRESS=" + encodeURIComponent("" + aDDRESS) + "&";
        if (eMAIL !== undefined && eMAIL !== null)
            url_ += "EMAIL=" + encodeURIComponent("" + eMAIL) + "&";
        if (tELEPHONE !== undefined && tELEPHONE !== null)
            url_ += "TELEPHONE=" + encodeURIComponent("" + tELEPHONE) + "&";
        if (aGN_NAME !== undefined && aGN_NAME !== null)
            url_ += "AGN_NAME=" + encodeURIComponent("" + aGN_NAME) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenerateNewOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenerateNewOtp(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenerateNewOtp(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postCreateNewPassword(model: ChangePasswordWithOtp | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/PostCreateNewPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCreateNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCreateNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostCreateNewPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendVerificationLinkToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/SendVerificationLinkToClient?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationLinkToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationLinkToClient(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationLinkToClient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAdminBasePath";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminBasePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminBasePath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminBasePath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param agentCmail (optional)
     * @return Success
     */
    getAgentPoliciesListByEmail(agentCmail: string | null | undefined): Observable<AgentListPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAgentPoliciesListByEmail?";
        if (agentCmail !== undefined && agentCmail !== null)
            url_ += "agentCmail=" + encodeURIComponent("" + agentCmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentPoliciesListByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentPoliciesListByEmail(<any>response_);
                } catch (e) {
                    return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentPoliciesListByEmail(response: HttpResponseBase): Observable<AgentListPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentListPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentListPoliciesByEmail>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    getAgentPoliciesDueDateByAgenctCode(agentCode: string | null | undefined): Observable<AgentListPoliciesByEmail> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAgentPoliciesDueDateByAgenctCode?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentPoliciesDueDateByAgenctCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentPoliciesDueDateByAgenctCode(<any>response_);
                } catch (e) {
                    return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentListPoliciesByEmail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentPoliciesDueDateByAgenctCode(response: HttpResponseBase): Observable<AgentListPoliciesByEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentListPoliciesByEmail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentListPoliciesByEmail>(<any>null);
    }

    /**
     * @return Success
     */
    get(id: string): Observable<IntermediaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IntermediaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/GetAll?";
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateIntermediaryDto | null | undefined): Observable<IntermediaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IntermediaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    update(input: IntermediaryDto | null | undefined): Observable<IntermediaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<IntermediaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IntermediaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IntermediaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IntermediaryDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IntermediaryDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Intermediary/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IInterswitchPaymentServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPayment(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPaymentForLifeRenewal(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentValidationResult(transactionRef: string | null | undefined, amount: number): Observable<boolean>;
}

@Injectable()
export class InterswitchPaymentServiceServiceProxy implements IInterswitchPaymentServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPayment(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/InterswitchPaymentService/FinalizeInterswitchPayment?";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeInterswitchPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeInterswitchPayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeInterswitchPayment(response: HttpResponseBase): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizeInterswitchPaymentForLifeRenewal(model: InterswitchParam | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/InterswitchPaymentService/FinalizeInterswitchPaymentForLifeRenewal?";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeInterswitchPaymentForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeInterswitchPaymentForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeInterswitchPaymentForLifeRenewal(response: HttpResponseBase): Observable<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentValidationResult(transactionRef: string | null | undefined, amount: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InterswitchPaymentService/GetPaymentValidationResult?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentValidationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentValidationResult(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentValidationResult(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface ILifeRenewalServiceServiceProxy {
    /**
     * @return Success
     */
    getRemittaDirectDebitBanks(): Observable<SelectListItem[]>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLoanListRepaymentDetails(policyNo: string | null | undefined): Observable<NameValueModelList>;
    /**
     * @param policyNo (optional)
     * @param refNumber (optional)
     * @return Success
     */
    getLoanRepaymentDetails(policyNo: string | null | undefined, refNumber: string | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLifePolicyRenewalDetails(model: LifePolicyRenewalRequest | null | undefined): Observable<LifeRenewalDetails>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyDetails(policyNo: string | null | undefined): Observable<LifePolicyDetails>;
    /**
     * @return Success
     */
    pushAllLifeTransactionsFromFlexsureToTq(): Observable<boolean>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    pushSingleLifeTransactionsFromFlexsureToTq(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    pushFailedLifeRenewalToTq(): Observable<string>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getLifeRenewalTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewLifeRenewalTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getLifeRenewalTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<LifeRenewalTransactionResponse>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceipt(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getNcspProposalForm(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceiptAsStreamContent(tr: string | null | undefined): Observable<string>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getNcspCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param email (optional)
     * @return Success
     */
    getDirectDebitMandatesForClient(email: string | null | undefined): Observable<RemittaDirectDebitMandateDto[]>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getDirectDebitMandatesTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewDirectDebitMandateViewModel[]>;
    /**
     * @param email (optional)
     * @return Success
     */
    getDirectDebitMandatesByEmail(email: string | null | undefined): Observable<string[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    createDirectDebitMandate(model: CreateRemittaDirectDebitMandateDto | null | undefined): Observable<RemittaMandateResponseModel>;
    /**
     * @param status (optional)
     * @param statusCode (optional)
     * @param mandateId (optional)
     * @param requestId (optional)
     * @return Success
     */
    getDirectDebitMandateUrl(status: string | null | undefined, statusCode: string | null | undefined, mandateId: string | null | undefined, requestId: string | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    activateMandateRequest(model: RemittaMandateResponseModel | null | undefined): Observable<RemittaActivateResponseOtpModel>;
    /**
     * @param id (optional)
     * @return Success
     */
    activateMandateRequestRevalidate(id: string | null | undefined): Observable<RemittaActivateResponseOtpModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    validateCustomerOtp(model: RemittaActivateResponseOtpModel | null | undefined): Observable<MessageOut>;
    /**
     * @param model (optional)
     * @return Success
     */
    mandateNotification(model: RemittaMandateNotificationRequestModel | null | undefined): Observable<string>;
    /**
     * @param renewalScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileLifeRenewalSchedule(renewalScheduleForMobile: LifeRenewalScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param transRef (optional)
     * @return Success
     */
    getEllaMobileLifeRenewalStreams(transRef: string | null | undefined): Observable<string>;
}

@Injectable()
export class LifeRenewalServiceServiceProxy implements ILifeRenewalServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    getRemittaDirectDebitBanks(): Observable<SelectListItem[]> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetRemittaDirectDebitBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemittaDirectDebitBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemittaDirectDebitBanks(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRemittaDirectDebitBanks(response: HttpResponseBase): Observable<SelectListItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectListItem.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItem[]>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLoanListRepaymentDetails(policyNo: string | null | undefined): Observable<NameValueModelList> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLoanListRepaymentDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoanListRepaymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoanListRepaymentDetails(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModelList>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModelList>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoanListRepaymentDetails(response: HttpResponseBase): Observable<NameValueModelList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NameValueModelList.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModelList>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @param refNumber (optional)
     * @return Success
     */
    getLoanRepaymentDetails(policyNo: string | null | undefined, refNumber: string | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLoanRepaymentDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (refNumber !== undefined && refNumber !== null)
            url_ += "refNumber=" + encodeURIComponent("" + refNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoanRepaymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoanRepaymentDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoanRepaymentDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyRenewalDetails(policyNo: string | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifePolicyRenewalDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifePolicyRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifePolicyRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifePolicyRenewalDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLifePolicyRenewalDetails(model: LifePolicyRenewalRequest | null | undefined): Observable<LifeRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PostLifePolicyRenewalDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLifePolicyRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLifePolicyRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processPostLifePolicyRenewalDetails(response: HttpResponseBase): Observable<LifeRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalDetails>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postLifeRenewalSchedule(model: LifeRenewalTran | null | undefined): Observable<LifeRenewalTran> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PostLifeRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLifeRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLifeRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTran>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTran>><any>_observableThrow(response_);
        }));
    }

    protected processPostLifeRenewalSchedule(response: HttpResponseBase): Observable<LifeRenewalTran> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTran.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTran>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getLifePolicyDetails(policyNo: string | null | undefined): Observable<LifePolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifePolicyDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifePolicyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifePolicyDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifePolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifePolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifePolicyDetails(response: HttpResponseBase): Observable<LifePolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifePolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifePolicyDetails>(<any>null);
    }

    /**
     * @return Success
     */
    pushAllLifeTransactionsFromFlexsureToTq(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PushAllLifeTransactionsFromFlexsureToTq";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushAllLifeTransactionsFromFlexsureToTq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushAllLifeTransactionsFromFlexsureToTq(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushAllLifeTransactionsFromFlexsureToTq(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    pushSingleLifeTransactionsFromFlexsureToTq(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PushSingleLifeTransactionsFromFlexsureToTq?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushSingleLifeTransactionsFromFlexsureToTq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushSingleLifeTransactionsFromFlexsureToTq(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushSingleLifeTransactionsFromFlexsureToTq(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    pushFailedLifeRenewalToTq(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PushFailedLifeRenewalToTq";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushFailedLifeRenewalToTq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushFailedLifeRenewalToTq(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushFailedLifeRenewalToTq(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getLifeRenewalTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewLifeRenewalTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifeRenewalTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewLifeRenewalTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewLifeRenewalTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalTransactionsWithRange(response: HttpResponseBase): Observable<ViewLifeRenewalTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewLifeRenewalTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewLifeRenewalTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getLifeRenewalTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<LifeRenewalTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifeRenewalTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<LifeRenewalTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeRenewalTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalTransactionDetails(response: HttpResponseBase): Observable<LifeRenewalTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeRenewalTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeRenewalTransactionResponse>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceipt(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifeRenewalReceipt?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalReceipt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalReceipt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getNcspProposalForm(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetNcspProposalForm?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNcspProposalForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNcspProposalForm(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetNcspProposalForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getLifeRenewalReceiptAsStreamContent(tr: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetLifeRenewalReceiptAsStreamContent?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLifeRenewalReceiptAsStreamContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLifeRenewalReceiptAsStreamContent(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLifeRenewalReceiptAsStreamContent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getNcspCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetNcspCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNcspCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNcspCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetNcspCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getDirectDebitMandatesForClient(email: string | null | undefined): Observable<RemittaDirectDebitMandateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetDirectDebitMandatesForClient?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectDebitMandatesForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectDebitMandatesForClient(<any>response_);
                } catch (e) {
                    return <Observable<RemittaDirectDebitMandateDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemittaDirectDebitMandateDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectDebitMandatesForClient(response: HttpResponseBase): Observable<RemittaDirectDebitMandateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemittaDirectDebitMandateDto.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemittaDirectDebitMandateDto[]>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getDirectDebitMandatesTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewDirectDebitMandateViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetDirectDebitMandatesTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectDebitMandatesTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectDebitMandatesTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewDirectDebitMandateViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewDirectDebitMandateViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectDebitMandatesTransactionsWithRange(response: HttpResponseBase): Observable<ViewDirectDebitMandateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewDirectDebitMandateViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewDirectDebitMandateViewModel[]>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getDirectDebitMandatesByEmail(email: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetDirectDebitMandatesByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectDebitMandatesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectDebitMandatesByEmail(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectDebitMandatesByEmail(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    createDirectDebitMandate(model: CreateRemittaDirectDebitMandateDto | null | undefined): Observable<RemittaMandateResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/CreateDirectDebitMandate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDirectDebitMandate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDirectDebitMandate(<any>response_);
                } catch (e) {
                    return <Observable<RemittaMandateResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemittaMandateResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDirectDebitMandate(response: HttpResponseBase): Observable<RemittaMandateResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RemittaMandateResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemittaMandateResponseModel>(<any>null);
    }

    /**
     * @param status (optional)
     * @param statusCode (optional)
     * @param mandateId (optional)
     * @param requestId (optional)
     * @return Success
     */
    getDirectDebitMandateUrl(status: string | null | undefined, statusCode: string | null | undefined, mandateId: string | null | undefined, requestId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetDirectDebitMandateUrl?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        if (mandateId !== undefined && mandateId !== null)
            url_ += "MandateId=" + encodeURIComponent("" + mandateId) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectDebitMandateUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectDebitMandateUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectDebitMandateUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    activateMandateRequest(model: RemittaMandateResponseModel | null | undefined): Observable<RemittaActivateResponseOtpModel> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/ActivateMandateRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateMandateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateMandateRequest(<any>response_);
                } catch (e) {
                    return <Observable<RemittaActivateResponseOtpModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemittaActivateResponseOtpModel>><any>_observableThrow(response_);
        }));
    }

    protected processActivateMandateRequest(response: HttpResponseBase): Observable<RemittaActivateResponseOtpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RemittaActivateResponseOtpModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemittaActivateResponseOtpModel>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    activateMandateRequestRevalidate(id: string | null | undefined): Observable<RemittaActivateResponseOtpModel> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/ActivateMandateRequestRevalidate?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateMandateRequestRevalidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateMandateRequestRevalidate(<any>response_);
                } catch (e) {
                    return <Observable<RemittaActivateResponseOtpModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemittaActivateResponseOtpModel>><any>_observableThrow(response_);
        }));
    }

    protected processActivateMandateRequestRevalidate(response: HttpResponseBase): Observable<RemittaActivateResponseOtpModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RemittaActivateResponseOtpModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemittaActivateResponseOtpModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    validateCustomerOtp(model: RemittaActivateResponseOtpModel | null | undefined): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/ValidateCustomerOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCustomerOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCustomerOtp(<any>response_);
                } catch (e) {
                    return <Observable<MessageOut>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageOut>><any>_observableThrow(response_);
        }));
    }

    protected processValidateCustomerOtp(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageOut>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    mandateNotification(model: RemittaMandateNotificationRequestModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/MandateNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMandateNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMandateNotification(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processMandateNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param renewalScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileLifeRenewalSchedule(renewalScheduleForMobile: LifeRenewalScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/PostEllaMobileLifeRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renewalScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileLifeRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileLifeRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileLifeRenewalSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param transRef (optional)
     * @return Success
     */
    getEllaMobileLifeRenewalStreams(transRef: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LifeRenewalService/GetEllaMobileLifeRenewalStreams?";
        if (transRef !== undefined && transRef !== null)
            url_ += "transRef=" + encodeURIComponent("" + transRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEllaMobileLifeRenewalStreams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEllaMobileLifeRenewalStreams(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEllaMobileLifeRenewalStreams(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IMarineServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postMarineSchedule(model: MarineScheduleDto | null | undefined): Observable<MarineScheduleDto>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMarineSchedule(transactionRef: string | null | undefined): Observable<MarineScheduleDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMarinePoliciesFromTqtoNiid(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param code (optional)
     * @return Success
     */
    niidResponse(code: string | null | undefined): Observable<string>;
}

@Injectable()
export class MarineServiceServiceProxy implements IMarineServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postMarineSchedule(model: MarineScheduleDto | null | undefined): Observable<MarineScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/MarineService/PostMarineSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMarineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMarineSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MarineScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarineScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processPostMarineSchedule(response: HttpResponseBase): Observable<MarineScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MarineScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarineScheduleDto>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMarineSchedule(transactionRef: string | null | undefined): Observable<MarineScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/MarineService/GetMarineSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarineSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarineSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MarineScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarineScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMarineSchedule(response: HttpResponseBase): Observable<MarineScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MarineScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarineScheduleDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMarinePoliciesFromTqtoNiid(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MarineService/PushMarinePoliciesFromTqtoNiid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMarinePoliciesFromTqtoNiid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMarinePoliciesFromTqtoNiid(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMarinePoliciesFromTqtoNiid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param code (optional)
     * @return Success
     */
    niidResponse(code: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MarineService/NiidResponse?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNiidResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNiidResponse(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processNiidResponse(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IMoneywiseRateServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: MoneywiseRateRequest | null | undefined): Observable<MoneywiseRateResponse>;
    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getTerms(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getTargetTypes(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getCashBackOptions(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getCashBackOptionsForTerm(term: number): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getTermsFromDate(dateOfBirth: Date): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    get(id: string): Observable<MoneywiseRateDto>;
    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateMoneywiseRateDto | null | undefined): Observable<MoneywiseRateDto>;
    /**
     * @param input (optional)
     * @return Success
     */
    update(input: MoneywiseRateDto | null | undefined): Observable<MoneywiseRateDto>;
    /**
     * @return Success
     */
    delete(id: string): Observable<void>;
}

@Injectable()
export class MoneywiseRateServiceProxy implements IMoneywiseRateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: MoneywiseRateRequest | null | undefined): Observable<MoneywiseRateResponse> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/ComputePremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputePremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputePremium(<any>response_);
                } catch (e) {
                    return <Observable<MoneywiseRateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MoneywiseRateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processComputePremium(response: HttpResponseBase): Observable<MoneywiseRateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoneywiseRateResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoneywiseRateResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenders(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenders(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTerms(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerms(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTerms(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentFrequencies(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetPaymentFrequencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentFrequencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentFrequencies(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentFrequencies(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTargetTypes(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetTargetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTargetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetTypes(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCashBackOptions(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetCashBackOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashBackOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashBackOptions(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashBackOptions(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCashBackOptionsForTerm(term: number): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetCashBackOptionsForTerm?";
        if (term === undefined || term === null)
            throw new Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashBackOptionsForTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashBackOptionsForTerm(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashBackOptionsForTerm(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTermsFromDate(dateOfBirth: Date): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetTermsFromDate?";
        if (dateOfBirth === undefined || dateOfBirth === null)
            throw new Error("The parameter 'dateOfBirth' must be defined and cannot be null.");
        else
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsFromDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsFromDate(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermsFromDate(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    get(id: string): Observable<MoneywiseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MoneywiseRateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MoneywiseRateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MoneywiseRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoneywiseRateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoneywiseRateDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/GetAll?";
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateMoneywiseRateDto | null | undefined): Observable<MoneywiseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<MoneywiseRateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MoneywiseRateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MoneywiseRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoneywiseRateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoneywiseRateDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    update(input: MoneywiseRateDto | null | undefined): Observable<MoneywiseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<MoneywiseRateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MoneywiseRateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MoneywiseRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoneywiseRateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoneywiseRateDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MoneywiseRate/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IMotorProductServiceServiceProxy {
    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number>;
    /**
     * @param numberPlate (optional)
     * @return Success
     */
    getVehicleDetails(numberPlate: string | null | undefined): Observable<FinalResponseModel>;
    /**
     * @param model (optional)
     * @return Success
     */
    postMotorSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postMotorRenewalSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest>;
    /**
     * @param model (optional)
     * @return Success
     */
    postRiskDetails(model: MotorScheduleDto | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMotorSchedule(transactionRef: string | null | undefined): Observable<MotorScheduleDto>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    vehicleVerificationByPolicyNumber(policyNumber: string | null | undefined): Observable<VehicleVerificationDetails>;
    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    vehicleVerificationByRegistrationNumber(registrationNumber: string | null | undefined): Observable<VehicleVerificationDetails>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    verifyVehicleByPolicyNumber(policyNumber: string | null | undefined): Observable<NewVehiclePolicyDetails>;
    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    verifyVehicleByRegistrationNumber(registrationNumber: string | null | undefined): Observable<NewVehiclePolicyDetails>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getMotorTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewMotorTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getMotorTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<MotorTransactionResponse>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromTqtoNiid(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromRetailerToNiid(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromFlexsureToNiid(model: TQNiidModel | null | undefined): Observable<string>;
    /**
     * @param id (optional)
     * @return Success
     */
    policyCancellation(id: string | null | undefined): Observable<string>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getMotorCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyEndorsement(model: VehicleEndorsementRequest | null | undefined): Observable<string>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTqByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTq(): Observable<boolean>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadThirdParty(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<MotorScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmThirdPartyUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<MotorScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filePath (optional)
     * @return Success
     */
    confirmFilePathExistById(clientId: string | null | undefined, transactionRef: string | null | undefined, filePath: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getMotorScheduleValidity(): Observable<string[]>;
    /**
     * @param motorScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileMotorSchedule(motorScheduleForMobile: MotorScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getAutoRenewalDetails(policyNo: string | null | undefined): Observable<AutoRenewalDetails>;
}

@Injectable()
export class MotorProductServiceServiceProxy implements IMotorProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/ComputeThirdPartyMotorPremium?";
        if (bodyType !== undefined && bodyType !== null)
            url_ += "bodyType=" + encodeURIComponent("" + bodyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeThirdPartyMotorPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeThirdPartyMotorPremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeThirdPartyMotorPremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param numberPlate (optional)
     * @return Success
     */
    getVehicleDetails(numberPlate: string | null | undefined): Observable<FinalResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetVehicleDetails?";
        if (numberPlate !== undefined && numberPlate !== null)
            url_ += "numberPlate=" + encodeURIComponent("" + numberPlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleDetails(<any>response_);
                } catch (e) {
                    return <Observable<FinalResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinalResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleDetails(response: HttpResponseBase): Observable<FinalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FinalResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinalResponseModel>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postMotorSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PostMotorSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMotorSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMotorSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostMotorSchedule(response: HttpResponseBase): Observable<MotorScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postMotorRenewalSchedule(model: MotorScheduleRequest | null | undefined): Observable<MotorScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PostMotorRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMotorRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMotorRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostMotorRenewalSchedule(response: HttpResponseBase): Observable<MotorScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleRequest>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postRiskDetails(model: MotorScheduleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PostRiskDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRiskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRiskDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPostRiskDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getMotorSchedule(transactionRef: string | null | undefined): Observable<MotorScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetMotorSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorSchedule(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorSchedule(response: HttpResponseBase): Observable<MotorScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleDto>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    vehicleVerificationByPolicyNumber(policyNumber: string | null | undefined): Observable<VehicleVerificationDetails> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VehicleVerificationByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehicleVerificationByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehicleVerificationByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<VehicleVerificationDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleVerificationDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVehicleVerificationByPolicyNumber(response: HttpResponseBase): Observable<VehicleVerificationDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = VehicleVerificationDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleVerificationDetails>(<any>null);
    }

    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    vehicleVerificationByRegistrationNumber(registrationNumber: string | null | undefined): Observable<VehicleVerificationDetails> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VehicleVerificationByRegistrationNumber?";
        if (registrationNumber !== undefined && registrationNumber !== null)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehicleVerificationByRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehicleVerificationByRegistrationNumber(<any>response_);
                } catch (e) {
                    return <Observable<VehicleVerificationDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleVerificationDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVehicleVerificationByRegistrationNumber(response: HttpResponseBase): Observable<VehicleVerificationDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = VehicleVerificationDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleVerificationDetails>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    verifyVehicleByPolicyNumber(policyNumber: string | null | undefined): Observable<NewVehiclePolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VerifyVehicleByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyVehicleByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyVehicleByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyVehicleByPolicyNumber(response: HttpResponseBase): Observable<NewVehiclePolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NewVehiclePolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewVehiclePolicyDetails>(<any>null);
    }

    /**
     * @param registrationNumber (optional)
     * @return Success
     */
    verifyVehicleByRegistrationNumber(registrationNumber: string | null | undefined): Observable<NewVehiclePolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VerifyVehicleByRegistrationNumber?";
        if (registrationNumber !== undefined && registrationNumber !== null)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyVehicleByRegistrationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyVehicleByRegistrationNumber(<any>response_);
                } catch (e) {
                    return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewVehiclePolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyVehicleByRegistrationNumber(response: HttpResponseBase): Observable<NewVehiclePolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NewVehiclePolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewVehiclePolicyDetails>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getMotorTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewMotorTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetMotorTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewMotorTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewMotorTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorTransactionsWithRange(response: HttpResponseBase): Observable<ViewMotorTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewMotorTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewMotorTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getMotorTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<MotorTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetMotorTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<MotorTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorTransactionDetails(response: HttpResponseBase): Observable<MotorTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorTransactionResponse>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromTqtoNiid(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PushMotorPoliciesFromTqtoNiid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromTqtoNiid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromTqtoNiid(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromTqtoNiid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromRetailerToNiid(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PushMotorPoliciesFromRetailerToNiid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromRetailerToNiid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromRetailerToNiid(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromRetailerToNiid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    pushMotorPoliciesFromFlexsureToNiid(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PushMotorPoliciesFromFlexsureToNiid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorPoliciesFromFlexsureToNiid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorPoliciesFromFlexsureToNiid(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorPoliciesFromFlexsureToNiid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    policyCancellation(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PolicyCancellation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyCancellation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPolicyCancellation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getMotorCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetMotorCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VehiclePolicyCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclePolicyCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclePolicyCancellation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclePolicyCancellation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyEndorsement(model: VehicleEndorsementRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/VehiclePolicyEndorsement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclePolicyEndorsement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclePolicyEndorsement(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclePolicyEndorsement(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTqByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PushMotorTransactionFromFlexsureToTqByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorTransactionFromFlexsureToTqByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorTransactionFromFlexsureToTqByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorTransactionFromFlexsureToTqByPolicyNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    pushMotorTransactionFromFlexsureToTq(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PushMotorTransactionFromFlexsureToTq";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushMotorTransactionFromFlexsureToTq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushMotorTransactionFromFlexsureToTq(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushMotorTransactionFromFlexsureToTq(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadThirdParty(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<MotorScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/UploadThirdPartyAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadThirdParty(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadThirdParty(response: HttpResponseBase): Observable<MotorScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmThirdPartyUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<MotorScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/ConfirmThirdPartyUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmThirdPartyUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmThirdPartyUpload(<any>response_);
                } catch (e) {
                    return <Observable<MotorScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<MotorScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmThirdPartyUpload(response: HttpResponseBase): Observable<MotorScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MotorScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MotorScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filePath (optional)
     * @return Success
     */
    confirmFilePathExistById(clientId: string | null | undefined, transactionRef: string | null | undefined, filePath: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/ConfirmFilePathExistById?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmFilePathExistById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmFilePathExistById(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmFilePathExistById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getMotorScheduleValidity(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetMotorScheduleValidity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotorScheduleValidity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotorScheduleValidity(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMotorScheduleValidity(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param motorScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileMotorSchedule(motorScheduleForMobile: MotorScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/PostEllaMobileMotorSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(motorScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileMotorSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileMotorSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileMotorSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getAutoRenewalDetails(policyNo: string | null | undefined): Observable<AutoRenewalDetails> {
        let url_ = this.baseUrl + "/api/services/app/MotorProductService/GetAutoRenewalDetails?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoRenewalDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoRenewalDetails(<any>response_);
                } catch (e) {
                    return <Observable<AutoRenewalDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<AutoRenewalDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoRenewalDetails(response: HttpResponseBase): Observable<AutoRenewalDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AutoRenewalDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AutoRenewalDetails>(<any>null);
    }
}

export interface INotificationServiceServiceProxy {
    /**
     * @param tr (optional)
     * @return Success
     */
    getReceipt(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getReceiptAsHtml(tr: string | null | undefined): Observable<string>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getCertificateAsHtml(tr: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    downloadStatusOrStatementAsHtml(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    sendStatusOrStatementToEmail(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    downloadEmbassyLetterAsHtml(model: EmbassyLetter | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param country (optional)
     * @param state (optional)
     * @param address (optional)
     * @return Success
     */
    sendEmbassyLetterToEmail(policyNo: string | null | undefined, country: string | null | undefined, state: string | null | undefined, address: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    downloadTaxRebateAsHtml(policyNo: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    sendTaxRebateToEmail(policyNo: string | null | undefined): Observable<string>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getAddressVerification(tr: string | null | undefined): Observable<void>;
    /**
     * @param model (optional)
     * @return Success
     */
    sendSuccessPolicyPaymentSMS(model: PolicyPayment | null | undefined): Observable<void>;
    /**
     * @param url (optional)
     * @return Success
     */
    sendSms(url: string | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTravelCertificate(model: ValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postMotorCertificate(model: ValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postShopCertificate(model: ValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postOfficeCertificate(model: ValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postHomeCertificate(model: ValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postPersonalAccidentCertificate(model: ValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postCovidCertificate(model: ValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postHospitalCashCertificate(model: ValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTermLifeCertificate(model: ValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postGadgetCertificate(model: ValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getAllNewCorporateSavingPlanFromTQ(): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postNcspCertificate(model: ValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postLtaCertificate(model: ValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postFepCertificate(model: ValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postCepCertificate(model: ValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @param cashChequeNumber (optional)
     * @param paymentPlatform (optional)
     * @return Success
     */
    postLifeRenewalEmail(model: ValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null | undefined, isNewClient: boolean, cashChequeNumber: string | null | undefined, paymentPlatform: string | null | undefined, isPaydirect: boolean): Observable<boolean>;
    /**
     * @param model (optional)
     * @param baseUrl (optional)
     * @return Success
     */
    sendSms(model: ValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null | undefined, baseUrl: string | null | undefined): Observable<void>;
    /**
     * @param phone (optional)
     * @param message (optional)
     * @return Success
     */
    sendSmsAsyncNew(phone: string | null | undefined, message: string | null | undefined): Observable<void>;
    /**
     * @param model (optional)
     * @param policyNumber (optional)
     * @param scheduleType (optional)
     * @return Success
     */
    sendClientVerificationLinkWithPolicy(model: ValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null | undefined, policyNumber: string | null | undefined, scheduleType: string | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @param scheduleType (optional)
     * @return Success
     */
    sendFailedTransaction(model: ValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null | undefined, scheduleType: string | null | undefined, isRetry: boolean): Observable<boolean>;
    /**
     * @param user (optional)
     * @param role (optional)
     * @return Success
     */
    sendVerificationLinkToClient(user: User | null | undefined, role: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string>;
}
export interface IOfficeProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postOfficeSchedule(model: OfficeScheduleRequest | null | undefined): Observable<OfficeScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getOfficeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewOfficeTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getOfficeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<OfficeTransactionResponse>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getOfficeCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadOffice(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<OfficeScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmOfficeUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<OfficeScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param officeScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileOfficeSchedule(officeScheduleForMobile: OfficeScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
}

@Injectable()
export class OfficeProductServiceServiceProxy implements IOfficeProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postOfficeSchedule(model: OfficeScheduleRequest | null | undefined): Observable<OfficeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/PostOfficeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOfficeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOfficeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<OfficeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostOfficeSchedule(response: HttpResponseBase): Observable<OfficeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getOfficeTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewOfficeTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/GetOfficeTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewOfficeTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewOfficeTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeTransactionsWithRange(response: HttpResponseBase): Observable<ViewOfficeTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewOfficeTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewOfficeTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getOfficeTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<OfficeTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/GetOfficeTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<OfficeTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeTransactionDetails(response: HttpResponseBase): Observable<OfficeTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeTransactionResponse>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getOfficeCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/GetOfficeCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetOfficeCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadOffice(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<OfficeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/UploadOfficeAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOffice(<any>response_);
                } catch (e) {
                    return <Observable<OfficeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadOffice(response: HttpResponseBase): Observable<OfficeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmOfficeUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<OfficeScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/ConfirmOfficeUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmOfficeUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmOfficeUpload(<any>response_);
                } catch (e) {
                    return <Observable<OfficeScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<OfficeScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmOfficeUpload(response: HttpResponseBase): Observable<OfficeScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OfficeScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfficeScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param officeScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileOfficeSchedule(officeScheduleForMobile: OfficeScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/OfficeProductService/PostEllaMobileOfficeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(officeScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileOfficeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileOfficeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileOfficeSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }
}

export interface IPartnerServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerPayment(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
}

@Injectable()
export class PartnerServiceServiceProxy implements IPartnerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerPayment(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/PartnerService/FinalizePartnerPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerPayment(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerPayment(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }
}

export interface IPayArenaServiceServiceProxy {
    /**
     * @return Success
     */
    catalog(): Observable<PayArenaCatalog[]>;
    /**
     * @param verify (optional)
     * @return Success
     */
    verify(verify: PayArenaVerifyRequest | null | undefined): Observable<PayArenaVerificationResponse>;
    /**
     * @param notification (optional)
     * @return Success
     */
    notify(notification: PayArenaNotification | null | undefined): Observable<PayArenaPolicyDetails>;
}

@Injectable()
export class PayArenaServiceServiceProxy implements IPayArenaServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    catalog(): Observable<PayArenaCatalog[]> {
        let url_ = this.baseUrl + "/api/services/app/PayArenaService/Catalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalog(<any>response_);
                } catch (e) {
                    return <Observable<PayArenaCatalog[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayArenaCatalog[]>><any>_observableThrow(response_);
        }));
    }

    protected processCatalog(response: HttpResponseBase): Observable<PayArenaCatalog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayArenaCatalog.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayArenaCatalog[]>(<any>null);
    }

    /**
     * @param verify (optional)
     * @return Success
     */
    verify(verify: PayArenaVerifyRequest | null | undefined): Observable<PayArenaVerificationResponse> {
        let url_ = this.baseUrl + "/api/services/app/PayArenaService/Verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verify);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerify(<any>response_);
                } catch (e) {
                    return <Observable<PayArenaVerificationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayArenaVerificationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processVerify(response: HttpResponseBase): Observable<PayArenaVerificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PayArenaVerificationResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayArenaVerificationResponse>(<any>null);
    }

    /**
     * @param notification (optional)
     * @return Success
     */
    notify(notification: PayArenaNotification | null | undefined): Observable<PayArenaPolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/PayArenaService/Notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notification);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotify(<any>response_);
                } catch (e) {
                    return <Observable<PayArenaPolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayArenaPolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processNotify(response: HttpResponseBase): Observable<PayArenaPolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PayArenaPolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayArenaPolicyDetails>(<any>null);
    }
}

export interface IPaydirectAndQuickTellerServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    sendPaydirectAndQuickTellerReceipt(model: TQNiidModel | null | undefined): Observable<string>;
}

@Injectable()
export class PaydirectAndQuickTellerServiceServiceProxy implements IPaydirectAndQuickTellerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    sendPaydirectAndQuickTellerReceipt(model: TQNiidModel | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PaydirectAndQuickTellerService/SendPaydirectAndQuickTellerReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaydirectAndQuickTellerReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaydirectAndQuickTellerReceipt(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendPaydirectAndQuickTellerReceipt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IPersonalAccidentProductServiceServiceProxy {
    /**
     * @return Success
     */
    getPersonalAccidentRates(): Observable<NameAmountModel[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    postPersonalAccidentSchedule(model: PersonalAccidentScheduleRequest | null | undefined): Observable<PersonalAccidentScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getPersonalAccidentTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewPersonalAccidentTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getPersonalAccidentTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<PersonalAccidentTransactionResponse>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadPersonalAccident(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<PersonalAccidentScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmPersonalAccidentUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<PersonalAccidentScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getPersonalAccidentCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param model (optional)
     * @return Success
     */
    buyDomesticTravel(model: DomesticTravelScheduleRequest | null | undefined): Observable<DomesticTravelScheduleResponse>;
    /**
     * @param travelScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobilePersonalAccidentSchedule(travelScheduleForMobile: PersonalAccidentScheduleForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param tr (optional)
     * @return Success
     */
    postPersonalAccidentCertificate(tr: string | null | undefined): Observable<void>;
}

@Injectable()
export class PersonalAccidentProductServiceServiceProxy implements IPersonalAccidentProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    getPersonalAccidentRates(): Observable<NameAmountModel[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/GetPersonalAccidentRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentRates(<any>response_);
                } catch (e) {
                    return <Observable<NameAmountModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameAmountModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentRates(response: HttpResponseBase): Observable<NameAmountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameAmountModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameAmountModel[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postPersonalAccidentSchedule(model: PersonalAccidentScheduleRequest | null | undefined): Observable<PersonalAccidentScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/PostPersonalAccidentSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPersonalAccidentSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPersonalAccidentSchedule(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostPersonalAccidentSchedule(response: HttpResponseBase): Observable<PersonalAccidentScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getPersonalAccidentTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewPersonalAccidentTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/GetPersonalAccidentTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewPersonalAccidentTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewPersonalAccidentTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentTransactionsWithRange(response: HttpResponseBase): Observable<ViewPersonalAccidentTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewPersonalAccidentTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewPersonalAccidentTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getPersonalAccidentTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<PersonalAccidentTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/GetPersonalAccidentTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentTransactionDetails(response: HttpResponseBase): Observable<PersonalAccidentTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentTransactionResponse>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadPersonalAccident(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<PersonalAccidentScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/UploadPersonalAccidentAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPersonalAccident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPersonalAccident(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadPersonalAccident(response: HttpResponseBase): Observable<PersonalAccidentScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmPersonalAccidentUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<PersonalAccidentScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/ConfirmPersonalAccidentUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPersonalAccidentUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPersonalAccidentUpload(<any>response_);
                } catch (e) {
                    return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalAccidentScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPersonalAccidentUpload(response: HttpResponseBase): Observable<PersonalAccidentScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonalAccidentScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalAccidentScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/OptOut?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOptOut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processOptOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getPersonalAccidentCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/GetPersonalAccidentCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalAccidentCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalAccidentCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalAccidentCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    buyDomesticTravel(model: DomesticTravelScheduleRequest | null | undefined): Observable<DomesticTravelScheduleResponse> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/BuyDomesticTravel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyDomesticTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyDomesticTravel(<any>response_);
                } catch (e) {
                    return <Observable<DomesticTravelScheduleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DomesticTravelScheduleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processBuyDomesticTravel(response: HttpResponseBase): Observable<DomesticTravelScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DomesticTravelScheduleResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DomesticTravelScheduleResponse>(<any>null);
    }

    /**
     * @param travelScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobilePersonalAccidentSchedule(travelScheduleForMobile: PersonalAccidentScheduleForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/PostEllaMobilePersonalAccidentSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(travelScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobilePersonalAccidentSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobilePersonalAccidentSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobilePersonalAccidentSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    postPersonalAccidentCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAccidentProductService/PostPersonalAccidentCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPersonalAccidentCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPersonalAccidentCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPostPersonalAccidentCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IPolicyServiceServiceProxy {
    /**
     * @return Success
     */
    generatePolicyNumber(): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    insertPolicyTemp(model: Policy | null | undefined): Observable<string>;
    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    getPolicyPayments(policyNo: string | null | undefined): Observable<PolicyPayments>;
    /**
     * @param policyId (optional)
     * @return Success
     */
    getPolicy(policyId: string | null | undefined): Observable<Policy>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    ginPolicyEnquiry(policyNo: string | null | undefined): Observable<AllPolicy>;
}

@Injectable()
export class PolicyServiceServiceProxy implements IPolicyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    generatePolicyNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/GeneratePolicyNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePolicyNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    insertPolicyTemp(model: Policy | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/InsertPolicyTemp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertPolicyTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertPolicyTemp(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processInsertPolicyTemp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    vehiclePolicyCancellation(model: VehicleCancellationRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/VehiclePolicyCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclePolicyCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclePolicyCancellation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclePolicyCancellation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    getPolicyPayments(policyNo: string | null | undefined): Observable<PolicyPayments> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/GetPolicyPayments?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyPayments(<any>response_);
                } catch (e) {
                    return <Observable<PolicyPayments>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyPayments>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicyPayments(response: HttpResponseBase): Observable<PolicyPayments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyPayments.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyPayments>(<any>null);
    }

    /**
     * @param policyId (optional)
     * @return Success
     */
    getPolicy(policyId: string | null | undefined): Observable<Policy> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/GetPolicy?";
        if (policyId !== undefined && policyId !== null)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicy(<any>response_);
                } catch (e) {
                    return <Observable<Policy>><any>_observableThrow(e);
                }
            } else
                return <Observable<Policy>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicy(response: HttpResponseBase): Observable<Policy> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Policy.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Policy>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    ginPolicyEnquiry(policyNo: string | null | undefined): Observable<AllPolicy> {
        let url_ = this.baseUrl + "/api/services/app/PolicyService/GinPolicyEnquiry?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGinPolicyEnquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGinPolicyEnquiry(<any>response_);
                } catch (e) {
                    return <Observable<AllPolicy>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllPolicy>><any>_observableThrow(response_);
        }));
    }

    protected processGinPolicyEnquiry(response: HttpResponseBase): Observable<AllPolicy> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AllPolicy.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllPolicy>(<any>null);
    }
}

export interface IPremiumCalculatorServiceProxy {
    /**
     * @return Success
     */
    fepProduct(): Observable<void>;
    /**
     * @return Success
     */
    getLiveProducts(): Observable<LifeProductDto[]>;
    /**
     * @param productCode (optional)
     * @return Success
     */
    getProductOptions(productCode: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @param productCode (optional)
     * @return Success
     */
    getProductCoverCode(productCode: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @param productCode (optional)
     * @return Success
     */
    getPremiumMass(productCode: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @param productOption (optional)
     * @return Success
     */
    getMainProductCoverTypes(productOption: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @return Success
     */
    getProductTerms(opt_pmas_code: number, opt_pct_code: number, opt_pop_code: number): Observable<LifeProductListDto>;
    /**
     * @param productOption (optional)
     * @return Success
     */
    getOtherProductCoverTypes(productOption: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @param productCode (optional)
     * @param productCoverTypes (optional)
     * @return Success
     */
    getSingleProductCoverTypes(productCode: string | null | undefined, productCoverTypes: string | null | undefined): Observable<LifeProductListDto>;
    /**
     * @param premiumMass (optional)
     * @param coverTypes (optional)
     * @param productOptions (optional)
     * @return Success
     */
    getPremiumRateTable(premiumMass: string | null | undefined, coverTypes: string | null | undefined, productOptions: string | null | undefined, age: number): Observable<LifeProductListDto>;
    /**
     * @return Success
     */
    getTargetTypes(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getTermFromAge(dateOfBirth: number): Observable<number>;
    /**
     * @return Success
     */
    getFrequency(): Observable<string[]>;
    /**
     * @param productParams (optional)
     * @return Success
     */
    calCulateProductsPremium(productParams: ProductParams | null | undefined): Observable<CalculatedResult>;
    /**
     * @param proposalRequest (optional)
     * @return Success
     */
    getProposalNumber(proposalRequest: ProposalRequest | null | undefined): Observable<ProposalDto>;
    /**
     * @param proposalRequest (optional)
     * @return Success
     */
    generateProposalNumber(proposalRequest: ProposalRequest | null | undefined): Observable<ProposalDto>;
    /**
     * @param agentCode (optional)
     * @return Success
     */
    geBranchCode(agentCode: string | null | undefined): Observable<BranchDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    calculateNcspPremium(model: NcspCalculatedRequest | null | undefined): Observable<NcspCalculatedResult>;
    /**
     * @param model (optional)
     * @return Success
     */
    sendQuoteEmail(model: QuoteMailModel | null | undefined): Observable<boolean>;
    /**
     * @param ncspScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileNCSPSchedule(ncspScheduleForMobile: NscpScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param fepScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileFEPSchedule(fepScheduleForMobile: FepScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param cepScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileCEPSchedule(cepScheduleForMobile: CepScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param dapScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileDAPSchedule(dapScheduleForMobile: DapScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param ltaScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileLTASchedule(ltaScheduleForMobile: LtaScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param mwScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileMWSchedule(mwScheduleForMobile: MwScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
}

@Injectable()
export class PremiumCalculatorServiceProxy implements IPremiumCalculatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    fepProduct(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/FepProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFepProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFepProduct(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processFepProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getLiveProducts(): Observable<LifeProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetLiveProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveProducts(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLiveProducts(response: HttpResponseBase): Observable<LifeProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifeProductDto.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductDto[]>(<any>null);
    }

    /**
     * @param productCode (optional)
     * @return Success
     */
    getProductOptions(productCode: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetProductOptions?";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOptions(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductOptions(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param productCode (optional)
     * @return Success
     */
    getProductCoverCode(productCode: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetProductCoverCode?";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductCoverCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCoverCode(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductCoverCode(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param productCode (optional)
     * @return Success
     */
    getPremiumMass(productCode: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetPremiumMass?";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumMass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumMass(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPremiumMass(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param productOption (optional)
     * @return Success
     */
    getMainProductCoverTypes(productOption: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetMainProductCoverTypes?";
        if (productOption !== undefined && productOption !== null)
            url_ += "productOption=" + encodeURIComponent("" + productOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainProductCoverTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainProductCoverTypes(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMainProductCoverTypes(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProductTerms(opt_pmas_code: number, opt_pct_code: number, opt_pop_code: number): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetProductTerms?";
        if (opt_pmas_code === undefined || opt_pmas_code === null)
            throw new Error("The parameter 'opt_pmas_code' must be defined and cannot be null.");
        else
            url_ += "opt_pmas_code=" + encodeURIComponent("" + opt_pmas_code) + "&";
        if (opt_pct_code === undefined || opt_pct_code === null)
            throw new Error("The parameter 'opt_pct_code' must be defined and cannot be null.");
        else
            url_ += "opt_pct_code=" + encodeURIComponent("" + opt_pct_code) + "&";
        if (opt_pop_code === undefined || opt_pop_code === null)
            throw new Error("The parameter 'opt_pop_code' must be defined and cannot be null.");
        else
            url_ += "opt_pop_code=" + encodeURIComponent("" + opt_pop_code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTerms(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductTerms(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param productOption (optional)
     * @return Success
     */
    getOtherProductCoverTypes(productOption: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetOtherProductCoverTypes?";
        if (productOption !== undefined && productOption !== null)
            url_ += "productOption=" + encodeURIComponent("" + productOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherProductCoverTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherProductCoverTypes(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOtherProductCoverTypes(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param productCode (optional)
     * @param productCoverTypes (optional)
     * @return Success
     */
    getSingleProductCoverTypes(productCode: string | null | undefined, productCoverTypes: string | null | undefined): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetSingleProductCoverTypes?";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (productCoverTypes !== undefined && productCoverTypes !== null)
            url_ += "productCoverTypes=" + encodeURIComponent("" + productCoverTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSingleProductCoverTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSingleProductCoverTypes(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSingleProductCoverTypes(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @param premiumMass (optional)
     * @param coverTypes (optional)
     * @param productOptions (optional)
     * @return Success
     */
    getPremiumRateTable(premiumMass: string | null | undefined, coverTypes: string | null | undefined, productOptions: string | null | undefined, age: number): Observable<LifeProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetPremiumRateTable?";
        if (premiumMass !== undefined && premiumMass !== null)
            url_ += "premiumMass=" + encodeURIComponent("" + premiumMass) + "&";
        if (coverTypes !== undefined && coverTypes !== null)
            url_ += "coverTypes=" + encodeURIComponent("" + coverTypes) + "&";
        if (productOptions !== undefined && productOptions !== null)
            url_ += "productOptions=" + encodeURIComponent("" + productOptions) + "&";
        if (age === undefined || age === null)
            throw new Error("The parameter 'age' must be defined and cannot be null.");
        else
            url_ += "age=" + encodeURIComponent("" + age) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPremiumRateTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPremiumRateTable(<any>response_);
                } catch (e) {
                    return <Observable<LifeProductListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LifeProductListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPremiumRateTable(response: HttpResponseBase): Observable<LifeProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LifeProductListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LifeProductListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTargetTypes(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetTargetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTargetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetTypes(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTermFromAge(dateOfBirth: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetTermFromAge?";
        if (dateOfBirth === undefined || dateOfBirth === null)
            throw new Error("The parameter 'dateOfBirth' must be defined and cannot be null.");
        else
            url_ += "dateOfBirth=" + encodeURIComponent("" + dateOfBirth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermFromAge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermFromAge(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermFromAge(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getFrequency(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetFrequency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrequency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrequency(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFrequency(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param productParams (optional)
     * @return Success
     */
    calCulateProductsPremium(productParams: ProductParams | null | undefined): Observable<CalculatedResult> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/CalCulateProductsPremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalCulateProductsPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalCulateProductsPremium(<any>response_);
                } catch (e) {
                    return <Observable<CalculatedResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalculatedResult>><any>_observableThrow(response_);
        }));
    }

    protected processCalCulateProductsPremium(response: HttpResponseBase): Observable<CalculatedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalculatedResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalculatedResult>(<any>null);
    }

    /**
     * @param proposalRequest (optional)
     * @return Success
     */
    getProposalNumber(proposalRequest: ProposalRequest | null | undefined): Observable<ProposalDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GetProposalNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proposalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProposalNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProposalNumber(<any>response_);
                } catch (e) {
                    return <Observable<ProposalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProposalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProposalNumber(response: HttpResponseBase): Observable<ProposalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProposalDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProposalDto>(<any>null);
    }

    /**
     * @param proposalRequest (optional)
     * @return Success
     */
    generateProposalNumber(proposalRequest: ProposalRequest | null | undefined): Observable<ProposalDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GenerateProposalNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proposalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateProposalNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateProposalNumber(<any>response_);
                } catch (e) {
                    return <Observable<ProposalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProposalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateProposalNumber(response: HttpResponseBase): Observable<ProposalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProposalDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProposalDto>(<any>null);
    }

    /**
     * @param agentCode (optional)
     * @return Success
     */
    geBranchCode(agentCode: string | null | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/GeBranchCode?";
        if (agentCode !== undefined && agentCode !== null)
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeBranchCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeBranchCode(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGeBranchCode(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BranchDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    calculateNcspPremium(model: NcspCalculatedRequest | null | undefined): Observable<NcspCalculatedResult> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/CalculateNcspPremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateNcspPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateNcspPremium(<any>response_);
                } catch (e) {
                    return <Observable<NcspCalculatedResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<NcspCalculatedResult>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateNcspPremium(response: HttpResponseBase): Observable<NcspCalculatedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NcspCalculatedResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NcspCalculatedResult>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    sendQuoteEmail(model: QuoteMailModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/SendQuoteEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendQuoteEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendQuoteEmail(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSendQuoteEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param ncspScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileNCSPSchedule(ncspScheduleForMobile: NscpScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileNCSPSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ncspScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileNCSPSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileNCSPSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileNCSPSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param fepScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileFEPSchedule(fepScheduleForMobile: FepScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileFEPSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fepScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileFEPSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileFEPSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileFEPSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param cepScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileCEPSchedule(cepScheduleForMobile: CepScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileCEPSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cepScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileCEPSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileCEPSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileCEPSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param dapScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileDAPSchedule(dapScheduleForMobile: DapScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileDAPSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dapScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileDAPSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileDAPSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileDAPSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param ltaScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileLTASchedule(ltaScheduleForMobile: LtaScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileLTASchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ltaScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileLTASchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileLTASchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileLTASchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param mwScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileMWSchedule(mwScheduleForMobile: MwScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/PremiumCalculator/PostEllaMobileMWSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mwScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileMWSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileMWSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileMWSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }
}

export interface IProductServiceServiceProxy {
    /**
     * @return Success
     */
    getProductSingleSubClassCoverType(id: string): Observable<ProductSubClassCoverTypesModelFinal>;
    /**
     * @return Success
     */
    getProductSingleSubClassCoverTypeWithKey(): Observable<ProductSubClassCoverTypesModelFinal>;
    /**
     * @return Success
     */
    getPartnerProductSingleSubClassCoverTypeWithKey(productId: string): Observable<ProductSubClassCoverTypesModelFinal>;
    /**
     * @return Success
     */
    getComprehensiveMotorRates(): Observable<PremiumRateResult[]>;
    /**
     * @return Success
     */
    getProductSubClassCoverTypes(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]>;
    /**
     * @return Success
     */
    getPartnerProductSubClassCoverTypesWithKey(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]>;
    /**
     * @return Success
     */
    getCoverTypePremiumRate(productId: string): Observable<PremiumRateResult[]>;
    /**
     * @param frequency (optional)
     * @return Success
     */
    computeFixedPremium(subclassSectCovtypeId: string, frequency: string | null | undefined): Observable<number>;
    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: PremiumModel | null | undefined): Observable<number>;
    /**
     * @return Success
     */
    getBusinessClasses(): Observable<BusinessClass[]>;
    /**
     * @return Success
     */
    getClasses(): Observable<Class[]>;
    /**
     * @return Success
     */
    getProducts(): Observable<GetProductResult[]>;
    /**
     * @param name (optional)
     * @return Success
     */
    getProductByName(name: string | null | undefined): Observable<GetProductResult>;
    /**
     * @return Success
     */
    getProductSubClassCoverTypesNew(): Observable<ProductSubClassCoverTypesModelFinal[]>;
}

@Injectable()
export class ProductServiceServiceProxy implements IProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    getProductSingleSubClassCoverType(id: string): Observable<ProductSubClassCoverTypesModelFinal> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProductSingleSubClassCoverType?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSingleSubClassCoverType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSingleSubClassCoverType(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSingleSubClassCoverType(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductSubClassCoverTypesModelFinal.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSingleSubClassCoverTypeWithKey(): Observable<ProductSubClassCoverTypesModelFinal> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProductSingleSubClassCoverTypeWithKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSingleSubClassCoverTypeWithKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSingleSubClassCoverTypeWithKey(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSingleSubClassCoverTypeWithKey(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductSubClassCoverTypesModelFinal.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal>(<any>null);
    }

    /**
     * @return Success
     */
    getPartnerProductSingleSubClassCoverTypeWithKey(productId: string): Observable<ProductSubClassCoverTypesModelFinal> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetPartnerProductSingleSubClassCoverTypeWithKey?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerProductSingleSubClassCoverTypeWithKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerProductSingleSubClassCoverTypeWithKey(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerProductSingleSubClassCoverTypeWithKey(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductSubClassCoverTypesModelFinal.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal>(<any>null);
    }

    /**
     * @return Success
     */
    getComprehensiveMotorRates(): Observable<PremiumRateResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetComprehensiveMotorRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComprehensiveMotorRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComprehensiveMotorRates(<any>response_);
                } catch (e) {
                    return <Observable<PremiumRateResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PremiumRateResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetComprehensiveMotorRates(response: HttpResponseBase): Observable<PremiumRateResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PremiumRateResult.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PremiumRateResult[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSubClassCoverTypes(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProductSubClassCoverTypes?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSubClassCoverTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSubClassCoverTypes(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSubClassCoverTypes(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductSubClassCoverTypesModelFinal.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPartnerProductSubClassCoverTypesWithKey(productId: string): Observable<ProductSubClassCoverTypesModelFinal[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetPartnerProductSubClassCoverTypesWithKey?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerProductSubClassCoverTypesWithKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerProductSubClassCoverTypesWithKey(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPartnerProductSubClassCoverTypesWithKey(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductSubClassCoverTypesModelFinal.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCoverTypePremiumRate(productId: string): Observable<PremiumRateResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetCoverTypePremiumRate?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverTypePremiumRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverTypePremiumRate(<any>response_);
                } catch (e) {
                    return <Observable<PremiumRateResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PremiumRateResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverTypePremiumRate(response: HttpResponseBase): Observable<PremiumRateResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PremiumRateResult.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PremiumRateResult[]>(<any>null);
    }

    /**
     * @param frequency (optional)
     * @return Success
     */
    computeFixedPremium(subclassSectCovtypeId: string, frequency: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/ComputeFixedPremium?";
        if (subclassSectCovtypeId === undefined || subclassSectCovtypeId === null)
            throw new Error("The parameter 'subclassSectCovtypeId' must be defined and cannot be null.");
        else
            url_ += "subclassSectCovtypeId=" + encodeURIComponent("" + subclassSectCovtypeId) + "&";
        if (frequency !== undefined && frequency !== null)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeFixedPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeFixedPremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeFixedPremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    computePremium(model: PremiumModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/ComputePremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputePremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputePremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputePremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getBusinessClasses(): Observable<BusinessClass[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetBusinessClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessClasses(<any>response_);
                } catch (e) {
                    return <Observable<BusinessClass[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessClass[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBusinessClasses(response: HttpResponseBase): Observable<BusinessClass[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessClass.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessClass[]>(<any>null);
    }

    /**
     * @return Success
     */
    getClasses(): Observable<Class[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClasses(<any>response_);
                } catch (e) {
                    return <Observable<Class[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Class[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClasses(response: HttpResponseBase): Observable<Class[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Class.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Class[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProducts(): Observable<GetProductResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(<any>response_);
                } catch (e) {
                    return <Observable<GetProductResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<GetProductResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProductResult.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductResult[]>(<any>null);
    }

    /**
     * @param name (optional)
     * @return Success
     */
    getProductByName(name: string | null | undefined): Observable<GetProductResult> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProductByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByName(<any>response_);
                } catch (e) {
                    return <Observable<GetProductResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductByName(response: HttpResponseBase): Observable<GetProductResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProductResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductResult>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSubClassCoverTypesNew(): Observable<ProductSubClassCoverTypesModelFinal[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductService/GetProductSubClassCoverTypesNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSubClassCoverTypesNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSubClassCoverTypesNew(<any>response_);
                } catch (e) {
                    return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSubClassCoverTypesModelFinal[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSubClassCoverTypesNew(response: HttpResponseBase): Observable<ProductSubClassCoverTypesModelFinal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductSubClassCoverTypesModelFinal.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSubClassCoverTypesModelFinal[]>(<any>null);
    }
}

export interface IRavePaymentServiceServiceProxy {
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForLifeRenewal(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param transactionFlwRef (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForRecurring(transactionFlwRef: string | null | undefined, transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param initiatePayment (optional)
     * @return Success
     */
    initiatePayment(initiatePayment: InitiatePaymentDto | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param initiatePayment (optional)
     * @return Success
     */
    charhePaymentWithPIN(initiatePayment: InitiatePaymentDto | null | undefined): Observable<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param validatecharge (optional)
     * @return Success
     */
    validatechargeWithOtp(validatecharge: ValidatechargeInput | null | undefined): Observable<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
}

@Injectable()
export class RavePaymentServiceServiceProxy implements IRavePaymentServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/FinalizeFlutterwavePayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePayment(response: HttpResponseBase): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForLifeRenewal(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/FinalizeFlutterwavePaymentForLifeRenewal?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePaymentForLifeRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePaymentForLifeRenewal(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePaymentForLifeRenewal(response: HttpResponseBase): Observable<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param transactionFlwRef (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeFlutterwavePaymentForRecurring(transactionFlwRef: string | null | undefined, transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/FinalizeFlutterwavePaymentForRecurring?";
        if (transactionFlwRef !== undefined && transactionFlwRef !== null)
            url_ += "transactionFlwRef=" + encodeURIComponent("" + transactionFlwRef) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeFlutterwavePaymentForRecurring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeFlutterwavePaymentForRecurring(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeFlutterwavePaymentForRecurring(response: HttpResponseBase): Observable<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param initiatePayment (optional)
     * @return Success
     */
    initiatePayment(initiatePayment: InitiatePaymentDto | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/InitiatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initiatePayment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiatePayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processInitiatePayment(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param initiatePayment (optional)
     * @return Success
     */
    charhePaymentWithPIN(initiatePayment: InitiatePaymentDto | null | undefined): Observable<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/CharhePaymentWithPIN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(initiatePayment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCharhePaymentWithPIN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCharhePaymentWithPIN(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processCharhePaymentWithPIN(response: HttpResponseBase): Observable<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param validatecharge (optional)
     * @return Success
     */
    validatechargeWithOtp(validatecharge: ValidatechargeInput | null | undefined): Observable<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/RavePaymentService/ValidatechargeWithOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validatecharge);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatechargeWithOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatechargeWithOtp(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processValidatechargeWithOtp(response: HttpResponseBase): Observable<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }
}

export interface IRenewalServiceProxy {
    /**
     * @param renewalInputModel (optional)
     * @return Success
     */
    validateRenewalPolicy(renewalInputModel: RenewalInputModel | null | undefined): Observable<RenewalDtoViewModel>;
    /**
     * @param policyNumber (optional)
     * @param auth (optional)
     * @return Success
     */
    validateRenewalByPolicy(policyNumber: string | null | undefined, auth: string | null | undefined): Observable<RenewalDtoViewModel>;
    /**
     * @param renewalInputModel (optional)
     * @return Success
     */
    getPolicyDetails(renewalInputModel: RenewalInputModel | null | undefined): Observable<RenewalDtoViewModel>;
    /**
     * @param inputSchedule (optional)
     * @return Success
     */
    postLiveRenewalSchedule(inputSchedule: LifeRenewalTran | null | undefined): Observable<PostLifeRenewalViewModel>;
}

@Injectable()
export class RenewalServiceProxy implements IRenewalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param renewalInputModel (optional)
     * @return Success
     */
    validateRenewalPolicy(renewalInputModel: RenewalInputModel | null | undefined): Observable<RenewalDtoViewModel> {
        let url_ = this.baseUrl + "/api/services/app/Renewal/ValidateRenewalPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renewalInputModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRenewalPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRenewalPolicy(<any>response_);
                } catch (e) {
                    return <Observable<RenewalDtoViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RenewalDtoViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidateRenewalPolicy(response: HttpResponseBase): Observable<RenewalDtoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RenewalDtoViewModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenewalDtoViewModel>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @param auth (optional)
     * @return Success
     */
    validateRenewalByPolicy(policyNumber: string | null | undefined, auth: string | null | undefined): Observable<RenewalDtoViewModel> {
        let url_ = this.baseUrl + "/api/services/app/Renewal/ValidateRenewalByPolicy?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (auth !== undefined && auth !== null)
            url_ += "auth=" + encodeURIComponent("" + auth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRenewalByPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRenewalByPolicy(<any>response_);
                } catch (e) {
                    return <Observable<RenewalDtoViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RenewalDtoViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidateRenewalByPolicy(response: HttpResponseBase): Observable<RenewalDtoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RenewalDtoViewModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenewalDtoViewModel>(<any>null);
    }

    /**
     * @param renewalInputModel (optional)
     * @return Success
     */
    getPolicyDetails(renewalInputModel: RenewalInputModel | null | undefined): Observable<RenewalDtoViewModel> {
        let url_ = this.baseUrl + "/api/services/app/Renewal/GetPolicyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renewalInputModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyDetails(<any>response_);
                } catch (e) {
                    return <Observable<RenewalDtoViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RenewalDtoViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicyDetails(response: HttpResponseBase): Observable<RenewalDtoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RenewalDtoViewModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenewalDtoViewModel>(<any>null);
    }

    /**
     * @param inputSchedule (optional)
     * @return Success
     */
    postLiveRenewalSchedule(inputSchedule: LifeRenewalTran | null | undefined): Observable<PostLifeRenewalViewModel> {
        let url_ = this.baseUrl + "/api/services/app/Renewal/PostLiveRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLiveRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLiveRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<PostLifeRenewalViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PostLifeRenewalViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostLiveRenewalSchedule(response: HttpResponseBase): Observable<PostLifeRenewalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PostLifeRenewalViewModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PostLifeRenewalViewModel>(<any>null);
    }
}

export interface IRoleServiceProxy {
    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto>;
    /**
     * @param input (optional)
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto>;
    /**
     * @return Success
     */
    delete(id: number): Observable<void>;
    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @return Success
     */
    get(id: number): Observable<RoleDto>;
    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
}

@Injectable()
export class RoleServiceProxy implements IRoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    get(id: number): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export interface ISchedulerServiceServiceProxy {
    /**
     * @return Success
     */
    postDailyAsyncRequest(): Observable<string>;
    /**
     * @return Success
     */
    postRecurringAsyncRequest(): Observable<string>;
    /**
     * @return Success
     */
    postMarineAsyncRequest(): Observable<string>;
}

@Injectable()
export class SchedulerServiceServiceProxy implements ISchedulerServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    postDailyAsyncRequest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerService/PostDailyAsyncRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDailyAsyncRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDailyAsyncRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostDailyAsyncRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    postRecurringAsyncRequest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerService/PostRecurringAsyncRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRecurringAsyncRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRecurringAsyncRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostRecurringAsyncRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    postMarineAsyncRequest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerService/PostMarineAsyncRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMarineAsyncRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMarineAsyncRequest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostMarineAsyncRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IShopProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    postShopSchedule(model: ShopScheduleRequest | null | undefined): Observable<ShopScheduleRequest>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getShopTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewShopTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getShopTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<ShopTransactionResponse>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getShopCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadShop(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<ShopScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmShopUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<ShopScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param shopScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileShopSchedule(shopScheduleForMobile: ShopScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
}

@Injectable()
export class ShopProductServiceServiceProxy implements IShopProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postShopSchedule(model: ShopScheduleRequest | null | undefined): Observable<ShopScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/PostShopSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostShopSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostShopSchedule(<any>response_);
                } catch (e) {
                    return <Observable<ShopScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostShopSchedule(response: HttpResponseBase): Observable<ShopScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopScheduleRequest>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getShopTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewShopTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/GetShopTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewShopTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewShopTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopTransactionsWithRange(response: HttpResponseBase): Observable<ViewShopTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewShopTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewShopTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getShopTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<ShopTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/GetShopTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<ShopTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopTransactionDetails(response: HttpResponseBase): Observable<ShopTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopTransactionResponse>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getShopCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/GetShopCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShopCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadShop(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<ShopScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/UploadShopAsync?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadShop(<any>response_);
                } catch (e) {
                    return <Observable<ShopScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadShop(response: HttpResponseBase): Observable<ShopScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmShopUpload(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<ShopScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/ConfirmShopUpload?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmShopUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmShopUpload(<any>response_);
                } catch (e) {
                    return <Observable<ShopScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShopScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmShopUpload(response: HttpResponseBase): Observable<ShopScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShopScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShopScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param shopScheduleForMobile (optional)
     * @return Success
     */
    postEllaMobileShopSchedule(shopScheduleForMobile: ShopScheduleRequestForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/ShopProductService/PostEllaMobileShopSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shopScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaMobileShopSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaMobileShopSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaMobileShopSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }
}

export interface ITermAssuranceServiceServiceProxy {
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionBeneficiary(transactionRef: string | null | undefined): Observable<BeneficiaryUpdateModel>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    updateBeneficiary(transactionRef: string | null | undefined): Observable<boolean>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTermLifeSchedule(model: TermLifeRequest | null | undefined): Observable<TermLifeRequest>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getTermLifeCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTermLifeTransactions(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<TermLifeTransaction[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTermLifeRenewalSchedule(model: TermLifeRequest | null | undefined): Observable<TermLifeRequest>;
}

@Injectable()
export class TermAssuranceServiceServiceProxy implements ITermAssuranceServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    optOut(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/OptOut?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOptOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOptOut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processOptOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTransactionBeneficiary(transactionRef: string | null | undefined): Observable<BeneficiaryUpdateModel> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/GetTransactionBeneficiary?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionBeneficiary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionBeneficiary(<any>response_);
                } catch (e) {
                    return <Observable<BeneficiaryUpdateModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BeneficiaryUpdateModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionBeneficiary(response: HttpResponseBase): Observable<BeneficiaryUpdateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryUpdateModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryUpdateModel>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    updateBeneficiary(transactionRef: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/UpdateBeneficiary?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBeneficiary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBeneficiary(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBeneficiary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postTermLifeSchedule(model: TermLifeRequest | null | undefined): Observable<TermLifeRequest> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/PostTermLifeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTermLifeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTermLifeSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TermLifeRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TermLifeRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostTermLifeSchedule(response: HttpResponseBase): Observable<TermLifeRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TermLifeRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermLifeRequest>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getTermLifeCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/GetTermLifeCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermLifeCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermLifeCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermLifeCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTermLifeTransactions(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<TermLifeTransaction[]> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/GetTermLifeTransactions?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermLifeTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermLifeTransactions(<any>response_);
                } catch (e) {
                    return <Observable<TermLifeTransaction[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TermLifeTransaction[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermLifeTransactions(response: HttpResponseBase): Observable<TermLifeTransaction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermLifeTransaction.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermLifeTransaction[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postTermLifeRenewalSchedule(model: TermLifeRequest | null | undefined): Observable<TermLifeRequest> {
        let url_ = this.baseUrl + "/api/services/app/TermAssuranceService/PostTermLifeRenewalSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTermLifeRenewalSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTermLifeRenewalSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TermLifeRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TermLifeRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostTermLifeRenewalSchedule(response: HttpResponseBase): Observable<TermLifeRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TermLifeRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermLifeRequest>(<any>null);
    }
}

export interface IThirdPartyServicesServiceProxy {
    /**
     * @param inputVm (optional)
     * @return Success
     */
    postPayment(inputVm: ThirdPartyServicesDto | null | undefined): Observable<string>;
}

@Injectable()
export class ThirdPartyServicesServiceProxy implements IThirdPartyServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param inputVm (optional)
     * @return Success
     */
    postPayment(inputVm: ThirdPartyServicesDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ThirdPartyServices/PostPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPayment(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostPayment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface ITokenAuthServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel>;
    /**
     * @param email (optional)
     * @return Success
     */
    getUserDetailsAfterLoginByEmail(email: string | null | undefined): Observable<MobileUserLoginDetails>;
    /**
     * @param transRef (optional)
     * @return Success
     */
    downloadReceipt(transRef: string | null | undefined): Observable<string>;
    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    postAgentProfilingForMobile(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param userId (optional)
     * @param username (optional)
     * @param otpNumber (optional)
     * @param password (optional)
     * @return Success
     */
    postCreateNewPassword(userId: string | null | undefined, username: string | null | undefined, otpNumber: string | null | undefined, password: string | null | undefined): Observable<string>;
    /**
     * @param agentCodel (optional)
     * @return Success
     */
    getAgentDetails(agentCodel: string | null | undefined): Observable<AgentProfillingDetail>;
    /**
     * @param email (optional)
     * @return Success
     */
    getForgetPassword(email: string | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    getGenerateNewOtp(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel>;
    /**
     * @param clientEmail (optional)
     * @param product (optional)
     * @param dateToPull (optional)
     * @return Success
     */
    getClientPaymentHistoryByEmail(clientEmail: string | null | undefined, product: string | null | undefined, dateToPull: Date | null | undefined): Observable<ClientPaymentHistory[]>;
    /**
     * @param transRef (optional)
     * @return Success
     */
    downloadCertificate(transRef: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    downloadStatusOrStatementAsHtml(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    sendStatusOrStatementToEmail(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string>;
    /**
     * @param polName (optional)
     * @param polProdShtDesc (optional)
     * @param polPolicyNumber (optional)
     * @param polEffectiveDate (optional)
     * @param polLastPremDueDate (optional)
     * @param polMaturityDate (optional)
     * @param polCurrentSa (optional)
     * @param polTerm (optional)
     * @param polOsPremBalAmt (optional)
     * @param polStatus (optional)
     * @param polInstlmtPrem (optional)
     * @param polPaidToDate (optional)
     * @param polFreqOfPayment (optional)
     * @param email (optional)
     * @param country (optional)
     * @param state (optional)
     * @param address (optional)
     * @return Success
     */
    downloadEmbassyLetterAsHtml(polName: string | null | undefined, polProdShtDesc: string | null | undefined, polPolicyNumber: string | null | undefined, polEffectiveDate: string | null | undefined, polLastPremDueDate: string | null | undefined, polMaturityDate: string | null | undefined, polCurrentSa: string | null | undefined, polTerm: string | null | undefined, polOsPremBalAmt: string | null | undefined, polStatus: string | null | undefined, polInstlmtPrem: string | null | undefined, polPaidToDate: string | null | undefined, polFreqOfPayment: string | null | undefined, email: string | null | undefined, country: string | null | undefined, state: string | null | undefined, address: string | null | undefined, isStatus: boolean, isSuccessful: boolean, isEmail: boolean): Observable<string>;
    /**
     * @param policyNo (optional)
     * @param country (optional)
     * @param state (optional)
     * @param address (optional)
     * @return Success
     */
    sendEmbassyLetterToEmail(policyNo: string | null | undefined, country: string | null | undefined, state: string | null | undefined, address: string | null | undefined): Observable<string>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    downloadTaxRebateAsHtml(policyNo: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getAllNewCorporateSavingPlanFromTQ(): Observable<boolean>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    sendTaxRebateToEmail(policyNo: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getEmbassyCOuntry(): Observable<string[]>;
    /**
     * @param country (optional)
     * @return Success
     */
    getEmbassyStates(country: string | null | undefined): Observable<string[]>;
    /**
     * @param country (optional)
     * @param state (optional)
     * @return Success
     */
    getEmbassyAddress(country: string | null | undefined, state: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]>;
    /**
     * @param model (optional)
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel>;
}

@Injectable()
export class TokenAuthServiceProxy implements ITokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getUserDetailsAfterLoginByEmail(email: string | null | undefined): Observable<MobileUserLoginDetails> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetUserDetailsAfterLoginByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetailsAfterLoginByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetailsAfterLoginByEmail(<any>response_);
                } catch (e) {
                    return <Observable<MobileUserLoginDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileUserLoginDetails>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDetailsAfterLoginByEmail(response: HttpResponseBase): Observable<MobileUserLoginDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MobileUserLoginDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileUserLoginDetails>(<any>null);
    }

    /**
     * @param transRef (optional)
     * @return Success
     */
    downloadReceipt(transRef: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/DownloadReceipt?";
        if (transRef !== undefined && transRef !== null)
            url_ += "transRef=" + encodeURIComponent("" + transRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReceipt(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadReceipt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    postAgentProfilingForMobile(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/PostAgentProfilingForMobile?";
        if (tQSYSCODE !== undefined && tQSYSCODE !== null)
            url_ += "TQSYSCODE=" + encodeURIComponent("" + tQSYSCODE) + "&";
        if (aCCOUNTTYPE !== undefined && aCCOUNTTYPE !== null)
            url_ += "ACCOUNTTYPE=" + encodeURIComponent("" + aCCOUNTTYPE) + "&";
        if (aGENTTYPE !== undefined && aGENTTYPE !== null)
            url_ += "AGENTTYPE=" + encodeURIComponent("" + aGENTTYPE) + "&";
        if (aGENTCODE !== undefined && aGENTCODE !== null)
            url_ += "AGENTCODE=" + encodeURIComponent("" + aGENTCODE) + "&";
        if (aDDRESS !== undefined && aDDRESS !== null)
            url_ += "ADDRESS=" + encodeURIComponent("" + aDDRESS) + "&";
        if (eMAIL !== undefined && eMAIL !== null)
            url_ += "EMAIL=" + encodeURIComponent("" + eMAIL) + "&";
        if (tELEPHONE !== undefined && tELEPHONE !== null)
            url_ += "TELEPHONE=" + encodeURIComponent("" + tELEPHONE) + "&";
        if (aGN_NAME !== undefined && aGN_NAME !== null)
            url_ += "AGN_NAME=" + encodeURIComponent("" + aGN_NAME) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAgentProfilingForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAgentProfilingForMobile(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processPostAgentProfilingForMobile(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param userId (optional)
     * @param username (optional)
     * @param otpNumber (optional)
     * @param password (optional)
     * @return Success
     */
    postCreateNewPassword(userId: string | null | undefined, username: string | null | undefined, otpNumber: string | null | undefined, password: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/PostCreateNewPassword?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (otpNumber !== undefined && otpNumber !== null)
            url_ += "OtpNumber=" + encodeURIComponent("" + otpNumber) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCreateNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCreateNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostCreateNewPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param agentCodel (optional)
     * @return Success
     */
    getAgentDetails(agentCodel: string | null | undefined): Observable<AgentProfillingDetail> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetAgentDetails?";
        if (agentCodel !== undefined && agentCodel !== null)
            url_ += "agentCodel=" + encodeURIComponent("" + agentCodel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgentDetails(<any>response_);
                } catch (e) {
                    return <Observable<AgentProfillingDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentProfillingDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgentDetails(response: HttpResponseBase): Observable<AgentProfillingDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentProfillingDetail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentProfillingDetail>(<any>null);
    }

    /**
     * @param email (optional)
     * @return Success
     */
    getForgetPassword(email: string | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetForgetPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForgetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForgetPassword(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetForgetPassword(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param tQSYSCODE (optional)
     * @param aCCOUNTTYPE (optional)
     * @param aGENTTYPE (optional)
     * @param aGENTCODE (optional)
     * @param aDDRESS (optional)
     * @param eMAIL (optional)
     * @param tELEPHONE (optional)
     * @param aGN_NAME (optional)
     * @return Success
     */
    getGenerateNewOtp(tQSYSCODE: string | null | undefined, aCCOUNTTYPE: string | null | undefined, aGENTTYPE: string | null | undefined, aGENTCODE: string | null | undefined, aDDRESS: string | null | undefined, eMAIL: string | null | undefined, tELEPHONE: string | null | undefined, aGN_NAME: string | null | undefined): Observable<AgentDetailByEmailModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetGenerateNewOtp?";
        if (tQSYSCODE !== undefined && tQSYSCODE !== null)
            url_ += "TQSYSCODE=" + encodeURIComponent("" + tQSYSCODE) + "&";
        if (aCCOUNTTYPE !== undefined && aCCOUNTTYPE !== null)
            url_ += "ACCOUNTTYPE=" + encodeURIComponent("" + aCCOUNTTYPE) + "&";
        if (aGENTTYPE !== undefined && aGENTTYPE !== null)
            url_ += "AGENTTYPE=" + encodeURIComponent("" + aGENTTYPE) + "&";
        if (aGENTCODE !== undefined && aGENTCODE !== null)
            url_ += "AGENTCODE=" + encodeURIComponent("" + aGENTCODE) + "&";
        if (aDDRESS !== undefined && aDDRESS !== null)
            url_ += "ADDRESS=" + encodeURIComponent("" + aDDRESS) + "&";
        if (eMAIL !== undefined && eMAIL !== null)
            url_ += "EMAIL=" + encodeURIComponent("" + eMAIL) + "&";
        if (tELEPHONE !== undefined && tELEPHONE !== null)
            url_ += "TELEPHONE=" + encodeURIComponent("" + tELEPHONE) + "&";
        if (aGN_NAME !== undefined && aGN_NAME !== null)
            url_ += "AGN_NAME=" + encodeURIComponent("" + aGN_NAME) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenerateNewOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenerateNewOtp(<any>response_);
                } catch (e) {
                    return <Observable<AgentDetailByEmailModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentDetailByEmailModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenerateNewOtp(response: HttpResponseBase): Observable<AgentDetailByEmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AgentDetailByEmailModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentDetailByEmailModel>(<any>null);
    }

    /**
     * @param clientEmail (optional)
     * @param product (optional)
     * @param dateToPull (optional)
     * @return Success
     */
    getClientPaymentHistoryByEmail(clientEmail: string | null | undefined, product: string | null | undefined, dateToPull: Date | null | undefined): Observable<ClientPaymentHistory[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetClientPaymentHistoryByEmail?";
        if (clientEmail !== undefined && clientEmail !== null)
            url_ += "clientEmail=" + encodeURIComponent("" + clientEmail) + "&";
        if (product !== undefined && product !== null)
            url_ += "product=" + encodeURIComponent("" + product) + "&";
        if (dateToPull !== undefined && dateToPull !== null)
            url_ += "dateToPull=" + encodeURIComponent(dateToPull ? "" + dateToPull.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPaymentHistoryByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPaymentHistoryByEmail(<any>response_);
                } catch (e) {
                    return <Observable<ClientPaymentHistory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientPaymentHistory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientPaymentHistoryByEmail(response: HttpResponseBase): Observable<ClientPaymentHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPaymentHistory.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientPaymentHistory[]>(<any>null);
    }

    /**
     * @param transRef (optional)
     * @return Success
     */
    downloadCertificate(transRef: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/DownloadCertificate?";
        if (transRef !== undefined && transRef !== null)
            url_ += "transRef=" + encodeURIComponent("" + transRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCertificate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadCertificate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    downloadStatusOrStatementAsHtml(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/DownloadStatusOrStatementAsHtml?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (isStatus !== undefined && isStatus !== null)
            url_ += "isStatus=" + encodeURIComponent("" + isStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStatusOrStatementAsHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStatusOrStatementAsHtml(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadStatusOrStatementAsHtml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @param isStatus (optional)
     * @return Success
     */
    sendStatusOrStatementToEmail(policyNo: string | null | undefined, isStatus: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendStatusOrStatementToEmail?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (isStatus !== undefined && isStatus !== null)
            url_ += "isStatus=" + encodeURIComponent("" + isStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendStatusOrStatementToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendStatusOrStatementToEmail(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendStatusOrStatementToEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param polName (optional)
     * @param polProdShtDesc (optional)
     * @param polPolicyNumber (optional)
     * @param polEffectiveDate (optional)
     * @param polLastPremDueDate (optional)
     * @param polMaturityDate (optional)
     * @param polCurrentSa (optional)
     * @param polTerm (optional)
     * @param polOsPremBalAmt (optional)
     * @param polStatus (optional)
     * @param polInstlmtPrem (optional)
     * @param polPaidToDate (optional)
     * @param polFreqOfPayment (optional)
     * @param email (optional)
     * @param country (optional)
     * @param state (optional)
     * @param address (optional)
     * @return Success
     */
    downloadEmbassyLetterAsHtml(polName: string | null | undefined, polProdShtDesc: string | null | undefined, polPolicyNumber: string | null | undefined, polEffectiveDate: string | null | undefined, polLastPremDueDate: string | null | undefined, polMaturityDate: string | null | undefined, polCurrentSa: string | null | undefined, polTerm: string | null | undefined, polOsPremBalAmt: string | null | undefined, polStatus: string | null | undefined, polInstlmtPrem: string | null | undefined, polPaidToDate: string | null | undefined, polFreqOfPayment: string | null | undefined, email: string | null | undefined, country: string | null | undefined, state: string | null | undefined, address: string | null | undefined, isStatus: boolean, isSuccessful: boolean, isEmail: boolean): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/DownloadEmbassyLetterAsHtml?";
        if (polName !== undefined && polName !== null)
            url_ += "PolName=" + encodeURIComponent("" + polName) + "&";
        if (polProdShtDesc !== undefined && polProdShtDesc !== null)
            url_ += "PolProdShtDesc=" + encodeURIComponent("" + polProdShtDesc) + "&";
        if (polPolicyNumber !== undefined && polPolicyNumber !== null)
            url_ += "PolPolicyNumber=" + encodeURIComponent("" + polPolicyNumber) + "&";
        if (polEffectiveDate !== undefined && polEffectiveDate !== null)
            url_ += "PolEffectiveDate=" + encodeURIComponent("" + polEffectiveDate) + "&";
        if (polLastPremDueDate !== undefined && polLastPremDueDate !== null)
            url_ += "PolLastPremDueDate=" + encodeURIComponent("" + polLastPremDueDate) + "&";
        if (polMaturityDate !== undefined && polMaturityDate !== null)
            url_ += "PolMaturityDate=" + encodeURIComponent("" + polMaturityDate) + "&";
        if (polCurrentSa !== undefined && polCurrentSa !== null)
            url_ += "PolCurrentSa=" + encodeURIComponent("" + polCurrentSa) + "&";
        if (polTerm !== undefined && polTerm !== null)
            url_ += "PolTerm=" + encodeURIComponent("" + polTerm) + "&";
        if (polOsPremBalAmt !== undefined && polOsPremBalAmt !== null)
            url_ += "PolOsPremBalAmt=" + encodeURIComponent("" + polOsPremBalAmt) + "&";
        if (polStatus !== undefined && polStatus !== null)
            url_ += "PolStatus=" + encodeURIComponent("" + polStatus) + "&";
        if (polInstlmtPrem !== undefined && polInstlmtPrem !== null)
            url_ += "PolInstlmtPrem=" + encodeURIComponent("" + polInstlmtPrem) + "&";
        if (polPaidToDate !== undefined && polPaidToDate !== null)
            url_ += "PolPaidToDate=" + encodeURIComponent("" + polPaidToDate) + "&";
        if (polFreqOfPayment !== undefined && polFreqOfPayment !== null)
            url_ += "PolFreqOfPayment=" + encodeURIComponent("" + polFreqOfPayment) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (address !== undefined && address !== null)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (isStatus === undefined || isStatus === null)
            throw new Error("The parameter 'isStatus' must be defined and cannot be null.");
        else
            url_ += "IsStatus=" + encodeURIComponent("" + isStatus) + "&";
        if (isSuccessful === undefined || isSuccessful === null)
            throw new Error("The parameter 'isSuccessful' must be defined and cannot be null.");
        else
            url_ += "IsSuccessful=" + encodeURIComponent("" + isSuccessful) + "&";
        if (isEmail === undefined || isEmail === null)
            throw new Error("The parameter 'isEmail' must be defined and cannot be null.");
        else
            url_ += "IsEmail=" + encodeURIComponent("" + isEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEmbassyLetterAsHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEmbassyLetterAsHtml(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadEmbassyLetterAsHtml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @param country (optional)
     * @param state (optional)
     * @param address (optional)
     * @return Success
     */
    sendEmbassyLetterToEmail(policyNo: string | null | undefined, country: string | null | undefined, state: string | null | undefined, address: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendEmbassyLetterToEmail?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmbassyLetterToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmbassyLetterToEmail(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmbassyLetterToEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    downloadTaxRebateAsHtml(policyNo: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/DownloadTaxRebateAsHtml?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTaxRebateAsHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTaxRebateAsHtml(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadTaxRebateAsHtml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNewCorporateSavingPlanFromTQ(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetAllNewCorporateSavingPlanFromTQAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNewCorporateSavingPlanFromTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNewCorporateSavingPlanFromTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNewCorporateSavingPlanFromTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    sendTaxRebateToEmail(policyNo: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTaxRebateToEmail?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTaxRebateToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTaxRebateToEmail(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendTaxRebateToEmail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getEmbassyCOuntry(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetEmbassyCOuntry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmbassyCOuntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbassyCOuntry(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmbassyCOuntry(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param country (optional)
     * @return Success
     */
    getEmbassyStates(country: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetEmbassyStates?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmbassyStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbassyStates(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmbassyStates(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param country (optional)
     * @param state (optional)
     * @return Success
     */
    getEmbassyAddress(country: string | null | undefined, state: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetEmbassyAddress?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmbassyAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmbassyAddress(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmbassyAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

export interface ITqServiceServiceProxy {
    /**
     * @param cQR_REF (optional)
     * @param amount (optional)
     * @param cQR_NARRATIVE (optional)
     * @param cQR_PAYEE (optional)
     * @param policy (optional)
     * @param dataFrom (optional)
     * @param policyType (optional)
     * @return Success
     */
    getPolicyEnquiry(cQR_REF: string | null | undefined, amount: string | null | undefined, actiono: string, cQR_NARRATIVE: string | null | undefined, cQR_PAYEE: string | null | undefined, policy: string | null | undefined, dataFrom: string | null | undefined, policyType: string | null | undefined): Observable<string>;
    /**
     * @param dateOfBirth (optional)
     * @param amount (optional)
     * @return Success
     */
    getAnnuityRate(dateOfBirth: string | null | undefined, amount: string | null | undefined, isMale: boolean): Observable<AnnuityResponseModel>;
}

@Injectable()
export class TqServiceServiceProxy implements ITqServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param cQR_REF (optional)
     * @param amount (optional)
     * @param cQR_NARRATIVE (optional)
     * @param cQR_PAYEE (optional)
     * @param policy (optional)
     * @param dataFrom (optional)
     * @param policyType (optional)
     * @return Success
     */
    getPolicyEnquiry(cQR_REF: string | null | undefined, amount: string | null | undefined, actiono: string, cQR_NARRATIVE: string | null | undefined, cQR_PAYEE: string | null | undefined, policy: string | null | undefined, dataFrom: string | null | undefined, policyType: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TqService/GetPolicyEnquiry?";
        if (cQR_REF !== undefined && cQR_REF !== null)
            url_ += "CQR_REF=" + encodeURIComponent("" + cQR_REF) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "Amount=" + encodeURIComponent("" + amount) + "&";
        if (actiono === undefined || actiono === null)
            throw new Error("The parameter 'actiono' must be defined and cannot be null.");
        else
            url_ += "Actiono=" + encodeURIComponent("" + actiono) + "&";
        if (cQR_NARRATIVE !== undefined && cQR_NARRATIVE !== null)
            url_ += "CQR_NARRATIVE=" + encodeURIComponent("" + cQR_NARRATIVE) + "&";
        if (cQR_PAYEE !== undefined && cQR_PAYEE !== null)
            url_ += "CQR_PAYEE=" + encodeURIComponent("" + cQR_PAYEE) + "&";
        if (policy !== undefined && policy !== null)
            url_ += "Policy=" + encodeURIComponent("" + policy) + "&";
        if (dataFrom !== undefined && dataFrom !== null)
            url_ += "DataFrom=" + encodeURIComponent("" + dataFrom) + "&";
        if (policyType !== undefined && policyType !== null)
            url_ += "PolicyType=" + encodeURIComponent("" + policyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyEnquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyEnquiry(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicyEnquiry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param dateOfBirth (optional)
     * @param amount (optional)
     * @return Success
     */
    getAnnuityRate(dateOfBirth: string | null | undefined, amount: string | null | undefined, isMale: boolean): Observable<AnnuityResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/TqService/GetAnnuityRate?";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent("" + dateOfBirth) + "&";
        if (amount !== undefined && amount !== null)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (isMale === undefined || isMale === null)
            throw new Error("The parameter 'isMale' must be defined and cannot be null.");
        else
            url_ += "isMale=" + encodeURIComponent("" + isMale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityRate(<any>response_);
                } catch (e) {
                    return <Observable<AnnuityResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnuityResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityRate(response: HttpResponseBase): Observable<AnnuityResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AnnuityResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnuityResponseModel>(<any>null);
    }
}

export interface ITravelProductServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    computeTravelPremium(model: TravelPremiumModel | null | undefined): Observable<TravelRateResult>;
    /**
     * @param model (optional)
     * @return Success
     */
    postTravelSchedule(model: TravelScheduleRequest | null | undefined): Observable<TravelScheduleRequest>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTravelSchedule(transactionRef: string | null | undefined): Observable<TravelScheduleDto>;
    /**
     * @param model (optional)
     * @return Success
     */
    travelPolicyDetails(model: PolicySearchModel | null | undefined): Observable<TravelPolicyDetails_TravelPolicyDetailsModel>;
    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTravelTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewTravelTransactionsViewModel[]>;
    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getTravelTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<TravelTransactionResponse>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificate(tr: string | null | undefined): Observable<void>;
    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificateToHtml(tr: string | null | undefined): Observable<string>;
    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTqByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean>;
    /**
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQ(): Observable<boolean>;
    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelRetailer(searchBy: SearchBy, searchParam: string | null | undefined, model: any | null | undefined): Observable<void>;
    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelRetailerFlexure(searchBy: SearchBy2, searchParam: string | null | undefined, model: any | null | undefined): Observable<void>;
    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelEBusiness(searchBy: SearchBy3, searchParam: string | null | undefined, model: any | null | undefined): Observable<void>;
    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelFlexsure(searchBy: SearchBy4, searchParam: string | null | undefined, model: any | null | undefined): Observable<void>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadTravel(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<TravelScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmUploadTravel(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<TravelScheduleRequest>;
    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void>;
    /**
     * @param certificateOrPhoneNo (optional)
     * @return Success
     */
    getTravelTermAssurance(certificateOrPhoneNo: string | null | undefined): Observable<TravelTermAssurance>;
    /**
     * @param searchString (optional)
     * @return Success
     */
    getTermAssuranceCertificate(searchString: string | null | undefined): Observable<void>;
    /**
     * @param travelScheduleForMobile (optional)
     * @return Success
     */
    postEllaTravelSchedule(travelScheduleForMobile: TravelScheduleForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
    /**
     * @param policyNo (optional)
     * @return Success
     */
    isSqllInjectionPattern(policyNo: string | null | undefined): Observable<boolean>;
}

@Injectable()
export class TravelProductServiceServiceProxy implements ITravelProductServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    computeTravelPremium(model: TravelPremiumModel | null | undefined): Observable<TravelRateResult> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/ComputeTravelPremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeTravelPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeTravelPremium(<any>response_);
                } catch (e) {
                    return <Observable<TravelRateResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelRateResult>><any>_observableThrow(response_);
        }));
    }

    protected processComputeTravelPremium(response: HttpResponseBase): Observable<TravelRateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelRateResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelRateResult>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    postTravelSchedule(model: TravelScheduleRequest | null | undefined): Observable<TravelScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/PostTravelSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTravelSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTravelSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processPostTravelSchedule(response: HttpResponseBase): Observable<TravelScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleRequest>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getTravelSchedule(transactionRef: string | null | undefined): Observable<TravelScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelSchedule?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelSchedule(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelSchedule(response: HttpResponseBase): Observable<TravelScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleDto>(<any>null);
    }

    /**
     * @param model (optional)
     * @return Success
     */
    travelPolicyDetails(model: PolicySearchModel | null | undefined): Observable<TravelPolicyDetails_TravelPolicyDetailsModel> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/TravelPolicyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTravelPolicyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTravelPolicyDetails(<any>response_);
                } catch (e) {
                    return <Observable<TravelPolicyDetails_TravelPolicyDetailsModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelPolicyDetails_TravelPolicyDetailsModel>><any>_observableThrow(response_);
        }));
    }

    protected processTravelPolicyDetails(response: HttpResponseBase): Observable<TravelPolicyDetails_TravelPolicyDetailsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelPolicyDetails_TravelPolicyDetailsModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelPolicyDetails_TravelPolicyDetailsModel>(<any>null);
    }

    /**
     * @param transactionStatus (optional)
     * @param transactionRef (optional)
     * @param referralCode (optional)
     * @param policyNo (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTravelTransactionsWithRange(isAgent: boolean, transactionStatus: string | null | undefined, transactionRef: string | null | undefined, referralCode: string | null | undefined, policyNo: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ViewTravelTransactionsViewModel[]> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelTransactionsWithRange?";
        if (isAgent === undefined || isAgent === null)
            throw new Error("The parameter 'isAgent' must be defined and cannot be null.");
        else
            url_ += "IsAgent=" + encodeURIComponent("" + isAgent) + "&";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "TransactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (referralCode !== undefined && referralCode !== null)
            url_ += "ReferralCode=" + encodeURIComponent("" + referralCode) + "&";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "PolicyNo=" + encodeURIComponent("" + policyNo) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTransactionsWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTransactionsWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ViewTravelTransactionsViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewTravelTransactionsViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelTransactionsWithRange(response: HttpResponseBase): Observable<ViewTravelTransactionsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewTravelTransactionsViewModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewTravelTransactionsViewModel[]>(<any>null);
    }

    /**
     * @param paymentRef (optional)
     * @return Success
     */
    getTravelTransactionDetails(id: string, paymentRef: string | null | undefined): Observable<TravelTransactionResponse> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelTransactionDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (paymentRef !== undefined && paymentRef !== null)
            url_ += "paymentRef=" + encodeURIComponent("" + paymentRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<TravelTransactionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelTransactionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelTransactionDetails(response: HttpResponseBase): Observable<TravelTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelTransactionResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelTransactionResponse>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificate(tr: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelCertificate?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tr (optional)
     * @return Success
     */
    getTravelCertificateToHtml(tr: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelCertificateToHtml?";
        if (tr !== undefined && tr !== null)
            url_ += "tr=" + encodeURIComponent("" + tr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelCertificateToHtml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelCertificateToHtml(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelCertificateToHtml(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param policyNumber (optional)
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTqByPolicyNumber(policyNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/PushTravelTransactionFromFlexsureToTqByPolicyNumber?";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushTravelTransactionFromFlexsureToTqByPolicyNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushTravelTransactionFromFlexsureToTqByPolicyNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushTravelTransactionFromFlexsureToTqByPolicyNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    pushTravelTransactionFromFlexsureToTQ(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/PushTravelTransactionFromFlexsureToTQ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushTravelTransactionFromFlexsureToTQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushTravelTransactionFromFlexsureToTQ(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPushTravelTransactionFromFlexsureToTQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelRetailer(searchBy: SearchBy, searchParam: string | null | undefined, model: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetDataFromTravelRetailer?";
        if (searchBy === undefined || searchBy === null)
            throw new Error("The parameter 'searchBy' must be defined and cannot be null.");
        else
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        if (searchParam !== undefined && searchParam !== null)
            url_ += "searchParam=" + encodeURIComponent("" + searchParam) + "&";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFromTravelRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFromTravelRetailer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDataFromTravelRetailer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelRetailerFlexure(searchBy: SearchBy2, searchParam: string | null | undefined, model: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetDataFromTravelRetailerFlexure?";
        if (searchBy === undefined || searchBy === null)
            throw new Error("The parameter 'searchBy' must be defined and cannot be null.");
        else
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        if (searchParam !== undefined && searchParam !== null)
            url_ += "searchParam=" + encodeURIComponent("" + searchParam) + "&";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFromTravelRetailerFlexure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFromTravelRetailerFlexure(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDataFromTravelRetailerFlexure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelEBusiness(searchBy: SearchBy3, searchParam: string | null | undefined, model: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetDataFromTravelEBusiness?";
        if (searchBy === undefined || searchBy === null)
            throw new Error("The parameter 'searchBy' must be defined and cannot be null.");
        else
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        if (searchParam !== undefined && searchParam !== null)
            url_ += "searchParam=" + encodeURIComponent("" + searchParam) + "&";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFromTravelEBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFromTravelEBusiness(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDataFromTravelEBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param searchParam (optional)
     * @param model (optional)
     * @return Success
     */
    getDataFromTravelFlexsure(searchBy: SearchBy4, searchParam: string | null | undefined, model: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetDataFromTravelFlexsure?";
        if (searchBy === undefined || searchBy === null)
            throw new Error("The parameter 'searchBy' must be defined and cannot be null.");
        else
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        if (searchParam !== undefined && searchParam !== null)
            url_ += "searchParam=" + encodeURIComponent("" + searchParam) + "&";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFromTravelFlexsure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFromTravelFlexsure(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDataFromTravelFlexsure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param filepath (optional)
     * @param fieldName (optional)
     * @return Success
     */
    uploadTravel(clientId: string | null | undefined, transactionRef: string | null | undefined, filepath: string | null | undefined, fieldName: string | null | undefined): Observable<TravelScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/UploadTravel?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (fieldName !== undefined && fieldName !== null)
            url_ += "FieldName=" + encodeURIComponent("" + fieldName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTravel(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processUploadTravel(response: HttpResponseBase): Observable<TravelScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @return Success
     */
    confirmUploadTravel(clientId: string | null | undefined, transactionRef: string | null | undefined): Observable<TravelScheduleRequest> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/ConfirmUploadTravel?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "TransactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmUploadTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmUploadTravel(<any>response_);
                } catch (e) {
                    return <Observable<TravelScheduleRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelScheduleRequest>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmUploadTravel(response: HttpResponseBase): Observable<TravelScheduleRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelScheduleRequest.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelScheduleRequest>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @param transactionRef (optional)
     * @param dFullName (optional)
     * @param dPhoneNumber (optional)
     * @param dateOfBirth (optional)
     * @return Success
     */
    termLifeCover(clientId: string | null | undefined, transactionRef: string | null | undefined, beneficiaryActive: boolean, dFullName: string | null | undefined, dPhoneNumber: string | null | undefined, dateOfBirth: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/TermLifeCover?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (beneficiaryActive === undefined || beneficiaryActive === null)
            throw new Error("The parameter 'beneficiaryActive' must be defined and cannot be null.");
        else
            url_ += "beneficiaryActive=" + encodeURIComponent("" + beneficiaryActive) + "&";
        if (dFullName !== undefined && dFullName !== null)
            url_ += "dFullName=" + encodeURIComponent("" + dFullName) + "&";
        if (dPhoneNumber !== undefined && dPhoneNumber !== null)
            url_ += "dPhoneNumber=" + encodeURIComponent("" + dPhoneNumber) + "&";
        if (dateOfBirth !== undefined && dateOfBirth !== null)
            url_ += "dateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermLifeCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermLifeCover(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTermLifeCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param certificateOrPhoneNo (optional)
     * @return Success
     */
    getTravelTermAssurance(certificateOrPhoneNo: string | null | undefined): Observable<TravelTermAssurance> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTravelTermAssurance?";
        if (certificateOrPhoneNo !== undefined && certificateOrPhoneNo !== null)
            url_ += "certificateOrPhoneNo=" + encodeURIComponent("" + certificateOrPhoneNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTermAssurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTermAssurance(<any>response_);
                } catch (e) {
                    return <Observable<TravelTermAssurance>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelTermAssurance>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelTermAssurance(response: HttpResponseBase): Observable<TravelTermAssurance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TravelTermAssurance.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelTermAssurance>(<any>null);
    }

    /**
     * @param searchString (optional)
     * @return Success
     */
    getTermAssuranceCertificate(searchString: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/GetTermAssuranceCertificate?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermAssuranceCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermAssuranceCertificate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermAssuranceCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param travelScheduleForMobile (optional)
     * @return Success
     */
    postEllaTravelSchedule(travelScheduleForMobile: TravelScheduleForMobile | null | undefined): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/PostEllaTravelSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(travelScheduleForMobile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEllaTravelSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEllaTravelSchedule(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>><any>_observableThrow(response_);
        }));
    }

    protected processPostEllaTravelSchedule(response: HttpResponseBase): Observable<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(<any>null);
    }

    /**
     * @param policyNo (optional)
     * @return Success
     */
    isSqllInjectionPattern(policyNo: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TravelProductService/IsSqllInjectionPattern?";
        if (policyNo !== undefined && policyNo !== null)
            url_ += "policyNo=" + encodeURIComponent("" + policyNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSqllInjectionPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSqllInjectionPattern(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsSqllInjectionPattern(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IUserServiceProxy {
    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateUserDto | null | undefined): Observable<UserDto>;
    /**
     * @param input (optional)
     * @return Success
     */
    update(input: UserDto | null | undefined): Observable<UserDto>;
    /**
     * @return Success
     */
    delete(id: number): Observable<void>;
    /**
     * @return Success
     */
    get(id: number): Observable<UserDto>;
    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @param accountStatus (optional)
     * @param email (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getAllUserWithRange(accountStatus: string | null | undefined, email: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
}

@Injectable()
export class UserServiceProxy implements IUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param input (optional)
     * @return Success
     */
    create(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    update(input: UserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    get(id: number): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param accountStatus (optional)
     * @param email (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getAllUserWithRange(accountStatus: string | null | undefined, email: string | null | undefined, hasStatus: boolean, startDate: Date | null | undefined, endDate: Date | null | undefined, hasRange: boolean): Observable<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUserWithRange?";
        if (accountStatus !== undefined && accountStatus !== null)
            url_ += "AccountStatus=" + encodeURIComponent("" + accountStatus) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (hasStatus === undefined || hasStatus === null)
            throw new Error("The parameter 'hasStatus' must be defined and cannot be null.");
        else
            url_ += "HasStatus=" + encodeURIComponent("" + hasStatus) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (hasRange === undefined || hasRange === null)
            throw new Error("The parameter 'hasRange' must be defined and cannot be null.");
        else
            url_ += "HasRange=" + encodeURIComponent("" + hasRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserWithRange(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserWithRange(response: HttpResponseBase): Observable<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(skipCount: number, maxResultCount: number): Observable<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export interface IUssdServiceProxy {
    /**
     * @param numberPlates (optional)
     * @return Success
     */
    getVehicleDetails(numberPlates: string | null | undefined): Observable<FinalResponseModel>;
    /**
     * @param inputBusinessDto (optional)
     * @return Success
     */
    newBusiness(inputBusinessDto: NewBusinessDto | null | undefined): Observable<string>;
    /**
     * @param inputPaymentDto (optional)
     * @return Success
     */
    payment(inputPaymentDto: PaymentDto | null | undefined): Observable<string>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    postOminicomWebhooks(transactionRef: string | null | undefined): Observable<OminicomWebhook>;
}

@Injectable()
export class UssdServiceProxy implements IUssdServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param numberPlates (optional)
     * @return Success
     */
    getVehicleDetails(numberPlates: string | null | undefined): Observable<FinalResponseModel> {
        let url_ = this.baseUrl + "/api/services/app/Ussd/GetVehicleDetails?";
        if (numberPlates !== undefined && numberPlates !== null)
            url_ += "numberPlates=" + encodeURIComponent("" + numberPlates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleDetails(<any>response_);
                } catch (e) {
                    return <Observable<FinalResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinalResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleDetails(response: HttpResponseBase): Observable<FinalResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FinalResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinalResponseModel>(<any>null);
    }

    /**
     * @param inputBusinessDto (optional)
     * @return Success
     */
    newBusiness(inputBusinessDto: NewBusinessDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ussd/NewBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputBusinessDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewBusiness(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processNewBusiness(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param inputPaymentDto (optional)
     * @return Success
     */
    payment(inputPaymentDto: PaymentDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ussd/Payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputPaymentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayment(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPayment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    postOminicomWebhooks(transactionRef: string | null | undefined): Observable<OminicomWebhook> {
        let url_ = this.baseUrl + "/api/services/app/Ussd/PostOminicomWebhooks?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOminicomWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOminicomWebhooks(<any>response_);
                } catch (e) {
                    return <Observable<OminicomWebhook>><any>_observableThrow(e);
                }
            } else
                return <Observable<OminicomWebhook>><any>_observableThrow(response_);
        }));
    }

    protected processPostOminicomWebhooks(response: HttpResponseBase): Observable<OminicomWebhook> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OminicomWebhook.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OminicomWebhook>(<any>null);
    }
}

export interface IUssdServiceServiceProxy {
    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails>;
}

@Injectable()
export class UssdServiceServiceProxy implements IUssdServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param model (optional)
     * @return Success
     */
    finalizePartnerUssd(model: PartnerFinalizeModel | null | undefined): Observable<PolicyDetails> {
        let url_ = this.baseUrl + "/api/services/app/UssdService/FinalizePartnerUssd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizePartnerUssd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizePartnerUssd(<any>response_);
                } catch (e) {
                    return <Observable<PolicyDetails>><any>_observableThrow(e);
                }
            } else
                return <Observable<PolicyDetails>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizePartnerUssd(response: HttpResponseBase): Observable<PolicyDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PolicyDetails.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyDetails>(<any>null);
    }
}

export interface IUtilitiyServiceServiceProxy {
    /**
     * @return Success
     */
    getCertificateBaseApiPath(): Observable<string>;
    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string>;
    /**
     * @return Success
     */
    getLoggedOnUserIdOrDefault(): Observable<number>;
    /**
     * @return Success
     */
    isUserLoggedIn(): Observable<boolean>;
    /**
     * @return Success
     */
    getRaveCredentials(): Observable<RaveCredentials>;
    /**
     * @return Success
     */
    getTitles(): Observable<NameValueModel[]>;
    /**
     * @param title (optional)
     * @return Success
     */
    getTitle(title: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getLocationName(locationId: string): Observable<string>;
    /**
     * @return Success
     */
    getClientCategories(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getCountries(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getTopCountries(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getNonSchengenCountries(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getStatesForCountry(countryId: string): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getAllLgas(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getLgasForState(stateId: string): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getHospitalsForLga(lgaId: string): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getMaritalStatus(): Observable<NameValueModel[]>;
    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number>;
    /**
     * @return Success
     */
    getBodyTypes(): Observable<string[]>;
    /**
     * @return Success
     */
    getManufactureYear(): Observable<string[]>;
    /**
     * @param makeYear (optional)
     * @return Success
     */
    getVehicleMake(makeYear: string | null | undefined): Observable<string[]>;
    /**
     * @param vehicleMake (optional)
     * @param vehicleYear (optional)
     * @return Success
     */
    getVehicleMakeModel(vehicleMake: string | null | undefined, vehicleYear: string | null | undefined): Observable<string[]>;
    /**
     * @return Success
     */
    getColorList(): Observable<string[]>;
    /**
     * @return Success
     */
    getPolicySearchValues(): Observable<NameValueModel[]>;
    /**
     * @return Success
     */
    getDefaultCountry(): Observable<Country>;
    /**
     * @param gender (optional)
     * @return Success
     */
    getGender(gender: string | null | undefined): Observable<string>;
    /**
     * @param clientId (optional)
     * @return Success
     */
    getClientApplication(clientId: string | null | undefined): Observable<ClientApplication>;
    /**
     * @param clientId (optional)
     * @return Success
     */
    getPaymentChannelFromClientApplication(clientId: string | null | undefined): Observable<string>;
    /**
     * @return Success
     */
    getGtPayApiKey(): Observable<string>;
    /**
     * @return Success
     */
    getRemitaApiKey(): Observable<string>;
    /**
     * @param transactionRef (optional)
     * @param paymentChannel (optional)
     * @return Success
     */
    updatePaymentChannel(transactionRef: string | null | undefined, paymentChannel: PaymentChannel2 | null | undefined): Observable<void>;
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentChannel(transactionRef: string | null | undefined): Observable<RevalidationModel>;
    /**
     * @return Success
     */
    getAutoRegMotorDetails(): Observable<boolean>;
    /**
     * @return Success
     */
    setAdminBaseUrl(): Observable<void>;
    /**
     * @return Success
     */
    customerTitle(): Observable<Title[]>;
    /**
     * @return Success
     */
    customerGender(): Observable<Gender[]>;
}

@Injectable()
export class UtilitiyServiceServiceProxy implements IUtilitiyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @return Success
     */
    getCertificateBaseApiPath(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetCertificateBaseApiPath";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateBaseApiPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateBaseApiPath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateBaseApiPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAdminBasePath(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetAdminBasePath";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminBasePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminBasePath(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminBasePath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getLoggedOnUserIdOrDefault(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetLoggedOnUserIdOrDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedOnUserIdOrDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedOnUserIdOrDefault(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoggedOnUserIdOrDefault(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    isUserLoggedIn(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/IsUserLoggedIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserLoggedIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserLoggedIn(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsUserLoggedIn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getRaveCredentials(): Observable<RaveCredentials> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetRaveCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaveCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaveCredentials(<any>response_);
                } catch (e) {
                    return <Observable<RaveCredentials>><any>_observableThrow(e);
                }
            } else
                return <Observable<RaveCredentials>><any>_observableThrow(response_);
        }));
    }

    protected processGetRaveCredentials(response: HttpResponseBase): Observable<RaveCredentials> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaveCredentials.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaveCredentials>(<any>null);
    }

    /**
     * @return Success
     */
    getTitles(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetTitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitles(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTitles(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param title (optional)
     * @return Success
     */
    getTitle(title: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetTitle?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitle(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getLocationName(locationId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetLocationName?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getClientCategories(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetClientCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCategories(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientCategories(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGenders(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenders(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenders(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCountries(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTopCountries(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetTopCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopCountries(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNonSchengenCountries(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetNonSchengenCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonSchengenCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonSchengenCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNonSchengenCountries(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStatesForCountry(countryId: string): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetStatesForCountry?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesForCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesForCountry(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatesForCountry(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLgas(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetAllLgas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLgas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLgas(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLgas(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLgasForState(stateId: string): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetLgasForState?";
        if (stateId === undefined || stateId === null)
            throw new Error("The parameter 'stateId' must be defined and cannot be null.");
        else
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLgasForState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLgasForState(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLgasForState(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getHospitalsForLga(lgaId: string): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetHospitalsForLga?";
        if (lgaId === undefined || lgaId === null)
            throw new Error("The parameter 'lgaId' must be defined and cannot be null.");
        else
            url_ += "lgaId=" + encodeURIComponent("" + lgaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHospitalsForLga(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHospitalsForLga(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHospitalsForLga(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMaritalStatus(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetMaritalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaritalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaritalStatus(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMaritalStatus(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @param bodyType (optional)
     * @return Success
     */
    computeThirdPartyMotorPremium(bodyType: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/ComputeThirdPartyMotorPremium?";
        if (bodyType !== undefined && bodyType !== null)
            url_ += "bodyType=" + encodeURIComponent("" + bodyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeThirdPartyMotorPremium(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeThirdPartyMotorPremium(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processComputeThirdPartyMotorPremium(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getBodyTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetBodyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBodyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBodyTypes(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBodyTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getManufactureYear(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetManufactureYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManufactureYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManufactureYear(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetManufactureYear(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param makeYear (optional)
     * @return Success
     */
    getVehicleMake(makeYear: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetVehicleMake?";
        if (makeYear !== undefined && makeYear !== null)
            url_ += "makeYear=" + encodeURIComponent("" + makeYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleMake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleMake(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleMake(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param vehicleMake (optional)
     * @param vehicleYear (optional)
     * @return Success
     */
    getVehicleMakeModel(vehicleMake: string | null | undefined, vehicleYear: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetVehicleMakeModel?";
        if (vehicleMake !== undefined && vehicleMake !== null)
            url_ += "VehicleMake=" + encodeURIComponent("" + vehicleMake) + "&";
        if (vehicleYear !== undefined && vehicleYear !== null)
            url_ += "VehicleYear=" + encodeURIComponent("" + vehicleYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleMakeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleMakeModel(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleMakeModel(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getColorList(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetColorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorList(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetColorList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPolicySearchValues(): Observable<NameValueModel[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetPolicySearchValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicySearchValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicySearchValues(<any>response_);
                } catch (e) {
                    return <Observable<NameValueModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPolicySearchValues(response: HttpResponseBase): Observable<NameValueModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueModel.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultCountry(): Observable<Country> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetDefaultCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultCountry(<any>response_);
                } catch (e) {
                    return <Observable<Country>><any>_observableThrow(e);
                }
            } else
                return <Observable<Country>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultCountry(response: HttpResponseBase): Observable<Country> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Country.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Country>(<any>null);
    }

    /**
     * @param gender (optional)
     * @return Success
     */
    getGender(gender: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetGender?";
        if (gender !== undefined && gender !== null)
            url_ += "gender=" + encodeURIComponent("" + gender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGender(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGender(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @return Success
     */
    getClientApplication(clientId: string | null | undefined): Observable<ClientApplication> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetClientApplication?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientApplication(<any>response_);
                } catch (e) {
                    return <Observable<ClientApplication>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClientApplication>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientApplication(response: HttpResponseBase): Observable<ClientApplication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientApplication.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientApplication>(<any>null);
    }

    /**
     * @param clientId (optional)
     * @return Success
     */
    getPaymentChannelFromClientApplication(clientId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetPaymentChannelFromClientApplication?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentChannelFromClientApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentChannelFromClientApplication(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentChannelFromClientApplication(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getGtPayApiKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetGtPayApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGtPayApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGtPayApiKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGtPayApiKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getRemitaApiKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetRemitaApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemitaApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemitaApiKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetRemitaApiKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @param paymentChannel (optional)
     * @return Success
     */
    updatePaymentChannel(transactionRef: string | null | undefined, paymentChannel: PaymentChannel2 | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/UpdatePaymentChannel?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentChannel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    getPaymentChannel(transactionRef: string | null | undefined): Observable<RevalidationModel> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetPaymentChannel?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentChannel(<any>response_);
                } catch (e) {
                    return <Observable<RevalidationModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevalidationModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentChannel(response: HttpResponseBase): Observable<RevalidationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RevalidationModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevalidationModel>(<any>null);
    }

    /**
     * @return Success
     */
    getAutoRegMotorDetails(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/GetAutoRegMotorDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoRegMotorDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoRegMotorDetails(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoRegMotorDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    setAdminBaseUrl(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/SetAdminBaseUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAdminBaseUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAdminBaseUrl(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAdminBaseUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    customerTitle(): Observable<Title[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/CustomerTitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerTitle(<any>response_);
                } catch (e) {
                    return <Observable<Title[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Title[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerTitle(response: HttpResponseBase): Observable<Title[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Title.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Title[]>(<any>null);
    }

    /**
     * @return Success
     */
    customerGender(): Observable<Gender[]> {
        let url_ = this.baseUrl + "/api/services/app/UtilitiyService/CustomerGender";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGender(<any>response_);
                } catch (e) {
                    return <Observable<Gender[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Gender[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGender(response: HttpResponseBase): Observable<Gender[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Gender.fromJS(item, _mappings));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Gender[]>(<any>null);
    }
}

export interface IWemaPaymentServiceServiceProxy {
    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeWemaBankPayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>;
}

@Injectable()
export class WemaPaymentServiceServiceProxy implements IWemaPaymentServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * @param transactionRef (optional)
     * @return Success
     */
    finalizeWemaBankPayment(transactionRef: string | null | undefined, isRetry: boolean): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/services/app/WemaPaymentService/FinalizeWemaBankPayment?";
        if (transactionRef !== undefined && transactionRef !== null)
            url_ += "transactionRef=" + encodeURIComponent("" + transactionRef) + "&";
        if (isRetry === undefined || isRetry === null)
            throw new Error("The parameter 'isRetry' must be defined and cannot be null.");
        else
            url_ += "isRetry=" + encodeURIComponent("" + isRetry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeWemaBankPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeWemaBankPayment(<any>response_);
                } catch (e) {
                    return <Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(e);
                }
            } else
                return <Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeWemaBankPayment(response: HttpResponseBase): Observable<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class Intermediary implements IIntermediary {
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;
    id?: string | undefined;

    constructor(data?: IIntermediary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : <any>undefined;
            this.userId = _data["userId"];
            this.physicalAddress = _data["physicalAddress"];
            this.fullName = _data["fullName"];
            this.agentType = _data["agentType"];
            this.tqSysCode = _data["tqSysCode"];
            this.accountType = _data["accountType"];
            this.agentCode = _data["agentCode"];
            this.tel1 = _data["tel1"];
            this.email = _data["email"];
            this.creditLimit = _data["creditLimit"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.referralCode = _data["referralCode"];
            this.walletBalance = _data["walletBalance"];
            this.commissionBalance = _data["commissionBalance"];
            this.resellerLink = _data["resellerLink"];
            if (Array.isArray(_data["productCommissions"])) {
                this.productCommissions = [] as any;
                for (let item of _data["productCommissions"])
                    this.productCommissions!.push(IntermediaryProductCommission.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Intermediary | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Intermediary>(data, _mappings, Intermediary);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["physicalAddress"] = this.physicalAddress;
        data["fullName"] = this.fullName;
        data["agentType"] = this.agentType;
        data["tqSysCode"] = this.tqSysCode;
        data["accountType"] = this.accountType;
        data["agentCode"] = this.agentCode;
        data["tel1"] = this.tel1;
        data["email"] = this.email;
        data["creditLimit"] = this.creditLimit;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["walletBalance"] = this.walletBalance;
        data["commissionBalance"] = this.commissionBalance;
        data["resellerLink"] = this.resellerLink;
        if (Array.isArray(this.productCommissions)) {
            data["productCommissions"] = [];
            for (let item of this.productCommissions)
                data["productCommissions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IIntermediary {
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;
    id?: string | undefined;
}

export class User implements IUser {
    password!: string;
    name!: string;
    normalizedUserName!: string;
    surname!: string;
    userName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp?: string | undefined;
    tokens?: UserToken[] | undefined;
    deleterUser?: User | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    authenticationSource?: string | undefined;
    tenantId?: number | undefined;
    emailAddress!: string;
    readonly fullName?: string | undefined;
    emailConfirmationCode?: string | undefined;
    passwordResetCode?: string | undefined;
    lockoutEndDateUtc?: Date | undefined;
    accessFailedCount?: number | undefined;
    isLockoutEnabled?: boolean | undefined;
    phoneNumber?: string | undefined;
    isPhoneNumberConfirmed?: boolean | undefined;
    securityStamp?: string | undefined;
    isTwoFactorEnabled?: boolean | undefined;
    logins?: UserLogin[] | undefined;
    roles?: UserRole[] | undefined;
    claims?: UserClaim[] | undefined;
    permissions?: UserPermissionSetting[] | undefined;
    settings?: Setting[] | undefined;
    isEmailConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    lastLoginTime?: Date | undefined;
    isDeleted?: boolean | undefined;
    deleterUserId?: number | undefined;
    deletionTime?: Date | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.password = _data["password"];
            this.name = _data["name"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item, _mappings));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"], _mappings) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"], _mappings) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"], _mappings) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            (<any>this).fullName = _data["fullName"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? new Date(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item, _mappings));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): User | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<User>(data, _mappings, User);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["name"] = this.name;
        data["normalizedUserName"] = this.normalizedUserName;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUser {
    password: string;
    name: string;
    normalizedUserName: string;
    surname: string;
    userName: string;
    normalizedEmailAddress: string;
    concurrencyStamp?: string | undefined;
    tokens?: UserToken[] | undefined;
    deleterUser?: User | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    authenticationSource?: string | undefined;
    tenantId?: number | undefined;
    emailAddress: string;
    fullName?: string | undefined;
    emailConfirmationCode?: string | undefined;
    passwordResetCode?: string | undefined;
    lockoutEndDateUtc?: Date | undefined;
    accessFailedCount?: number | undefined;
    isLockoutEnabled?: boolean | undefined;
    phoneNumber?: string | undefined;
    isPhoneNumberConfirmed?: boolean | undefined;
    securityStamp?: string | undefined;
    isTwoFactorEnabled?: boolean | undefined;
    logins?: UserLogin[] | undefined;
    roles?: UserRole[] | undefined;
    claims?: UserClaim[] | undefined;
    permissions?: UserPermissionSetting[] | undefined;
    settings?: Setting[] | undefined;
    isEmailConfirmed?: boolean | undefined;
    isActive?: boolean | undefined;
    lastLoginTime?: Date | undefined;
    isDeleted?: boolean | undefined;
    deleterUserId?: number | undefined;
    deletionTime?: Date | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class IntermediaryProductCommission implements IIntermediaryProductCommission {
    agentCode?: string | undefined;
    product?: string | undefined;
    productPrefix?: string | undefined;
    commCode?: string | undefined;
    commRate?: number | undefined;
    commRateDesc?: string | undefined;
    rateType?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IIntermediaryProductCommission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agentCode = _data["agentCode"];
            this.product = _data["product"];
            this.productPrefix = _data["productPrefix"];
            this.commCode = _data["commCode"];
            this.commRate = _data["commRate"];
            this.commRateDesc = _data["commRateDesc"];
            this.rateType = _data["rateType"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryProductCommission | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryProductCommission>(data, _mappings, IntermediaryProductCommission);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentCode"] = this.agentCode;
        data["product"] = this.product;
        data["productPrefix"] = this.productPrefix;
        data["commCode"] = this.commCode;
        data["commRate"] = this.commRate;
        data["commRateDesc"] = this.commRateDesc;
        data["rateType"] = this.rateType;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IIntermediaryProductCommission {
    agentCode?: string | undefined;
    product?: string | undefined;
    productPrefix?: string | undefined;
    commCode?: string | undefined;
    commRate?: number | undefined;
    commRateDesc?: string | undefined;
    rateType?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    id?: string | undefined;
}

export class UserToken implements IUserToken {
    tenantId?: number | undefined;
    userId?: number | undefined;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    id?: number | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserToken | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserToken>(data, _mappings, UserToken);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserToken {
    tenantId?: number | undefined;
    userId?: number | undefined;
    loginProvider?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    id?: number | undefined;
}

export class UserLogin implements IUserLogin {
    tenantId?: number | undefined;
    userId?: number | undefined;
    loginProvider!: string;
    providerKey!: string;
    id?: number | undefined;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserLogin | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLogin>(data, _mappings, UserLogin);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLogin {
    tenantId?: number | undefined;
    userId?: number | undefined;
    loginProvider: string;
    providerKey: string;
    id?: number | undefined;
}

export class UserRole implements IUserRole {
    tenantId?: number | undefined;
    userId?: number | undefined;
    roleId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserRole | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserRole>(data, _mappings, UserRole);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserRole {
    tenantId?: number | undefined;
    userId?: number | undefined;
    roleId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class UserClaim implements IUserClaim {
    tenantId?: number | undefined;
    userId?: number | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserClaim | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserClaim>(data, _mappings, UserClaim);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserClaim {
    tenantId?: number | undefined;
    userId?: number | undefined;
    claimType?: string | undefined;
    claimValue?: string | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId?: number | undefined;
    tenantId?: number | undefined;
    name!: string;
    isGranted?: boolean | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserPermissionSetting | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserPermissionSetting>(data, _mappings, UserPermissionSetting);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserPermissionSetting {
    userId?: number | undefined;
    tenantId?: number | undefined;
    name: string;
    isGranted?: boolean | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class Setting implements ISetting {
    tenantId?: number | undefined;
    userId?: number | undefined;
    name!: string;
    value?: string | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Setting | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Setting>(data, _mappings, Setting);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISetting {
    tenantId?: number | undefined;
    userId?: number | undefined;
    name: string;
    value?: string | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    id?: number | undefined;
}

export class AgentDetailsModel implements IAgentDetailsModel {
    isAgent?: boolean | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;

    constructor(data?: IAgentDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isAgent = _data["isAgent"];
            this.walletBalance = _data["walletBalance"];
            this.commissionBalance = _data["commissionBalance"];
        }
    }

    static fromJS(data: any, _mappings?: any): AgentDetailsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentDetailsModel>(data, _mappings, AgentDetailsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAgent"] = this.isAgent;
        data["walletBalance"] = this.walletBalance;
        data["commissionBalance"] = this.commissionBalance;
        return data;
    }
}

export interface IAgentDetailsModel {
    isAgent?: boolean | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
}

export class NameValueModel implements INameValueModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: INameValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueModel>(data, _mappings, NameValueModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INameValueModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class PolicyDetails implements IPolicyDetails {
    fullName?: string | undefined;
    agentName?: string | undefined;
    policies?: string[] | undefined;
    clientAddress?: string | undefined;
    clientEmail?: string | undefined;
    clientPhoneNumber?: string | undefined;
    wef?: string | undefined;
    wet?: string | undefined;
    totalAmount?: string | undefined;
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    hash?: string | undefined;
    responseMessage?: string | undefined;
    responseCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;

    constructor(data?: IPolicyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.agentName = _data["agentName"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
            this.clientAddress = _data["clientAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhoneNumber = _data["clientPhoneNumber"];
            this.wef = _data["wef"];
            this.wet = _data["wet"];
            this.totalAmount = _data["totalAmount"];
            this.printPolicyUrl = _data["printPolicyUrl"];
            this.printReceiptUrl = _data["printReceiptUrl"];
            this.hash = _data["hash"];
            this.responseMessage = _data["responseMessage"];
            this.responseCode = _data["responseCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.isLoan = _data["isLoan"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyDetails>(data, _mappings, PolicyDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["agentName"] = this.agentName;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        data["clientAddress"] = this.clientAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhoneNumber"] = this.clientPhoneNumber;
        data["wef"] = this.wef;
        data["wet"] = this.wet;
        data["totalAmount"] = this.totalAmount;
        data["printPolicyUrl"] = this.printPolicyUrl;
        data["printReceiptUrl"] = this.printReceiptUrl;
        data["hash"] = this.hash;
        data["responseMessage"] = this.responseMessage;
        data["responseCode"] = this.responseCode;
        data["polledToTQ"] = this.polledToTQ;
        data["isLoan"] = this.isLoan;
        return data;
    }
}

export interface IPolicyDetails {
    fullName?: string | undefined;
    agentName?: string | undefined;
    policies?: string[] | undefined;
    clientAddress?: string | undefined;
    clientEmail?: string | undefined;
    clientPhoneNumber?: string | undefined;
    wef?: string | undefined;
    wet?: string | undefined;
    totalAmount?: string | undefined;
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    hash?: string | undefined;
    responseMessage?: string | undefined;
    responseCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;
}

export class CreateGtBankLeadDto implements ICreateGtBankLeadDto {
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    refId?: string | undefined;
    children?: BancassuranceDetail[] | undefined;

    constructor(data?: ICreateGtBankLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.dob = _data["dob"];
            this.refId = _data["refId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BancassuranceDetail.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateGtBankLeadDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateGtBankLeadDto>(data, _mappings, CreateGtBankLeadDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["dob"] = this.dob;
        data["refId"] = this.refId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateGtBankLeadDto {
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    refId?: string | undefined;
    children?: BancassuranceDetail[] | undefined;
}

export class BancassuranceDetail implements IBancassuranceDetail {
    bancassuranceLead?: GtBankLead | undefined;
    bancassuranceLeadId?: string | undefined;
    childName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    id?: string | undefined;

    constructor(data?: IBancassuranceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.bancassuranceLead = _data["bancassuranceLead"] ? GtBankLead.fromJS(_data["bancassuranceLead"], _mappings) : <any>undefined;
            this.bancassuranceLeadId = _data["bancassuranceLeadId"];
            this.childName = _data["childName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): BancassuranceDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BancassuranceDetail>(data, _mappings, BancassuranceDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bancassuranceLead"] = this.bancassuranceLead ? this.bancassuranceLead.toJSON() : <any>undefined;
        data["bancassuranceLeadId"] = this.bancassuranceLeadId;
        data["childName"] = this.childName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["id"] = this.id;
        return data;
    }
}

export interface IBancassuranceDetail {
    bancassuranceLead?: GtBankLead | undefined;
    bancassuranceLeadId?: string | undefined;
    childName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    id?: string | undefined;
}

export class GtBankLead implements IGtBankLead {
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    location?: string | undefined;
    refId?: string | undefined;
    postedOn?: Date | undefined;
    polledToCrm?: boolean | undefined;
    children?: BancassuranceDetail[] | undefined;
    id?: string | undefined;

    constructor(data?: IGtBankLead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.dob = _data["dob"];
            this.location = _data["location"];
            this.refId = _data["refId"];
            this.postedOn = _data["postedOn"] ? new Date(_data["postedOn"].toString()) : <any>undefined;
            this.polledToCrm = _data["polledToCrm"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BancassuranceDetail.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): GtBankLead | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GtBankLead>(data, _mappings, GtBankLead);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["dob"] = this.dob;
        data["location"] = this.location;
        data["refId"] = this.refId;
        data["postedOn"] = this.postedOn ? this.postedOn.toISOString() : <any>undefined;
        data["polledToCrm"] = this.polledToCrm;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGtBankLead {
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dob?: string | undefined;
    location?: string | undefined;
    refId?: string | undefined;
    postedOn?: Date | undefined;
    polledToCrm?: boolean | undefined;
    children?: BancassuranceDetail[] | undefined;
    id?: string | undefined;
}

export class BrianBoxRequisitionsModel implements IBrianBoxRequisitionsModel {
    branchShortDesc?: string | undefined;
    organisationCode?: number | undefined;
    curDesc?: string | undefined;
    vcbDate?: Date | undefined;
    description?: string | undefined;
    reference?: string | undefined;
    raisedBy?: number | undefined;
    raisedOn?: Date | undefined;
    chqueNo?: string | undefined;
    chequeDate?: Date | undefined;
    amount?: number | undefined;
    bctAccount?: string | undefined;
    currentRate?: number | undefined;
    mode?: string | undefined;
    reqPayee?: string | undefined;

    constructor(data?: IBrianBoxRequisitionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.branchShortDesc = _data["branchShortDesc"];
            this.organisationCode = _data["organisationCode"];
            this.curDesc = _data["curDesc"];
            this.vcbDate = _data["vcbDate"] ? new Date(_data["vcbDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.reference = _data["reference"];
            this.raisedBy = _data["raisedBy"];
            this.raisedOn = _data["raisedOn"] ? new Date(_data["raisedOn"].toString()) : <any>undefined;
            this.chqueNo = _data["chqueNo"];
            this.chequeDate = _data["chequeDate"] ? new Date(_data["chequeDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.bctAccount = _data["bctAccount"];
            this.currentRate = _data["currentRate"];
            this.mode = _data["mode"];
            this.reqPayee = _data["reqPayee"];
        }
    }

    static fromJS(data: any, _mappings?: any): BrianBoxRequisitionsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BrianBoxRequisitionsModel>(data, _mappings, BrianBoxRequisitionsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchShortDesc"] = this.branchShortDesc;
        data["organisationCode"] = this.organisationCode;
        data["curDesc"] = this.curDesc;
        data["vcbDate"] = this.vcbDate ? this.vcbDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["reference"] = this.reference;
        data["raisedBy"] = this.raisedBy;
        data["raisedOn"] = this.raisedOn ? this.raisedOn.toISOString() : <any>undefined;
        data["chqueNo"] = this.chqueNo;
        data["chequeDate"] = this.chequeDate ? this.chequeDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["bctAccount"] = this.bctAccount;
        data["currentRate"] = this.currentRate;
        data["mode"] = this.mode;
        data["reqPayee"] = this.reqPayee;
        return data;
    }
}

export interface IBrianBoxRequisitionsModel {
    branchShortDesc?: string | undefined;
    organisationCode?: number | undefined;
    curDesc?: string | undefined;
    vcbDate?: Date | undefined;
    description?: string | undefined;
    reference?: string | undefined;
    raisedBy?: number | undefined;
    raisedOn?: Date | undefined;
    chqueNo?: string | undefined;
    chequeDate?: Date | undefined;
    amount?: number | undefined;
    bctAccount?: string | undefined;
    currentRate?: number | undefined;
    mode?: string | undefined;
    reqPayee?: string | undefined;
}

export class BrianBoxBeneficiaryModel implements IBrianBoxBeneficiaryModel {
    reference?: string | undefined;
    beneficiaryName?: string | undefined;
    beneficiaryBank?: string | undefined;
    costCenter?: string | undefined;
    expenseType?: string | undefined;
    accountCode?: string | undefined;
    amount?: string | undefined;
    branchName?: string | undefined;
    bankName?: string | undefined;
    physicalAddress?: string | undefined;
    bankRefCode?: string | undefined;

    constructor(data?: IBrianBoxBeneficiaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.beneficiaryName = _data["beneficiaryName"];
            this.beneficiaryBank = _data["beneficiaryBank"];
            this.costCenter = _data["costCenter"];
            this.expenseType = _data["expenseType"];
            this.accountCode = _data["accountCode"];
            this.amount = _data["amount"];
            this.branchName = _data["branchName"];
            this.bankName = _data["bankName"];
            this.physicalAddress = _data["physicalAddress"];
            this.bankRefCode = _data["bankRefCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): BrianBoxBeneficiaryModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BrianBoxBeneficiaryModel>(data, _mappings, BrianBoxBeneficiaryModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["beneficiaryName"] = this.beneficiaryName;
        data["beneficiaryBank"] = this.beneficiaryBank;
        data["costCenter"] = this.costCenter;
        data["expenseType"] = this.expenseType;
        data["accountCode"] = this.accountCode;
        data["amount"] = this.amount;
        data["branchName"] = this.branchName;
        data["bankName"] = this.bankName;
        data["physicalAddress"] = this.physicalAddress;
        data["bankRefCode"] = this.bankRefCode;
        return data;
    }
}

export interface IBrianBoxBeneficiaryModel {
    reference?: string | undefined;
    beneficiaryName?: string | undefined;
    beneficiaryBank?: string | undefined;
    costCenter?: string | undefined;
    expenseType?: string | undefined;
    accountCode?: string | undefined;
    amount?: string | undefined;
    branchName?: string | undefined;
    bankName?: string | undefined;
    physicalAddress?: string | undefined;
    bankRefCode?: string | undefined;
}

export class ClaimsModel implements IClaimsModel {
    policyNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    product?: string | undefined;
    departureDate?: string | undefined;
    returnDate?: string | undefined;
    dateofoccurrence?: string | undefined;
    locationofOccurrence?: string | undefined;
    detailsofIncident?: string | undefined;
    vehicleRegNumber?: string | undefined;
    dateofIncident?: string | undefined;
    timeofIncident?: string | undefined;
    estimateofRepairs?: string | undefined;
    driverSide?: string | undefined;
    passengerSide?: string | undefined;
    carCenter?: string | undefined;
    typeofClaim?: number | undefined;

    constructor(data?: IClaimsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.product = _data["product"];
            this.departureDate = _data["departureDate"];
            this.returnDate = _data["returnDate"];
            this.dateofoccurrence = _data["dateofoccurrence"];
            this.locationofOccurrence = _data["locationofOccurrence"];
            this.detailsofIncident = _data["detailsofIncident"];
            this.vehicleRegNumber = _data["vehicleRegNumber"];
            this.dateofIncident = _data["dateofIncident"];
            this.timeofIncident = _data["timeofIncident"];
            this.estimateofRepairs = _data["estimateofRepairs"];
            this.driverSide = _data["driverSide"];
            this.passengerSide = _data["passengerSide"];
            this.carCenter = _data["carCenter"];
            this.typeofClaim = _data["typeofClaim"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClaimsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClaimsModel>(data, _mappings, ClaimsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["product"] = this.product;
        data["departureDate"] = this.departureDate;
        data["returnDate"] = this.returnDate;
        data["dateofoccurrence"] = this.dateofoccurrence;
        data["locationofOccurrence"] = this.locationofOccurrence;
        data["detailsofIncident"] = this.detailsofIncident;
        data["vehicleRegNumber"] = this.vehicleRegNumber;
        data["dateofIncident"] = this.dateofIncident;
        data["timeofIncident"] = this.timeofIncident;
        data["estimateofRepairs"] = this.estimateofRepairs;
        data["driverSide"] = this.driverSide;
        data["passengerSide"] = this.passengerSide;
        data["carCenter"] = this.carCenter;
        data["typeofClaim"] = this.typeofClaim;
        return data;
    }
}

export interface IClaimsModel {
    policyNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    product?: string | undefined;
    departureDate?: string | undefined;
    returnDate?: string | undefined;
    dateofoccurrence?: string | undefined;
    locationofOccurrence?: string | undefined;
    detailsofIncident?: string | undefined;
    vehicleRegNumber?: string | undefined;
    dateofIncident?: string | undefined;
    timeofIncident?: string | undefined;
    estimateofRepairs?: string | undefined;
    driverSide?: string | undefined;
    passengerSide?: string | undefined;
    carCenter?: string | undefined;
    typeofClaim?: number | undefined;
}

export class ViewMotorTransactionsViewModel implements IViewMotorTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    vehicleAmount?: number | undefined;
    coverType?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewMotorTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.coverType = _data["coverType"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewMotorTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewMotorTransactionsViewModel>(data, _mappings, ViewMotorTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["vehicleAmount"] = this.vehicleAmount;
        data["coverType"] = this.coverType;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewMotorTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    vehicleAmount?: number | undefined;
    coverType?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class MotorTransactionResponse implements IMotorTransactionResponse {
    motorTransactionsViewModel?: ViewMotorTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IMotorTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.motorTransactionsViewModel = _data["motorTransactionsViewModel"] ? ViewMotorTransactionsViewModel.fromJS(_data["motorTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): MotorTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MotorTransactionResponse>(data, _mappings, MotorTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motorTransactionsViewModel"] = this.motorTransactionsViewModel ? this.motorTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IMotorTransactionResponse {
    motorTransactionsViewModel?: ViewMotorTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewTravelTransactionsViewModel implements IViewTravelTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    countryType?: string | undefined;
    policyDuration?: string | undefined;
    destinationCountry?: string | undefined;
    passportNumber?: string | undefined;
    rowCount?: number | undefined;
    passportUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewTravelTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.countryType = _data["countryType"];
            this.policyDuration = _data["policyDuration"];
            this.destinationCountry = _data["destinationCountry"];
            this.passportNumber = _data["passportNumber"];
            this.rowCount = _data["rowCount"];
            this.passportUrl = _data["passportUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewTravelTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewTravelTransactionsViewModel>(data, _mappings, ViewTravelTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["countryType"] = this.countryType;
        data["policyDuration"] = this.policyDuration;
        data["destinationCountry"] = this.destinationCountry;
        data["passportNumber"] = this.passportNumber;
        data["rowCount"] = this.rowCount;
        data["passportUrl"] = this.passportUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewTravelTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    countryType?: string | undefined;
    policyDuration?: string | undefined;
    destinationCountry?: string | undefined;
    passportNumber?: string | undefined;
    rowCount?: number | undefined;
    passportUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class TravelTransactionResponse implements ITravelTransactionResponse {
    travelTransactionsViewModel?: ViewTravelTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: ITravelTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.travelTransactionsViewModel = _data["travelTransactionsViewModel"] ? ViewTravelTransactionsViewModel.fromJS(_data["travelTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelTransactionResponse>(data, _mappings, TravelTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelTransactionsViewModel"] = this.travelTransactionsViewModel ? this.travelTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface ITravelTransactionResponse {
    travelTransactionsViewModel?: ViewTravelTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewLifeRenewalTransactionsViewModel implements IViewLifeRenewalTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    policyNumber?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    status?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
    ncspProposalConversion?: boolean | undefined;

    constructor(data?: IViewLifeRenewalTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.policyNumber = _data["policyNumber"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.status = _data["status"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
            this.ncspProposalConversion = _data["ncspProposalConversion"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewLifeRenewalTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewLifeRenewalTransactionsViewModel>(data, _mappings, ViewLifeRenewalTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["policyNumber"] = this.policyNumber;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["status"] = this.status;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        data["ncspProposalConversion"] = this.ncspProposalConversion;
        return data;
    }
}

export interface IViewLifeRenewalTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    policyNumber?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    status?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
    ncspProposalConversion?: boolean | undefined;
}

export class LifeRenewalTransactionResponse implements ILifeRenewalTransactionResponse {
    lifeRenewalTransactionsViewModel?: ViewLifeRenewalTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: ILifeRenewalTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.lifeRenewalTransactionsViewModel = _data["lifeRenewalTransactionsViewModel"] ? ViewLifeRenewalTransactionsViewModel.fromJS(_data["lifeRenewalTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalTransactionResponse>(data, _mappings, LifeRenewalTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lifeRenewalTransactionsViewModel"] = this.lifeRenewalTransactionsViewModel ? this.lifeRenewalTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface ILifeRenewalTransactionResponse {
    lifeRenewalTransactionsViewModel?: ViewLifeRenewalTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewHomeTransactionsViewModel implements IViewHomeTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    valueOfContents?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    contents?: HomeScheduleDetail[] | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewHomeTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.valueOfContents = _data["valueOfContents"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(HomeScheduleDetail.fromJS(item, _mappings));
            }
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewHomeTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewHomeTransactionsViewModel>(data, _mappings, ViewHomeTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["valueOfContents"] = this.valueOfContents;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewHomeTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    valueOfContents?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    contents?: HomeScheduleDetail[] | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class HomeScheduleDetail implements IHomeScheduleDetail {
    homeSchedule?: HomeSchedule | undefined;
    homeScheduleId?: string | undefined;
    nameOfContent?: string | undefined;
    valueOfContent?: number | undefined;
    id?: string | undefined;

    constructor(data?: IHomeScheduleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.homeSchedule = _data["homeSchedule"] ? HomeSchedule.fromJS(_data["homeSchedule"], _mappings) : <any>undefined;
            this.homeScheduleId = _data["homeScheduleId"];
            this.nameOfContent = _data["nameOfContent"];
            this.valueOfContent = _data["valueOfContent"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): HomeScheduleDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HomeScheduleDetail>(data, _mappings, HomeScheduleDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeSchedule"] = this.homeSchedule ? this.homeSchedule.toJSON() : <any>undefined;
        data["homeScheduleId"] = this.homeScheduleId;
        data["nameOfContent"] = this.nameOfContent;
        data["valueOfContent"] = this.valueOfContent;
        data["id"] = this.id;
        return data;
    }
}

export interface IHomeScheduleDetail {
    homeSchedule?: HomeSchedule | undefined;
    homeScheduleId?: string | undefined;
    nameOfContent?: string | undefined;
    valueOfContent?: number | undefined;
    id?: string | undefined;
}

export class HomeSchedule implements IHomeSchedule {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    valueOfContents?: number | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IHomeSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.preOwnership = _data["preOwnership"];
            this.tenancy = _data["tenancy"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.postalAddress = _data["postalAddress"];
            this.lga = _data["lga"] ? Lga.fromJS(_data["lga"], _mappings) : <any>undefined;
            this.lgaId = _data["lgaId"];
            this.valueOfContents = _data["valueOfContents"];
            this.premiumAmount = _data["premiumAmount"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): HomeSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HomeSchedule>(data, _mappings, HomeSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preOwnership"] = this.preOwnership;
        data["tenancy"] = this.tenancy;
        data["description"] = this.description;
        data["address"] = this.address;
        data["postalAddress"] = this.postalAddress;
        data["lga"] = this.lga ? this.lga.toJSON() : <any>undefined;
        data["lgaId"] = this.lgaId;
        data["valueOfContents"] = this.valueOfContents;
        data["premiumAmount"] = this.premiumAmount;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IHomeSchedule {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    valueOfContents?: number | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class Lga implements ILga {
    desc?: string | undefined;
    name?: string | undefined;
    stateId?: string | undefined;
    state?: State | undefined;
    id?: string | undefined;

    constructor(data?: ILga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.desc = _data["desc"];
            this.name = _data["name"];
            this.stateId = _data["stateId"];
            this.state = _data["state"] ? State.fromJS(_data["state"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Lga | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Lga>(data, _mappings, Lga);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desc"] = this.desc;
        data["name"] = this.name;
        data["stateId"] = this.stateId;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ILga {
    desc?: string | undefined;
    name?: string | undefined;
    stateId?: string | undefined;
    state?: State | undefined;
    id?: string | undefined;
}

export class SubclassSectCovtype implements ISubclassSectCovtype {
    desc?: string | undefined;
    subclass?: Subclass | undefined;
    coverType?: CoverType | undefined;
    section?: Section | undefined;
    subclassId?: string | undefined;
    coverTypeId?: string | undefined;
    sectionId?: string | undefined;
    thirdParty?: boolean | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: ISubclassSectCovtype) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.thirdParty = false;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.desc = _data["desc"];
            this.subclass = _data["subclass"] ? Subclass.fromJS(_data["subclass"], _mappings) : <any>undefined;
            this.coverType = _data["coverType"] ? CoverType.fromJS(_data["coverType"], _mappings) : <any>undefined;
            this.section = _data["section"] ? Section.fromJS(_data["section"], _mappings) : <any>undefined;
            this.subclassId = _data["subclassId"];
            this.coverTypeId = _data["coverTypeId"];
            this.sectionId = _data["sectionId"];
            this.thirdParty = _data["thirdParty"] !== undefined ? _data["thirdParty"] : false;
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubclassSectCovtype | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubclassSectCovtype>(data, _mappings, SubclassSectCovtype);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desc"] = this.desc;
        data["subclass"] = this.subclass ? this.subclass.toJSON() : <any>undefined;
        data["coverType"] = this.coverType ? this.coverType.toJSON() : <any>undefined;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["subclassId"] = this.subclassId;
        data["coverTypeId"] = this.coverTypeId;
        data["sectionId"] = this.sectionId;
        data["thirdParty"] = this.thirdParty;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubclassSectCovtype {
    desc?: string | undefined;
    subclass?: Subclass | undefined;
    coverType?: CoverType | undefined;
    section?: Section | undefined;
    subclassId?: string | undefined;
    coverTypeId?: string | undefined;
    sectionId?: string | undefined;
    thirdParty?: boolean | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class ClientApplication implements IClientApplication {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    apiKey?: string | undefined;
    access?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IClientApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.apiKey = _data["apiKey"];
            this.access = _data["access"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientApplication | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientApplication>(data, _mappings, ClientApplication);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["apiKey"] = this.apiKey;
        data["access"] = this.access;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientApplication {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    apiKey?: string | undefined;
    access?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class Product implements IProduct {
    prefix?: string | undefined;
    name?: string | undefined;
    reqUW?: boolean | undefined;
    renewable?: boolean | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    productCategory?: ProductCategory | undefined;
    productCategoryId?: string | undefined;
    class?: Class | undefined;
    classId?: string | undefined;
    isThirdParty?: boolean | undefined;
    isActive?: boolean | undefined;
    subclasses?: Subclass[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.reqUW = _data["reqUW"];
            this.renewable = _data["renewable"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"], _mappings) : <any>undefined;
            this.productCategoryId = _data["productCategoryId"];
            this.class = _data["class"] ? Class.fromJS(_data["class"], _mappings) : <any>undefined;
            this.classId = _data["classId"];
            this.isThirdParty = _data["isThirdParty"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["subclasses"])) {
                this.subclasses = [] as any;
                for (let item of _data["subclasses"])
                    this.subclasses!.push(Subclass.fromJS(item, _mappings));
            }
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Product | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Product>(data, _mappings, Product);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["reqUW"] = this.reqUW;
        data["renewable"] = this.renewable;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["class"] = this.class ? this.class.toJSON() : <any>undefined;
        data["classId"] = this.classId;
        data["isThirdParty"] = this.isThirdParty;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.subclasses)) {
            data["subclasses"] = [];
            for (let item of this.subclasses)
                data["subclasses"].push(item.toJSON());
        }
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IProduct {
    prefix?: string | undefined;
    name?: string | undefined;
    reqUW?: boolean | undefined;
    renewable?: boolean | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    productCategory?: ProductCategory | undefined;
    productCategoryId?: string | undefined;
    class?: Class | undefined;
    classId?: string | undefined;
    isThirdParty?: boolean | undefined;
    isActive?: boolean | undefined;
    subclasses?: Subclass[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Branch implements IBranch {
    organisation?: Organisation | undefined;
    organisationId?: string | undefined;
    prefix?: string | undefined;
    shtDesc?: string | undefined;
    regCode?: string | undefined;
    name?: string | undefined;
    phyAddrs?: string | undefined;
    emailAddrs?: string | undefined;
    postAddrs?: string | undefined;
    town?: Lga | undefined;
    townId?: string | undefined;
    contact?: string | undefined;
    manager?: User | undefined;
    managerId?: number | undefined;
    tel?: string | undefined;
    fax?: string | undefined;
    locationCoordinate?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.organisation = _data["organisation"] ? Organisation.fromJS(_data["organisation"], _mappings) : <any>undefined;
            this.organisationId = _data["organisationId"];
            this.prefix = _data["prefix"];
            this.shtDesc = _data["shtDesc"];
            this.regCode = _data["regCode"];
            this.name = _data["name"];
            this.phyAddrs = _data["phyAddrs"];
            this.emailAddrs = _data["emailAddrs"];
            this.postAddrs = _data["postAddrs"];
            this.town = _data["town"] ? Lga.fromJS(_data["town"], _mappings) : <any>undefined;
            this.townId = _data["townId"];
            this.contact = _data["contact"];
            this.manager = _data["manager"] ? User.fromJS(_data["manager"], _mappings) : <any>undefined;
            this.managerId = _data["managerId"];
            this.tel = _data["tel"];
            this.fax = _data["fax"];
            this.locationCoordinate = _data["locationCoordinate"];
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Branch | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Branch>(data, _mappings, Branch);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisation"] = this.organisation ? this.organisation.toJSON() : <any>undefined;
        data["organisationId"] = this.organisationId;
        data["prefix"] = this.prefix;
        data["shtDesc"] = this.shtDesc;
        data["regCode"] = this.regCode;
        data["name"] = this.name;
        data["phyAddrs"] = this.phyAddrs;
        data["emailAddrs"] = this.emailAddrs;
        data["postAddrs"] = this.postAddrs;
        data["town"] = this.town ? this.town.toJSON() : <any>undefined;
        data["townId"] = this.townId;
        data["contact"] = this.contact;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["managerId"] = this.managerId;
        data["tel"] = this.tel;
        data["fax"] = this.fax;
        data["locationCoordinate"] = this.locationCoordinate;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IBranch {
    organisation?: Organisation | undefined;
    organisationId?: string | undefined;
    prefix?: string | undefined;
    shtDesc?: string | undefined;
    regCode?: string | undefined;
    name?: string | undefined;
    phyAddrs?: string | undefined;
    emailAddrs?: string | undefined;
    postAddrs?: string | undefined;
    town?: Lga | undefined;
    townId?: string | undefined;
    contact?: string | undefined;
    manager?: User | undefined;
    managerId?: number | undefined;
    tel?: string | undefined;
    fax?: string | undefined;
    locationCoordinate?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Client implements IClient {
    code?: number | undefined;
    clientNo?: string | undefined;
    user?: User | undefined;
    userId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    titleId?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: Gender | undefined;
    genderId?: string | undefined;
    pryEmail?: string | undefined;
    secEmail?: string | undefined;
    accOfficer?: User | undefined;
    accOfficerId?: number | undefined;
    parent?: Client | undefined;
    parentId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    businessOrOccupation?: string | undefined;
    categoryWorth?: string | undefined;
    createdBy?: User | undefined;
    createdById?: number | undefined;
    dateCreated?: Date | undefined;
    dateOfEmpl?: Date | undefined;
    employerPhoneNo?: string | undefined;
    preferredCommMode?: string | undefined;
    domiciledCountry?: Country | undefined;
    domiciledCountryId?: string | undefined;
    regDate?: Date | undefined;
    regNumber?: string | undefined;
    dlNo?: string | undefined;
    dlExpiryDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    fax?: string | undefined;
    imagePath?: string | undefined;
    maritalStatus?: MaritalStatus | undefined;
    maritalStatusId?: string | undefined;
    passportNo?: string | undefined;
    physicalAddrs?: string | undefined;
    pin?: string | undefined;
    postalAddrs?: string | undefined;
    oldAccntNo?: string | undefined;
    proposer?: string | undefined;
    salMinRange?: number | undefined;
    salMaxRange?: number | undefined;
    signature?: string | undefined;
    smsTel?: string | undefined;
    altTel?: string | undefined;
    isActive?: boolean | undefined;
    town?: Lga | undefined;
    townId?: string | undefined;
    website?: string | undefined;
    workPermit?: string | undefined;
    zipCode?: string | undefined;
    crdtRating?: string | undefined;
    creditLimAllowed?: boolean | undefined;
    creditLimit?: number | undefined;
    terminateDate?: Date | undefined;
    withdrawalReason?: string | undefined;
    prospectStatus?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;
    risks?: Risk[] | undefined;
    clientCategoryId?: string | undefined;
    clientCategory?: ClientCategory | undefined;
    clientType?: ClientType | undefined;
    clientTypeId?: string | undefined;
    title?: Title | undefined;
    occupation?: string | undefined;
    accountNumber?: number | undefined;
    locationCoordinate?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.clientNo = _data["clientNo"];
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : <any>undefined;
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.titleId = _data["titleId"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"] ? Gender.fromJS(_data["gender"], _mappings) : <any>undefined;
            this.genderId = _data["genderId"];
            this.pryEmail = _data["pryEmail"];
            this.secEmail = _data["secEmail"];
            this.accOfficer = _data["accOfficer"] ? User.fromJS(_data["accOfficer"], _mappings) : <any>undefined;
            this.accOfficerId = _data["accOfficerId"];
            this.parent = _data["parent"] ? Client.fromJS(_data["parent"], _mappings) : <any>undefined;
            this.parentId = _data["parentId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.businessOrOccupation = _data["businessOrOccupation"];
            this.categoryWorth = _data["categoryWorth"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"], _mappings) : <any>undefined;
            this.createdById = _data["createdById"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateOfEmpl = _data["dateOfEmpl"] ? new Date(_data["dateOfEmpl"].toString()) : <any>undefined;
            this.employerPhoneNo = _data["employerPhoneNo"];
            this.preferredCommMode = _data["preferredCommMode"];
            this.domiciledCountry = _data["domiciledCountry"] ? Country.fromJS(_data["domiciledCountry"], _mappings) : <any>undefined;
            this.domiciledCountryId = _data["domiciledCountryId"];
            this.regDate = _data["regDate"] ? new Date(_data["regDate"].toString()) : <any>undefined;
            this.regNumber = _data["regNumber"];
            this.dlNo = _data["dlNo"];
            this.dlExpiryDate = _data["dlExpiryDate"] ? new Date(_data["dlExpiryDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.fax = _data["fax"];
            this.imagePath = _data["imagePath"];
            this.maritalStatus = _data["maritalStatus"] ? MaritalStatus.fromJS(_data["maritalStatus"], _mappings) : <any>undefined;
            this.maritalStatusId = _data["maritalStatusId"];
            this.passportNo = _data["passportNo"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.pin = _data["pin"];
            this.postalAddrs = _data["postalAddrs"];
            this.oldAccntNo = _data["oldAccntNo"];
            this.proposer = _data["proposer"];
            this.salMinRange = _data["salMinRange"];
            this.salMaxRange = _data["salMaxRange"];
            this.signature = _data["signature"];
            this.smsTel = _data["smsTel"];
            this.altTel = _data["altTel"];
            this.isActive = _data["isActive"];
            this.town = _data["town"] ? Lga.fromJS(_data["town"], _mappings) : <any>undefined;
            this.townId = _data["townId"];
            this.website = _data["website"];
            this.workPermit = _data["workPermit"];
            this.zipCode = _data["zipCode"];
            this.crdtRating = _data["crdtRating"];
            this.creditLimAllowed = _data["creditLimAllowed"];
            this.creditLimit = _data["creditLimit"];
            this.terminateDate = _data["terminateDate"] ? new Date(_data["terminateDate"].toString()) : <any>undefined;
            this.withdrawalReason = _data["withdrawalReason"];
            this.prospectStatus = _data["prospectStatus"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(Beneficiary.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["risks"])) {
                this.risks = [] as any;
                for (let item of _data["risks"])
                    this.risks!.push(Risk.fromJS(item, _mappings));
            }
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientCategory = _data["clientCategory"] ? ClientCategory.fromJS(_data["clientCategory"], _mappings) : <any>undefined;
            this.clientType = _data["clientType"] ? ClientType.fromJS(_data["clientType"], _mappings) : <any>undefined;
            this.clientTypeId = _data["clientTypeId"];
            this.title = _data["title"] ? Title.fromJS(_data["title"], _mappings) : <any>undefined;
            this.occupation = _data["occupation"];
            this.accountNumber = _data["accountNumber"];
            this.locationCoordinate = _data["locationCoordinate"];
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Client | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Client>(data, _mappings, Client);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["clientNo"] = this.clientNo;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["titleId"] = this.titleId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["genderId"] = this.genderId;
        data["pryEmail"] = this.pryEmail;
        data["secEmail"] = this.secEmail;
        data["accOfficer"] = this.accOfficer ? this.accOfficer.toJSON() : <any>undefined;
        data["accOfficerId"] = this.accOfficerId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["businessOrOccupation"] = this.businessOrOccupation;
        data["categoryWorth"] = this.categoryWorth;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdById"] = this.createdById;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateOfEmpl"] = this.dateOfEmpl ? this.dateOfEmpl.toISOString() : <any>undefined;
        data["employerPhoneNo"] = this.employerPhoneNo;
        data["preferredCommMode"] = this.preferredCommMode;
        data["domiciledCountry"] = this.domiciledCountry ? this.domiciledCountry.toJSON() : <any>undefined;
        data["domiciledCountryId"] = this.domiciledCountryId;
        data["regDate"] = this.regDate ? this.regDate.toISOString() : <any>undefined;
        data["regNumber"] = this.regNumber;
        data["dlNo"] = this.dlNo;
        data["dlExpiryDate"] = this.dlExpiryDate ? this.dlExpiryDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["fax"] = this.fax;
        data["imagePath"] = this.imagePath;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["maritalStatusId"] = this.maritalStatusId;
        data["passportNo"] = this.passportNo;
        data["physicalAddrs"] = this.physicalAddrs;
        data["pin"] = this.pin;
        data["postalAddrs"] = this.postalAddrs;
        data["oldAccntNo"] = this.oldAccntNo;
        data["proposer"] = this.proposer;
        data["salMinRange"] = this.salMinRange;
        data["salMaxRange"] = this.salMaxRange;
        data["signature"] = this.signature;
        data["smsTel"] = this.smsTel;
        data["altTel"] = this.altTel;
        data["isActive"] = this.isActive;
        data["town"] = this.town ? this.town.toJSON() : <any>undefined;
        data["townId"] = this.townId;
        data["website"] = this.website;
        data["workPermit"] = this.workPermit;
        data["zipCode"] = this.zipCode;
        data["crdtRating"] = this.crdtRating;
        data["creditLimAllowed"] = this.creditLimAllowed;
        data["creditLimit"] = this.creditLimit;
        data["terminateDate"] = this.terminateDate ? this.terminateDate.toISOString() : <any>undefined;
        data["withdrawalReason"] = this.withdrawalReason;
        data["prospectStatus"] = this.prospectStatus;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        if (Array.isArray(this.risks)) {
            data["risks"] = [];
            for (let item of this.risks)
                data["risks"].push(item.toJSON());
        }
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientCategory"] = this.clientCategory ? this.clientCategory.toJSON() : <any>undefined;
        data["clientType"] = this.clientType ? this.clientType.toJSON() : <any>undefined;
        data["clientTypeId"] = this.clientTypeId;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["occupation"] = this.occupation;
        data["accountNumber"] = this.accountNumber;
        data["locationCoordinate"] = this.locationCoordinate;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IClient {
    code?: number | undefined;
    clientNo?: string | undefined;
    user?: User | undefined;
    userId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    titleId?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: Gender | undefined;
    genderId?: string | undefined;
    pryEmail?: string | undefined;
    secEmail?: string | undefined;
    accOfficer?: User | undefined;
    accOfficerId?: number | undefined;
    parent?: Client | undefined;
    parentId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    businessOrOccupation?: string | undefined;
    categoryWorth?: string | undefined;
    createdBy?: User | undefined;
    createdById?: number | undefined;
    dateCreated?: Date | undefined;
    dateOfEmpl?: Date | undefined;
    employerPhoneNo?: string | undefined;
    preferredCommMode?: string | undefined;
    domiciledCountry?: Country | undefined;
    domiciledCountryId?: string | undefined;
    regDate?: Date | undefined;
    regNumber?: string | undefined;
    dlNo?: string | undefined;
    dlExpiryDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    fax?: string | undefined;
    imagePath?: string | undefined;
    maritalStatus?: MaritalStatus | undefined;
    maritalStatusId?: string | undefined;
    passportNo?: string | undefined;
    physicalAddrs?: string | undefined;
    pin?: string | undefined;
    postalAddrs?: string | undefined;
    oldAccntNo?: string | undefined;
    proposer?: string | undefined;
    salMinRange?: number | undefined;
    salMaxRange?: number | undefined;
    signature?: string | undefined;
    smsTel?: string | undefined;
    altTel?: string | undefined;
    isActive?: boolean | undefined;
    town?: Lga | undefined;
    townId?: string | undefined;
    website?: string | undefined;
    workPermit?: string | undefined;
    zipCode?: string | undefined;
    crdtRating?: string | undefined;
    creditLimAllowed?: boolean | undefined;
    creditLimit?: number | undefined;
    terminateDate?: Date | undefined;
    withdrawalReason?: string | undefined;
    prospectStatus?: boolean | undefined;
    beneficiaries?: Beneficiary[] | undefined;
    risks?: Risk[] | undefined;
    clientCategoryId?: string | undefined;
    clientCategory?: ClientCategory | undefined;
    clientType?: ClientType | undefined;
    clientTypeId?: string | undefined;
    title?: Title | undefined;
    occupation?: string | undefined;
    accountNumber?: number | undefined;
    locationCoordinate?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Policy implements IPolicy {
    policyNo?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    inceptionDt?: Date | undefined;
    renewable?: boolean | undefined;
    renewalDt?: Date | undefined;
    isActive?: boolean | undefined;
    cancelDt?: Date | undefined;
    loaded?: boolean | undefined;
    oldPolicyNo?: string | undefined;
    freqOfPayment?: string | undefined;
    osInstlmtNo?: number | undefined;
    instlmtAmt?: number | undefined;
    instlmtNxtDate?: Date | undefined;
    instlmtNxtPrem?: number | undefined;
    osPremBalAmt?: number | undefined;
    paidInstlmtNo?: number | undefined;
    paidToDate?: number | undefined;
    facultative?: boolean | undefined;
    trxnPayMethod?: string | undefined;
    transactionRef?: string | undefined;
    policyEndorsements?: PolicyEndorsement[] | undefined;
    id?: string | undefined;

    constructor(data?: IPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.inceptionDt = _data["inceptionDt"] ? new Date(_data["inceptionDt"].toString()) : <any>undefined;
            this.renewable = _data["renewable"];
            this.renewalDt = _data["renewalDt"] ? new Date(_data["renewalDt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.cancelDt = _data["cancelDt"] ? new Date(_data["cancelDt"].toString()) : <any>undefined;
            this.loaded = _data["loaded"];
            this.oldPolicyNo = _data["oldPolicyNo"];
            this.freqOfPayment = _data["freqOfPayment"];
            this.osInstlmtNo = _data["osInstlmtNo"];
            this.instlmtAmt = _data["instlmtAmt"];
            this.instlmtNxtDate = _data["instlmtNxtDate"] ? new Date(_data["instlmtNxtDate"].toString()) : <any>undefined;
            this.instlmtNxtPrem = _data["instlmtNxtPrem"];
            this.osPremBalAmt = _data["osPremBalAmt"];
            this.paidInstlmtNo = _data["paidInstlmtNo"];
            this.paidToDate = _data["paidToDate"];
            this.facultative = _data["facultative"];
            this.trxnPayMethod = _data["trxnPayMethod"];
            this.transactionRef = _data["transactionRef"];
            if (Array.isArray(_data["policyEndorsements"])) {
                this.policyEndorsements = [] as any;
                for (let item of _data["policyEndorsements"])
                    this.policyEndorsements!.push(PolicyEndorsement.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Policy | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Policy>(data, _mappings, Policy);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["inceptionDt"] = this.inceptionDt ? this.inceptionDt.toISOString() : <any>undefined;
        data["renewable"] = this.renewable;
        data["renewalDt"] = this.renewalDt ? this.renewalDt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["cancelDt"] = this.cancelDt ? this.cancelDt.toISOString() : <any>undefined;
        data["loaded"] = this.loaded;
        data["oldPolicyNo"] = this.oldPolicyNo;
        data["freqOfPayment"] = this.freqOfPayment;
        data["osInstlmtNo"] = this.osInstlmtNo;
        data["instlmtAmt"] = this.instlmtAmt;
        data["instlmtNxtDate"] = this.instlmtNxtDate ? this.instlmtNxtDate.toISOString() : <any>undefined;
        data["instlmtNxtPrem"] = this.instlmtNxtPrem;
        data["osPremBalAmt"] = this.osPremBalAmt;
        data["paidInstlmtNo"] = this.paidInstlmtNo;
        data["paidToDate"] = this.paidToDate;
        data["facultative"] = this.facultative;
        data["trxnPayMethod"] = this.trxnPayMethod;
        data["transactionRef"] = this.transactionRef;
        if (Array.isArray(this.policyEndorsements)) {
            data["policyEndorsements"] = [];
            for (let item of this.policyEndorsements)
                data["policyEndorsements"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPolicy {
    policyNo?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    inceptionDt?: Date | undefined;
    renewable?: boolean | undefined;
    renewalDt?: Date | undefined;
    isActive?: boolean | undefined;
    cancelDt?: Date | undefined;
    loaded?: boolean | undefined;
    oldPolicyNo?: string | undefined;
    freqOfPayment?: string | undefined;
    osInstlmtNo?: number | undefined;
    instlmtAmt?: number | undefined;
    instlmtNxtDate?: Date | undefined;
    instlmtNxtPrem?: number | undefined;
    osPremBalAmt?: number | undefined;
    paidInstlmtNo?: number | undefined;
    paidToDate?: number | undefined;
    facultative?: boolean | undefined;
    trxnPayMethod?: string | undefined;
    transactionRef?: string | undefined;
    policyEndorsements?: PolicyEndorsement[] | undefined;
    id?: string | undefined;
}

export class State implements IState {
    code?: string | undefined;
    name?: string | undefined;
    regionId?: string | undefined;
    countryId?: string | undefined;
    stateCountryCode?: string | undefined;
    lgas?: Lga[] | undefined;
    country?: Country | undefined;
    region?: Region | undefined;
    id?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.regionId = _data["regionId"];
            this.countryId = _data["countryId"];
            this.stateCountryCode = _data["stateCountryCode"];
            if (Array.isArray(_data["lgas"])) {
                this.lgas = [] as any;
                for (let item of _data["lgas"])
                    this.lgas!.push(Lga.fromJS(item, _mappings));
            }
            this.country = _data["country"] ? Country.fromJS(_data["country"], _mappings) : <any>undefined;
            this.region = _data["region"] ? Region.fromJS(_data["region"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): State | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<State>(data, _mappings, State);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        data["countryId"] = this.countryId;
        data["stateCountryCode"] = this.stateCountryCode;
        if (Array.isArray(this.lgas)) {
            data["lgas"] = [];
            for (let item of this.lgas)
                data["lgas"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IState {
    code?: string | undefined;
    name?: string | undefined;
    regionId?: string | undefined;
    countryId?: string | undefined;
    stateCountryCode?: string | undefined;
    lgas?: Lga[] | undefined;
    country?: Country | undefined;
    region?: Region | undefined;
    id?: string | undefined;
}

export class Subclass implements ISubclass {
    name?: string | undefined;
    prefix?: string | undefined;
    clmPrefix?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isActive?: boolean | undefined;
    motorSchedule?: MotorSchedule | undefined;
    motorScheduleId?: string | undefined;
    travelSchedule?: TravelSchedule | undefined;
    travelScheduleId?: string | undefined;
    marOpenCovSch?: MarOpenCovSch | undefined;
    marOpenCovSchId?: string | undefined;
    renewable?: boolean | undefined;
    uniqueRsk?: boolean | undefined;
    acctGrp?: string | undefined;
    class?: Class | undefined;
    classId?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    productSubClasses?: ProductSubClass[] | undefined;
    coverTypes?: CoverType[] | undefined;
    sections?: Section[] | undefined;
    subclassSectCovtypes?: SubclassSectCovtype[] | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;

    constructor(data?: ISubclass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.clmPrefix = _data["clmPrefix"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.motorSchedule = _data["motorSchedule"] ? MotorSchedule.fromJS(_data["motorSchedule"], _mappings) : <any>undefined;
            this.motorScheduleId = _data["motorScheduleId"];
            this.travelSchedule = _data["travelSchedule"] ? TravelSchedule.fromJS(_data["travelSchedule"], _mappings) : <any>undefined;
            this.travelScheduleId = _data["travelScheduleId"];
            this.marOpenCovSch = _data["marOpenCovSch"] ? MarOpenCovSch.fromJS(_data["marOpenCovSch"], _mappings) : <any>undefined;
            this.marOpenCovSchId = _data["marOpenCovSchId"];
            this.renewable = _data["renewable"];
            this.uniqueRsk = _data["uniqueRsk"];
            this.acctGrp = _data["acctGrp"];
            this.class = _data["class"] ? Class.fromJS(_data["class"], _mappings) : <any>undefined;
            this.classId = _data["classId"];
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            if (Array.isArray(_data["productSubClasses"])) {
                this.productSubClasses = [] as any;
                for (let item of _data["productSubClasses"])
                    this.productSubClasses!.push(ProductSubClass.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["coverTypes"])) {
                this.coverTypes = [] as any;
                for (let item of _data["coverTypes"])
                    this.coverTypes!.push(CoverType.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(Section.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["subclassSectCovtypes"])) {
                this.subclassSectCovtypes = [] as any;
                for (let item of _data["subclassSectCovtypes"])
                    this.subclassSectCovtypes!.push(SubclassSectCovtype.fromJS(item, _mappings));
            }
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"], _mappings) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"], _mappings) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Subclass | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Subclass>(data, _mappings, Subclass);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["clmPrefix"] = this.clmPrefix;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["motorSchedule"] = this.motorSchedule ? this.motorSchedule.toJSON() : <any>undefined;
        data["motorScheduleId"] = this.motorScheduleId;
        data["travelSchedule"] = this.travelSchedule ? this.travelSchedule.toJSON() : <any>undefined;
        data["travelScheduleId"] = this.travelScheduleId;
        data["marOpenCovSch"] = this.marOpenCovSch ? this.marOpenCovSch.toJSON() : <any>undefined;
        data["marOpenCovSchId"] = this.marOpenCovSchId;
        data["renewable"] = this.renewable;
        data["uniqueRsk"] = this.uniqueRsk;
        data["acctGrp"] = this.acctGrp;
        data["class"] = this.class ? this.class.toJSON() : <any>undefined;
        data["classId"] = this.classId;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        if (Array.isArray(this.productSubClasses)) {
            data["productSubClasses"] = [];
            for (let item of this.productSubClasses)
                data["productSubClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.coverTypes)) {
            data["coverTypes"] = [];
            for (let item of this.coverTypes)
                data["coverTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.subclassSectCovtypes)) {
            data["subclassSectCovtypes"] = [];
            for (let item of this.subclassSectCovtypes)
                data["subclassSectCovtypes"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubclass {
    name?: string | undefined;
    prefix?: string | undefined;
    clmPrefix?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isActive?: boolean | undefined;
    motorSchedule?: MotorSchedule | undefined;
    motorScheduleId?: string | undefined;
    travelSchedule?: TravelSchedule | undefined;
    travelScheduleId?: string | undefined;
    marOpenCovSch?: MarOpenCovSch | undefined;
    marOpenCovSchId?: string | undefined;
    renewable?: boolean | undefined;
    uniqueRsk?: boolean | undefined;
    acctGrp?: string | undefined;
    class?: Class | undefined;
    classId?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    productSubClasses?: ProductSubClass[] | undefined;
    coverTypes?: CoverType[] | undefined;
    sections?: Section[] | undefined;
    subclassSectCovtypes?: SubclassSectCovtype[] | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;
}

export class CoverType implements ICoverType {
    name?: string | undefined;
    shtDesc?: string | undefined;
    risks?: Risk[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: ICoverType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shtDesc = _data["shtDesc"];
            if (Array.isArray(_data["risks"])) {
                this.risks = [] as any;
                for (let item of _data["risks"])
                    this.risks!.push(Risk.fromJS(item, _mappings));
            }
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): CoverType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CoverType>(data, _mappings, CoverType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shtDesc"] = this.shtDesc;
        if (Array.isArray(this.risks)) {
            data["risks"] = [];
            for (let item of this.risks)
                data["risks"].push(item.toJSON());
        }
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoverType {
    name?: string | undefined;
    shtDesc?: string | undefined;
    risks?: Risk[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Section implements ISection {
    name?: string | undefined;
    sectionType?: SectionType | undefined;
    sectionTypeId?: string | undefined;
    isPositive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: ISection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sectionType = _data["sectionType"] ? SectionType.fromJS(_data["sectionType"], _mappings) : <any>undefined;
            this.sectionTypeId = _data["sectionTypeId"];
            this.isPositive = _data["isPositive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Section | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Section>(data, _mappings, Section);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sectionType"] = this.sectionType ? this.sectionType.toJSON() : <any>undefined;
        data["sectionTypeId"] = this.sectionTypeId;
        data["isPositive"] = this.isPositive;
        data["id"] = this.id;
        return data;
    }
}

export interface ISection {
    name?: string | undefined;
    sectionType?: SectionType | undefined;
    sectionTypeId?: string | undefined;
    isPositive?: boolean | undefined;
    id?: string | undefined;
}

export class ProductCategory implements IProductCategory {
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductCategory | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductCategory>(data, _mappings, ProductCategory);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductCategory {
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class Class implements IClass {
    prefix?: string | undefined;
    name?: string | undefined;
    businessClassId?: string | undefined;
    businessClass?: BusinessClass | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    isAvalableOnUI?: boolean | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;

    constructor(data?: IClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.businessClassId = _data["businessClassId"];
            this.businessClass = _data["businessClass"] ? BusinessClass.fromJS(_data["businessClass"], _mappings) : <any>undefined;
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.isAvalableOnUI = _data["isAvalableOnUI"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"], _mappings) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"], _mappings) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Class | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Class>(data, _mappings, Class);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["businessClassId"] = this.businessClassId;
        data["businessClass"] = this.businessClass ? this.businessClass.toJSON() : <any>undefined;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["isAvalableOnUI"] = this.isAvalableOnUI;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IClass {
    prefix?: string | undefined;
    name?: string | undefined;
    businessClassId?: string | undefined;
    businessClass?: BusinessClass | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    isAvalableOnUI?: boolean | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;
}

export class Organisation implements IOrganisation {
    shtDesc?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    slogan?: string | undefined;
    logo?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shtDesc = _data["shtDesc"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.slogan = _data["slogan"];
            this.logo = _data["logo"];
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Organisation | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Organisation>(data, _mappings, Organisation);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shtDesc"] = this.shtDesc;
        data["name"] = this.name;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["slogan"] = this.slogan;
        data["logo"] = this.logo;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganisation {
    shtDesc?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    slogan?: string | undefined;
    logo?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Gender implements IGender {
    name?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IGender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Gender | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Gender>(data, _mappings, Gender);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IGender {
    name?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class Country implements ICountry {
    code?: string | undefined;
    shtDesc?: string | undefined;
    name?: string | undefined;
    currencyName?: string | undefined;
    currencyCode?: string | undefined;
    currencyLogo?: string | undefined;
    embassyCode?: string | undefined;
    isShengen?: boolean | undefined;
    isActive?: boolean | undefined;
    isDefault?: boolean | undefined;
    states?: State[] | undefined;
    id?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.shtDesc = _data["shtDesc"];
            this.name = _data["name"];
            this.currencyName = _data["currencyName"];
            this.currencyCode = _data["currencyCode"];
            this.currencyLogo = _data["currencyLogo"];
            this.embassyCode = _data["embassyCode"];
            this.isShengen = _data["isShengen"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(State.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Country | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Country>(data, _mappings, Country);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["shtDesc"] = this.shtDesc;
        data["name"] = this.name;
        data["currencyName"] = this.currencyName;
        data["currencyCode"] = this.currencyCode;
        data["currencyLogo"] = this.currencyLogo;
        data["embassyCode"] = this.embassyCode;
        data["isShengen"] = this.isShengen;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICountry {
    code?: string | undefined;
    shtDesc?: string | undefined;
    name?: string | undefined;
    currencyName?: string | undefined;
    currencyCode?: string | undefined;
    currencyLogo?: string | undefined;
    embassyCode?: string | undefined;
    isShengen?: boolean | undefined;
    isActive?: boolean | undefined;
    isDefault?: boolean | undefined;
    states?: State[] | undefined;
    id?: string | undefined;
}

export class MaritalStatus implements IMaritalStatus {
    name?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IMaritalStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MaritalStatus | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaritalStatus>(data, _mappings, MaritalStatus);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IMaritalStatus {
    name?: string | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class Beneficiary implements IBeneficiary {
    clientId?: string | undefined;
    client?: Client | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    telephone?: string | undefined;
    dateOfBirth?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IBeneficiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Beneficiary | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Beneficiary>(data, _mappings, Beneficiary);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeneficiary {
    clientId?: string | undefined;
    client?: Client | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    telephone?: string | undefined;
    dateOfBirth?: Date | undefined;
    id?: string | undefined;
}

export class Risk implements IRisk {
    clientId?: string | undefined;
    coverTypeId?: string | undefined;
    client?: Client | undefined;
    coverType?: CoverType | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    code?: string | undefined;
    itemDesc?: string | undefined;
    insuredValue?: number | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    coverDays?: number | undefined;
    uwYr?: number | undefined;
    polRenEndosNo?: string | undefined;
    polBatchNo?: number | undefined;
    prevBatchNo?: number | undefined;
    basicPremium?: number | undefined;
    prorata?: number | undefined;
    netPremium?: number | undefined;
    commission?: number | undefined;
    commRate?: number | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    location?: Branch | undefined;
    locationId?: string | undefined;
    secSclCode?: string | undefined;
    ncdStatus?: string | undefined;
    certIssued?: boolean | undefined;
    certNo?: string | undefined;
    covNoteNo?: string | undefined;
    prevRskCode?: string | undefined;
    comments?: string | undefined;
    cancellationDays?: number | undefined;
    status?: string | undefined;
    surveyRequired?: boolean | undefined;
    surveyDate?: Date | undefined;
    declared?: boolean | undefined;
    conveyanceType?: string | undefined;
    id?: string | undefined;

    constructor(data?: IRisk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.coverTypeId = _data["coverTypeId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.coverType = _data["coverType"] ? CoverType.fromJS(_data["coverType"], _mappings) : <any>undefined;
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.code = _data["code"];
            this.itemDesc = _data["itemDesc"];
            this.insuredValue = _data["insuredValue"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.coverDays = _data["coverDays"];
            this.uwYr = _data["uwYr"];
            this.polRenEndosNo = _data["polRenEndosNo"];
            this.polBatchNo = _data["polBatchNo"];
            this.prevBatchNo = _data["prevBatchNo"];
            this.basicPremium = _data["basicPremium"];
            this.prorata = _data["prorata"];
            this.netPremium = _data["netPremium"];
            this.commission = _data["commission"];
            this.commRate = _data["commRate"];
            this.country = _data["country"] ? Country.fromJS(_data["country"], _mappings) : <any>undefined;
            this.countryId = _data["countryId"];
            this.location = _data["location"] ? Branch.fromJS(_data["location"], _mappings) : <any>undefined;
            this.locationId = _data["locationId"];
            this.secSclCode = _data["secSclCode"];
            this.ncdStatus = _data["ncdStatus"];
            this.certIssued = _data["certIssued"];
            this.certNo = _data["certNo"];
            this.covNoteNo = _data["covNoteNo"];
            this.prevRskCode = _data["prevRskCode"];
            this.comments = _data["comments"];
            this.cancellationDays = _data["cancellationDays"];
            this.status = _data["status"];
            this.surveyRequired = _data["surveyRequired"];
            this.surveyDate = _data["surveyDate"] ? new Date(_data["surveyDate"].toString()) : <any>undefined;
            this.declared = _data["declared"];
            this.conveyanceType = _data["conveyanceType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Risk | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Risk>(data, _mappings, Risk);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["coverTypeId"] = this.coverTypeId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["coverType"] = this.coverType ? this.coverType.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["code"] = this.code;
        data["itemDesc"] = this.itemDesc;
        data["insuredValue"] = this.insuredValue;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["coverDays"] = this.coverDays;
        data["uwYr"] = this.uwYr;
        data["polRenEndosNo"] = this.polRenEndosNo;
        data["polBatchNo"] = this.polBatchNo;
        data["prevBatchNo"] = this.prevBatchNo;
        data["basicPremium"] = this.basicPremium;
        data["prorata"] = this.prorata;
        data["netPremium"] = this.netPremium;
        data["commission"] = this.commission;
        data["commRate"] = this.commRate;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["secSclCode"] = this.secSclCode;
        data["ncdStatus"] = this.ncdStatus;
        data["certIssued"] = this.certIssued;
        data["certNo"] = this.certNo;
        data["covNoteNo"] = this.covNoteNo;
        data["prevRskCode"] = this.prevRskCode;
        data["comments"] = this.comments;
        data["cancellationDays"] = this.cancellationDays;
        data["status"] = this.status;
        data["surveyRequired"] = this.surveyRequired;
        data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : <any>undefined;
        data["declared"] = this.declared;
        data["conveyanceType"] = this.conveyanceType;
        data["id"] = this.id;
        return data;
    }
}

export interface IRisk {
    clientId?: string | undefined;
    coverTypeId?: string | undefined;
    client?: Client | undefined;
    coverType?: CoverType | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    code?: string | undefined;
    itemDesc?: string | undefined;
    insuredValue?: number | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    coverDays?: number | undefined;
    uwYr?: number | undefined;
    polRenEndosNo?: string | undefined;
    polBatchNo?: number | undefined;
    prevBatchNo?: number | undefined;
    basicPremium?: number | undefined;
    prorata?: number | undefined;
    netPremium?: number | undefined;
    commission?: number | undefined;
    commRate?: number | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    location?: Branch | undefined;
    locationId?: string | undefined;
    secSclCode?: string | undefined;
    ncdStatus?: string | undefined;
    certIssued?: boolean | undefined;
    certNo?: string | undefined;
    covNoteNo?: string | undefined;
    prevRskCode?: string | undefined;
    comments?: string | undefined;
    cancellationDays?: number | undefined;
    status?: string | undefined;
    surveyRequired?: boolean | undefined;
    surveyDate?: Date | undefined;
    declared?: boolean | undefined;
    conveyanceType?: string | undefined;
    id?: string | undefined;
}

export class ClientCategory implements IClientCategory {
    shtDesc?: string | undefined;
    categoryName?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IClientCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shtDesc = _data["shtDesc"];
            this.categoryName = _data["categoryName"];
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientCategory | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientCategory>(data, _mappings, ClientCategory);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shtDesc"] = this.shtDesc;
        data["categoryName"] = this.categoryName;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientCategory {
    shtDesc?: string | undefined;
    categoryName?: string | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class ClientType implements IClientType {
    shtDesc?: string | undefined;
    name?: string | undefined;
    isPerson?: boolean | undefined;
    clientCategory?: ClientCategory | undefined;
    clientCategoryId?: string | undefined;
    clients?: Client[] | undefined;
    clientCategories?: ClientCategory[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IClientType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shtDesc = _data["shtDesc"];
            this.name = _data["name"];
            this.isPerson = _data["isPerson"];
            this.clientCategory = _data["clientCategory"] ? ClientCategory.fromJS(_data["clientCategory"], _mappings) : <any>undefined;
            this.clientCategoryId = _data["clientCategoryId"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(Client.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["clientCategories"])) {
                this.clientCategories = [] as any;
                for (let item of _data["clientCategories"])
                    this.clientCategories!.push(ClientCategory.fromJS(item, _mappings));
            }
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientType>(data, _mappings, ClientType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shtDesc"] = this.shtDesc;
        data["name"] = this.name;
        data["isPerson"] = this.isPerson;
        data["clientCategory"] = this.clientCategory ? this.clientCategory.toJSON() : <any>undefined;
        data["clientCategoryId"] = this.clientCategoryId;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        if (Array.isArray(this.clientCategories)) {
            data["clientCategories"] = [];
            for (let item of this.clientCategories)
                data["clientCategories"].push(item.toJSON());
        }
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientType {
    shtDesc?: string | undefined;
    name?: string | undefined;
    isPerson?: boolean | undefined;
    clientCategory?: ClientCategory | undefined;
    clientCategoryId?: string | undefined;
    clients?: Client[] | undefined;
    clientCategories?: ClientCategory[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class Title implements ITitle {
    titleName?: string | undefined;
    clients?: Client[] | undefined;
    id?: string | undefined;

    constructor(data?: ITitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleName = _data["titleName"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(Client.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Title | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Title>(data, _mappings, Title);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleName"] = this.titleName;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITitle {
    titleName?: string | undefined;
    clients?: Client[] | undefined;
    id?: string | undefined;
}

export class PolicyEndorsement implements IPolicyEndorsement {
    policy?: Policy | undefined;
    policyId?: string | undefined;
    polRenEndosNo?: string | undefined;
    previousEndorsement?: PolicyEndorsement | undefined;
    previousEndorsementId?: string | undefined;
    preparedBy?: User | undefined;
    preparedById?: number | undefined;
    approvedBy?: User | undefined;
    approvedId?: number | undefined;
    endorsementDate?: Date | undefined;
    grossPremium?: number | undefined;
    prevPremium?: number | undefined;
    netPremium?: number | undefined;
    flutterwavePayment?: FlutterwavePayment | undefined;
    flutterwavePaymentId?: string | undefined;
    wemaBankPayment?: WemaBankPayment | undefined;
    wemaBankPaymentId?: string | undefined;
    alatPayment?: AlatPayment | undefined;
    alatPaymentId?: string | undefined;
    gtbPayment?: GtbPayment | undefined;
    gtbPaymentId?: string | undefined;
    posPayment?: PosPayment | undefined;
    posPaymentId?: string | undefined;
    interswitchPayment?: InterswitchPayment | undefined;
    interswitchPaymentId?: string | undefined;
    arikPayment?: ArikPayment | undefined;
    arikPaymentId?: string | undefined;
    aeroPayment?: AeroPayment | undefined;
    boffPaymentId?: string | undefined;
    boffPayment?: BoffPayment | undefined;
    autogeniusPayment?: AutogeniusPayment | undefined;
    autogeniusPaymentId?: string | undefined;
    transboxxPayment?: TransboxxPayment | undefined;
    transboxxPaymentId?: string | undefined;
    paddycoverPayment?: PaddycoverPayment | undefined;
    paddycoverPaymentId?: string | undefined;
    payArenaPayment?: PayArenaPayment | undefined;
    payArenaPaymentId?: string | undefined;
    aeroPaymentId?: string | undefined;
    intermediaryPayment?: IntermediaryLedger | undefined;
    intermediaryPaymentId?: string | undefined;
    curRate?: number | undefined;
    curAmt?: number | undefined;
    drcrNo?: string | undefined;
    covtNo?: string | undefined;
    prevStatus?: string | undefined;
    currentStatus?: string | undefined;
    uwYear?: number | undefined;
    comment?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    intDiscountAmt?: number | undefined;
    intDiscountRate?: number | undefined;
    commAmt?: number | undefined;
    commRate?: number | undefined;
    commEndosDiffAmt?: number | undefined;
    commissionAllowed?: boolean | undefined;
    commPayable?: number | undefined;
    vat?: number | undefined;
    vatAmt?: number | undefined;
    vatRate?: number | undefined;
    whtx?: number | undefined;
    wthtAmt?: number | undefined;
    wthtRate?: number | undefined;
    controlAcc?: string | undefined;
    ltaCommDiscAmt?: number | undefined;
    mktrComAmt?: number | undefined;
    mktrIntCode?: Intermediary | undefined;
    mktrIntCodeId?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    policyGenerated?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IPolicyEndorsement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.polRenEndosNo = _data["polRenEndosNo"];
            this.previousEndorsement = _data["previousEndorsement"] ? PolicyEndorsement.fromJS(_data["previousEndorsement"], _mappings) : <any>undefined;
            this.previousEndorsementId = _data["previousEndorsementId"];
            this.preparedBy = _data["preparedBy"] ? User.fromJS(_data["preparedBy"], _mappings) : <any>undefined;
            this.preparedById = _data["preparedById"];
            this.approvedBy = _data["approvedBy"] ? User.fromJS(_data["approvedBy"], _mappings) : <any>undefined;
            this.approvedId = _data["approvedId"];
            this.endorsementDate = _data["endorsementDate"] ? new Date(_data["endorsementDate"].toString()) : <any>undefined;
            this.grossPremium = _data["grossPremium"];
            this.prevPremium = _data["prevPremium"];
            this.netPremium = _data["netPremium"];
            this.flutterwavePayment = _data["flutterwavePayment"] ? FlutterwavePayment.fromJS(_data["flutterwavePayment"], _mappings) : <any>undefined;
            this.flutterwavePaymentId = _data["flutterwavePaymentId"];
            this.wemaBankPayment = _data["wemaBankPayment"] ? WemaBankPayment.fromJS(_data["wemaBankPayment"], _mappings) : <any>undefined;
            this.wemaBankPaymentId = _data["wemaBankPaymentId"];
            this.alatPayment = _data["alatPayment"] ? AlatPayment.fromJS(_data["alatPayment"], _mappings) : <any>undefined;
            this.alatPaymentId = _data["alatPaymentId"];
            this.gtbPayment = _data["gtbPayment"] ? GtbPayment.fromJS(_data["gtbPayment"], _mappings) : <any>undefined;
            this.gtbPaymentId = _data["gtbPaymentId"];
            this.posPayment = _data["posPayment"] ? PosPayment.fromJS(_data["posPayment"], _mappings) : <any>undefined;
            this.posPaymentId = _data["posPaymentId"];
            this.interswitchPayment = _data["interswitchPayment"] ? InterswitchPayment.fromJS(_data["interswitchPayment"], _mappings) : <any>undefined;
            this.interswitchPaymentId = _data["interswitchPaymentId"];
            this.arikPayment = _data["arikPayment"] ? ArikPayment.fromJS(_data["arikPayment"], _mappings) : <any>undefined;
            this.arikPaymentId = _data["arikPaymentId"];
            this.aeroPayment = _data["aeroPayment"] ? AeroPayment.fromJS(_data["aeroPayment"], _mappings) : <any>undefined;
            this.boffPaymentId = _data["boffPaymentId"];
            this.boffPayment = _data["boffPayment"] ? BoffPayment.fromJS(_data["boffPayment"], _mappings) : <any>undefined;
            this.autogeniusPayment = _data["autogeniusPayment"] ? AutogeniusPayment.fromJS(_data["autogeniusPayment"], _mappings) : <any>undefined;
            this.autogeniusPaymentId = _data["autogeniusPaymentId"];
            this.transboxxPayment = _data["transboxxPayment"] ? TransboxxPayment.fromJS(_data["transboxxPayment"], _mappings) : <any>undefined;
            this.transboxxPaymentId = _data["transboxxPaymentId"];
            this.paddycoverPayment = _data["paddycoverPayment"] ? PaddycoverPayment.fromJS(_data["paddycoverPayment"], _mappings) : <any>undefined;
            this.paddycoverPaymentId = _data["paddycoverPaymentId"];
            this.payArenaPayment = _data["payArenaPayment"] ? PayArenaPayment.fromJS(_data["payArenaPayment"], _mappings) : <any>undefined;
            this.payArenaPaymentId = _data["payArenaPaymentId"];
            this.aeroPaymentId = _data["aeroPaymentId"];
            this.intermediaryPayment = _data["intermediaryPayment"] ? IntermediaryLedger.fromJS(_data["intermediaryPayment"], _mappings) : <any>undefined;
            this.intermediaryPaymentId = _data["intermediaryPaymentId"];
            this.curRate = _data["curRate"];
            this.curAmt = _data["curAmt"];
            this.drcrNo = _data["drcrNo"];
            this.covtNo = _data["covtNo"];
            this.prevStatus = _data["prevStatus"];
            this.currentStatus = _data["currentStatus"];
            this.uwYear = _data["uwYear"];
            this.comment = _data["comment"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.intDiscountAmt = _data["intDiscountAmt"];
            this.intDiscountRate = _data["intDiscountRate"];
            this.commAmt = _data["commAmt"];
            this.commRate = _data["commRate"];
            this.commEndosDiffAmt = _data["commEndosDiffAmt"];
            this.commissionAllowed = _data["commissionAllowed"];
            this.commPayable = _data["commPayable"];
            this.vat = _data["vat"];
            this.vatAmt = _data["vatAmt"];
            this.vatRate = _data["vatRate"];
            this.whtx = _data["whtx"];
            this.wthtAmt = _data["wthtAmt"];
            this.wthtRate = _data["wthtRate"];
            this.controlAcc = _data["controlAcc"];
            this.ltaCommDiscAmt = _data["ltaCommDiscAmt"];
            this.mktrComAmt = _data["mktrComAmt"];
            this.mktrIntCode = _data["mktrIntCode"] ? Intermediary.fromJS(_data["mktrIntCode"], _mappings) : <any>undefined;
            this.mktrIntCodeId = _data["mktrIntCodeId"];
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.policyGenerated = _data["policyGenerated"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyEndorsement | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyEndorsement>(data, _mappings, PolicyEndorsement);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["polRenEndosNo"] = this.polRenEndosNo;
        data["previousEndorsement"] = this.previousEndorsement ? this.previousEndorsement.toJSON() : <any>undefined;
        data["previousEndorsementId"] = this.previousEndorsementId;
        data["preparedBy"] = this.preparedBy ? this.preparedBy.toJSON() : <any>undefined;
        data["preparedById"] = this.preparedById;
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : <any>undefined;
        data["approvedId"] = this.approvedId;
        data["endorsementDate"] = this.endorsementDate ? this.endorsementDate.toISOString() : <any>undefined;
        data["grossPremium"] = this.grossPremium;
        data["prevPremium"] = this.prevPremium;
        data["netPremium"] = this.netPremium;
        data["flutterwavePayment"] = this.flutterwavePayment ? this.flutterwavePayment.toJSON() : <any>undefined;
        data["flutterwavePaymentId"] = this.flutterwavePaymentId;
        data["wemaBankPayment"] = this.wemaBankPayment ? this.wemaBankPayment.toJSON() : <any>undefined;
        data["wemaBankPaymentId"] = this.wemaBankPaymentId;
        data["alatPayment"] = this.alatPayment ? this.alatPayment.toJSON() : <any>undefined;
        data["alatPaymentId"] = this.alatPaymentId;
        data["gtbPayment"] = this.gtbPayment ? this.gtbPayment.toJSON() : <any>undefined;
        data["gtbPaymentId"] = this.gtbPaymentId;
        data["posPayment"] = this.posPayment ? this.posPayment.toJSON() : <any>undefined;
        data["posPaymentId"] = this.posPaymentId;
        data["interswitchPayment"] = this.interswitchPayment ? this.interswitchPayment.toJSON() : <any>undefined;
        data["interswitchPaymentId"] = this.interswitchPaymentId;
        data["arikPayment"] = this.arikPayment ? this.arikPayment.toJSON() : <any>undefined;
        data["arikPaymentId"] = this.arikPaymentId;
        data["aeroPayment"] = this.aeroPayment ? this.aeroPayment.toJSON() : <any>undefined;
        data["boffPaymentId"] = this.boffPaymentId;
        data["boffPayment"] = this.boffPayment ? this.boffPayment.toJSON() : <any>undefined;
        data["autogeniusPayment"] = this.autogeniusPayment ? this.autogeniusPayment.toJSON() : <any>undefined;
        data["autogeniusPaymentId"] = this.autogeniusPaymentId;
        data["transboxxPayment"] = this.transboxxPayment ? this.transboxxPayment.toJSON() : <any>undefined;
        data["transboxxPaymentId"] = this.transboxxPaymentId;
        data["paddycoverPayment"] = this.paddycoverPayment ? this.paddycoverPayment.toJSON() : <any>undefined;
        data["paddycoverPaymentId"] = this.paddycoverPaymentId;
        data["payArenaPayment"] = this.payArenaPayment ? this.payArenaPayment.toJSON() : <any>undefined;
        data["payArenaPaymentId"] = this.payArenaPaymentId;
        data["aeroPaymentId"] = this.aeroPaymentId;
        data["intermediaryPayment"] = this.intermediaryPayment ? this.intermediaryPayment.toJSON() : <any>undefined;
        data["intermediaryPaymentId"] = this.intermediaryPaymentId;
        data["curRate"] = this.curRate;
        data["curAmt"] = this.curAmt;
        data["drcrNo"] = this.drcrNo;
        data["covtNo"] = this.covtNo;
        data["prevStatus"] = this.prevStatus;
        data["currentStatus"] = this.currentStatus;
        data["uwYear"] = this.uwYear;
        data["comment"] = this.comment;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["intDiscountAmt"] = this.intDiscountAmt;
        data["intDiscountRate"] = this.intDiscountRate;
        data["commAmt"] = this.commAmt;
        data["commRate"] = this.commRate;
        data["commEndosDiffAmt"] = this.commEndosDiffAmt;
        data["commissionAllowed"] = this.commissionAllowed;
        data["commPayable"] = this.commPayable;
        data["vat"] = this.vat;
        data["vatAmt"] = this.vatAmt;
        data["vatRate"] = this.vatRate;
        data["whtx"] = this.whtx;
        data["wthtAmt"] = this.wthtAmt;
        data["wthtRate"] = this.wthtRate;
        data["controlAcc"] = this.controlAcc;
        data["ltaCommDiscAmt"] = this.ltaCommDiscAmt;
        data["mktrComAmt"] = this.mktrComAmt;
        data["mktrIntCode"] = this.mktrIntCode ? this.mktrIntCode.toJSON() : <any>undefined;
        data["mktrIntCodeId"] = this.mktrIntCodeId;
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["policyGenerated"] = this.policyGenerated;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolicyEndorsement {
    policy?: Policy | undefined;
    policyId?: string | undefined;
    polRenEndosNo?: string | undefined;
    previousEndorsement?: PolicyEndorsement | undefined;
    previousEndorsementId?: string | undefined;
    preparedBy?: User | undefined;
    preparedById?: number | undefined;
    approvedBy?: User | undefined;
    approvedId?: number | undefined;
    endorsementDate?: Date | undefined;
    grossPremium?: number | undefined;
    prevPremium?: number | undefined;
    netPremium?: number | undefined;
    flutterwavePayment?: FlutterwavePayment | undefined;
    flutterwavePaymentId?: string | undefined;
    wemaBankPayment?: WemaBankPayment | undefined;
    wemaBankPaymentId?: string | undefined;
    alatPayment?: AlatPayment | undefined;
    alatPaymentId?: string | undefined;
    gtbPayment?: GtbPayment | undefined;
    gtbPaymentId?: string | undefined;
    posPayment?: PosPayment | undefined;
    posPaymentId?: string | undefined;
    interswitchPayment?: InterswitchPayment | undefined;
    interswitchPaymentId?: string | undefined;
    arikPayment?: ArikPayment | undefined;
    arikPaymentId?: string | undefined;
    aeroPayment?: AeroPayment | undefined;
    boffPaymentId?: string | undefined;
    boffPayment?: BoffPayment | undefined;
    autogeniusPayment?: AutogeniusPayment | undefined;
    autogeniusPaymentId?: string | undefined;
    transboxxPayment?: TransboxxPayment | undefined;
    transboxxPaymentId?: string | undefined;
    paddycoverPayment?: PaddycoverPayment | undefined;
    paddycoverPaymentId?: string | undefined;
    payArenaPayment?: PayArenaPayment | undefined;
    payArenaPaymentId?: string | undefined;
    aeroPaymentId?: string | undefined;
    intermediaryPayment?: IntermediaryLedger | undefined;
    intermediaryPaymentId?: string | undefined;
    curRate?: number | undefined;
    curAmt?: number | undefined;
    drcrNo?: string | undefined;
    covtNo?: string | undefined;
    prevStatus?: string | undefined;
    currentStatus?: string | undefined;
    uwYear?: number | undefined;
    comment?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    intDiscountAmt?: number | undefined;
    intDiscountRate?: number | undefined;
    commAmt?: number | undefined;
    commRate?: number | undefined;
    commEndosDiffAmt?: number | undefined;
    commissionAllowed?: boolean | undefined;
    commPayable?: number | undefined;
    vat?: number | undefined;
    vatAmt?: number | undefined;
    vatRate?: number | undefined;
    whtx?: number | undefined;
    wthtAmt?: number | undefined;
    wthtRate?: number | undefined;
    controlAcc?: string | undefined;
    ltaCommDiscAmt?: number | undefined;
    mktrComAmt?: number | undefined;
    mktrIntCode?: Intermediary | undefined;
    mktrIntCodeId?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    policyGenerated?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    id?: string | undefined;
}

export class Region implements IRegion {
    regionCode?: number | undefined;
    regionName?: string | undefined;
    states?: State[] | undefined;
    id?: string | undefined;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.regionCode = _data["regionCode"];
            this.regionName = _data["regionName"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(State.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Region | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Region>(data, _mappings, Region);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionCode"] = this.regionCode;
        data["regionName"] = this.regionName;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRegion {
    regionCode?: number | undefined;
    regionName?: string | undefined;
    states?: State[] | undefined;
    id?: string | undefined;
}

export class MotorSchedule implements IMotorSchedule {
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    transactionDate?: Date | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    isRenewal?: boolean | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    vehicleCoverType?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    renewalNarration?: string | undefined;
    renewedPolicyNumber?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IMotorSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.regNo = _data["regNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.cubicCap = _data["cubicCap"];
            this.yrManft = _data["yrManft"];
            this.carryCap = _data["carryCap"];
            this.bodyType = _data["bodyType"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.premiumAmount = _data["premiumAmount"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.engineNo = _data["engineNo"];
            this.chasisNo = _data["chasisNo"];
            this.color = _data["color"];
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.isRenewal = _data["isRenewal"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.vehicleCoverType = _data["vehicleCoverType"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.renewalNarration = _data["renewalNarration"];
            this.renewedPolicyNumber = _data["renewedPolicyNumber"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MotorSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MotorSchedule>(data, _mappings, MotorSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNo"] = this.regNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["cubicCap"] = this.cubicCap;
        data["yrManft"] = this.yrManft;
        data["carryCap"] = this.carryCap;
        data["bodyType"] = this.bodyType;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["premiumAmount"] = this.premiumAmount;
        data["vehicleAmount"] = this.vehicleAmount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["engineNo"] = this.engineNo;
        data["chasisNo"] = this.chasisNo;
        data["color"] = this.color;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["isRenewal"] = this.isRenewal;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["vehicleCoverType"] = this.vehicleCoverType;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["renewalNarration"] = this.renewalNarration;
        data["renewedPolicyNumber"] = this.renewedPolicyNumber;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IMotorSchedule {
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    transactionDate?: Date | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    isRenewal?: boolean | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    vehicleCoverType?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    renewalNarration?: string | undefined;
    renewedPolicyNumber?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class TravelSchedule implements ITravelSchedule {
    name?: string | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    nokName?: string | undefined;
    noKrelationship?: string | undefined;
    noKaddr?: string | undefined;
    embassycode?: string | undefined;
    travelParty?: string | undefined;
    groupType?: string | undefined;
    currency?: string | undefined;
    travelPurpose?: string | undefined;
    is90days?: boolean | undefined;
    preMedical?: boolean | undefined;
    medical?: string | undefined;
    transDate?: Date | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    certNo?: string | undefined;
    passportNumber?: string | undefined;
    passportUrl?: string | undefined;
    sumAssured?: number | undefined;
    premium?: number | undefined;
    excess?: number | undefined;
    commAllowed?: boolean | undefined;
    isActive?: boolean | undefined;
    transactionRef?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ITravelSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.country = _data["country"] ? Country.fromJS(_data["country"], _mappings) : <any>undefined;
            this.countryId = _data["countryId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.nokName = _data["nokName"];
            this.noKrelationship = _data["noKrelationship"];
            this.noKaddr = _data["noKaddr"];
            this.embassycode = _data["embassycode"];
            this.travelParty = _data["travelParty"];
            this.groupType = _data["groupType"];
            this.currency = _data["currency"];
            this.travelPurpose = _data["travelPurpose"];
            this.is90days = _data["is90days"];
            this.preMedical = _data["preMedical"];
            this.medical = _data["medical"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.certNo = _data["certNo"];
            this.passportNumber = _data["passportNumber"];
            this.passportUrl = _data["passportUrl"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.excess = _data["excess"];
            this.commAllowed = _data["commAllowed"];
            this.isActive = _data["isActive"];
            this.transactionRef = _data["transactionRef"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelSchedule>(data, _mappings, TravelSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["nokName"] = this.nokName;
        data["noKrelationship"] = this.noKrelationship;
        data["noKaddr"] = this.noKaddr;
        data["embassycode"] = this.embassycode;
        data["travelParty"] = this.travelParty;
        data["groupType"] = this.groupType;
        data["currency"] = this.currency;
        data["travelPurpose"] = this.travelPurpose;
        data["is90days"] = this.is90days;
        data["preMedical"] = this.preMedical;
        data["medical"] = this.medical;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["certNo"] = this.certNo;
        data["passportNumber"] = this.passportNumber;
        data["passportUrl"] = this.passportUrl;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["excess"] = this.excess;
        data["commAllowed"] = this.commAllowed;
        data["isActive"] = this.isActive;
        data["transactionRef"] = this.transactionRef;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ITravelSchedule {
    name?: string | undefined;
    country?: Country | undefined;
    countryId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    nokName?: string | undefined;
    noKrelationship?: string | undefined;
    noKaddr?: string | undefined;
    embassycode?: string | undefined;
    travelParty?: string | undefined;
    groupType?: string | undefined;
    currency?: string | undefined;
    travelPurpose?: string | undefined;
    is90days?: boolean | undefined;
    preMedical?: boolean | undefined;
    medical?: string | undefined;
    transDate?: Date | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    certNo?: string | undefined;
    passportNumber?: string | undefined;
    passportUrl?: string | undefined;
    sumAssured?: number | undefined;
    premium?: number | undefined;
    excess?: number | undefined;
    commAllowed?: boolean | undefined;
    isActive?: boolean | undefined;
    transactionRef?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class MarOpenCovSch implements IMarOpenCovSch {
    ipuCode?: string | undefined;
    conveyance?: string | undefined;
    voyages?: string | undefined;
    subjectMatter?: Date | undefined;
    valuationBasis?: Date | undefined;
    basicRate?: number | undefined;
    warRate?: number | undefined;
    totRates?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionDate?: Date | undefined;
    limitOneVessel?: number | undefined;
    limitOneLocations?: string | undefined;
    coverNoteNo?: string | undefined;
    packingMode?: string | undefined;
    qrCode?: string | undefined;
    qsrCode?: string | undefined;
    excessPerc?: number | undefined;
    excessMin?: number | undefined;
    minPrem?: string | undefined;
    markNumbers?: string | undefined;
    transactionRef?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    id?: string | undefined;

    constructor(data?: IMarOpenCovSch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ipuCode = _data["ipuCode"];
            this.conveyance = _data["conveyance"];
            this.voyages = _data["voyages"];
            this.subjectMatter = _data["subjectMatter"] ? new Date(_data["subjectMatter"].toString()) : <any>undefined;
            this.valuationBasis = _data["valuationBasis"] ? new Date(_data["valuationBasis"].toString()) : <any>undefined;
            this.basicRate = _data["basicRate"];
            this.warRate = _data["warRate"];
            this.totRates = _data["totRates"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.limitOneVessel = _data["limitOneVessel"];
            this.limitOneLocations = _data["limitOneLocations"];
            this.coverNoteNo = _data["coverNoteNo"];
            this.packingMode = _data["packingMode"];
            this.qrCode = _data["qrCode"];
            this.qsrCode = _data["qsrCode"];
            this.excessPerc = _data["excessPerc"];
            this.excessMin = _data["excessMin"];
            this.minPrem = _data["minPrem"];
            this.markNumbers = _data["markNumbers"];
            this.transactionRef = _data["transactionRef"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MarOpenCovSch | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MarOpenCovSch>(data, _mappings, MarOpenCovSch);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipuCode"] = this.ipuCode;
        data["conveyance"] = this.conveyance;
        data["voyages"] = this.voyages;
        data["subjectMatter"] = this.subjectMatter ? this.subjectMatter.toISOString() : <any>undefined;
        data["valuationBasis"] = this.valuationBasis ? this.valuationBasis.toISOString() : <any>undefined;
        data["basicRate"] = this.basicRate;
        data["warRate"] = this.warRate;
        data["totRates"] = this.totRates;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["limitOneVessel"] = this.limitOneVessel;
        data["limitOneLocations"] = this.limitOneLocations;
        data["coverNoteNo"] = this.coverNoteNo;
        data["packingMode"] = this.packingMode;
        data["qrCode"] = this.qrCode;
        data["qsrCode"] = this.qsrCode;
        data["excessPerc"] = this.excessPerc;
        data["excessMin"] = this.excessMin;
        data["minPrem"] = this.minPrem;
        data["markNumbers"] = this.markNumbers;
        data["transactionRef"] = this.transactionRef;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["id"] = this.id;
        return data;
    }
}

export interface IMarOpenCovSch {
    ipuCode?: string | undefined;
    conveyance?: string | undefined;
    voyages?: string | undefined;
    subjectMatter?: Date | undefined;
    valuationBasis?: Date | undefined;
    basicRate?: number | undefined;
    warRate?: number | undefined;
    totRates?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionDate?: Date | undefined;
    limitOneVessel?: number | undefined;
    limitOneLocations?: string | undefined;
    coverNoteNo?: string | undefined;
    packingMode?: string | undefined;
    qrCode?: string | undefined;
    qsrCode?: string | undefined;
    excessPerc?: number | undefined;
    excessMin?: number | undefined;
    minPrem?: string | undefined;
    markNumbers?: string | undefined;
    transactionRef?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    id?: string | undefined;
}

export class ProductSubClass implements IProductSubClass {
    subclass?: Subclass | undefined;
    subClassId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    isDefault?: boolean | undefined;
    startDate?: Date | undefined;
    expDate?: Date | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IProductSubClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subclass = _data["subclass"] ? Subclass.fromJS(_data["subclass"], _mappings) : <any>undefined;
            this.subClassId = _data["subClassId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.isDefault = _data["isDefault"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.expDate = _data["expDate"] ? new Date(_data["expDate"].toString()) : <any>undefined;
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductSubClass | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductSubClass>(data, _mappings, ProductSubClass);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subclass"] = this.subclass ? this.subclass.toJSON() : <any>undefined;
        data["subClassId"] = this.subClassId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["isDefault"] = this.isDefault;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expDate"] = this.expDate ? this.expDate.toISOString() : <any>undefined;
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductSubClass {
    subclass?: Subclass | undefined;
    subClassId?: string | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    isDefault?: boolean | undefined;
    startDate?: Date | undefined;
    expDate?: Date | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class SectionType implements ISectionType {
    name?: string | undefined;
    shtDesc?: string | undefined;
    sections?: Section[] | undefined;
    id?: string | undefined;

    constructor(data?: ISectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shtDesc = _data["shtDesc"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(Section.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): SectionType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SectionType>(data, _mappings, SectionType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shtDesc"] = this.shtDesc;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISectionType {
    name?: string | undefined;
    shtDesc?: string | undefined;
    sections?: Section[] | undefined;
    id?: string | undefined;
}

export class BusinessClass implements IBusinessClass {
    prefix?: string | undefined;
    shtDesc?: string | undefined;
    name?: string | undefined;
    head?: User | undefined;
    headId?: number | undefined;
    classes?: Class[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;

    constructor(data?: IBusinessClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.shtDesc = _data["shtDesc"];
            this.name = _data["name"];
            this.head = _data["head"] ? User.fromJS(_data["head"], _mappings) : <any>undefined;
            this.headId = _data["headId"];
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(Class.fromJS(item, _mappings));
            }
            this.ownedByFlexsure = _data["ownedByFlexsure"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"], _mappings) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"], _mappings) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): BusinessClass | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BusinessClass>(data, _mappings, BusinessClass);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["shtDesc"] = this.shtDesc;
        data["name"] = this.name;
        data["head"] = this.head ? this.head.toJSON() : <any>undefined;
        data["headId"] = this.headId;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item.toJSON());
        }
        data["ownedByFlexsure"] = this.ownedByFlexsure;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessClass {
    prefix?: string | undefined;
    shtDesc?: string | undefined;
    name?: string | undefined;
    head?: User | undefined;
    headId?: number | undefined;
    classes?: Class[] | undefined;
    ownedByFlexsure?: boolean | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    creationTime?: Date | undefined;
    creatorUserId?: number | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierUserId?: number | undefined;
    creatorUser?: User | undefined;
    lastModifierUser?: User | undefined;
    isDeleted?: boolean | undefined;
    deletionTime?: Date | undefined;
    deleterUserId?: number | undefined;
    deleterUser?: User | undefined;
    id?: string | undefined;
}

export class FlutterwavePayment implements IFlutterwavePayment {
    transactionRef?: string | undefined;
    flwRef?: string | undefined;
    transactionType?: string | undefined;
    transactionProcessor?: string | undefined;
    status?: string | undefined;
    ip?: string | undefined;
    deviceFingerPrint?: string | undefined;
    cycle?: string | undefined;
    narration?: string | undefined;
    amount?: number | undefined;
    appFee?: number | undefined;
    merchantFee?: number | undefined;
    markupFee?: number | undefined;
    merchantBearsFee?: number | undefined;
    chargedAmount?: number | undefined;
    transactionCurrency?: string | undefined;
    systemType?: string | undefined;
    paymentEntity?: string | undefined;
    paymentId?: string | undefined;
    fraudStatus?: string | undefined;
    chargeType?: string | undefined;
    isLive?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    merchantId?: number | undefined;
    addonId?: number | undefined;
    customerId?: number | undefined;
    customerPhone?: string | undefined;
    customerName?: string | undefined;
    customerEmail?: string | undefined;
    customerCreatedAt?: string | undefined;
    customerUpdatedAt?: string | undefined;
    customerDeletedAt?: string | undefined;
    customerAccountId?: number | undefined;
    embedToken?: string | undefined;
    shortCode?: string | undefined;
    message?: string | undefined;
    cardNumber?: string | undefined;
    brand?: string | undefined;
    chargeResponse?: string | undefined;
    chargeResponseMessage?: string | undefined;
    vbvResponseMessage?: string | undefined;
    vbvResponseCode?: string | undefined;
    accountValidationResponseMessage?: string | undefined;
    accountValidationResponseCode?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IFlutterwavePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.flwRef = _data["flwRef"];
            this.transactionType = _data["transactionType"];
            this.transactionProcessor = _data["transactionProcessor"];
            this.status = _data["status"];
            this.ip = _data["ip"];
            this.deviceFingerPrint = _data["deviceFingerPrint"];
            this.cycle = _data["cycle"];
            this.narration = _data["narration"];
            this.amount = _data["amount"];
            this.appFee = _data["appFee"];
            this.merchantFee = _data["merchantFee"];
            this.markupFee = _data["markupFee"];
            this.merchantBearsFee = _data["merchantBearsFee"];
            this.chargedAmount = _data["chargedAmount"];
            this.transactionCurrency = _data["transactionCurrency"];
            this.systemType = _data["systemType"];
            this.paymentEntity = _data["paymentEntity"];
            this.paymentId = _data["paymentId"];
            this.fraudStatus = _data["fraudStatus"];
            this.chargeType = _data["chargeType"];
            this.isLive = _data["isLive"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
            this.deletedAt = _data["deletedAt"];
            this.merchantId = _data["merchantId"];
            this.addonId = _data["addonId"];
            this.customerId = _data["customerId"];
            this.customerPhone = _data["customerPhone"];
            this.customerName = _data["customerName"];
            this.customerEmail = _data["customerEmail"];
            this.customerCreatedAt = _data["customerCreatedAt"];
            this.customerUpdatedAt = _data["customerUpdatedAt"];
            this.customerDeletedAt = _data["customerDeletedAt"];
            this.customerAccountId = _data["customerAccountId"];
            this.embedToken = _data["embedToken"];
            this.shortCode = _data["shortCode"];
            this.message = _data["message"];
            this.cardNumber = _data["cardNumber"];
            this.brand = _data["brand"];
            this.chargeResponse = _data["chargeResponse"];
            this.chargeResponseMessage = _data["chargeResponseMessage"];
            this.vbvResponseMessage = _data["vbvResponseMessage"];
            this.vbvResponseCode = _data["vbvResponseCode"];
            this.accountValidationResponseMessage = _data["accountValidationResponseMessage"];
            this.accountValidationResponseCode = _data["accountValidationResponseCode"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): FlutterwavePayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlutterwavePayment>(data, _mappings, FlutterwavePayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["flwRef"] = this.flwRef;
        data["transactionType"] = this.transactionType;
        data["transactionProcessor"] = this.transactionProcessor;
        data["status"] = this.status;
        data["ip"] = this.ip;
        data["deviceFingerPrint"] = this.deviceFingerPrint;
        data["cycle"] = this.cycle;
        data["narration"] = this.narration;
        data["amount"] = this.amount;
        data["appFee"] = this.appFee;
        data["merchantFee"] = this.merchantFee;
        data["markupFee"] = this.markupFee;
        data["merchantBearsFee"] = this.merchantBearsFee;
        data["chargedAmount"] = this.chargedAmount;
        data["transactionCurrency"] = this.transactionCurrency;
        data["systemType"] = this.systemType;
        data["paymentEntity"] = this.paymentEntity;
        data["paymentId"] = this.paymentId;
        data["fraudStatus"] = this.fraudStatus;
        data["chargeType"] = this.chargeType;
        data["isLive"] = this.isLive;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        data["deletedAt"] = this.deletedAt;
        data["merchantId"] = this.merchantId;
        data["addonId"] = this.addonId;
        data["customerId"] = this.customerId;
        data["customerPhone"] = this.customerPhone;
        data["customerName"] = this.customerName;
        data["customerEmail"] = this.customerEmail;
        data["customerCreatedAt"] = this.customerCreatedAt;
        data["customerUpdatedAt"] = this.customerUpdatedAt;
        data["customerDeletedAt"] = this.customerDeletedAt;
        data["customerAccountId"] = this.customerAccountId;
        data["embedToken"] = this.embedToken;
        data["shortCode"] = this.shortCode;
        data["message"] = this.message;
        data["cardNumber"] = this.cardNumber;
        data["brand"] = this.brand;
        data["chargeResponse"] = this.chargeResponse;
        data["chargeResponseMessage"] = this.chargeResponseMessage;
        data["vbvResponseMessage"] = this.vbvResponseMessage;
        data["vbvResponseCode"] = this.vbvResponseCode;
        data["accountValidationResponseMessage"] = this.accountValidationResponseMessage;
        data["accountValidationResponseCode"] = this.accountValidationResponseCode;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFlutterwavePayment {
    transactionRef?: string | undefined;
    flwRef?: string | undefined;
    transactionType?: string | undefined;
    transactionProcessor?: string | undefined;
    status?: string | undefined;
    ip?: string | undefined;
    deviceFingerPrint?: string | undefined;
    cycle?: string | undefined;
    narration?: string | undefined;
    amount?: number | undefined;
    appFee?: number | undefined;
    merchantFee?: number | undefined;
    markupFee?: number | undefined;
    merchantBearsFee?: number | undefined;
    chargedAmount?: number | undefined;
    transactionCurrency?: string | undefined;
    systemType?: string | undefined;
    paymentEntity?: string | undefined;
    paymentId?: string | undefined;
    fraudStatus?: string | undefined;
    chargeType?: string | undefined;
    isLive?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    merchantId?: number | undefined;
    addonId?: number | undefined;
    customerId?: number | undefined;
    customerPhone?: string | undefined;
    customerName?: string | undefined;
    customerEmail?: string | undefined;
    customerCreatedAt?: string | undefined;
    customerUpdatedAt?: string | undefined;
    customerDeletedAt?: string | undefined;
    customerAccountId?: number | undefined;
    embedToken?: string | undefined;
    shortCode?: string | undefined;
    message?: string | undefined;
    cardNumber?: string | undefined;
    brand?: string | undefined;
    chargeResponse?: string | undefined;
    chargeResponseMessage?: string | undefined;
    vbvResponseMessage?: string | undefined;
    vbvResponseCode?: string | undefined;
    accountValidationResponseMessage?: string | undefined;
    accountValidationResponseCode?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;
}

export class WemaBankPayment implements IWemaBankPayment {
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    merchantRef?: string | undefined;
    customerDetails?: string | undefined;
    transactionDate?: Date | undefined;
    customerEmail?: string | undefined;
    status?: string | undefined;
    selectedGateway?: string | undefined;
    currency?: string | undefined;
    convertedToNgn?: boolean | undefined;
    isSettled?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IWemaBankPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseDescription = _data["responseDescription"];
            this.amount = _data["amount"];
            this.transactionRef = _data["transactionRef"];
            this.merchantRef = _data["merchantRef"];
            this.customerDetails = _data["customerDetails"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.customerEmail = _data["customerEmail"];
            this.status = _data["status"];
            this.selectedGateway = _data["selectedGateway"];
            this.currency = _data["currency"];
            this.convertedToNgn = _data["convertedToNgn"];
            this.isSettled = _data["isSettled"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): WemaBankPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WemaBankPayment>(data, _mappings, WemaBankPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseDescription"] = this.responseDescription;
        data["amount"] = this.amount;
        data["transactionRef"] = this.transactionRef;
        data["merchantRef"] = this.merchantRef;
        data["customerDetails"] = this.customerDetails;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["customerEmail"] = this.customerEmail;
        data["status"] = this.status;
        data["selectedGateway"] = this.selectedGateway;
        data["currency"] = this.currency;
        data["convertedToNgn"] = this.convertedToNgn;
        data["isSettled"] = this.isSettled;
        data["id"] = this.id;
        return data;
    }
}

export interface IWemaBankPayment {
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    merchantRef?: string | undefined;
    customerDetails?: string | undefined;
    transactionDate?: Date | undefined;
    customerEmail?: string | undefined;
    status?: string | undefined;
    selectedGateway?: string | undefined;
    currency?: string | undefined;
    convertedToNgn?: boolean | undefined;
    isSettled?: boolean | undefined;
    id?: string | undefined;
}

export class AlatPayment implements IAlatPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    accountNumber?: string | undefined;
    paymentRef?: string | undefined;
    id?: string | undefined;

    constructor(data?: IAlatPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseDesc = _data["responseDesc"];
            this.transDate = _data["transDate"];
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.accountNumber = _data["accountNumber"];
            this.paymentRef = _data["paymentRef"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): AlatPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AlatPayment>(data, _mappings, AlatPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseDesc"] = this.responseDesc;
        data["transDate"] = this.transDate;
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["accountNumber"] = this.accountNumber;
        data["paymentRef"] = this.paymentRef;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlatPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    accountNumber?: string | undefined;
    paymentRef?: string | undefined;
    id?: string | undefined;
}

export class GtbPayment implements IGtbPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transTime?: string | undefined;
    transRef?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    customerName?: string | undefined;
    merchantName?: string | undefined;
    transStatus?: string | undefined;
    transMessage?: string | undefined;
    hash?: string | undefined;
    charge?: string | undefined;
    currency?: string | undefined;
    id?: string | undefined;

    constructor(data?: IGtbPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseDesc = _data["responseDesc"];
            this.transDate = _data["transDate"];
            this.transTime = _data["transTime"];
            this.transRef = _data["transRef"];
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.customerName = _data["customerName"];
            this.merchantName = _data["merchantName"];
            this.transStatus = _data["transStatus"];
            this.transMessage = _data["transMessage"];
            this.hash = _data["hash"];
            this.charge = _data["charge"];
            this.currency = _data["currency"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): GtbPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GtbPayment>(data, _mappings, GtbPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseDesc"] = this.responseDesc;
        data["transDate"] = this.transDate;
        data["transTime"] = this.transTime;
        data["transRef"] = this.transRef;
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["customerName"] = this.customerName;
        data["merchantName"] = this.merchantName;
        data["transStatus"] = this.transStatus;
        data["transMessage"] = this.transMessage;
        data["hash"] = this.hash;
        data["charge"] = this.charge;
        data["currency"] = this.currency;
        data["id"] = this.id;
        return data;
    }
}

export interface IGtbPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transTime?: string | undefined;
    transRef?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    customerName?: string | undefined;
    merchantName?: string | undefined;
    transStatus?: string | undefined;
    transMessage?: string | undefined;
    hash?: string | undefined;
    charge?: string | undefined;
    currency?: string | undefined;
    id?: string | undefined;
}

export class PosPayment implements IPosPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IPosPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PosPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PosPayment>(data, _mappings, PosPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPosPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class InterswitchPayment implements IInterswitchPayment {
    amount?: number | undefined;
    cardNumber?: string | undefined;
    merchantReference?: string | undefined;
    paymentReference?: string | undefined;
    retrievalReferenceNumber?: string | undefined;
    leadBankCbnCode?: string | undefined;
    leadBankName?: string | undefined;
    splitAccounts?: string | undefined;
    transactionDate?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    clientApplicationId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    id?: string | undefined;

    constructor(data?: IInterswitchPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.cardNumber = _data["cardNumber"];
            this.merchantReference = _data["merchantReference"];
            this.paymentReference = _data["paymentReference"];
            this.retrievalReferenceNumber = _data["retrievalReferenceNumber"];
            this.leadBankCbnCode = _data["leadBankCbnCode"];
            this.leadBankName = _data["leadBankName"];
            this.splitAccounts = _data["splitAccounts"];
            this.transactionDate = _data["transactionDate"];
            this.responseCode = _data["responseCode"];
            this.responseDescription = _data["responseDescription"];
            this.clientApplicationId = _data["clientApplicationId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): InterswitchPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InterswitchPayment>(data, _mappings, InterswitchPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["cardNumber"] = this.cardNumber;
        data["merchantReference"] = this.merchantReference;
        data["paymentReference"] = this.paymentReference;
        data["retrievalReferenceNumber"] = this.retrievalReferenceNumber;
        data["leadBankCbnCode"] = this.leadBankCbnCode;
        data["leadBankName"] = this.leadBankName;
        data["splitAccounts"] = this.splitAccounts;
        data["transactionDate"] = this.transactionDate;
        data["responseCode"] = this.responseCode;
        data["responseDescription"] = this.responseDescription;
        data["clientApplicationId"] = this.clientApplicationId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IInterswitchPayment {
    amount?: number | undefined;
    cardNumber?: string | undefined;
    merchantReference?: string | undefined;
    paymentReference?: string | undefined;
    retrievalReferenceNumber?: string | undefined;
    leadBankCbnCode?: string | undefined;
    leadBankName?: string | undefined;
    splitAccounts?: string | undefined;
    transactionDate?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    clientApplicationId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    id?: string | undefined;
}

export class ArikPayment implements IArikPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IArikPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.status = _data["status"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ArikPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ArikPayment>(data, _mappings, ArikPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["status"] = this.status;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IArikPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;
}

export class AeroPayment implements IAeroPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IAeroPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.status = _data["status"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): AeroPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AeroPayment>(data, _mappings, AeroPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["status"] = this.status;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAeroPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    id?: string | undefined;
}

export class BoffPayment implements IBoffPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IBoffPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): BoffPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BoffPayment>(data, _mappings, BoffPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IBoffPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class AutogeniusPayment implements IAutogeniusPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IAutogeniusPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): AutogeniusPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AutogeniusPayment>(data, _mappings, AutogeniusPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAutogeniusPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class TransboxxPayment implements ITransboxxPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: ITransboxxPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): TransboxxPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TransboxxPayment>(data, _mappings, TransboxxPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITransboxxPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class PaddycoverPayment implements IPaddycoverPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IPaddycoverPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PaddycoverPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PaddycoverPayment>(data, _mappings, PaddycoverPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPaddycoverPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class PayArenaPayment implements IPayArenaPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IPayArenaPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.accountNumber = _data["accountNumber"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaPayment>(data, _mappings, PayArenaPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["accountNumber"] = this.accountNumber;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayArenaPayment {
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    accountNumber?: string | undefined;
    transDate?: Date | undefined;
    id?: string | undefined;
}

export class IntermediaryLedger implements IIntermediaryLedger {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    narration?: string | undefined;
    paymentMode?: string | undefined;
    paymentChannel?: string | undefined;
    transactionType?: string | undefined;
    transactionRef?: string | undefined;
    crossReference?: string | undefined;
    credit?: number | undefined;
    debit?: number | undefined;
    creditLimit?: number | undefined;
    creditUsed?: number | undefined;
    currentWalletBalance?: number | undefined;
    previousWalletBalance?: number | undefined;
    currentCommissionBalance?: number | undefined;
    previousCommissionBalance?: number | undefined;
    createdBy?: User | undefined;
    createdById?: number | undefined;
    approvedBy?: User | undefined;
    approvedId?: number | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;

    constructor(data?: IIntermediaryLedger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.narration = _data["narration"];
            this.paymentMode = _data["paymentMode"];
            this.paymentChannel = _data["paymentChannel"];
            this.transactionType = _data["transactionType"];
            this.transactionRef = _data["transactionRef"];
            this.crossReference = _data["crossReference"];
            this.credit = _data["credit"];
            this.debit = _data["debit"];
            this.creditLimit = _data["creditLimit"];
            this.creditUsed = _data["creditUsed"];
            this.currentWalletBalance = _data["currentWalletBalance"];
            this.previousWalletBalance = _data["previousWalletBalance"];
            this.currentCommissionBalance = _data["currentCommissionBalance"];
            this.previousCommissionBalance = _data["previousCommissionBalance"];
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"], _mappings) : <any>undefined;
            this.createdById = _data["createdById"];
            this.approvedBy = _data["approvedBy"] ? User.fromJS(_data["approvedBy"], _mappings) : <any>undefined;
            this.approvedId = _data["approvedId"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryLedger | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryLedger>(data, _mappings, IntermediaryLedger);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["narration"] = this.narration;
        data["paymentMode"] = this.paymentMode;
        data["paymentChannel"] = this.paymentChannel;
        data["transactionType"] = this.transactionType;
        data["transactionRef"] = this.transactionRef;
        data["crossReference"] = this.crossReference;
        data["credit"] = this.credit;
        data["debit"] = this.debit;
        data["creditLimit"] = this.creditLimit;
        data["creditUsed"] = this.creditUsed;
        data["currentWalletBalance"] = this.currentWalletBalance;
        data["previousWalletBalance"] = this.previousWalletBalance;
        data["currentCommissionBalance"] = this.currentCommissionBalance;
        data["previousCommissionBalance"] = this.previousCommissionBalance;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdById"] = this.createdById;
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : <any>undefined;
        data["approvedId"] = this.approvedId;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["id"] = this.id;
        return data;
    }
}

export interface IIntermediaryLedger {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    narration?: string | undefined;
    paymentMode?: string | undefined;
    paymentChannel?: string | undefined;
    transactionType?: string | undefined;
    transactionRef?: string | undefined;
    crossReference?: string | undefined;
    credit?: number | undefined;
    debit?: number | undefined;
    creditLimit?: number | undefined;
    creditUsed?: number | undefined;
    currentWalletBalance?: number | undefined;
    previousWalletBalance?: number | undefined;
    currentCommissionBalance?: number | undefined;
    previousCommissionBalance?: number | undefined;
    createdBy?: User | undefined;
    createdById?: number | undefined;
    approvedBy?: User | undefined;
    approvedId?: number | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    id?: string | undefined;
}

export class HomeTransactionResponse implements IHomeTransactionResponse {
    homeTransactionsViewModel?: ViewHomeTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IHomeTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.homeTransactionsViewModel = _data["homeTransactionsViewModel"] ? ViewHomeTransactionsViewModel.fromJS(_data["homeTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): HomeTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HomeTransactionResponse>(data, _mappings, HomeTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeTransactionsViewModel"] = this.homeTransactionsViewModel ? this.homeTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IHomeTransactionResponse {
    homeTransactionsViewModel?: ViewHomeTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewOfficeTransactionsViewModel implements IViewOfficeTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    valueOfContents?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    contents?: OfficeScheduleDetail[] | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewOfficeTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.valueOfContents = _data["valueOfContents"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(OfficeScheduleDetail.fromJS(item, _mappings));
            }
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewOfficeTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewOfficeTransactionsViewModel>(data, _mappings, ViewOfficeTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["valueOfContents"] = this.valueOfContents;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewOfficeTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    valueOfContents?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    contents?: OfficeScheduleDetail[] | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class OfficeScheduleDetail implements IOfficeScheduleDetail {
    officeSchedule?: OfficeSchedule | undefined;
    officeScheduleId?: string | undefined;
    nameOfContent?: string | undefined;
    valueOfContent?: number | undefined;
    id?: string | undefined;

    constructor(data?: IOfficeScheduleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.officeSchedule = _data["officeSchedule"] ? OfficeSchedule.fromJS(_data["officeSchedule"], _mappings) : <any>undefined;
            this.officeScheduleId = _data["officeScheduleId"];
            this.nameOfContent = _data["nameOfContent"];
            this.valueOfContent = _data["valueOfContent"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): OfficeScheduleDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OfficeScheduleDetail>(data, _mappings, OfficeScheduleDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeSchedule"] = this.officeSchedule ? this.officeSchedule.toJSON() : <any>undefined;
        data["officeScheduleId"] = this.officeScheduleId;
        data["nameOfContent"] = this.nameOfContent;
        data["valueOfContent"] = this.valueOfContent;
        data["id"] = this.id;
        return data;
    }
}

export interface IOfficeScheduleDetail {
    officeSchedule?: OfficeSchedule | undefined;
    officeScheduleId?: string | undefined;
    nameOfContent?: string | undefined;
    valueOfContent?: number | undefined;
    id?: string | undefined;
}

export class OfficeSchedule implements IOfficeSchedule {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    valueOfContents?: number | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IOfficeSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.preOwnership = _data["preOwnership"];
            this.tenancy = _data["tenancy"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.postalAddress = _data["postalAddress"];
            this.lga = _data["lga"] ? Lga.fromJS(_data["lga"], _mappings) : <any>undefined;
            this.lgaId = _data["lgaId"];
            this.valueOfContents = _data["valueOfContents"];
            this.premiumAmount = _data["premiumAmount"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): OfficeSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OfficeSchedule>(data, _mappings, OfficeSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preOwnership"] = this.preOwnership;
        data["tenancy"] = this.tenancy;
        data["description"] = this.description;
        data["address"] = this.address;
        data["postalAddress"] = this.postalAddress;
        data["lga"] = this.lga ? this.lga.toJSON() : <any>undefined;
        data["lgaId"] = this.lgaId;
        data["valueOfContents"] = this.valueOfContents;
        data["premiumAmount"] = this.premiumAmount;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IOfficeSchedule {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    valueOfContents?: number | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class OfficeTransactionResponse implements IOfficeTransactionResponse {
    officeTransactionsViewModel?: ViewOfficeTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IOfficeTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.officeTransactionsViewModel = _data["officeTransactionsViewModel"] ? ViewOfficeTransactionsViewModel.fromJS(_data["officeTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): OfficeTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OfficeTransactionResponse>(data, _mappings, OfficeTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeTransactionsViewModel"] = this.officeTransactionsViewModel ? this.officeTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IOfficeTransactionResponse {
    officeTransactionsViewModel?: ViewOfficeTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewShopTransactionsViewModel implements IViewShopTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    stockAmount?: number | undefined;
    natureOfStock?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewShopTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.stockAmount = _data["stockAmount"];
            this.natureOfStock = _data["natureOfStock"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewShopTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewShopTransactionsViewModel>(data, _mappings, ViewShopTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["stockAmount"] = this.stockAmount;
        data["natureOfStock"] = this.natureOfStock;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewShopTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    stockAmount?: number | undefined;
    natureOfStock?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class ShopTransactionResponse implements IShopTransactionResponse {
    shopTransactionsViewModel?: ViewShopTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IShopTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shopTransactionsViewModel = _data["shopTransactionsViewModel"] ? ViewShopTransactionsViewModel.fromJS(_data["shopTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShopTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShopTransactionResponse>(data, _mappings, ShopTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopTransactionsViewModel"] = this.shopTransactionsViewModel ? this.shopTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IShopTransactionResponse {
    shopTransactionsViewModel?: ViewShopTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class ViewPersonalAccidentTransactionsViewModel implements IViewPersonalAccidentTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewPersonalAccidentTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.unit = _data["unit"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewPersonalAccidentTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewPersonalAccidentTransactionsViewModel>(data, _mappings, ViewPersonalAccidentTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["unit"] = this.unit;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewPersonalAccidentTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class PersonalAccidentTransactionResponse implements IPersonalAccidentTransactionResponse {
    personalAccidentTransactionsViewModel?: ViewPersonalAccidentTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IPersonalAccidentTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.personalAccidentTransactionsViewModel = _data["personalAccidentTransactionsViewModel"] ? ViewPersonalAccidentTransactionsViewModel.fromJS(_data["personalAccidentTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonalAccidentTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonalAccidentTransactionResponse>(data, _mappings, PersonalAccidentTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalAccidentTransactionsViewModel"] = this.personalAccidentTransactionsViewModel ? this.personalAccidentTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IPersonalAccidentTransactionResponse {
    personalAccidentTransactionsViewModel?: ViewPersonalAccidentTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class NewVehiclePolicyDetails implements INewVehiclePolicyDetails {
    policyNumber?: string | undefined;
    insuredName?: string | undefined;
    newRegistrationNumber?: string | undefined;
    registrationNumber?: string | undefined;
    vehicleType?: string | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    color?: string | undefined;
    chassisNumber?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;
    licenseStatus?: string | undefined;
    uploadDate?: string | undefined;
    uploadTime?: string | undefined;

    constructor(data?: INewVehiclePolicyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.insuredName = _data["insuredName"];
            this.newRegistrationNumber = _data["newRegistrationNumber"];
            this.registrationNumber = _data["registrationNumber"];
            this.vehicleType = _data["vehicleType"];
            this.vehicleMake = _data["vehicleMake"];
            this.vehicleModel = _data["vehicleModel"];
            this.color = _data["color"];
            this.chassisNumber = _data["chassisNumber"];
            this.issueDate = _data["issueDate"];
            this.expiryDate = _data["expiryDate"];
            this.licenseStatus = _data["licenseStatus"];
            this.uploadDate = _data["uploadDate"];
            this.uploadTime = _data["uploadTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): NewVehiclePolicyDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NewVehiclePolicyDetails>(data, _mappings, NewVehiclePolicyDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["insuredName"] = this.insuredName;
        data["newRegistrationNumber"] = this.newRegistrationNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["vehicleType"] = this.vehicleType;
        data["vehicleMake"] = this.vehicleMake;
        data["vehicleModel"] = this.vehicleModel;
        data["color"] = this.color;
        data["chassisNumber"] = this.chassisNumber;
        data["issueDate"] = this.issueDate;
        data["expiryDate"] = this.expiryDate;
        data["licenseStatus"] = this.licenseStatus;
        data["uploadDate"] = this.uploadDate;
        data["uploadTime"] = this.uploadTime;
        return data;
    }
}

export interface INewVehiclePolicyDetails {
    policyNumber?: string | undefined;
    insuredName?: string | undefined;
    newRegistrationNumber?: string | undefined;
    registrationNumber?: string | undefined;
    vehicleType?: string | undefined;
    vehicleMake?: string | undefined;
    vehicleModel?: string | undefined;
    color?: string | undefined;
    chassisNumber?: string | undefined;
    issueDate?: string | undefined;
    expiryDate?: string | undefined;
    licenseStatus?: string | undefined;
    uploadDate?: string | undefined;
    uploadTime?: string | undefined;
}

export class RaveCredentials implements IRaveCredentials {
    ravePayScript?: string | undefined;
    ravePayVerifyUrl?: string | undefined;
    ravePubKeyLife?: string | undefined;
    raveSecKeyLife?: string | undefined;
    ravePubKeyNonLife?: string | undefined;
    raveSecKeyNonLife?: string | undefined;

    constructor(data?: IRaveCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ravePayScript = _data["ravePayScript"];
            this.ravePayVerifyUrl = _data["ravePayVerifyUrl"];
            this.ravePubKeyLife = _data["ravePubKeyLife"];
            this.raveSecKeyLife = _data["raveSecKeyLife"];
            this.ravePubKeyNonLife = _data["ravePubKeyNonLife"];
            this.raveSecKeyNonLife = _data["raveSecKeyNonLife"];
        }
    }

    static fromJS(data: any, _mappings?: any): RaveCredentials | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RaveCredentials>(data, _mappings, RaveCredentials);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ravePayScript"] = this.ravePayScript;
        data["ravePayVerifyUrl"] = this.ravePayVerifyUrl;
        data["ravePubKeyLife"] = this.ravePubKeyLife;
        data["raveSecKeyLife"] = this.raveSecKeyLife;
        data["ravePubKeyNonLife"] = this.ravePubKeyNonLife;
        data["raveSecKeyNonLife"] = this.raveSecKeyNonLife;
        return data;
    }
}

export interface IRaveCredentials {
    ravePayScript?: string | undefined;
    ravePayVerifyUrl?: string | undefined;
    ravePubKeyLife?: string | undefined;
    raveSecKeyLife?: string | undefined;
    ravePubKeyNonLife?: string | undefined;
    raveSecKeyNonLife?: string | undefined;
}

export class Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements ITuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    readonly item1?: RequeryData | undefined;
    readonly item2?: PolicyDetails | undefined;

    constructor(data?: ITuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? RequeryData.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"] ? PolicyDetails.fromJS(_data["item2"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, Tuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITuple_2OfOfRequeryDataAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: RequeryData | undefined;
    item2?: PolicyDetails | undefined;
}

export class RequeryData implements IRequeryData {
    txid?: number | undefined;
    txref?: string | undefined;
    flwref?: string | undefined;
    devicefingerprint?: string | undefined;
    cycle?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    chargedamount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    merchantbearsfee?: number | undefined;
    chargecode?: string | undefined;
    chargemessage?: string | undefined;
    authmodel?: string | undefined;
    ip?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    vbvcode?: string | undefined;
    vbvmessage?: string | undefined;
    authurl?: string | undefined;
    acctcode?: any | undefined;
    acctmessage?: any | undefined;
    paymenttype?: string | undefined;
    paymentid?: string | undefined;
    fraudstatus?: string | undefined;
    chargetype?: string | undefined;
    createdday?: number | undefined;
    createddayname?: string | undefined;
    createdweek?: number | undefined;
    createdmonth?: number | undefined;
    createdmonthname?: string | undefined;
    createdquarter?: number | undefined;
    createdyear?: number | undefined;
    createdyearisleap?: boolean | undefined;
    createddayispublicholiday?: number | undefined;
    createdhour?: number | undefined;
    createdminute?: number | undefined;
    createdpmam?: string | undefined;
    created?: Date | undefined;
    customerid?: number | undefined;
    custphone?: string | undefined;
    custnetworkprovider?: string | undefined;
    custname?: string | undefined;
    custemail?: string | undefined;
    custemailprovider?: string | undefined;
    custcreated?: Date | undefined;
    accountid?: number | undefined;
    acctbusinessname?: string | undefined;
    acctcontactperson?: string | undefined;
    acctcountry?: string | undefined;
    acctbearsfeeattransactiontime?: number | undefined;
    acctparent?: number | undefined;
    acctvpcmerchant?: string | undefined;
    acctalias?: any | undefined;
    acctisliveapproved?: number | undefined;
    orderref?: string | undefined;
    paymentplan?: number | undefined;
    paymentpage?: any | undefined;
    raveref?: any | undefined;
    amountsettledforthistransaction?: number | undefined;
    card?: RequeryCard | undefined;
    meta?: any[] | undefined;

    constructor(data?: IRequeryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.txid = _data["txid"];
            this.txref = _data["txref"];
            this.flwref = _data["flwref"];
            this.devicefingerprint = _data["devicefingerprint"];
            this.cycle = _data["cycle"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.chargedamount = _data["chargedamount"];
            this.appfee = _data["appfee"];
            this.merchantfee = _data["merchantfee"];
            this.merchantbearsfee = _data["merchantbearsfee"];
            this.chargecode = _data["chargecode"];
            this.chargemessage = _data["chargemessage"];
            this.authmodel = _data["authmodel"];
            this.ip = _data["ip"];
            this.narration = _data["narration"];
            this.status = _data["status"];
            this.vbvcode = _data["vbvcode"];
            this.vbvmessage = _data["vbvmessage"];
            this.authurl = _data["authurl"];
            this.acctcode = _data["acctcode"];
            this.acctmessage = _data["acctmessage"];
            this.paymenttype = _data["paymenttype"];
            this.paymentid = _data["paymentid"];
            this.fraudstatus = _data["fraudstatus"];
            this.chargetype = _data["chargetype"];
            this.createdday = _data["createdday"];
            this.createddayname = _data["createddayname"];
            this.createdweek = _data["createdweek"];
            this.createdmonth = _data["createdmonth"];
            this.createdmonthname = _data["createdmonthname"];
            this.createdquarter = _data["createdquarter"];
            this.createdyear = _data["createdyear"];
            this.createdyearisleap = _data["createdyearisleap"];
            this.createddayispublicholiday = _data["createddayispublicholiday"];
            this.createdhour = _data["createdhour"];
            this.createdminute = _data["createdminute"];
            this.createdpmam = _data["createdpmam"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.customerid = _data["customerid"];
            this.custphone = _data["custphone"];
            this.custnetworkprovider = _data["custnetworkprovider"];
            this.custname = _data["custname"];
            this.custemail = _data["custemail"];
            this.custemailprovider = _data["custemailprovider"];
            this.custcreated = _data["custcreated"] ? new Date(_data["custcreated"].toString()) : <any>undefined;
            this.accountid = _data["accountid"];
            this.acctbusinessname = _data["acctbusinessname"];
            this.acctcontactperson = _data["acctcontactperson"];
            this.acctcountry = _data["acctcountry"];
            this.acctbearsfeeattransactiontime = _data["acctbearsfeeattransactiontime"];
            this.acctparent = _data["acctparent"];
            this.acctvpcmerchant = _data["acctvpcmerchant"];
            this.acctalias = _data["acctalias"];
            this.acctisliveapproved = _data["acctisliveapproved"];
            this.orderref = _data["orderref"];
            this.paymentplan = _data["paymentplan"];
            this.paymentpage = _data["paymentpage"];
            this.raveref = _data["raveref"];
            this.amountsettledforthistransaction = _data["amountsettledforthistransaction"];
            this.card = _data["card"] ? RequeryCard.fromJS(_data["card"], _mappings) : <any>undefined;
            if (Array.isArray(_data["meta"])) {
                this.meta = [] as any;
                for (let item of _data["meta"])
                    this.meta!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RequeryData | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequeryData>(data, _mappings, RequeryData);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["txid"] = this.txid;
        data["txref"] = this.txref;
        data["flwref"] = this.flwref;
        data["devicefingerprint"] = this.devicefingerprint;
        data["cycle"] = this.cycle;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["chargedamount"] = this.chargedamount;
        data["appfee"] = this.appfee;
        data["merchantfee"] = this.merchantfee;
        data["merchantbearsfee"] = this.merchantbearsfee;
        data["chargecode"] = this.chargecode;
        data["chargemessage"] = this.chargemessage;
        data["authmodel"] = this.authmodel;
        data["ip"] = this.ip;
        data["narration"] = this.narration;
        data["status"] = this.status;
        data["vbvcode"] = this.vbvcode;
        data["vbvmessage"] = this.vbvmessage;
        data["authurl"] = this.authurl;
        data["acctcode"] = this.acctcode;
        data["acctmessage"] = this.acctmessage;
        data["paymenttype"] = this.paymenttype;
        data["paymentid"] = this.paymentid;
        data["fraudstatus"] = this.fraudstatus;
        data["chargetype"] = this.chargetype;
        data["createdday"] = this.createdday;
        data["createddayname"] = this.createddayname;
        data["createdweek"] = this.createdweek;
        data["createdmonth"] = this.createdmonth;
        data["createdmonthname"] = this.createdmonthname;
        data["createdquarter"] = this.createdquarter;
        data["createdyear"] = this.createdyear;
        data["createdyearisleap"] = this.createdyearisleap;
        data["createddayispublicholiday"] = this.createddayispublicholiday;
        data["createdhour"] = this.createdhour;
        data["createdminute"] = this.createdminute;
        data["createdpmam"] = this.createdpmam;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["customerid"] = this.customerid;
        data["custphone"] = this.custphone;
        data["custnetworkprovider"] = this.custnetworkprovider;
        data["custname"] = this.custname;
        data["custemail"] = this.custemail;
        data["custemailprovider"] = this.custemailprovider;
        data["custcreated"] = this.custcreated ? this.custcreated.toISOString() : <any>undefined;
        data["accountid"] = this.accountid;
        data["acctbusinessname"] = this.acctbusinessname;
        data["acctcontactperson"] = this.acctcontactperson;
        data["acctcountry"] = this.acctcountry;
        data["acctbearsfeeattransactiontime"] = this.acctbearsfeeattransactiontime;
        data["acctparent"] = this.acctparent;
        data["acctvpcmerchant"] = this.acctvpcmerchant;
        data["acctalias"] = this.acctalias;
        data["acctisliveapproved"] = this.acctisliveapproved;
        data["orderref"] = this.orderref;
        data["paymentplan"] = this.paymentplan;
        data["paymentpage"] = this.paymentpage;
        data["raveref"] = this.raveref;
        data["amountsettledforthistransaction"] = this.amountsettledforthistransaction;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        if (Array.isArray(this.meta)) {
            data["meta"] = [];
            for (let item of this.meta)
                data["meta"].push(item);
        }
        return data;
    }
}

export interface IRequeryData {
    txid?: number | undefined;
    txref?: string | undefined;
    flwref?: string | undefined;
    devicefingerprint?: string | undefined;
    cycle?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    chargedamount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    merchantbearsfee?: number | undefined;
    chargecode?: string | undefined;
    chargemessage?: string | undefined;
    authmodel?: string | undefined;
    ip?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    vbvcode?: string | undefined;
    vbvmessage?: string | undefined;
    authurl?: string | undefined;
    acctcode?: any | undefined;
    acctmessage?: any | undefined;
    paymenttype?: string | undefined;
    paymentid?: string | undefined;
    fraudstatus?: string | undefined;
    chargetype?: string | undefined;
    createdday?: number | undefined;
    createddayname?: string | undefined;
    createdweek?: number | undefined;
    createdmonth?: number | undefined;
    createdmonthname?: string | undefined;
    createdquarter?: number | undefined;
    createdyear?: number | undefined;
    createdyearisleap?: boolean | undefined;
    createddayispublicholiday?: number | undefined;
    createdhour?: number | undefined;
    createdminute?: number | undefined;
    createdpmam?: string | undefined;
    created?: Date | undefined;
    customerid?: number | undefined;
    custphone?: string | undefined;
    custnetworkprovider?: string | undefined;
    custname?: string | undefined;
    custemail?: string | undefined;
    custemailprovider?: string | undefined;
    custcreated?: Date | undefined;
    accountid?: number | undefined;
    acctbusinessname?: string | undefined;
    acctcontactperson?: string | undefined;
    acctcountry?: string | undefined;
    acctbearsfeeattransactiontime?: number | undefined;
    acctparent?: number | undefined;
    acctvpcmerchant?: string | undefined;
    acctalias?: any | undefined;
    acctisliveapproved?: number | undefined;
    orderref?: string | undefined;
    paymentplan?: number | undefined;
    paymentpage?: any | undefined;
    raveref?: any | undefined;
    amountsettledforthistransaction?: number | undefined;
    card?: RequeryCard | undefined;
    meta?: any[] | undefined;
}

export class RequeryCard implements IRequeryCard {
    expirymonth?: string | undefined;
    expiryyear?: string | undefined;
    cardBIN?: string | undefined;
    last4digits?: string | undefined;
    brand?: string | undefined;
    card_tokens?: RequeryCardToken[] | undefined;
    type?: string | undefined;
    life_time_token?: string | undefined;

    constructor(data?: IRequeryCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.expirymonth = _data["expirymonth"];
            this.expiryyear = _data["expiryyear"];
            this.cardBIN = _data["cardBIN"];
            this.last4digits = _data["last4digits"];
            this.brand = _data["brand"];
            if (Array.isArray(_data["card_tokens"])) {
                this.card_tokens = [] as any;
                for (let item of _data["card_tokens"])
                    this.card_tokens!.push(RequeryCardToken.fromJS(item, _mappings));
            }
            this.type = _data["type"];
            this.life_time_token = _data["life_time_token"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequeryCard | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequeryCard>(data, _mappings, RequeryCard);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirymonth"] = this.expirymonth;
        data["expiryyear"] = this.expiryyear;
        data["cardBIN"] = this.cardBIN;
        data["last4digits"] = this.last4digits;
        data["brand"] = this.brand;
        if (Array.isArray(this.card_tokens)) {
            data["card_tokens"] = [];
            for (let item of this.card_tokens)
                data["card_tokens"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["life_time_token"] = this.life_time_token;
        return data;
    }
}

export interface IRequeryCard {
    expirymonth?: string | undefined;
    expiryyear?: string | undefined;
    cardBIN?: string | undefined;
    last4digits?: string | undefined;
    brand?: string | undefined;
    card_tokens?: RequeryCardToken[] | undefined;
    type?: string | undefined;
    life_time_token?: string | undefined;
}

export class RequeryCardToken implements IRequeryCardToken {
    embedtoken?: string | undefined;
    shortcode?: string | undefined;
    expiry?: string | undefined;

    constructor(data?: IRequeryCardToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.embedtoken = _data["embedtoken"];
            this.shortcode = _data["shortcode"];
            this.expiry = _data["expiry"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequeryCardToken | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequeryCardToken>(data, _mappings, RequeryCardToken);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embedtoken"] = this.embedtoken;
        data["shortcode"] = this.shortcode;
        data["expiry"] = this.expiry;
        return data;
    }
}

export interface IRequeryCardToken {
    embedtoken?: string | undefined;
    shortcode?: string | undefined;
    expiry?: string | undefined;
}

export class GetProductResult implements IGetProductResult {
    id?: string | undefined;
    prefix?: string | undefined;
    name?: string | undefined;
    reqUW?: boolean | undefined;
    renewable?: boolean | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    productCategory?: string | undefined;
    isThirdParty?: boolean | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IGetProductResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.reqUW = _data["reqUW"];
            this.renewable = _data["renewable"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.productCategory = _data["productCategory"];
            this.isThirdParty = _data["isThirdParty"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProductResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProductResult>(data, _mappings, GetProductResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["reqUW"] = this.reqUW;
        data["renewable"] = this.renewable;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["productCategory"] = this.productCategory;
        data["isThirdParty"] = this.isThirdParty;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetProductResult {
    id?: string | undefined;
    prefix?: string | undefined;
    name?: string | undefined;
    reqUW?: boolean | undefined;
    renewable?: boolean | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    productCategory?: string | undefined;
    isThirdParty?: boolean | undefined;
    isActive?: boolean | undefined;
}

export class GetClientResult implements IGetClientResult {
    code?: number | undefined;
    clientNo?: string | undefined;
    accOfficer?: string | undefined;
    branch?: string | undefined;
    createdBy?: string | undefined;
    dateCreated?: Date | undefined;
    imagePath?: string | undefined;
    isActive?: boolean | undefined;
    crdtRating?: string | undefined;
    creditLimAllowed?: boolean | undefined;
    creditLimit?: number | undefined;
    terminateDate?: Date | undefined;
    withdrawalReason?: string | undefined;
    prospectStatus?: boolean | undefined;
    emailOwnedByOther?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: string | undefined;
    genderId?: string | undefined;
    pryEmail?: string | undefined;
    secEmail?: string | undefined;
    businessOrOccupation?: string | undefined;
    categoryWorth?: string | undefined;
    dateOfEmpl?: Date | undefined;
    employerPhoneNo?: string | undefined;
    preferredCommMode?: string | undefined;
    domiciledCountry?: string | undefined;
    regDate?: Date | undefined;
    regNumber?: string | undefined;
    dlNo?: string | undefined;
    dlExpiryDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    fax?: string | undefined;
    image?: string | undefined;
    passportNo?: string | undefined;
    physicalAddrs?: string | undefined;
    pin?: string | undefined;
    postalAddrs?: string | undefined;
    oldAccntNo?: string | undefined;
    proposer?: string | undefined;
    salMinRange?: number | undefined;
    salMaxRange?: number | undefined;
    signature?: string | undefined;
    smsTel?: string | undefined;
    altTel?: string | undefined;
    town?: string | undefined;
    website?: string | undefined;
    workPermit?: string | undefined;
    zipCode?: string | undefined;
    clientCategoryId?: string | undefined;
    titleId?: string | undefined;
    title?: string | undefined;
    userId?: number | undefined;
    maritalStatusId?: string | undefined;

    constructor(data?: IGetClientResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.clientNo = _data["clientNo"];
            this.accOfficer = _data["accOfficer"];
            this.branch = _data["branch"];
            this.createdBy = _data["createdBy"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.imagePath = _data["imagePath"];
            this.isActive = _data["isActive"];
            this.crdtRating = _data["crdtRating"];
            this.creditLimAllowed = _data["creditLimAllowed"];
            this.creditLimit = _data["creditLimit"];
            this.terminateDate = _data["terminateDate"] ? new Date(_data["terminateDate"].toString()) : <any>undefined;
            this.withdrawalReason = _data["withdrawalReason"];
            this.prospectStatus = _data["prospectStatus"];
            this.emailOwnedByOther = _data["emailOwnedByOther"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.genderId = _data["genderId"];
            this.pryEmail = _data["pryEmail"];
            this.secEmail = _data["secEmail"];
            this.businessOrOccupation = _data["businessOrOccupation"];
            this.categoryWorth = _data["categoryWorth"];
            this.dateOfEmpl = _data["dateOfEmpl"] ? new Date(_data["dateOfEmpl"].toString()) : <any>undefined;
            this.employerPhoneNo = _data["employerPhoneNo"];
            this.preferredCommMode = _data["preferredCommMode"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.regDate = _data["regDate"] ? new Date(_data["regDate"].toString()) : <any>undefined;
            this.regNumber = _data["regNumber"];
            this.dlNo = _data["dlNo"];
            this.dlExpiryDate = _data["dlExpiryDate"] ? new Date(_data["dlExpiryDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.fax = _data["fax"];
            this.image = _data["image"];
            this.passportNo = _data["passportNo"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.pin = _data["pin"];
            this.postalAddrs = _data["postalAddrs"];
            this.oldAccntNo = _data["oldAccntNo"];
            this.proposer = _data["proposer"];
            this.salMinRange = _data["salMinRange"];
            this.salMaxRange = _data["salMaxRange"];
            this.signature = _data["signature"];
            this.smsTel = _data["smsTel"];
            this.altTel = _data["altTel"];
            this.town = _data["town"];
            this.website = _data["website"];
            this.workPermit = _data["workPermit"];
            this.zipCode = _data["zipCode"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.titleId = _data["titleId"];
            this.title = _data["title"];
            this.userId = _data["userId"];
            this.maritalStatusId = _data["maritalStatusId"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetClientResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetClientResult>(data, _mappings, GetClientResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["clientNo"] = this.clientNo;
        data["accOfficer"] = this.accOfficer;
        data["branch"] = this.branch;
        data["createdBy"] = this.createdBy;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        data["crdtRating"] = this.crdtRating;
        data["creditLimAllowed"] = this.creditLimAllowed;
        data["creditLimit"] = this.creditLimit;
        data["terminateDate"] = this.terminateDate ? this.terminateDate.toISOString() : <any>undefined;
        data["withdrawalReason"] = this.withdrawalReason;
        data["prospectStatus"] = this.prospectStatus;
        data["emailOwnedByOther"] = this.emailOwnedByOther;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["genderId"] = this.genderId;
        data["pryEmail"] = this.pryEmail;
        data["secEmail"] = this.secEmail;
        data["businessOrOccupation"] = this.businessOrOccupation;
        data["categoryWorth"] = this.categoryWorth;
        data["dateOfEmpl"] = this.dateOfEmpl ? this.dateOfEmpl.toISOString() : <any>undefined;
        data["employerPhoneNo"] = this.employerPhoneNo;
        data["preferredCommMode"] = this.preferredCommMode;
        data["domiciledCountry"] = this.domiciledCountry;
        data["regDate"] = this.regDate ? this.regDate.toISOString() : <any>undefined;
        data["regNumber"] = this.regNumber;
        data["dlNo"] = this.dlNo;
        data["dlExpiryDate"] = this.dlExpiryDate ? this.dlExpiryDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["fax"] = this.fax;
        data["image"] = this.image;
        data["passportNo"] = this.passportNo;
        data["physicalAddrs"] = this.physicalAddrs;
        data["pin"] = this.pin;
        data["postalAddrs"] = this.postalAddrs;
        data["oldAccntNo"] = this.oldAccntNo;
        data["proposer"] = this.proposer;
        data["salMinRange"] = this.salMinRange;
        data["salMaxRange"] = this.salMaxRange;
        data["signature"] = this.signature;
        data["smsTel"] = this.smsTel;
        data["altTel"] = this.altTel;
        data["town"] = this.town;
        data["website"] = this.website;
        data["workPermit"] = this.workPermit;
        data["zipCode"] = this.zipCode;
        data["clientCategoryId"] = this.clientCategoryId;
        data["titleId"] = this.titleId;
        data["title"] = this.title;
        data["userId"] = this.userId;
        data["maritalStatusId"] = this.maritalStatusId;
        return data;
    }
}

export interface IGetClientResult {
    code?: number | undefined;
    clientNo?: string | undefined;
    accOfficer?: string | undefined;
    branch?: string | undefined;
    createdBy?: string | undefined;
    dateCreated?: Date | undefined;
    imagePath?: string | undefined;
    isActive?: boolean | undefined;
    crdtRating?: string | undefined;
    creditLimAllowed?: boolean | undefined;
    creditLimit?: number | undefined;
    terminateDate?: Date | undefined;
    withdrawalReason?: string | undefined;
    prospectStatus?: boolean | undefined;
    emailOwnedByOther?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: string | undefined;
    genderId?: string | undefined;
    pryEmail?: string | undefined;
    secEmail?: string | undefined;
    businessOrOccupation?: string | undefined;
    categoryWorth?: string | undefined;
    dateOfEmpl?: Date | undefined;
    employerPhoneNo?: string | undefined;
    preferredCommMode?: string | undefined;
    domiciledCountry?: string | undefined;
    regDate?: Date | undefined;
    regNumber?: string | undefined;
    dlNo?: string | undefined;
    dlExpiryDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    fax?: string | undefined;
    image?: string | undefined;
    passportNo?: string | undefined;
    physicalAddrs?: string | undefined;
    pin?: string | undefined;
    postalAddrs?: string | undefined;
    oldAccntNo?: string | undefined;
    proposer?: string | undefined;
    salMinRange?: number | undefined;
    salMaxRange?: number | undefined;
    signature?: string | undefined;
    smsTel?: string | undefined;
    altTel?: string | undefined;
    town?: string | undefined;
    website?: string | undefined;
    workPermit?: string | undefined;
    zipCode?: string | undefined;
    clientCategoryId?: string | undefined;
    titleId?: string | undefined;
    title?: string | undefined;
    userId?: number | undefined;
    maritalStatusId?: string | undefined;
}

export class FinalResponseModel implements IFinalResponseModel {
    licenseInfo?: LicenseInfoModel | undefined;
    response?: ResponseModel | undefined;

    constructor(data?: IFinalResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.licenseInfo = _data["licenseInfo"] ? LicenseInfoModel.fromJS(_data["licenseInfo"], _mappings) : <any>undefined;
            this.response = _data["response"] ? ResponseModel.fromJS(_data["response"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): FinalResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FinalResponseModel>(data, _mappings, FinalResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseInfo"] = this.licenseInfo ? this.licenseInfo.toJSON() : <any>undefined;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFinalResponseModel {
    licenseInfo?: LicenseInfoModel | undefined;
    response?: ResponseModel | undefined;
}

export class LicenseInfoModel implements ILicenseInfoModel {
    color?: string | undefined;
    model?: string | undefined;
    registrationNo?: string | undefined;
    chasisNo?: string | undefined;
    engineNo?: string | undefined;
    vehicleMakeName?: string | undefined;
    vehicleStatus?: string | undefined;
    isssueDate?: string | undefined;
    expiryDate?: string | undefined;
    year?: string | undefined;

    constructor(data?: ILicenseInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.color = _data["color"];
            this.model = _data["model"];
            this.registrationNo = _data["registrationNo"];
            this.chasisNo = _data["chasisNo"];
            this.engineNo = _data["engineNo"];
            this.vehicleMakeName = _data["vehicleMakeName"];
            this.vehicleStatus = _data["vehicleStatus"];
            this.isssueDate = _data["isssueDate"];
            this.expiryDate = _data["expiryDate"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any, _mappings?: any): LicenseInfoModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LicenseInfoModel>(data, _mappings, LicenseInfoModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["model"] = this.model;
        data["registrationNo"] = this.registrationNo;
        data["chasisNo"] = this.chasisNo;
        data["engineNo"] = this.engineNo;
        data["vehicleMakeName"] = this.vehicleMakeName;
        data["vehicleStatus"] = this.vehicleStatus;
        data["isssueDate"] = this.isssueDate;
        data["expiryDate"] = this.expiryDate;
        data["year"] = this.year;
        return data;
    }
}

export interface ILicenseInfoModel {
    color?: string | undefined;
    model?: string | undefined;
    registrationNo?: string | undefined;
    chasisNo?: string | undefined;
    engineNo?: string | undefined;
    vehicleMakeName?: string | undefined;
    vehicleStatus?: string | undefined;
    isssueDate?: string | undefined;
    expiryDate?: string | undefined;
    year?: string | undefined;
}

export class ResponseModel implements IResponseModel {
    responseCode?: string | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResponseModel>(data, _mappings, ResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IResponseModel {
    responseCode?: string | undefined;
    responseMessage?: string | undefined;
}

export class NameAmountModel implements INameAmountModel {
    name?: string | undefined;
    amount?: number | undefined;

    constructor(data?: INameAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameAmountModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameAmountModel>(data, _mappings, NameAmountModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface INameAmountModel {
    name?: string | undefined;
    amount?: number | undefined;
}

export class CheckClientRequest implements ICheckClientRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;

    constructor(data?: ICheckClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckClientRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckClientRequest>(data, _mappings, CheckClientRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface ICheckClientRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;
}

export class Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: GetClientResult | undefined;
    readonly item2?: string | undefined;

    constructor(data?: ITuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? GetClientResult.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfOfGetClientResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: GetClientResult | undefined;
    item2?: string | undefined;
}

export class MotorScheduleRequest implements IMotorScheduleRequest {
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    transactionRef?: string | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    validityPeriod?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    paystackPublicKey?:string|undefined;
    paystackSubaccount?:string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    oldPolicyNumber?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: IMotorScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.regNo = _data["regNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.cubicCap = _data["cubicCap"];
            this.yrManft = _data["yrManft"];
            this.carryCap = _data["carryCap"];
            this.bodyType = _data["bodyType"];
            this.engineNo = _data["engineNo"];
            this.chasisNo = _data["chasisNo"];
            this.color = _data["color"];
            this.transactionRef = _data["transactionRef"];
            this.premiumAmount = _data["premiumAmount"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.validityPeriod = _data["validityPeriod"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.referralCode = _data["referralCode"];
            this.paymentChannel = _data["paymentChannel"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.oldPolicyNumber = _data["oldPolicyNumber"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): MotorScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MotorScheduleRequest>(data, _mappings, MotorScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNo"] = this.regNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["cubicCap"] = this.cubicCap;
        data["yrManft"] = this.yrManft;
        data["carryCap"] = this.carryCap;
        data["bodyType"] = this.bodyType;
        data["engineNo"] = this.engineNo;
        data["chasisNo"] = this.chasisNo;
        data["color"] = this.color;
        data["transactionRef"] = this.transactionRef;
        data["premiumAmount"] = this.premiumAmount;
        data["vehicleAmount"] = this.vehicleAmount;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["validityPeriod"] = this.validityPeriod;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["referralCode"] = this.referralCode;
        data["paymentChannel"] = this.paymentChannel;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["oldPolicyNumber"] = this.oldPolicyNumber;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface IMotorScheduleRequest {
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    transactionRef?: string | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    validityPeriod?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    oldPolicyNumber?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
}

export class ShopScheduleRequest implements IShopScheduleRequest {
    typeOfShop?: string | undefined;
    otherTypeOfShop?: string | undefined;
    natureOfBusiness?: string | undefined;
    natureOfStructure?: string | undefined;
    otherNatureOfStructure?: string | undefined;
    natureOfStock?: string | undefined;
    otherNatureOfStock?: string | undefined;
    stockTakingMode?: string | undefined;
    otherStockTakingMode?: string | undefined;
    keepsStockBook?: boolean | undefined;
    keepsStockBookInSafePlace?: boolean | undefined;
    stockAmount?: string | undefined;
    declearation?: string | undefined;
    transactionRef?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    address?: string | undefined;
    isFullYear?: boolean | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgaId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    flutterWavePubKey?: string | undefined;
    flutterWaveSecKey?: string | undefined;
    clientCategories?: NameValueModel[] | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;

    constructor(data?: IShopScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.typeOfShop = _data["typeOfShop"];
            this.otherTypeOfShop = _data["otherTypeOfShop"];
            this.natureOfBusiness = _data["natureOfBusiness"];
            this.natureOfStructure = _data["natureOfStructure"];
            this.otherNatureOfStructure = _data["otherNatureOfStructure"];
            this.natureOfStock = _data["natureOfStock"];
            this.otherNatureOfStock = _data["otherNatureOfStock"];
            this.stockTakingMode = _data["stockTakingMode"];
            this.otherStockTakingMode = _data["otherStockTakingMode"];
            this.keepsStockBook = _data["keepsStockBook"];
            this.keepsStockBookInSafePlace = _data["keepsStockBookInSafePlace"];
            this.stockAmount = _data["stockAmount"];
            this.declearation = _data["declearation"];
            this.transactionRef = _data["transactionRef"];
            this.premiumAmount = _data["premiumAmount"];
            this.sumAssured = _data["sumAssured"];
            this.address = _data["address"];
            this.isFullYear = _data["isFullYear"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.lgaId = _data["lgaId"];
            if (Array.isArray(_data["lgas"])) {
                this.lgas = [] as any;
                for (let item of _data["lgas"])
                    this.lgas!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(NameValueModel.fromJS(item, _mappings));
            }
            this.flutterWavePubKey = _data["flutterWavePubKey"];
            this.flutterWaveSecKey = _data["flutterWaveSecKey"];
            if (Array.isArray(_data["clientCategories"])) {
                this.clientCategories = [] as any;
                for (let item of _data["clientCategories"])
                    this.clientCategories!.push(NameValueModel.fromJS(item, _mappings));
            }
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.isWemaBank = _data["isWemaBank"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ShopScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShopScheduleRequest>(data, _mappings, ShopScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfShop"] = this.typeOfShop;
        data["otherTypeOfShop"] = this.otherTypeOfShop;
        data["natureOfBusiness"] = this.natureOfBusiness;
        data["natureOfStructure"] = this.natureOfStructure;
        data["otherNatureOfStructure"] = this.otherNatureOfStructure;
        data["natureOfStock"] = this.natureOfStock;
        data["otherNatureOfStock"] = this.otherNatureOfStock;
        data["stockTakingMode"] = this.stockTakingMode;
        data["otherStockTakingMode"] = this.otherStockTakingMode;
        data["keepsStockBook"] = this.keepsStockBook;
        data["keepsStockBookInSafePlace"] = this.keepsStockBookInSafePlace;
        data["stockAmount"] = this.stockAmount;
        data["declearation"] = this.declearation;
        data["transactionRef"] = this.transactionRef;
        data["premiumAmount"] = this.premiumAmount;
        data["sumAssured"] = this.sumAssured;
        data["address"] = this.address;
        data["isFullYear"] = this.isFullYear;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["lgaId"] = this.lgaId;
        if (Array.isArray(this.lgas)) {
            data["lgas"] = [];
            for (let item of this.lgas)
                data["lgas"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item.toJSON());
        }
        data["flutterWavePubKey"] = this.flutterWavePubKey;
        data["flutterWaveSecKey"] = this.flutterWaveSecKey;
        if (Array.isArray(this.clientCategories)) {
            data["clientCategories"] = [];
            for (let item of this.clientCategories)
                data["clientCategories"].push(item.toJSON());
        }
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["isWemaBank"] = this.isWemaBank;
        data["referralCode"] = this.referralCode;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        return data;
    }
}

export interface IShopScheduleRequest {
    typeOfShop?: string | undefined;
    otherTypeOfShop?: string | undefined;
    natureOfBusiness?: string | undefined;
    natureOfStructure?: string | undefined;
    otherNatureOfStructure?: string | undefined;
    natureOfStock?: string | undefined;
    otherNatureOfStock?: string | undefined;
    stockTakingMode?: string | undefined;
    otherStockTakingMode?: string | undefined;
    keepsStockBook?: boolean | undefined;
    keepsStockBookInSafePlace?: boolean | undefined;
    stockAmount?: string | undefined;
    declearation?: string | undefined;
    transactionRef?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    address?: string | undefined;
    isFullYear?: boolean | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgaId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    flutterWavePubKey?: string | undefined;
    flutterWaveSecKey?: string | undefined;
    clientCategories?: NameValueModel[] | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
}

export class HomeScheduleRequest implements IHomeScheduleRequest {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    homeItems?: NameAmountModel[] | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;

    constructor(data?: IHomeScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.preOwnership = _data["preOwnership"];
            this.tenancy = _data["tenancy"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.postalAddress = _data["postalAddress"];
            this.premiumAmount = _data["premiumAmount"];
            this.sumAssured = _data["sumAssured"];
            if (Array.isArray(_data["homeItems"])) {
                this.homeItems = [] as any;
                for (let item of _data["homeItems"])
                    this.homeItems!.push(NameAmountModel.fromJS(item, _mappings));
            }
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            if (Array.isArray(_data["lgas"])) {
                this.lgas = [] as any;
                for (let item of _data["lgas"])
                    this.lgas!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(NameValueModel.fromJS(item, _mappings));
            }
            this.lgaId = _data["lgaId"];
            this.isFullYear = _data["isFullYear"];
            this.valueOfContents = _data["valueOfContents"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.isWemaBank = _data["isWemaBank"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): HomeScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HomeScheduleRequest>(data, _mappings, HomeScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preOwnership"] = this.preOwnership;
        data["tenancy"] = this.tenancy;
        data["description"] = this.description;
        data["address"] = this.address;
        data["postalAddress"] = this.postalAddress;
        data["premiumAmount"] = this.premiumAmount;
        data["sumAssured"] = this.sumAssured;
        if (Array.isArray(this.homeItems)) {
            data["homeItems"] = [];
            for (let item of this.homeItems)
                data["homeItems"].push(item.toJSON());
        }
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        if (Array.isArray(this.lgas)) {
            data["lgas"] = [];
            for (let item of this.lgas)
                data["lgas"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item.toJSON());
        }
        data["lgaId"] = this.lgaId;
        data["isFullYear"] = this.isFullYear;
        data["valueOfContents"] = this.valueOfContents;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["isWemaBank"] = this.isWemaBank;
        data["referralCode"] = this.referralCode;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        return data;
    }
}

export interface IHomeScheduleRequest {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    homeItems?: NameAmountModel[] | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
}

export class OfficeScheduleRequest implements IOfficeScheduleRequest {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    officeItems?: NameAmountModel[] | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;

    constructor(data?: IOfficeScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.preOwnership = _data["preOwnership"];
            this.tenancy = _data["tenancy"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.postalAddress = _data["postalAddress"];
            this.premiumAmount = _data["premiumAmount"];
            this.sumAssured = _data["sumAssured"];
            if (Array.isArray(_data["officeItems"])) {
                this.officeItems = [] as any;
                for (let item of _data["officeItems"])
                    this.officeItems!.push(NameAmountModel.fromJS(item, _mappings));
            }
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            if (Array.isArray(_data["lgas"])) {
                this.lgas = [] as any;
                for (let item of _data["lgas"])
                    this.lgas!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(NameValueModel.fromJS(item, _mappings));
            }
            this.lgaId = _data["lgaId"];
            this.isFullYear = _data["isFullYear"];
            this.valueOfContents = _data["valueOfContents"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.isWemaBank = _data["isWemaBank"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): OfficeScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OfficeScheduleRequest>(data, _mappings, OfficeScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preOwnership"] = this.preOwnership;
        data["tenancy"] = this.tenancy;
        data["description"] = this.description;
        data["address"] = this.address;
        data["postalAddress"] = this.postalAddress;
        data["premiumAmount"] = this.premiumAmount;
        data["sumAssured"] = this.sumAssured;
        if (Array.isArray(this.officeItems)) {
            data["officeItems"] = [];
            for (let item of this.officeItems)
                data["officeItems"].push(item.toJSON());
        }
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        if (Array.isArray(this.lgas)) {
            data["lgas"] = [];
            for (let item of this.lgas)
                data["lgas"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item.toJSON());
        }
        data["lgaId"] = this.lgaId;
        data["isFullYear"] = this.isFullYear;
        data["valueOfContents"] = this.valueOfContents;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["isWemaBank"] = this.isWemaBank;
        data["referralCode"] = this.referralCode;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOfficeScheduleRequest {
    preOwnership?: string | undefined;
    tenancy?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    postalAddress?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    officeItems?: NameAmountModel[] | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    lgas?: NameValueModel[] | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
}

export class PersonalAccidentScheduleRequest implements IPersonalAccidentScheduleRequest {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    unit?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: IPersonalAccidentScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"];
            this.relationship = _data["relationship"];
            this.premiumAmount = _data["premiumAmount"];
            this.sumAssured = _data["sumAssured"];
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(NameValueModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(NameValueModel.fromJS(item, _mappings));
            }
            this.lgaId = _data["lgaId"];
            this.isFullYear = _data["isFullYear"];
            this.valueOfContents = _data["valueOfContents"];
            this.unit = _data["unit"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.isWemaBank = _data["isWemaBank"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonalAccidentScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonalAccidentScheduleRequest>(data, _mappings, PersonalAccidentScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary;
        data["relationship"] = this.relationship;
        data["premiumAmount"] = this.premiumAmount;
        data["sumAssured"] = this.sumAssured;
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item.toJSON());
        }
        data["lgaId"] = this.lgaId;
        data["isFullYear"] = this.isFullYear;
        data["valueOfContents"] = this.valueOfContents;
        data["unit"] = this.unit;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["isWemaBank"] = this.isWemaBank;
        data["referralCode"] = this.referralCode;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface IPersonalAccidentScheduleRequest {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titles?: NameValueModel[] | undefined;
    gender?: NameValueModel[] | undefined;
    lgaId?: string | undefined;
    isFullYear?: boolean | undefined;
    valueOfContents?: string | undefined;
    unit?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    isWemaBank?: boolean | undefined;
    referralCode?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
}

export class ClientPolicyByEmailModel implements IClientPolicyByEmailModel {
    code?: string | undefined;
    clientCode?: string | undefined;
    shortdescription?: string | undefined;
    title?: string | undefined;
    surname?: string | undefined;
    othernames?: string | undefined;
    sex?: string | undefined;
    business?: string | undefined;
    physicalAddress?: string | undefined;
    maritalStatus?: string | undefined;
    dob?: string | undefined;
    telephone?: string | undefined;
    smsTelephone?: string | undefined;
    email?: string | undefined;
    policyNo?: string | undefined;
    policyStatus?: string | undefined;
    productName?: string | undefined;
    policyDuration?: string | undefined;
    effectiveDate?: string | undefined;
    maturityDate?: string | undefined;
    lifeCover?: string | undefined;
    payToDate?: string | undefined;
    paidToDate?: string | undefined;
    isSuccessful?: boolean | undefined;
    paidToDueDate?: string | undefined;
    agentShortCode?: string | undefined;
    amountToPay?: string | undefined;
    paymentFrequency?: string | undefined;
    totalInstallment?: string | undefined;
    numberOfInstallmentPaid?: string | undefined;
    premiumBalance?: string | undefined;

    constructor(data?: IClientPolicyByEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.clientCode = _data["clientCode"];
            this.shortdescription = _data["shortdescription"];
            this.title = _data["title"];
            this.surname = _data["surname"];
            this.othernames = _data["othernames"];
            this.sex = _data["sex"];
            this.business = _data["business"];
            this.physicalAddress = _data["physicalAddress"];
            this.maritalStatus = _data["maritalStatus"];
            this.dob = _data["dob"];
            this.telephone = _data["telephone"];
            this.smsTelephone = _data["smsTelephone"];
            this.email = _data["email"];
            this.policyNo = _data["policyNo"];
            this.policyStatus = _data["policyStatus"];
            this.productName = _data["productName"];
            this.policyDuration = _data["policyDuration"];
            this.effectiveDate = _data["effectiveDate"];
            this.maturityDate = _data["maturityDate"];
            this.lifeCover = _data["lifeCover"];
            this.payToDate = _data["payToDate"];
            this.paidToDate = _data["paidToDate"];
            this.isSuccessful = _data["isSuccessful"];
            this.paidToDueDate = _data["paidToDueDate"];
            this.agentShortCode = _data["agentShortCode"];
            this.amountToPay = _data["amountToPay"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.totalInstallment = _data["totalInstallment"];
            this.numberOfInstallmentPaid = _data["numberOfInstallmentPaid"];
            this.premiumBalance = _data["premiumBalance"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPolicyByEmailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPolicyByEmailModel>(data, _mappings, ClientPolicyByEmailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["clientCode"] = this.clientCode;
        data["shortdescription"] = this.shortdescription;
        data["title"] = this.title;
        data["surname"] = this.surname;
        data["othernames"] = this.othernames;
        data["sex"] = this.sex;
        data["business"] = this.business;
        data["physicalAddress"] = this.physicalAddress;
        data["maritalStatus"] = this.maritalStatus;
        data["dob"] = this.dob;
        data["telephone"] = this.telephone;
        data["smsTelephone"] = this.smsTelephone;
        data["email"] = this.email;
        data["policyNo"] = this.policyNo;
        data["policyStatus"] = this.policyStatus;
        data["productName"] = this.productName;
        data["policyDuration"] = this.policyDuration;
        data["effectiveDate"] = this.effectiveDate;
        data["maturityDate"] = this.maturityDate;
        data["lifeCover"] = this.lifeCover;
        data["payToDate"] = this.payToDate;
        data["paidToDate"] = this.paidToDate;
        data["isSuccessful"] = this.isSuccessful;
        data["paidToDueDate"] = this.paidToDueDate;
        data["agentShortCode"] = this.agentShortCode;
        data["amountToPay"] = this.amountToPay;
        data["paymentFrequency"] = this.paymentFrequency;
        data["totalInstallment"] = this.totalInstallment;
        data["numberOfInstallmentPaid"] = this.numberOfInstallmentPaid;
        data["premiumBalance"] = this.premiumBalance;
        return data;
    }
}

export interface IClientPolicyByEmailModel {
    code?: string | undefined;
    clientCode?: string | undefined;
    shortdescription?: string | undefined;
    title?: string | undefined;
    surname?: string | undefined;
    othernames?: string | undefined;
    sex?: string | undefined;
    business?: string | undefined;
    physicalAddress?: string | undefined;
    maritalStatus?: string | undefined;
    dob?: string | undefined;
    telephone?: string | undefined;
    smsTelephone?: string | undefined;
    email?: string | undefined;
    policyNo?: string | undefined;
    policyStatus?: string | undefined;
    productName?: string | undefined;
    policyDuration?: string | undefined;
    effectiveDate?: string | undefined;
    maturityDate?: string | undefined;
    lifeCover?: string | undefined;
    payToDate?: string | undefined;
    paidToDate?: string | undefined;
    isSuccessful?: boolean | undefined;
    paidToDueDate?: string | undefined;
    agentShortCode?: string | undefined;
    amountToPay?: string | undefined;
    paymentFrequency?: string | undefined;
    totalInstallment?: string | undefined;
    numberOfInstallmentPaid?: string | undefined;
    premiumBalance?: string | undefined;
}

export class RevalidationModel implements IRevalidationModel {
    paymentChannel?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;

    constructor(data?: IRevalidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentChannel = _data["paymentChannel"];
            this.amount = _data["amount"];
            this.transactionRef = _data["transactionRef"];
            this.partnerReference = _data["partnerReference"];
        }
    }

    static fromJS(data: any, _mappings?: any): RevalidationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RevalidationModel>(data, _mappings, RevalidationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentChannel"] = this.paymentChannel;
        data["amount"] = this.amount;
        data["transactionRef"] = this.transactionRef;
        data["partnerReference"] = this.partnerReference;
        return data;
    }
}

export interface IRevalidationModel {
    paymentChannel?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;
}

export class Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements ITuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    readonly item1?: RavePaymentResponse | undefined;
    readonly item2?: PolicyDetails | undefined;

    constructor(data?: ITuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? RavePaymentResponse.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"] ? PolicyDetails.fromJS(_data["item2"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, Tuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITuple_2OfOfRavePaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: RavePaymentResponse | undefined;
    item2?: PolicyDetails | undefined;
}

export class RavePaymentResponse implements IRavePaymentResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: RavePaymentData | undefined;

    constructor(data?: IRavePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? RavePaymentData.fromJS(_data["data"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): RavePaymentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RavePaymentResponse>(data, _mappings, RavePaymentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRavePaymentResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: RavePaymentData | undefined;
}

export class RavePaymentData implements IRavePaymentData {
    tx_ref?: string | undefined;
    flw_ref?: string | undefined;
    transaction_type?: string | undefined;
    transaction_processor?: string | undefined;
    status?: string | undefined;
    ip?: string | undefined;
    device_fingerprint?: string | undefined;
    cycle?: string | undefined;
    narration?: string | undefined;
    amount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    markupFee?: number | undefined;
    merchantbearsfee?: number | undefined;
    charged_amount?: number | undefined;
    transaction_currency?: string | undefined;
    system_type?: string | undefined;
    payment_entity?: string | undefined;
    payment_id?: string | undefined;
    fraud_status?: string | undefined;
    charge_type?: string | undefined;
    is_live?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    merchant_id?: number | undefined;
    addon_id?: number | undefined;
    customerId?: number | undefined;
    customerPhone?: string | undefined;
    customerFullname?: string | undefined;
    customerEmail?: string | undefined;
    customerCreatedAt?: string | undefined;
    customerUpdatedAt?: string | undefined;
    customerDeletedAt?: string | undefined;
    customerAccountId?: number | undefined;
    card?: Card | undefined;
    flwMeta?: FlwMeta | undefined;

    constructor(data?: IRavePaymentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tx_ref = _data["tx_ref"];
            this.flw_ref = _data["flw_ref"];
            this.transaction_type = _data["transaction_type"];
            this.transaction_processor = _data["transaction_processor"];
            this.status = _data["status"];
            this.ip = _data["ip"];
            this.device_fingerprint = _data["device_fingerprint"];
            this.cycle = _data["cycle"];
            this.narration = _data["narration"];
            this.amount = _data["amount"];
            this.appfee = _data["appfee"];
            this.merchantfee = _data["merchantfee"];
            this.markupFee = _data["markupFee"];
            this.merchantbearsfee = _data["merchantbearsfee"];
            this.charged_amount = _data["charged_amount"];
            this.transaction_currency = _data["transaction_currency"];
            this.system_type = _data["system_type"];
            this.payment_entity = _data["payment_entity"];
            this.payment_id = _data["payment_id"];
            this.fraud_status = _data["fraud_status"];
            this.charge_type = _data["charge_type"];
            this.is_live = _data["is_live"];
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
            this.deletedAt = _data["deletedAt"];
            this.merchant_id = _data["merchant_id"];
            this.addon_id = _data["addon_id"];
            this.customerId = _data["customer.id"];
            this.customerPhone = _data["customer.phone"];
            this.customerFullname = _data["customer.fullname"];
            this.customerEmail = _data["customer.email"];
            this.customerCreatedAt = _data["customer.createdAt"];
            this.customerUpdatedAt = _data["customer.updatedAt"];
            this.customerDeletedAt = _data["customer.deletedAt"];
            this.customerAccountId = _data["customer.AccountId"];
            this.card = _data["card"] ? Card.fromJS(_data["card"], _mappings) : <any>undefined;
            this.flwMeta = _data["flwMeta"] ? FlwMeta.fromJS(_data["flwMeta"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): RavePaymentData | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RavePaymentData>(data, _mappings, RavePaymentData);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tx_ref"] = this.tx_ref;
        data["flw_ref"] = this.flw_ref;
        data["transaction_type"] = this.transaction_type;
        data["transaction_processor"] = this.transaction_processor;
        data["status"] = this.status;
        data["ip"] = this.ip;
        data["device_fingerprint"] = this.device_fingerprint;
        data["cycle"] = this.cycle;
        data["narration"] = this.narration;
        data["amount"] = this.amount;
        data["appfee"] = this.appfee;
        data["merchantfee"] = this.merchantfee;
        data["markupFee"] = this.markupFee;
        data["merchantbearsfee"] = this.merchantbearsfee;
        data["charged_amount"] = this.charged_amount;
        data["transaction_currency"] = this.transaction_currency;
        data["system_type"] = this.system_type;
        data["payment_entity"] = this.payment_entity;
        data["payment_id"] = this.payment_id;
        data["fraud_status"] = this.fraud_status;
        data["charge_type"] = this.charge_type;
        data["is_live"] = this.is_live;
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        data["deletedAt"] = this.deletedAt;
        data["merchant_id"] = this.merchant_id;
        data["addon_id"] = this.addon_id;
        data["customer.id"] = this.customerId;
        data["customer.phone"] = this.customerPhone;
        data["customer.fullname"] = this.customerFullname;
        data["customer.email"] = this.customerEmail;
        data["customer.createdAt"] = this.customerCreatedAt;
        data["customer.updatedAt"] = this.customerUpdatedAt;
        data["customer.deletedAt"] = this.customerDeletedAt;
        data["customer.AccountId"] = this.customerAccountId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["flwMeta"] = this.flwMeta ? this.flwMeta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRavePaymentData {
    tx_ref?: string | undefined;
    flw_ref?: string | undefined;
    transaction_type?: string | undefined;
    transaction_processor?: string | undefined;
    status?: string | undefined;
    ip?: string | undefined;
    device_fingerprint?: string | undefined;
    cycle?: string | undefined;
    narration?: string | undefined;
    amount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    markupFee?: number | undefined;
    merchantbearsfee?: number | undefined;
    charged_amount?: number | undefined;
    transaction_currency?: string | undefined;
    system_type?: string | undefined;
    payment_entity?: string | undefined;
    payment_id?: string | undefined;
    fraud_status?: string | undefined;
    charge_type?: string | undefined;
    is_live?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    merchant_id?: number | undefined;
    addon_id?: number | undefined;
    customerId?: number | undefined;
    customerPhone?: string | undefined;
    customerFullname?: string | undefined;
    customerEmail?: string | undefined;
    customerCreatedAt?: string | undefined;
    customerUpdatedAt?: string | undefined;
    customerDeletedAt?: string | undefined;
    customerAccountId?: number | undefined;
    card?: Card | undefined;
    flwMeta?: FlwMeta | undefined;
}

export class Card implements ICard {
    cardBIN?: string | undefined;
    brand?: string | undefined;
    card_tokens?: CardToken[] | undefined;

    constructor(data?: ICard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cardBIN = _data["cardBIN"];
            this.brand = _data["brand"];
            if (Array.isArray(_data["card_tokens"])) {
                this.card_tokens = [] as any;
                for (let item of _data["card_tokens"])
                    this.card_tokens!.push(CardToken.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Card | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Card>(data, _mappings, Card);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardBIN"] = this.cardBIN;
        data["brand"] = this.brand;
        if (Array.isArray(this.card_tokens)) {
            data["card_tokens"] = [];
            for (let item of this.card_tokens)
                data["card_tokens"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICard {
    cardBIN?: string | undefined;
    brand?: string | undefined;
    card_tokens?: CardToken[] | undefined;
}

export class FlwMeta implements IFlwMeta {
    chargeResponse?: string | undefined;
    chargeResponseMessage?: string | undefined;
    vBVRESPONSEMESSAGE?: string | undefined;
    vBVRESPONSECODE?: string | undefined;
    aCCOUNTVALIDATIONRESPMESSAGE?: string | undefined;
    aCCOUNTVALIDATIONRESPONSECODE?: string | undefined;

    constructor(data?: IFlwMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.chargeResponse = _data["chargeResponse"];
            this.chargeResponseMessage = _data["chargeResponseMessage"];
            this.vBVRESPONSEMESSAGE = _data["VBVRESPONSEMESSAGE"];
            this.vBVRESPONSECODE = _data["VBVRESPONSECODE"];
            this.aCCOUNTVALIDATIONRESPMESSAGE = _data["ACCOUNTVALIDATIONRESPMESSAGE"];
            this.aCCOUNTVALIDATIONRESPONSECODE = _data["ACCOUNTVALIDATIONRESPONSECODE"];
        }
    }

    static fromJS(data: any, _mappings?: any): FlwMeta | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlwMeta>(data, _mappings, FlwMeta);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeResponse"] = this.chargeResponse;
        data["chargeResponseMessage"] = this.chargeResponseMessage;
        data["VBVRESPONSEMESSAGE"] = this.vBVRESPONSEMESSAGE;
        data["VBVRESPONSECODE"] = this.vBVRESPONSECODE;
        data["ACCOUNTVALIDATIONRESPMESSAGE"] = this.aCCOUNTVALIDATIONRESPMESSAGE;
        data["ACCOUNTVALIDATIONRESPONSECODE"] = this.aCCOUNTVALIDATIONRESPONSECODE;
        return data;
    }
}

export interface IFlwMeta {
    chargeResponse?: string | undefined;
    chargeResponseMessage?: string | undefined;
    vBVRESPONSEMESSAGE?: string | undefined;
    vBVRESPONSECODE?: string | undefined;
    aCCOUNTVALIDATIONRESPMESSAGE?: string | undefined;
    aCCOUNTVALIDATIONRESPONSECODE?: string | undefined;
}

export class CardToken implements ICardToken {
    embedtoken?: string | undefined;
    shortcode?: string | undefined;

    constructor(data?: ICardToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.embedtoken = _data["embedtoken"];
            this.shortcode = _data["shortcode"];
        }
    }

    static fromJS(data: any, _mappings?: any): CardToken | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CardToken>(data, _mappings, CardToken);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embedtoken"] = this.embedtoken;
        data["shortcode"] = this.shortcode;
        return data;
    }
}

export interface ICardToken {
    embedtoken?: string | undefined;
    shortcode?: string | undefined;
}

export class Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements ITuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    readonly item1?: WemaBankPaymentResponse | undefined;
    readonly item2?: PolicyDetails | undefined;

    constructor(data?: ITuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? WemaBankPaymentResponse.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"] ? PolicyDetails.fromJS(_data["item2"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, Tuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITuple_2OfOfWemaBankPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: WemaBankPaymentResponse | undefined;
    item2?: PolicyDetails | undefined;
}

export class WemaBankPaymentResponse implements IWemaBankPaymentResponse {
    id?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    merchantRef?: string | undefined;
    customerDetails?: string | undefined;
    transactionDate?: Date | undefined;
    customerEmail?: string | undefined;
    status?: string | undefined;
    selectedGateway?: string | undefined;
    currency?: string | undefined;
    convertedToNgn?: boolean | undefined;
    isSettled?: boolean | undefined;

    constructor(data?: IWemaBankPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseCode = _data["responseCode"];
            this.responseDescription = _data["responseDescription"];
            this.amount = _data["amount"];
            this.transactionRef = _data["transactionRef"];
            this.merchantRef = _data["merchantRef"];
            this.customerDetails = _data["customerDetails"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.customerEmail = _data["customerEmail"];
            this.status = _data["status"];
            this.selectedGateway = _data["selectedGateway"];
            this.currency = _data["currency"];
            this.convertedToNgn = _data["convertedToNgn"];
            this.isSettled = _data["isSettled"];
        }
    }

    static fromJS(data: any, _mappings?: any): WemaBankPaymentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WemaBankPaymentResponse>(data, _mappings, WemaBankPaymentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseCode"] = this.responseCode;
        data["responseDescription"] = this.responseDescription;
        data["amount"] = this.amount;
        data["transactionRef"] = this.transactionRef;
        data["merchantRef"] = this.merchantRef;
        data["customerDetails"] = this.customerDetails;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["customerEmail"] = this.customerEmail;
        data["status"] = this.status;
        data["selectedGateway"] = this.selectedGateway;
        data["currency"] = this.currency;
        data["convertedToNgn"] = this.convertedToNgn;
        data["isSettled"] = this.isSettled;
        return data;
    }
}

export interface IWemaBankPaymentResponse {
    id?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    amount?: number | undefined;
    transactionRef?: string | undefined;
    merchantRef?: string | undefined;
    customerDetails?: string | undefined;
    transactionDate?: Date | undefined;
    customerEmail?: string | undefined;
    status?: string | undefined;
    selectedGateway?: string | undefined;
    currency?: string | undefined;
    convertedToNgn?: boolean | undefined;
    isSettled?: boolean | undefined;
}

export class InterswitchParam implements IInterswitchParam {
    transactionRef?: string | undefined;
    amount?: number | undefined;
    interswitchMacKey?: string | undefined;

    constructor(data?: IInterswitchParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.interswitchMacKey = _data["interswitchMacKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): InterswitchParam | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InterswitchParam>(data, _mappings, InterswitchParam);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["interswitchMacKey"] = this.interswitchMacKey;
        return data;
    }
}

export interface IInterswitchParam {
    transactionRef?: string | undefined;
    amount?: number | undefined;
    interswitchMacKey?: string | undefined;
}

export class Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements ITuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    readonly item1?: InterswitchPaymentResponse | undefined;
    readonly item2?: PolicyDetails | undefined;

    constructor(data?: ITuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? InterswitchPaymentResponse.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"] ? PolicyDetails.fromJS(_data["item2"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, Tuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITuple_2OfOfInterswitchPaymentResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: InterswitchPaymentResponse | undefined;
    item2?: PolicyDetails | undefined;
}

export class InterswitchPaymentResponse implements IInterswitchPaymentResponse {
    amount?: number | undefined;
    cardNumber?: string | undefined;
    merchantReference?: string | undefined;
    paymentReference?: string | undefined;
    retrievalReferenceNumber?: string | undefined;
    leadBankCbnCode?: any | undefined;
    leadBankName?: any | undefined;
    splitAccounts?: any[] | undefined;
    transactionDate?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;

    constructor(data?: IInterswitchPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.cardNumber = _data["cardNumber"];
            this.merchantReference = _data["merchantReference"];
            this.paymentReference = _data["paymentReference"];
            this.retrievalReferenceNumber = _data["retrievalReferenceNumber"];
            this.leadBankCbnCode = _data["leadBankCbnCode"];
            this.leadBankName = _data["leadBankName"];
            if (Array.isArray(_data["splitAccounts"])) {
                this.splitAccounts = [] as any;
                for (let item of _data["splitAccounts"])
                    this.splitAccounts!.push(item);
            }
            this.transactionDate = _data["transactionDate"];
            this.responseCode = _data["responseCode"];
            this.responseDescription = _data["responseDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): InterswitchPaymentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InterswitchPaymentResponse>(data, _mappings, InterswitchPaymentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["cardNumber"] = this.cardNumber;
        data["merchantReference"] = this.merchantReference;
        data["paymentReference"] = this.paymentReference;
        data["retrievalReferenceNumber"] = this.retrievalReferenceNumber;
        data["leadBankCbnCode"] = this.leadBankCbnCode;
        data["leadBankName"] = this.leadBankName;
        if (Array.isArray(this.splitAccounts)) {
            data["splitAccounts"] = [];
            for (let item of this.splitAccounts)
                data["splitAccounts"].push(item);
        }
        data["transactionDate"] = this.transactionDate;
        data["responseCode"] = this.responseCode;
        data["responseDescription"] = this.responseDescription;
        return data;
    }
}

export interface IInterswitchPaymentResponse {
    amount?: number | undefined;
    cardNumber?: string | undefined;
    merchantReference?: string | undefined;
    paymentReference?: string | undefined;
    retrievalReferenceNumber?: string | undefined;
    leadBankCbnCode?: any | undefined;
    leadBankName?: any | undefined;
    splitAccounts?: any[] | undefined;
    transactionDate?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
}

export class VehicleVerificationDetails implements IVehicleVerificationDetails {
    chasisNo?: string | undefined;
    color?: string | undefined;
    policyNo?: string | undefined;
    model?: string | undefined;
    clientName?: string | undefined;
    carMake?: string | undefined;
    vehicleType?: string | undefined;
    newRegistrationNo?: string | undefined;
    registrationNo?: string | undefined;
    issueDate?: string | undefined;
    expirationDate?: string | undefined;
    licencePlate?: string | undefined;
    oldLicensePlate?: string | undefined;
    dateuploaded?: string | undefined;
    timeuploaded?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IVehicleVerificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.chasisNo = _data["chasisNo"];
            this.color = _data["color"];
            this.policyNo = _data["policyNo"];
            this.model = _data["model"];
            this.clientName = _data["clientName"];
            this.carMake = _data["carMake"];
            this.vehicleType = _data["vehicleType"];
            this.newRegistrationNo = _data["newRegistrationNo"];
            this.registrationNo = _data["registrationNo"];
            this.issueDate = _data["issueDate"];
            this.expirationDate = _data["expirationDate"];
            this.licencePlate = _data["licencePlate"];
            this.oldLicensePlate = _data["oldLicensePlate"];
            this.dateuploaded = _data["dateuploaded"];
            this.timeuploaded = _data["timeuploaded"];
            this.status = _data["status"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): VehicleVerificationDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<VehicleVerificationDetails>(data, _mappings, VehicleVerificationDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chasisNo"] = this.chasisNo;
        data["color"] = this.color;
        data["policyNo"] = this.policyNo;
        data["model"] = this.model;
        data["clientName"] = this.clientName;
        data["carMake"] = this.carMake;
        data["vehicleType"] = this.vehicleType;
        data["newRegistrationNo"] = this.newRegistrationNo;
        data["registrationNo"] = this.registrationNo;
        data["issueDate"] = this.issueDate;
        data["expirationDate"] = this.expirationDate;
        data["licencePlate"] = this.licencePlate;
        data["oldLicensePlate"] = this.oldLicensePlate;
        data["dateuploaded"] = this.dateuploaded;
        data["timeuploaded"] = this.timeuploaded;
        data["status"] = this.status;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IVehicleVerificationDetails {
    chasisNo?: string | undefined;
    color?: string | undefined;
    policyNo?: string | undefined;
    model?: string | undefined;
    clientName?: string | undefined;
    carMake?: string | undefined;
    vehicleType?: string | undefined;
    newRegistrationNo?: string | undefined;
    registrationNo?: string | undefined;
    issueDate?: string | undefined;
    expirationDate?: string | undefined;
    licencePlate?: string | undefined;
    oldLicensePlate?: string | undefined;
    dateuploaded?: string | undefined;
    timeuploaded?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
}

export class PartnerFinalizeModel implements IPartnerFinalizeModel {
    amountPaid?: number | undefined;
    amoumntPaid?: number | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;
    accountNumber?: string | undefined;
    hash?: string | undefined;
    paymentRef?: string | undefined;
    paymentDetails?: any | undefined;
    isGtPay?: boolean | undefined;
    agentEmail?: string | undefined;

    constructor(data?: IPartnerFinalizeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amountPaid = _data["amountPaid"];
            this.amoumntPaid = _data["amoumntPaid"];
            this.transactionRef = _data["transactionRef"];
            this.partnerReference = _data["partnerReference"];
            this.accountNumber = _data["accountNumber"];
            this.hash = _data["hash"];
            this.paymentRef = _data["paymentRef"];
            this.paymentDetails = _data["paymentDetails"];
            this.isGtPay = _data["isGtPay"];
            this.agentEmail = _data["agentEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): PartnerFinalizeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PartnerFinalizeModel>(data, _mappings, PartnerFinalizeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPaid"] = this.amountPaid;
        data["amoumntPaid"] = this.amoumntPaid;
        data["transactionRef"] = this.transactionRef;
        data["partnerReference"] = this.partnerReference;
        data["accountNumber"] = this.accountNumber;
        data["hash"] = this.hash;
        data["paymentRef"] = this.paymentRef;
        data["paymentDetails"] = this.paymentDetails;
        data["isGtPay"] = this.isGtPay;
        data["agentEmail"] = this.agentEmail;
        return data;
    }
}

export interface IPartnerFinalizeModel {
    amountPaid?: number | undefined;
    amoumntPaid?: number | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;
    accountNumber?: string | undefined;
    hash?: string | undefined;
    paymentRef?: string | undefined;
    paymentDetails?: any | undefined;
    isGtPay?: boolean | undefined;
    agentEmail?: string | undefined;
}

export class LifeRenewalTranDto implements ILifeRenewalTranDto {
    policyNo?: string | undefined;
    transactionDate?: Date | undefined;
    customerName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionType?: string | undefined;
    amount?: number | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    transactionRef?: string | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    policyStatus?: string | undefined;
    paymentChannel?: string | undefined;
    responseMessage?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ILifeRenewalTranDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.transactionType = _data["transactionType"];
            this.amount = _data["amount"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.transactionRef = _data["transactionRef"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.policyStatus = _data["policyStatus"];
            this.paymentChannel = _data["paymentChannel"];
            this.responseMessage = _data["responseMessage"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalTranDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalTranDto>(data, _mappings, LifeRenewalTranDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["transactionType"] = this.transactionType;
        data["amount"] = this.amount;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["transactionRef"] = this.transactionRef;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["policyStatus"] = this.policyStatus;
        data["paymentChannel"] = this.paymentChannel;
        data["responseMessage"] = this.responseMessage;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ILifeRenewalTranDto {
    policyNo?: string | undefined;
    transactionDate?: Date | undefined;
    customerName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionType?: string | undefined;
    amount?: number | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    transactionRef?: string | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    policyStatus?: string | undefined;
    paymentChannel?: string | undefined;
    responseMessage?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class MerchantDto implements IMerchantDto {
    merchantBank?: string | undefined;
    merchantCode?: string | undefined;
    shortDescription?: string | undefined;
    successCode?: string | undefined;
    glCode?: string | undefined;
    accountNumber?: string | undefined;
    commissionRate?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IMerchantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.merchantBank = _data["merchantBank"];
            this.merchantCode = _data["merchantCode"];
            this.shortDescription = _data["shortDescription"];
            this.successCode = _data["successCode"];
            this.glCode = _data["glCode"];
            this.accountNumber = _data["accountNumber"];
            this.commissionRate = _data["commissionRate"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MerchantDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MerchantDto>(data, _mappings, MerchantDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantBank"] = this.merchantBank;
        data["merchantCode"] = this.merchantCode;
        data["shortDescription"] = this.shortDescription;
        data["successCode"] = this.successCode;
        data["glCode"] = this.glCode;
        data["accountNumber"] = this.accountNumber;
        data["commissionRate"] = this.commissionRate;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IMerchantDto {
    merchantBank?: string | undefined;
    merchantCode?: string | undefined;
    shortDescription?: string | undefined;
    successCode?: string | undefined;
    glCode?: string | undefined;
    accountNumber?: string | undefined;
    commissionRate?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class MarineScheduleDto implements IMarineScheduleDto {
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    id?: string | undefined;

    constructor(data?: IMarineScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MarineScheduleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MarineScheduleDto>(data, _mappings, MarineScheduleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["id"] = this.id;
        return data;
    }
}

export interface IMarineScheduleDto {
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    id?: string | undefined;
}

export class TravelScheduleRequest implements ITravelScheduleRequest {
    name?: string | undefined;
    countryId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    nokName?: string | undefined;
    noKrelationship?: string | undefined;
    noKaddr?: string | undefined;
    embassycode?: string | undefined;
    travelParty?: string | undefined;
    groupType?: string | undefined;
    currency?: string | undefined;
    travelPurpose?: string | undefined;
    preMedical?: boolean | undefined;
    medical?: string | undefined;
    transDate?: Date | undefined;
    certNo?: string | undefined;
    sumAssured?: number | undefined;
    passportNumber?: string | undefined;
    passportUrl?: string | undefined;
    premium?: number | undefined;
    excess?: number | undefined;
    commAllowed?: boolean | undefined;
    isActive?: boolean | undefined;
    transactionRef?: string | undefined;
    productId?: string | undefined;
    branchId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: ITravelScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.nokName = _data["nokName"];
            this.noKrelationship = _data["noKrelationship"];
            this.noKaddr = _data["noKaddr"];
            this.embassycode = _data["embassycode"];
            this.travelParty = _data["travelParty"];
            this.groupType = _data["groupType"];
            this.currency = _data["currency"];
            this.travelPurpose = _data["travelPurpose"];
            this.preMedical = _data["preMedical"];
            this.medical = _data["medical"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.certNo = _data["certNo"];
            this.sumAssured = _data["sumAssured"];
            this.passportNumber = _data["passportNumber"];
            this.passportUrl = _data["passportUrl"];
            this.premium = _data["premium"];
            this.excess = _data["excess"];
            this.commAllowed = _data["commAllowed"];
            this.isActive = _data["isActive"];
            this.transactionRef = _data["transactionRef"];
            this.productId = _data["productId"];
            this.branchId = _data["branchId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.intermediaryId = _data["intermediaryId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.paymentChannel = _data["paymentChannel"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelScheduleRequest>(data, _mappings, TravelScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["nokName"] = this.nokName;
        data["noKrelationship"] = this.noKrelationship;
        data["noKaddr"] = this.noKaddr;
        data["embassycode"] = this.embassycode;
        data["travelParty"] = this.travelParty;
        data["groupType"] = this.groupType;
        data["currency"] = this.currency;
        data["travelPurpose"] = this.travelPurpose;
        data["preMedical"] = this.preMedical;
        data["medical"] = this.medical;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["certNo"] = this.certNo;
        data["sumAssured"] = this.sumAssured;
        data["passportNumber"] = this.passportNumber;
        data["passportUrl"] = this.passportUrl;
        data["premium"] = this.premium;
        data["excess"] = this.excess;
        data["commAllowed"] = this.commAllowed;
        data["isActive"] = this.isActive;
        data["transactionRef"] = this.transactionRef;
        data["productId"] = this.productId;
        data["branchId"] = this.branchId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["intermediaryId"] = this.intermediaryId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["paymentChannel"] = this.paymentChannel;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface ITravelScheduleRequest {
    name?: string | undefined;
    countryId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    nokName?: string | undefined;
    noKrelationship?: string | undefined;
    noKaddr?: string | undefined;
    embassycode?: string | undefined;
    travelParty?: string | undefined;
    groupType?: string | undefined;
    currency?: string | undefined;
    travelPurpose?: string | undefined;
    preMedical?: boolean | undefined;
    medical?: string | undefined;
    transDate?: Date | undefined;
    certNo?: string | undefined;
    sumAssured?: number | undefined;
    passportNumber?: string | undefined;
    passportUrl?: string | undefined;
    premium?: number | undefined;
    excess?: number | undefined;
    commAllowed?: boolean | undefined;
    isActive?: boolean | undefined;
    transactionRef?: string | undefined;
    productId?: string | undefined;
    branchId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    intermediaryId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    agentShortDescription?: string | undefined;
}

export class MotorScheduleDto implements IMotorScheduleDto {
    id?: string | undefined;

    constructor(data?: IMotorScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MotorScheduleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MotorScheduleDto>(data, _mappings, MotorScheduleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMotorScheduleDto {
    id?: string | undefined;
}

export class TravelScheduleDto implements ITravelScheduleDto {
    id?: string | undefined;

    constructor(data?: ITravelScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelScheduleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelScheduleDto>(data, _mappings, TravelScheduleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITravelScheduleDto {
    id?: string | undefined;
}

export class TQNiidModel implements ITQNiidModel {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ITQNiidModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): TQNiidModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TQNiidModel>(data, _mappings, TQNiidModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITQNiidModel {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ClientPolicies implements IClientPolicies {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    clientPolicyList?: ClientPolicyModel[] | undefined;
    emails?: string[] | undefined;

    constructor(data?: IClientPolicies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["clientPolicyList"])) {
                this.clientPolicyList = [] as any;
                for (let item of _data["clientPolicyList"])
                    this.clientPolicyList!.push(ClientPolicyModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPolicies | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPolicies>(data, _mappings, ClientPolicies);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.clientPolicyList)) {
            data["clientPolicyList"] = [];
            for (let item of this.clientPolicyList)
                data["clientPolicyList"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IClientPolicies {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    clientPolicyList?: ClientPolicyModel[] | undefined;
    emails?: string[] | undefined;
}

export class ClientPolicyModel implements IClientPolicyModel {
    clientShortDescription?: string | undefined;
    policyNumber?: string | undefined;
    policyStatus?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    productDescription?: string | undefined;
    clientName?: string | undefined;

    constructor(data?: IClientPolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientShortDescription = _data["clientShortDescription"];
            this.policyNumber = _data["policyNumber"];
            this.policyStatus = _data["policyStatus"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.productDescription = _data["productDescription"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPolicyModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPolicyModel>(data, _mappings, ClientPolicyModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientShortDescription"] = this.clientShortDescription;
        data["policyNumber"] = this.policyNumber;
        data["policyStatus"] = this.policyStatus;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["productDescription"] = this.productDescription;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IClientPolicyModel {
    clientShortDescription?: string | undefined;
    policyNumber?: string | undefined;
    policyStatus?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    productDescription?: string | undefined;
    clientName?: string | undefined;
}

export class ClientPoliciesByEmail implements IClientPoliciesByEmail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    clientPolicyByEmailList?: ClientPolicyByEmailModel[] | undefined;

    constructor(data?: IClientPoliciesByEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["clientPolicyByEmailList"])) {
                this.clientPolicyByEmailList = [] as any;
                for (let item of _data["clientPolicyByEmailList"])
                    this.clientPolicyByEmailList!.push(ClientPolicyByEmailModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPoliciesByEmail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPoliciesByEmail>(data, _mappings, ClientPoliciesByEmail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.clientPolicyByEmailList)) {
            data["clientPolicyByEmailList"] = [];
            for (let item of this.clientPolicyByEmailList)
                data["clientPolicyByEmailList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPoliciesByEmail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    clientPolicyByEmailList?: ClientPolicyByEmailModel[] | undefined;
}

export class PolicyPayments implements IPolicyPayments {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    policyPaymentList?: PolicyPaymentModel[] | undefined;

    constructor(data?: IPolicyPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["policyPaymentList"])) {
                this.policyPaymentList = [] as any;
                for (let item of _data["policyPaymentList"])
                    this.policyPaymentList!.push(PolicyPaymentModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyPayments | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyPayments>(data, _mappings, PolicyPayments);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.policyPaymentList)) {
            data["policyPaymentList"] = [];
            for (let item of this.policyPaymentList)
                data["policyPaymentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolicyPayments {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    policyPaymentList?: PolicyPaymentModel[] | undefined;
}

export class PolicyPaymentModel implements IPolicyPaymentModel {
    policyNumber?: string | undefined;
    polCode?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    dob?: string | undefined;
    agentName?: string | undefined;
    agentCode?: string | undefined;
    policyPrefix?: string | undefined;
    productDescription?: string | undefined;
    effectiveDate?: string | undefined;
    paidTodate?: string | undefined;
    maturityDate?: string | undefined;
    endorsementTerm?: string | undefined;
    installmentPremuim?: string | undefined;
    totalSavings?: string | undefined;
    paymentFrequency?: string | undefined;
    premiumReceipt?: string | undefined;
    debitOrCredit?: string | undefined;
    totalPremuim?: string | undefined;
    receiptDate?: string | undefined;
    chequeNumber?: string | undefined;
    receiptNumber?: string | undefined;

    constructor(data?: IPolicyPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.polCode = _data["polCode"];
            this.clientName = _data["clientName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dob = _data["dob"];
            this.agentName = _data["agentName"];
            this.agentCode = _data["agentCode"];
            this.policyPrefix = _data["policyPrefix"];
            this.productDescription = _data["productDescription"];
            this.effectiveDate = _data["effectiveDate"];
            this.paidTodate = _data["paidTodate"];
            this.maturityDate = _data["maturityDate"];
            this.endorsementTerm = _data["endorsementTerm"];
            this.installmentPremuim = _data["installmentPremuim"];
            this.totalSavings = _data["totalSavings"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.premiumReceipt = _data["premiumReceipt"];
            this.debitOrCredit = _data["debitOrCredit"];
            this.totalPremuim = _data["totalPremuim"];
            this.receiptDate = _data["receiptDate"];
            this.chequeNumber = _data["chequeNumber"];
            this.receiptNumber = _data["receiptNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyPaymentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyPaymentModel>(data, _mappings, PolicyPaymentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["polCode"] = this.polCode;
        data["clientName"] = this.clientName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dob"] = this.dob;
        data["agentName"] = this.agentName;
        data["agentCode"] = this.agentCode;
        data["policyPrefix"] = this.policyPrefix;
        data["productDescription"] = this.productDescription;
        data["effectiveDate"] = this.effectiveDate;
        data["paidTodate"] = this.paidTodate;
        data["maturityDate"] = this.maturityDate;
        data["endorsementTerm"] = this.endorsementTerm;
        data["installmentPremuim"] = this.installmentPremuim;
        data["totalSavings"] = this.totalSavings;
        data["paymentFrequency"] = this.paymentFrequency;
        data["premiumReceipt"] = this.premiumReceipt;
        data["debitOrCredit"] = this.debitOrCredit;
        data["totalPremuim"] = this.totalPremuim;
        data["receiptDate"] = this.receiptDate;
        data["chequeNumber"] = this.chequeNumber;
        data["receiptNumber"] = this.receiptNumber;
        return data;
    }
}

export interface IPolicyPaymentModel {
    policyNumber?: string | undefined;
    polCode?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    dob?: string | undefined;
    agentName?: string | undefined;
    agentCode?: string | undefined;
    policyPrefix?: string | undefined;
    productDescription?: string | undefined;
    effectiveDate?: string | undefined;
    paidTodate?: string | undefined;
    maturityDate?: string | undefined;
    endorsementTerm?: string | undefined;
    installmentPremuim?: string | undefined;
    totalSavings?: string | undefined;
    paymentFrequency?: string | undefined;
    premiumReceipt?: string | undefined;
    debitOrCredit?: string | undefined;
    totalPremuim?: string | undefined;
    receiptDate?: string | undefined;
    chequeNumber?: string | undefined;
    receiptNumber?: string | undefined;
}

export class VehicleCancellationRequest implements IVehicleCancellationRequest {
    username?: string | undefined;
    password?: string | undefined;
    policyNo?: string | undefined;
    chasisNo?: string | undefined;
    regNo?: string | undefined;

    constructor(data?: IVehicleCancellationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.policyNo = _data["policyNo"];
            this.chasisNo = _data["chasisNo"];
            this.regNo = _data["regNo"];
        }
    }

    static fromJS(data: any, _mappings?: any): VehicleCancellationRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<VehicleCancellationRequest>(data, _mappings, VehicleCancellationRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["policyNo"] = this.policyNo;
        data["chasisNo"] = this.chasisNo;
        data["regNo"] = this.regNo;
        return data;
    }
}

export interface IVehicleCancellationRequest {
    username?: string | undefined;
    password?: string | undefined;
    policyNo?: string | undefined;
    chasisNo?: string | undefined;
    regNo?: string | undefined;
}

export class VehicleEndorsementRequest implements IVehicleEndorsementRequest {
    username?: string | undefined;
    password?: string | undefined;
    chasisNo?: string | undefined;
    niaNaicomID?: string | undefined;
    policyNo?: string | undefined;
    currentRegNo?: string | undefined;
    preferredInsuredName?: string | undefined;
    preferredInsuredAddress?: string | undefined;
    preferredInsuredTelephone?: string | undefined;
    preferredInsuredEmail?: string | undefined;
    preferredNewRegNo?: string | undefined;
    preferredOldRegNo?: string | undefined;
    preferredChassisNo?: string | undefined;
    preferredEngineNo?: string | undefined;
    preferredEngineCapacity?: string | undefined;
    preferredVehicleColor?: string | undefined;
    preferredVehicleMake?: string | undefined;
    preferredVehicleModel?: string | undefined;
    preferredVehicleType?: string | undefined;
    preferredCertificateNo?: string | undefined;
    preferredSumInsured?: number | undefined;
    preferredPremium?: number | undefined;

    constructor(data?: IVehicleEndorsementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.chasisNo = _data["chasisNo"];
            this.niaNaicomID = _data["niaNaicomID"];
            this.policyNo = _data["policyNo"];
            this.currentRegNo = _data["currentRegNo"];
            this.preferredInsuredName = _data["preferredInsuredName"];
            this.preferredInsuredAddress = _data["preferredInsuredAddress"];
            this.preferredInsuredTelephone = _data["preferredInsuredTelephone"];
            this.preferredInsuredEmail = _data["preferredInsuredEmail"];
            this.preferredNewRegNo = _data["preferredNewRegNo"];
            this.preferredOldRegNo = _data["preferredOldRegNo"];
            this.preferredChassisNo = _data["preferredChassisNo"];
            this.preferredEngineNo = _data["preferredEngineNo"];
            this.preferredEngineCapacity = _data["preferredEngineCapacity"];
            this.preferredVehicleColor = _data["preferredVehicleColor"];
            this.preferredVehicleMake = _data["preferredVehicleMake"];
            this.preferredVehicleModel = _data["preferredVehicleModel"];
            this.preferredVehicleType = _data["preferredVehicleType"];
            this.preferredCertificateNo = _data["preferredCertificateNo"];
            this.preferredSumInsured = _data["preferredSumInsured"];
            this.preferredPremium = _data["preferredPremium"];
        }
    }

    static fromJS(data: any, _mappings?: any): VehicleEndorsementRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<VehicleEndorsementRequest>(data, _mappings, VehicleEndorsementRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["chasisNo"] = this.chasisNo;
        data["niaNaicomID"] = this.niaNaicomID;
        data["policyNo"] = this.policyNo;
        data["currentRegNo"] = this.currentRegNo;
        data["preferredInsuredName"] = this.preferredInsuredName;
        data["preferredInsuredAddress"] = this.preferredInsuredAddress;
        data["preferredInsuredTelephone"] = this.preferredInsuredTelephone;
        data["preferredInsuredEmail"] = this.preferredInsuredEmail;
        data["preferredNewRegNo"] = this.preferredNewRegNo;
        data["preferredOldRegNo"] = this.preferredOldRegNo;
        data["preferredChassisNo"] = this.preferredChassisNo;
        data["preferredEngineNo"] = this.preferredEngineNo;
        data["preferredEngineCapacity"] = this.preferredEngineCapacity;
        data["preferredVehicleColor"] = this.preferredVehicleColor;
        data["preferredVehicleMake"] = this.preferredVehicleMake;
        data["preferredVehicleModel"] = this.preferredVehicleModel;
        data["preferredVehicleType"] = this.preferredVehicleType;
        data["preferredCertificateNo"] = this.preferredCertificateNo;
        data["preferredSumInsured"] = this.preferredSumInsured;
        data["preferredPremium"] = this.preferredPremium;
        return data;
    }
}

export interface IVehicleEndorsementRequest {
    username?: string | undefined;
    password?: string | undefined;
    chasisNo?: string | undefined;
    niaNaicomID?: string | undefined;
    policyNo?: string | undefined;
    currentRegNo?: string | undefined;
    preferredInsuredName?: string | undefined;
    preferredInsuredAddress?: string | undefined;
    preferredInsuredTelephone?: string | undefined;
    preferredInsuredEmail?: string | undefined;
    preferredNewRegNo?: string | undefined;
    preferredOldRegNo?: string | undefined;
    preferredChassisNo?: string | undefined;
    preferredEngineNo?: string | undefined;
    preferredEngineCapacity?: string | undefined;
    preferredVehicleColor?: string | undefined;
    preferredVehicleMake?: string | undefined;
    preferredVehicleModel?: string | undefined;
    preferredVehicleType?: string | undefined;
    preferredCertificateNo?: string | undefined;
    preferredSumInsured?: number | undefined;
    preferredPremium?: number | undefined;
}

export class PolicySearchModel implements IPolicySearchModel {
    searchBy?: PolicySearchModelSearchBy | undefined;
    param?: string | undefined;

    constructor(data?: IPolicySearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.searchBy = _data["searchBy"];
            this.param = _data["param"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicySearchModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicySearchModel>(data, _mappings, PolicySearchModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchBy"] = this.searchBy;
        data["param"] = this.param;
        return data;
    }
}

export interface IPolicySearchModel {
    searchBy?: PolicySearchModelSearchBy | undefined;
    param?: string | undefined;
}

export class TravelPolicyDetails_TravelPolicyDetailsModel implements ITravelPolicyDetails_TravelPolicyDetailsModel {

    constructor(data?: ITravelPolicyDetails_TravelPolicyDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TravelPolicyDetails_TravelPolicyDetailsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelPolicyDetails_TravelPolicyDetailsModel>(data, _mappings, TravelPolicyDetails_TravelPolicyDetailsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITravelPolicyDetails_TravelPolicyDetailsModel {
}

export class TravelPolicyDetails implements ITravelPolicyDetails {
    policyNo?: string | undefined;
    netPremium?: string | undefined;
    clientName?: string | undefined;
    postalAddress?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    smsTelephone?: string | undefined;
    dateIssued?: string | undefined;
    benefit?: string | undefined;
    agent?: string | undefined;
    policyDuration?: string | undefined;
    effectiveDate?: string | undefined;
    maturityDate?: string | undefined;
    clientDateOfBirth?: string | undefined;
    passportNo?: string | undefined;
    geographicalLimit?: string | undefined;
    embassyCode?: string | undefined;
    certificateNo?: string | undefined;
    destination?: string | undefined;

    constructor(data?: ITravelPolicyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.netPremium = _data["netPremium"];
            this.clientName = _data["clientName"];
            this.postalAddress = _data["postalAddress"];
            this.emailAddress = _data["emailAddress"];
            this.telephone = _data["telephone"];
            this.smsTelephone = _data["smsTelephone"];
            this.dateIssued = _data["dateIssued"];
            this.benefit = _data["benefit"];
            this.agent = _data["agent"];
            this.policyDuration = _data["policyDuration"];
            this.effectiveDate = _data["effectiveDate"];
            this.maturityDate = _data["maturityDate"];
            this.clientDateOfBirth = _data["clientDateOfBirth"];
            this.passportNo = _data["passportNo"];
            this.geographicalLimit = _data["geographicalLimit"];
            this.embassyCode = _data["embassyCode"];
            this.certificateNo = _data["certificateNo"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelPolicyDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelPolicyDetails>(data, _mappings, TravelPolicyDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["netPremium"] = this.netPremium;
        data["clientName"] = this.clientName;
        data["postalAddress"] = this.postalAddress;
        data["emailAddress"] = this.emailAddress;
        data["telephone"] = this.telephone;
        data["smsTelephone"] = this.smsTelephone;
        data["dateIssued"] = this.dateIssued;
        data["benefit"] = this.benefit;
        data["agent"] = this.agent;
        data["policyDuration"] = this.policyDuration;
        data["effectiveDate"] = this.effectiveDate;
        data["maturityDate"] = this.maturityDate;
        data["clientDateOfBirth"] = this.clientDateOfBirth;
        data["passportNo"] = this.passportNo;
        data["geographicalLimit"] = this.geographicalLimit;
        data["embassyCode"] = this.embassyCode;
        data["certificateNo"] = this.certificateNo;
        data["destination"] = this.destination;
        return data;
    }
}

export interface ITravelPolicyDetails {
    policyNo?: string | undefined;
    netPremium?: string | undefined;
    clientName?: string | undefined;
    postalAddress?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    smsTelephone?: string | undefined;
    dateIssued?: string | undefined;
    benefit?: string | undefined;
    agent?: string | undefined;
    policyDuration?: string | undefined;
    effectiveDate?: string | undefined;
    maturityDate?: string | undefined;
    clientDateOfBirth?: string | undefined;
    passportNo?: string | undefined;
    geographicalLimit?: string | undefined;
    embassyCode?: string | undefined;
    certificateNo?: string | undefined;
    destination?: string | undefined;
}

export class ProductSubClassCoverTypesModelFinal implements IProductSubClassCoverTypesModelFinal {
    subClassCoverTypes?: ProductSubClassCoverTypesModel | undefined;
    benefits?: NameDescriptionPair[] | undefined;

    constructor(data?: IProductSubClassCoverTypesModelFinal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subClassCoverTypes = _data["subClassCoverTypes"] ? ProductSubClassCoverTypesModel.fromJS(_data["subClassCoverTypes"], _mappings) : <any>undefined;
            if (Array.isArray(_data["benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["benefits"])
                    this.benefits!.push(NameDescriptionPair.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductSubClassCoverTypesModelFinal | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductSubClassCoverTypesModelFinal>(data, _mappings, ProductSubClassCoverTypesModelFinal);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subClassCoverTypes"] = this.subClassCoverTypes ? this.subClassCoverTypes.toJSON() : <any>undefined;
        if (Array.isArray(this.benefits)) {
            data["benefits"] = [];
            for (let item of this.benefits)
                data["benefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductSubClassCoverTypesModelFinal {
    subClassCoverTypes?: ProductSubClassCoverTypesModel | undefined;
    benefits?: NameDescriptionPair[] | undefined;
}

export class ProductSubClassCoverTypesModel implements IProductSubClassCoverTypesModel {
    productId?: string | undefined;
    id?: string | undefined;
    productName?: string | undefined;
    subClassName?: string | undefined;
    coverTypeName?: string | undefined;
    description?: string | undefined;
    benefit?: NameDescriptionPair | undefined;
    rate?: number | undefined;
    fixed?: boolean | undefined;
    sectionType?: string | undefined;

    constructor(data?: IProductSubClassCoverTypesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.subClassName = _data["subClassName"];
            this.coverTypeName = _data["coverTypeName"];
            this.description = _data["description"];
            this.benefit = _data["benefit"] ? NameDescriptionPair.fromJS(_data["benefit"], _mappings) : <any>undefined;
            this.rate = _data["rate"];
            this.fixed = _data["fixed"];
            this.sectionType = _data["sectionType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductSubClassCoverTypesModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductSubClassCoverTypesModel>(data, _mappings, ProductSubClassCoverTypesModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["subClassName"] = this.subClassName;
        data["coverTypeName"] = this.coverTypeName;
        data["description"] = this.description;
        data["benefit"] = this.benefit ? this.benefit.toJSON() : <any>undefined;
        data["rate"] = this.rate;
        data["fixed"] = this.fixed;
        data["sectionType"] = this.sectionType;
        return data;
    }
}

export interface IProductSubClassCoverTypesModel {
    productId?: string | undefined;
    id?: string | undefined;
    productName?: string | undefined;
    subClassName?: string | undefined;
    coverTypeName?: string | undefined;
    description?: string | undefined;
    benefit?: NameDescriptionPair | undefined;
    rate?: number | undefined;
    fixed?: boolean | undefined;
    sectionType?: string | undefined;
}

export class NameDescriptionPair implements INameDescriptionPair {
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: INameDescriptionPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameDescriptionPair | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameDescriptionPair>(data, _mappings, NameDescriptionPair);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface INameDescriptionPair {
    name?: string | undefined;
    description?: string | undefined;
}

export class PremiumRateResult implements IPremiumRateResult {
    rate?: number | undefined;
    fixed?: boolean | undefined;
    sectionType?: string | undefined;

    constructor(data?: IPremiumRateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.fixed = _data["fixed"];
            this.sectionType = _data["sectionType"];
        }
    }

    static fromJS(data: any, _mappings?: any): PremiumRateResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PremiumRateResult>(data, _mappings, PremiumRateResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["fixed"] = this.fixed;
        data["sectionType"] = this.sectionType;
        return data;
    }
}

export interface IPremiumRateResult {
    rate?: number | undefined;
    fixed?: boolean | undefined;
    sectionType?: string | undefined;
}

export class PremiumModel implements IPremiumModel {
    id?: string | undefined;
    sumInsured?: number | undefined;

    constructor(data?: IPremiumModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sumInsured = _data["sumInsured"];
        }
    }

    static fromJS(data: any, _mappings?: any): PremiumModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PremiumModel>(data, _mappings, PremiumModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sumInsured"] = this.sumInsured;
        return data;
    }
}

export interface IPremiumModel {
    id?: string | undefined;
    sumInsured?: number | undefined;
}

export class TravelPremiumModel implements ITravelPremiumModel {
    dateOfBirth?: Date | undefined;
    destinationCountryId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ITravelPremiumModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.destinationCountryId = _data["destinationCountryId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): TravelPremiumModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelPremiumModel>(data, _mappings, TravelPremiumModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["destinationCountryId"] = this.destinationCountryId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITravelPremiumModel {
    dateOfBirth?: Date | undefined;
    destinationCountryId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class TravelRateResult implements ITravelRateResult {
    premium?: number | undefined;
    currency?: string | undefined;
    currencySymbol?: string | undefined;
    sumAssured?: number | undefined;
    excess?: number | undefined;
    countryCategory?: string | undefined;

    constructor(data?: ITravelRateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.premium = _data["premium"];
            this.currency = _data["currency"];
            this.currencySymbol = _data["currencySymbol"];
            this.sumAssured = _data["sumAssured"];
            this.excess = _data["excess"];
            this.countryCategory = _data["countryCategory"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelRateResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelRateResult>(data, _mappings, TravelRateResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["premium"] = this.premium;
        data["currency"] = this.currency;
        data["currencySymbol"] = this.currencySymbol;
        data["sumAssured"] = this.sumAssured;
        data["excess"] = this.excess;
        data["countryCategory"] = this.countryCategory;
        return data;
    }
}

export interface ITravelRateResult {
    premium?: number | undefined;
    currency?: string | undefined;
    currencySymbol?: string | undefined;
    sumAssured?: number | undefined;
    excess?: number | undefined;
    countryCategory?: string | undefined;
}

export class LifeRenewalDetails implements ILifeRenewalDetails {
    isSuccessful?: boolean | undefined;
    productName?: string | undefined;
    policyStatus?: string | undefined;
    policyNumber?: string | undefined;
    policyCode?: string | undefined;
    dateOfBirth?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    clientName?: string | undefined;
    clientShortDescription?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    effectiveDate?: string | undefined;
    paidToDate?: string | undefined;
    maturityDate?: string | undefined;
    totalPremium?: string | undefined;
    totalSavings?: string | undefined;
    paidPremium?: string | undefined;
    paymentFrequency?: string | undefined;
    nextInstallmentPremium?: string | undefined;
    hash?: string | undefined;
    loanId?: string | undefined;
    outStandingPremiumBalance?: string | undefined;
    amountToPay?: string | undefined;

    constructor(data?: ILifeRenewalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.productName = _data["productName"];
            this.policyStatus = _data["policyStatus"];
            this.policyNumber = _data["policyNumber"];
            this.policyCode = _data["policyCode"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.agentName = _data["agentName"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.clientName = _data["clientName"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.effectiveDate = _data["effectiveDate"];
            this.paidToDate = _data["paidToDate"];
            this.maturityDate = _data["maturityDate"];
            this.totalPremium = _data["totalPremium"];
            this.totalSavings = _data["totalSavings"];
            this.paidPremium = _data["paidPremium"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.nextInstallmentPremium = _data["nextInstallmentPremium"];
            this.hash = _data["hash"];
            this.loanId = _data["loanId"];
            this.outStandingPremiumBalance = _data["outStandingPremiumBalance"];
            this.amountToPay = _data["amountToPay"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalDetails>(data, _mappings, LifeRenewalDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["productName"] = this.productName;
        data["policyStatus"] = this.policyStatus;
        data["policyNumber"] = this.policyNumber;
        data["policyCode"] = this.policyCode;
        data["dateOfBirth"] = this.dateOfBirth;
        data["agentName"] = this.agentName;
        data["agentShortDescription"] = this.agentShortDescription;
        data["clientName"] = this.clientName;
        data["clientShortDescription"] = this.clientShortDescription;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["effectiveDate"] = this.effectiveDate;
        data["paidToDate"] = this.paidToDate;
        data["maturityDate"] = this.maturityDate;
        data["totalPremium"] = this.totalPremium;
        data["totalSavings"] = this.totalSavings;
        data["paidPremium"] = this.paidPremium;
        data["paymentFrequency"] = this.paymentFrequency;
        data["nextInstallmentPremium"] = this.nextInstallmentPremium;
        data["hash"] = this.hash;
        data["loanId"] = this.loanId;
        data["outStandingPremiumBalance"] = this.outStandingPremiumBalance;
        data["amountToPay"] = this.amountToPay;
        return data;
    }
}

export interface ILifeRenewalDetails {
    isSuccessful?: boolean | undefined;
    productName?: string | undefined;
    policyStatus?: string | undefined;
    policyNumber?: string | undefined;
    policyCode?: string | undefined;
    dateOfBirth?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    clientName?: string | undefined;
    clientShortDescription?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    effectiveDate?: string | undefined;
    paidToDate?: string | undefined;
    maturityDate?: string | undefined;
    totalPremium?: string | undefined;
    totalSavings?: string | undefined;
    paidPremium?: string | undefined;
    paymentFrequency?: string | undefined;
    nextInstallmentPremium?: string | undefined;
    hash?: string | undefined;
    loanId?: string | undefined;
    outStandingPremiumBalance?: string | undefined;
    amountToPay?: string | undefined;
}

export class AnnuityResponseModel implements IAnnuityResponseModel {
    age?: number | undefined;
    annualPayment?: string | undefined;
    quarterlyPayment?: string | undefined;
    monthlyPayment?: string | undefined;
    dateOfExecution?: string | undefined;

    constructor(data?: IAnnuityResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.age = _data["age"];
            this.annualPayment = _data["annualPayment"];
            this.quarterlyPayment = _data["quarterlyPayment"];
            this.monthlyPayment = _data["monthlyPayment"];
            this.dateOfExecution = _data["dateOfExecution"];
        }
    }

    static fromJS(data: any, _mappings?: any): AnnuityResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AnnuityResponseModel>(data, _mappings, AnnuityResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["annualPayment"] = this.annualPayment;
        data["quarterlyPayment"] = this.quarterlyPayment;
        data["monthlyPayment"] = this.monthlyPayment;
        data["dateOfExecution"] = this.dateOfExecution;
        return data;
    }
}

export interface IAnnuityResponseModel {
    age?: number | undefined;
    annualPayment?: string | undefined;
    quarterlyPayment?: string | undefined;
    monthlyPayment?: string | undefined;
    dateOfExecution?: string | undefined;
}

export class LifePolicyRenewalRequest implements ILifePolicyRenewalRequest {
    policyNo?: string | undefined;
    hash?: string | undefined;

    constructor(data?: ILifePolicyRenewalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifePolicyRenewalRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifePolicyRenewalRequest>(data, _mappings, LifePolicyRenewalRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["hash"] = this.hash;
        return data;
    }
}

export interface ILifePolicyRenewalRequest {
    policyNo?: string | undefined;
    hash?: string | undefined;
}

export class LifeRenewalTran implements ILifeRenewalTran {
    policyNo?: string | undefined;
    transactionDate?: Date | undefined;
    customerName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionType?: string | undefined;
    flutterwavePayment?: FlutterwavePayment | undefined;
    flutterwavePaymentId?: string | undefined;
    gtbPayment?: GtbPayment | undefined;
    gtbPaymentId?: string | undefined;
    interswitchPayment?: InterswitchPayment | undefined;
    interswitchPaymentId?: string | undefined;
    wemaBankPayment?: WemaBankPayment | undefined;
    wemaBankPaymentId?: string | undefined;
    alatPayment?: AlatPayment | undefined;
    alatPaymentId?: string | undefined;
    ubnPayment?: UbnPayment | undefined;
    ubnPaymentId?: string | undefined;
    posPayment?: PosPayment | undefined;
    posPaymentId?: string | undefined;
    boffPayment?: BoffPayment | undefined;
    boffPaymentId?: string | undefined;
    autogeniusPayment?: AutogeniusPayment | undefined;
    autogeniusPaymentId?: string | undefined;
    paddycoverPayment?: PaddycoverPayment | undefined;
    paddycoverPaymentId?: string | undefined;
    transboxxPayment?: TransboxxPayment | undefined;
    transboxxPaymentId?: string | undefined;
    payArenaPayment?: PayArenaPayment | undefined;
    payArenaPaymentId?: string | undefined;
    remittaDirectDebitPayment?: RemittaDirectDebitNotification | undefined;
    remittaDirectDebitPaymentId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    intermediaryPayment?: IntermediaryLedger | undefined;
    intermediaryPaymentId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    amount?: number | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;
    loanId?: string | undefined;
    failureOrSuccessReason?: string | undefined;
    transactionRef?: string | undefined;
    ravePublicKey?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    policyStatus?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ILifeRenewalTran) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.transactionType = _data["transactionType"];
            this.flutterwavePayment = _data["flutterwavePayment"] ? FlutterwavePayment.fromJS(_data["flutterwavePayment"], _mappings) : <any>undefined;
            this.flutterwavePaymentId = _data["flutterwavePaymentId"];
            this.gtbPayment = _data["gtbPayment"] ? GtbPayment.fromJS(_data["gtbPayment"], _mappings) : <any>undefined;
            this.gtbPaymentId = _data["gtbPaymentId"];
            this.interswitchPayment = _data["interswitchPayment"] ? InterswitchPayment.fromJS(_data["interswitchPayment"], _mappings) : <any>undefined;
            this.interswitchPaymentId = _data["interswitchPaymentId"];
            this.wemaBankPayment = _data["wemaBankPayment"] ? WemaBankPayment.fromJS(_data["wemaBankPayment"], _mappings) : <any>undefined;
            this.wemaBankPaymentId = _data["wemaBankPaymentId"];
            this.alatPayment = _data["alatPayment"] ? AlatPayment.fromJS(_data["alatPayment"], _mappings) : <any>undefined;
            this.alatPaymentId = _data["alatPaymentId"];
            this.ubnPayment = _data["ubnPayment"] ? UbnPayment.fromJS(_data["ubnPayment"], _mappings) : <any>undefined;
            this.ubnPaymentId = _data["ubnPaymentId"];
            this.posPayment = _data["posPayment"] ? PosPayment.fromJS(_data["posPayment"], _mappings) : <any>undefined;
            this.posPaymentId = _data["posPaymentId"];
            this.boffPayment = _data["boffPayment"] ? BoffPayment.fromJS(_data["boffPayment"], _mappings) : <any>undefined;
            this.boffPaymentId = _data["boffPaymentId"];
            this.autogeniusPayment = _data["autogeniusPayment"] ? AutogeniusPayment.fromJS(_data["autogeniusPayment"], _mappings) : <any>undefined;
            this.autogeniusPaymentId = _data["autogeniusPaymentId"];
            this.paddycoverPayment = _data["paddycoverPayment"] ? PaddycoverPayment.fromJS(_data["paddycoverPayment"], _mappings) : <any>undefined;
            this.paddycoverPaymentId = _data["paddycoverPaymentId"];
            this.transboxxPayment = _data["transboxxPayment"] ? TransboxxPayment.fromJS(_data["transboxxPayment"], _mappings) : <any>undefined;
            this.transboxxPaymentId = _data["transboxxPaymentId"];
            this.payArenaPayment = _data["payArenaPayment"] ? PayArenaPayment.fromJS(_data["payArenaPayment"], _mappings) : <any>undefined;
            this.payArenaPaymentId = _data["payArenaPaymentId"];
            this.remittaDirectDebitPayment = _data["remittaDirectDebitPayment"] ? RemittaDirectDebitNotification.fromJS(_data["remittaDirectDebitPayment"], _mappings) : <any>undefined;
            this.remittaDirectDebitPaymentId = _data["remittaDirectDebitPaymentId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.intermediaryPayment = _data["intermediaryPayment"] ? IntermediaryLedger.fromJS(_data["intermediaryPayment"], _mappings) : <any>undefined;
            this.intermediaryPaymentId = _data["intermediaryPaymentId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.amount = _data["amount"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.polledToTQ = _data["polledToTQ"];
            this.isLoan = _data["isLoan"];
            this.loanId = _data["loanId"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.transactionRef = _data["transactionRef"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.policyStatus = _data["policyStatus"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalTran | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalTran>(data, _mappings, LifeRenewalTran);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["transactionType"] = this.transactionType;
        data["flutterwavePayment"] = this.flutterwavePayment ? this.flutterwavePayment.toJSON() : <any>undefined;
        data["flutterwavePaymentId"] = this.flutterwavePaymentId;
        data["gtbPayment"] = this.gtbPayment ? this.gtbPayment.toJSON() : <any>undefined;
        data["gtbPaymentId"] = this.gtbPaymentId;
        data["interswitchPayment"] = this.interswitchPayment ? this.interswitchPayment.toJSON() : <any>undefined;
        data["interswitchPaymentId"] = this.interswitchPaymentId;
        data["wemaBankPayment"] = this.wemaBankPayment ? this.wemaBankPayment.toJSON() : <any>undefined;
        data["wemaBankPaymentId"] = this.wemaBankPaymentId;
        data["alatPayment"] = this.alatPayment ? this.alatPayment.toJSON() : <any>undefined;
        data["alatPaymentId"] = this.alatPaymentId;
        data["ubnPayment"] = this.ubnPayment ? this.ubnPayment.toJSON() : <any>undefined;
        data["ubnPaymentId"] = this.ubnPaymentId;
        data["posPayment"] = this.posPayment ? this.posPayment.toJSON() : <any>undefined;
        data["posPaymentId"] = this.posPaymentId;
        data["boffPayment"] = this.boffPayment ? this.boffPayment.toJSON() : <any>undefined;
        data["boffPaymentId"] = this.boffPaymentId;
        data["autogeniusPayment"] = this.autogeniusPayment ? this.autogeniusPayment.toJSON() : <any>undefined;
        data["autogeniusPaymentId"] = this.autogeniusPaymentId;
        data["paddycoverPayment"] = this.paddycoverPayment ? this.paddycoverPayment.toJSON() : <any>undefined;
        data["paddycoverPaymentId"] = this.paddycoverPaymentId;
        data["transboxxPayment"] = this.transboxxPayment ? this.transboxxPayment.toJSON() : <any>undefined;
        data["transboxxPaymentId"] = this.transboxxPaymentId;
        data["payArenaPayment"] = this.payArenaPayment ? this.payArenaPayment.toJSON() : <any>undefined;
        data["payArenaPaymentId"] = this.payArenaPaymentId;
        data["remittaDirectDebitPayment"] = this.remittaDirectDebitPayment ? this.remittaDirectDebitPayment.toJSON() : <any>undefined;
        data["remittaDirectDebitPaymentId"] = this.remittaDirectDebitPaymentId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["intermediaryPayment"] = this.intermediaryPayment ? this.intermediaryPayment.toJSON() : <any>undefined;
        data["intermediaryPaymentId"] = this.intermediaryPaymentId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["amount"] = this.amount;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["polledToTQ"] = this.polledToTQ;
        data["isLoan"] = this.isLoan;
        data["loanId"] = this.loanId;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["transactionRef"] = this.transactionRef;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["policyStatus"] = this.policyStatus;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ILifeRenewalTran {
    policyNo?: string | undefined;
    transactionDate?: Date | undefined;
    customerName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionType?: string | undefined;
    flutterwavePayment?: FlutterwavePayment | undefined;
    flutterwavePaymentId?: string | undefined;
    gtbPayment?: GtbPayment | undefined;
    gtbPaymentId?: string | undefined;
    interswitchPayment?: InterswitchPayment | undefined;
    interswitchPaymentId?: string | undefined;
    wemaBankPayment?: WemaBankPayment | undefined;
    wemaBankPaymentId?: string | undefined;
    alatPayment?: AlatPayment | undefined;
    alatPaymentId?: string | undefined;
    ubnPayment?: UbnPayment | undefined;
    ubnPaymentId?: string | undefined;
    posPayment?: PosPayment | undefined;
    posPaymentId?: string | undefined;
    boffPayment?: BoffPayment | undefined;
    boffPaymentId?: string | undefined;
    autogeniusPayment?: AutogeniusPayment | undefined;
    autogeniusPaymentId?: string | undefined;
    paddycoverPayment?: PaddycoverPayment | undefined;
    paddycoverPaymentId?: string | undefined;
    transboxxPayment?: TransboxxPayment | undefined;
    transboxxPaymentId?: string | undefined;
    payArenaPayment?: PayArenaPayment | undefined;
    payArenaPaymentId?: string | undefined;
    remittaDirectDebitPayment?: RemittaDirectDebitNotification | undefined;
    remittaDirectDebitPaymentId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    intermediaryPayment?: IntermediaryLedger | undefined;
    intermediaryPaymentId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    amount?: number | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;
    loanId?: string | undefined;
    failureOrSuccessReason?: string | undefined;
    transactionRef?: string | undefined;
    ravePublicKey?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    policyStatus?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class UbnPayment implements IUbnPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    accountNumber?: string | undefined;
    paymentRef?: string | undefined;
    id?: string | undefined;

    constructor(data?: IUbnPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseDesc = _data["responseDesc"];
            this.transDate = _data["transDate"];
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.accountNumber = _data["accountNumber"];
            this.paymentRef = _data["paymentRef"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UbnPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UbnPayment>(data, _mappings, UbnPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseDesc"] = this.responseDesc;
        data["transDate"] = this.transDate;
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["accountNumber"] = this.accountNumber;
        data["paymentRef"] = this.paymentRef;
        data["id"] = this.id;
        return data;
    }
}

export interface IUbnPayment {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transDate?: string | undefined;
    transactionRef?: string | undefined;
    amount?: string | undefined;
    accountNumber?: string | undefined;
    paymentRef?: string | undefined;
    id?: string | undefined;
}

export class RemittaDirectDebitNotification implements IRemittaDirectDebitNotification {
    notificationType?: string | undefined;
    mandateId?: string | undefined;
    debitDate?: string | undefined;
    requestId?: string | undefined;
    setupRequestId?: string | undefined;
    amount?: number | undefined;
    createdOn?: Date | undefined;
    id?: string | undefined;

    constructor(data?: IRemittaDirectDebitNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.mandateId = _data["mandateId"];
            this.debitDate = _data["debitDate"];
            this.requestId = _data["requestId"];
            this.setupRequestId = _data["setupRequestId"];
            this.amount = _data["amount"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): RemittaDirectDebitNotification | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemittaDirectDebitNotification>(data, _mappings, RemittaDirectDebitNotification);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["mandateId"] = this.mandateId;
        data["debitDate"] = this.debitDate;
        data["requestId"] = this.requestId;
        data["setupRequestId"] = this.setupRequestId;
        data["amount"] = this.amount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRemittaDirectDebitNotification {
    notificationType?: string | undefined;
    mandateId?: string | undefined;
    debitDate?: string | undefined;
    requestId?: string | undefined;
    setupRequestId?: string | undefined;
    amount?: number | undefined;
    createdOn?: Date | undefined;
    id?: string | undefined;
}

export class WhistleBlowerModel implements IWhistleBlowerModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    modeOfReach?: string | undefined;
    description?: string | undefined;

    constructor(data?: IWhistleBlowerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactAddress = _data["contactAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.modeOfReach = _data["modeOfReach"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): WhistleBlowerModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WhistleBlowerModel>(data, _mappings, WhistleBlowerModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactAddress"] = this.contactAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["modeOfReach"] = this.modeOfReach;
        data["description"] = this.description;
        return data;
    }
}

export interface IWhistleBlowerModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    modeOfReach?: string | undefined;
    description?: string | undefined;
}

export class LeadRequestModel implements ILeadRequestModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    transactionDate?: Date | undefined;

    constructor(data?: ILeadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): LeadRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadRequestModel>(data, _mappings, LeadRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILeadRequestModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    transactionDate?: Date | undefined;
}

export class IncidentModel implements IIncidentModel {
    customerNumber?: string | undefined;
    caseType?: number | undefined;
    subject?: number | undefined;
    caseDescription?: string | undefined;
    product?: number | undefined;
    caseOrigin?: number | undefined;
    aiicoBranch?: number | undefined;
    agentName?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    others?: string | undefined;
    segment?: number | undefined;
    phoneNumber?: string | undefined;
    policy?: string | undefined;

    constructor(data?: IIncidentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.caseType = _data["caseType"];
            this.subject = _data["subject"];
            this.caseDescription = _data["caseDescription"];
            this.product = _data["product"];
            this.caseOrigin = _data["caseOrigin"];
            this.aiicoBranch = _data["aiicoBranch"];
            this.agentName = _data["agentName"];
            this.clientName = _data["clientName"];
            this.email = _data["email"];
            this.others = _data["others"];
            this.segment = _data["segment"];
            this.phoneNumber = _data["phoneNumber"];
            this.policy = _data["policy"];
        }
    }

    static fromJS(data: any, _mappings?: any): IncidentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IncidentModel>(data, _mappings, IncidentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["caseType"] = this.caseType;
        data["subject"] = this.subject;
        data["caseDescription"] = this.caseDescription;
        data["product"] = this.product;
        data["caseOrigin"] = this.caseOrigin;
        data["aiicoBranch"] = this.aiicoBranch;
        data["agentName"] = this.agentName;
        data["clientName"] = this.clientName;
        data["email"] = this.email;
        data["others"] = this.others;
        data["segment"] = this.segment;
        data["phoneNumber"] = this.phoneNumber;
        data["policy"] = this.policy;
        return data;
    }
}

export interface IIncidentModel {
    customerNumber?: string | undefined;
    caseType?: number | undefined;
    subject?: number | undefined;
    caseDescription?: string | undefined;
    product?: number | undefined;
    caseOrigin?: number | undefined;
    aiicoBranch?: number | undefined;
    agentName?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    others?: string | undefined;
    segment?: number | undefined;
    phoneNumber?: string | undefined;
    policy?: string | undefined;
}

export class QuoteModel implements IQuoteModel {
    customerName?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    products?: number | undefined;
    description?: string | undefined;

    constructor(data?: IQuoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.emailAddress = _data["emailAddress"];
            this.telephone = _data["telephone"];
            this.products = _data["products"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): QuoteModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<QuoteModel>(data, _mappings, QuoteModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["emailAddress"] = this.emailAddress;
        data["telephone"] = this.telephone;
        data["products"] = this.products;
        data["description"] = this.description;
        return data;
    }
}

export interface IQuoteModel {
    customerName?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    products?: number | undefined;
    description?: string | undefined;
}

export class ChangeRequestModel implements IChangeRequestModel {
    customerName?: string | undefined;
    policyNumber?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    postalAddress?: string | undefined;
    residentialAddress?: string | undefined;
    city?: string | undefined;
    state?: number | undefined;

    constructor(data?: IChangeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.policyNumber = _data["policyNumber"];
            this.emailAddress = _data["emailAddress"];
            this.telephone = _data["telephone"];
            this.postalAddress = _data["postalAddress"];
            this.residentialAddress = _data["residentialAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeRequestModel>(data, _mappings, ChangeRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["policyNumber"] = this.policyNumber;
        data["emailAddress"] = this.emailAddress;
        data["telephone"] = this.telephone;
        data["postalAddress"] = this.postalAddress;
        data["residentialAddress"] = this.residentialAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        return data;
    }
}

export interface IChangeRequestModel {
    customerName?: string | undefined;
    policyNumber?: string | undefined;
    emailAddress?: string | undefined;
    telephone?: string | undefined;
    postalAddress?: string | undefined;
    residentialAddress?: string | undefined;
    city?: string | undefined;
    state?: number | undefined;
}

export class ClientProfilingRequest implements IClientProfilingRequest {
    policy?: string | undefined;
    email?: string | undefined;

    constructor(data?: IClientProfilingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policy = _data["policy"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientProfilingRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientProfilingRequest>(data, _mappings, ClientProfilingRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy"] = this.policy;
        data["email"] = this.email;
        return data;
    }
}

export interface IClientProfilingRequest {
    policy?: string | undefined;
    email?: string | undefined;
}

export class AgentDetailByEmailModel implements IAgentDetailByEmailModel {
    tqsyscode?: string | undefined;
    accounttype?: string | undefined;
    agenttype?: string | undefined;
    agentcode?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    agN_NAME?: string | undefined;

    constructor(data?: IAgentDetailByEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tqsyscode = _data["tqsyscode"];
            this.accounttype = _data["accounttype"];
            this.agenttype = _data["agenttype"];
            this.agentcode = _data["agentcode"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
            this.agN_NAME = _data["agN_NAME"];
        }
    }

    static fromJS(data: any, _mappings?: any): AgentDetailByEmailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentDetailByEmailModel>(data, _mappings, AgentDetailByEmailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tqsyscode"] = this.tqsyscode;
        data["accounttype"] = this.accounttype;
        data["agenttype"] = this.agenttype;
        data["agentcode"] = this.agentcode;
        data["address"] = this.address;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        data["agN_NAME"] = this.agN_NAME;
        return data;
    }
}

export interface IAgentDetailByEmailModel {
    tqsyscode?: string | undefined;
    accounttype?: string | undefined;
    agenttype?: string | undefined;
    agentcode?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
    agN_NAME?: string | undefined;
}

export class ClientProfileByEmail implements IClientProfileByEmail {
    surname?: string | undefined;
    firstName?: string | undefined;
    otherNames?: string | undefined;
    title?: string | undefined;
    residentialAddress?: string | undefined;
    postalAddress?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    tinNumber?: string | undefined;
    country?: string | undefined;
    domiciledCountry?: string | undefined;
    residingCountry?: string | undefined;
    otherCountry?: string | undefined;
    state?: string | undefined;
    town?: string | undefined;
    accountNumber?: string | undefined;
    totalPremium?: number | undefined;
    policyNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    remark?: string | undefined;
    isSuccessful?: boolean | undefined;

    constructor(data?: IClientProfileByEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.surname = _data["surname"];
            this.firstName = _data["firstName"];
            this.otherNames = _data["otherNames"];
            this.title = _data["title"];
            this.residentialAddress = _data["residentialAddress"];
            this.postalAddress = _data["postalAddress"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.tinNumber = _data["tinNumber"];
            this.country = _data["country"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.residingCountry = _data["residingCountry"];
            this.otherCountry = _data["otherCountry"];
            this.state = _data["state"];
            this.town = _data["town"];
            this.accountNumber = _data["accountNumber"];
            this.totalPremium = _data["totalPremium"];
            this.policyNumber = _data["policyNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.remark = _data["remark"];
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientProfileByEmail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientProfileByEmail>(data, _mappings, ClientProfileByEmail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surname"] = this.surname;
        data["firstName"] = this.firstName;
        data["otherNames"] = this.otherNames;
        data["title"] = this.title;
        data["residentialAddress"] = this.residentialAddress;
        data["postalAddress"] = this.postalAddress;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["tinNumber"] = this.tinNumber;
        data["country"] = this.country;
        data["domiciledCountry"] = this.domiciledCountry;
        data["residingCountry"] = this.residingCountry;
        data["otherCountry"] = this.otherCountry;
        data["state"] = this.state;
        data["town"] = this.town;
        data["accountNumber"] = this.accountNumber;
        data["totalPremium"] = this.totalPremium;
        data["policyNumber"] = this.policyNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["remark"] = this.remark;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IClientProfileByEmail {
    surname?: string | undefined;
    firstName?: string | undefined;
    otherNames?: string | undefined;
    title?: string | undefined;
    residentialAddress?: string | undefined;
    postalAddress?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    tinNumber?: string | undefined;
    country?: string | undefined;
    domiciledCountry?: string | undefined;
    residingCountry?: string | undefined;
    otherCountry?: string | undefined;
    state?: string | undefined;
    town?: string | undefined;
    accountNumber?: string | undefined;
    totalPremium?: number | undefined;
    policyNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    remark?: string | undefined;
    isSuccessful?: boolean | undefined;
}

export class PolicyCheckDto implements IPolicyCheckDto {
    isServerError?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    policyNo?: string | undefined;

    constructor(data?: IPolicyCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isServerError = _data["isServerError"];
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.policyNo = _data["policyNo"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyCheckDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyCheckDto>(data, _mappings, PolicyCheckDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isServerError"] = this.isServerError;
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["policyNo"] = this.policyNo;
        return data;
    }
}

export interface IPolicyCheckDto {
    isServerError?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    policyNo?: string | undefined;
}

export class AgentProfillingDetail implements IAgentProfillingDetail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentdetailByEmailModels?: AgentDetailByEmailModel | undefined;

    constructor(data?: IAgentProfillingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.agentdetailByEmailModels = _data["agentdetailByEmailModels"] ? AgentDetailByEmailModel.fromJS(_data["agentdetailByEmailModels"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): AgentProfillingDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentProfillingDetail>(data, _mappings, AgentProfillingDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["agentdetailByEmailModels"] = this.agentdetailByEmailModels ? this.agentdetailByEmailModels.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgentProfillingDetail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentdetailByEmailModels?: AgentDetailByEmailModel | undefined;
}

export class DebitDetailDto implements IDebitDetailDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    debitNoteModel?: DebitNoteModel | undefined;

    constructor(data?: IDebitDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.debitNoteModel = _data["debitNoteModel"] ? DebitNoteModel.fromJS(_data["debitNoteModel"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): DebitDetailDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DebitDetailDto>(data, _mappings, DebitDetailDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["debitNoteModel"] = this.debitNoteModel ? this.debitNoteModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDebitDetailDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    debitNoteModel?: DebitNoteModel | undefined;
}

export class DebitNoteModel implements IDebitNoteModel {
    branchName?: string | undefined;
    productClass?: string | undefined;
    productClassShortDescription?: string | undefined;
    debitNoteNo?: string | undefined;
    agentCode?: string | undefined;
    agentType?: string | undefined;
    policyNo?: string | undefined;
    firstName?: string | undefined;
    otherNames?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    endorsFrom?: string | undefined;
    endorsTo?: string | undefined;
    amount?: string | undefined;
    endorsNo?: string | undefined;
    outStandingBalance?: string | undefined;
    policeBatchNo?: string | undefined;
    agentShortDescription?: string | undefined;
    clientShortDescription?: string | undefined;

    constructor(data?: IDebitNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.productClass = _data["productClass"];
            this.productClassShortDescription = _data["productClassShortDescription"];
            this.debitNoteNo = _data["debitNoteNo"];
            this.agentCode = _data["agentCode"];
            this.agentType = _data["agentType"];
            this.policyNo = _data["policyNo"];
            this.firstName = _data["firstName"];
            this.otherNames = _data["otherNames"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.coverFrom = _data["coverFrom"];
            this.coverTo = _data["coverTo"];
            this.endorsFrom = _data["endorsFrom"];
            this.endorsTo = _data["endorsTo"];
            this.amount = _data["amount"];
            this.endorsNo = _data["endorsNo"];
            this.outStandingBalance = _data["outStandingBalance"];
            this.policeBatchNo = _data["policeBatchNo"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.clientShortDescription = _data["clientShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): DebitNoteModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DebitNoteModel>(data, _mappings, DebitNoteModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["productClass"] = this.productClass;
        data["productClassShortDescription"] = this.productClassShortDescription;
        data["debitNoteNo"] = this.debitNoteNo;
        data["agentCode"] = this.agentCode;
        data["agentType"] = this.agentType;
        data["policyNo"] = this.policyNo;
        data["firstName"] = this.firstName;
        data["otherNames"] = this.otherNames;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["address"] = this.address;
        data["coverFrom"] = this.coverFrom;
        data["coverTo"] = this.coverTo;
        data["endorsFrom"] = this.endorsFrom;
        data["endorsTo"] = this.endorsTo;
        data["amount"] = this.amount;
        data["endorsNo"] = this.endorsNo;
        data["outStandingBalance"] = this.outStandingBalance;
        data["policeBatchNo"] = this.policeBatchNo;
        data["agentShortDescription"] = this.agentShortDescription;
        data["clientShortDescription"] = this.clientShortDescription;
        return data;
    }
}

export interface IDebitNoteModel {
    branchName?: string | undefined;
    productClass?: string | undefined;
    productClassShortDescription?: string | undefined;
    debitNoteNo?: string | undefined;
    agentCode?: string | undefined;
    agentType?: string | undefined;
    policyNo?: string | undefined;
    firstName?: string | undefined;
    otherNames?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    endorsFrom?: string | undefined;
    endorsTo?: string | undefined;
    amount?: string | undefined;
    endorsNo?: string | undefined;
    outStandingBalance?: string | undefined;
    policeBatchNo?: string | undefined;
    agentShortDescription?: string | undefined;
    clientShortDescription?: string | undefined;
}

export class ConfirmpayTravelscheduleDto implements IConfirmpayTravelscheduleDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    traveleModel?: ConfirmpayTravelScduleModel | undefined;

    constructor(data?: IConfirmpayTravelscheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.traveleModel = _data["traveleModel"] ? ConfirmpayTravelScduleModel.fromJS(_data["traveleModel"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmpayTravelscheduleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmpayTravelscheduleDto>(data, _mappings, ConfirmpayTravelscheduleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["traveleModel"] = this.traveleModel ? this.traveleModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfirmpayTravelscheduleDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    traveleModel?: ConfirmpayTravelScduleModel | undefined;
}

export class ConfirmpayTravelScduleModel implements IConfirmpayTravelScduleModel {
    policyStatus?: string | undefined;
    sumAssured?: string | undefined;
    passportNo?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    surname?: string | undefined;
    otherNames?: string | undefined;
    certificateNo?: string | undefined;
    policyNo?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    transactionDate?: string | undefined;
    premium?: string | undefined;
    dateOfBirth?: string | undefined;
    reportName?: string | undefined;
    cover?: string | undefined;
    excess?: string | undefined;
    embassyCode?: string | undefined;
    country?: string | undefined;
    schengen?: string | undefined;
    currency?: string | undefined;
    readonly title?: string | undefined;
    readonly gender?: string | undefined;

    constructor(data?: IConfirmpayTravelScduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyStatus = _data["policyStatus"];
            this.sumAssured = _data["sumAssured"];
            this.passportNo = _data["passportNo"];
            this.agentName = _data["agentName"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.surname = _data["surname"];
            this.otherNames = _data["otherNames"];
            this.certificateNo = _data["certificateNo"];
            this.policyNo = _data["policyNo"];
            this.coverFrom = _data["coverFrom"];
            this.coverTo = _data["coverTo"];
            this.transactionDate = _data["transactionDate"];
            this.premium = _data["premium"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.reportName = _data["reportName"];
            this.cover = _data["cover"];
            this.excess = _data["excess"];
            this.embassyCode = _data["embassyCode"];
            this.country = _data["country"];
            this.schengen = _data["schengen"];
            this.currency = _data["currency"];
            (<any>this).title = _data["title"];
            (<any>this).gender = _data["gender"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmpayTravelScduleModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmpayTravelScduleModel>(data, _mappings, ConfirmpayTravelScduleModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyStatus"] = this.policyStatus;
        data["sumAssured"] = this.sumAssured;
        data["passportNo"] = this.passportNo;
        data["agentName"] = this.agentName;
        data["agentShortDescription"] = this.agentShortDescription;
        data["surname"] = this.surname;
        data["otherNames"] = this.otherNames;
        data["certificateNo"] = this.certificateNo;
        data["policyNo"] = this.policyNo;
        data["coverFrom"] = this.coverFrom;
        data["coverTo"] = this.coverTo;
        data["transactionDate"] = this.transactionDate;
        data["premium"] = this.premium;
        data["dateOfBirth"] = this.dateOfBirth;
        data["reportName"] = this.reportName;
        data["cover"] = this.cover;
        data["excess"] = this.excess;
        data["embassyCode"] = this.embassyCode;
        data["country"] = this.country;
        data["schengen"] = this.schengen;
        data["currency"] = this.currency;
        data["title"] = this.title;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IConfirmpayTravelScduleModel {
    policyStatus?: string | undefined;
    sumAssured?: string | undefined;
    passportNo?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    surname?: string | undefined;
    otherNames?: string | undefined;
    certificateNo?: string | undefined;
    policyNo?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    transactionDate?: string | undefined;
    premium?: string | undefined;
    dateOfBirth?: string | undefined;
    reportName?: string | undefined;
    cover?: string | undefined;
    excess?: string | undefined;
    embassyCode?: string | undefined;
    country?: string | undefined;
    schengen?: string | undefined;
    currency?: string | undefined;
    title?: string | undefined;
    gender?: string | undefined;
}

export class ConfirmpayMotorcheduleDto implements IConfirmpayMotorcheduleDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    motorModel?: ConfirmpayMotorScduleModel | undefined;

    constructor(data?: IConfirmpayMotorcheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.motorModel = _data["motorModel"] ? ConfirmpayMotorScduleModel.fromJS(_data["motorModel"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmpayMotorcheduleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmpayMotorcheduleDto>(data, _mappings, ConfirmpayMotorcheduleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["motorModel"] = this.motorModel ? this.motorModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfirmpayMotorcheduleDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    motorModel?: ConfirmpayMotorScduleModel | undefined;
}

export class ConfirmpayMotorScduleModel implements IConfirmpayMotorScduleModel {
    policyStatus?: string | undefined;
    sumAssured?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    surname?: string | undefined;
    otherNames?: string | undefined;
    certificateNo?: string | undefined;
    policyNo?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    transactionDate?: string | undefined;
    premium?: string | undefined;
    dateOfBirth?: string | undefined;
    reportName?: string | undefined;
    cover?: string | undefined;
    sumInsured?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleMake?: string | undefined;
    regNo?: string | undefined;
    scL_DESC?: string | undefined;
    coverType?: string | undefined;
    yearOfMake?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    readonly title?: string | undefined;
    readonly gender?: string | undefined;
    readonly physicalAddress?: string | undefined;
    readonly clientType?: string | undefined;

    constructor(data?: IConfirmpayMotorScduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyStatus = _data["policyStatus"];
            this.sumAssured = _data["sumAssured"];
            this.agentName = _data["agentName"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.surname = _data["surname"];
            this.otherNames = _data["otherNames"];
            this.certificateNo = _data["certificateNo"];
            this.policyNo = _data["policyNo"];
            this.coverFrom = _data["coverFrom"];
            this.coverTo = _data["coverTo"];
            this.transactionDate = _data["transactionDate"];
            this.premium = _data["premium"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.reportName = _data["reportName"];
            this.cover = _data["cover"];
            this.sumInsured = _data["sumInsured"];
            this.vehicleModel = _data["vehicleModel"];
            this.vehicleMake = _data["vehicleMake"];
            this.regNo = _data["regNo"];
            this.scL_DESC = _data["scL_DESC"];
            this.coverType = _data["coverType"];
            this.yearOfMake = _data["yearOfMake"];
            this.bodyType = _data["bodyType"];
            this.engineNo = _data["engineNo"];
            this.chasisNo = _data["chasisNo"];
            (<any>this).title = _data["title"];
            (<any>this).gender = _data["gender"];
            (<any>this).physicalAddress = _data["physicalAddress"];
            (<any>this).clientType = _data["clientType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmpayMotorScduleModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmpayMotorScduleModel>(data, _mappings, ConfirmpayMotorScduleModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyStatus"] = this.policyStatus;
        data["sumAssured"] = this.sumAssured;
        data["agentName"] = this.agentName;
        data["agentShortDescription"] = this.agentShortDescription;
        data["surname"] = this.surname;
        data["otherNames"] = this.otherNames;
        data["certificateNo"] = this.certificateNo;
        data["policyNo"] = this.policyNo;
        data["coverFrom"] = this.coverFrom;
        data["coverTo"] = this.coverTo;
        data["transactionDate"] = this.transactionDate;
        data["premium"] = this.premium;
        data["dateOfBirth"] = this.dateOfBirth;
        data["reportName"] = this.reportName;
        data["cover"] = this.cover;
        data["sumInsured"] = this.sumInsured;
        data["vehicleModel"] = this.vehicleModel;
        data["vehicleMake"] = this.vehicleMake;
        data["regNo"] = this.regNo;
        data["scL_DESC"] = this.scL_DESC;
        data["coverType"] = this.coverType;
        data["yearOfMake"] = this.yearOfMake;
        data["bodyType"] = this.bodyType;
        data["engineNo"] = this.engineNo;
        data["chasisNo"] = this.chasisNo;
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["physicalAddress"] = this.physicalAddress;
        data["clientType"] = this.clientType;
        return data;
    }
}

export interface IConfirmpayMotorScduleModel {
    policyStatus?: string | undefined;
    sumAssured?: string | undefined;
    agentName?: string | undefined;
    agentShortDescription?: string | undefined;
    surname?: string | undefined;
    otherNames?: string | undefined;
    certificateNo?: string | undefined;
    policyNo?: string | undefined;
    coverFrom?: string | undefined;
    coverTo?: string | undefined;
    transactionDate?: string | undefined;
    premium?: string | undefined;
    dateOfBirth?: string | undefined;
    reportName?: string | undefined;
    cover?: string | undefined;
    sumInsured?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleMake?: string | undefined;
    regNo?: string | undefined;
    scL_DESC?: string | undefined;
    coverType?: string | undefined;
    yearOfMake?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    title?: string | undefined;
    gender?: string | undefined;
    physicalAddress?: string | undefined;
    clientType?: string | undefined;
}

export class DebitDetailRequesDto implements IDebitDetailRequesDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    accountNumber?: string | undefined;
    businessRemark?: string | undefined;
    amount?: number | undefined;
    debitNoteModel?: DebitNoteModel | undefined;
    subclassSectCovtypeId?: string | undefined;

    constructor(data?: IDebitDetailRequesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.accountNumber = _data["accountNumber"];
            this.businessRemark = _data["businessRemark"];
            this.amount = _data["amount"];
            this.debitNoteModel = _data["debitNoteModel"] ? DebitNoteModel.fromJS(_data["debitNoteModel"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): DebitDetailRequesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DebitDetailRequesDto>(data, _mappings, DebitDetailRequesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["accountNumber"] = this.accountNumber;
        data["businessRemark"] = this.businessRemark;
        data["amount"] = this.amount;
        data["debitNoteModel"] = this.debitNoteModel ? this.debitNoteModel.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        return data;
    }
}

export interface IDebitDetailRequesDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    accountNumber?: string | undefined;
    businessRemark?: string | undefined;
    amount?: number | undefined;
    debitNoteModel?: DebitNoteModel | undefined;
    subclassSectCovtypeId?: string | undefined;
}

export class DeferredAnnuityRate implements IDeferredAnnuityRate {
    rate?: number | undefined;
    singleRate?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    age?: number | undefined;
    rateCode?: string | undefined;
    gender?: string | undefined;
    retirementAge?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IDeferredAnnuityRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.singleRate = _data["singleRate"];
            this.yearsTerm = _data["yearsTerm"];
            this.premiumFrequency = _data["premiumFrequency"];
            this.coverType = _data["coverType"];
            this.age = _data["age"];
            this.rateCode = _data["rateCode"];
            this.gender = _data["gender"];
            this.retirementAge = _data["retirementAge"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeferredAnnuityRate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeferredAnnuityRate>(data, _mappings, DeferredAnnuityRate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["singleRate"] = this.singleRate;
        data["yearsTerm"] = this.yearsTerm;
        data["premiumFrequency"] = this.premiumFrequency;
        data["coverType"] = this.coverType;
        data["age"] = this.age;
        data["rateCode"] = this.rateCode;
        data["gender"] = this.gender;
        data["retirementAge"] = this.retirementAge;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeferredAnnuityRate {
    rate?: number | undefined;
    singleRate?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    age?: number | undefined;
    rateCode?: string | undefined;
    gender?: string | undefined;
    retirementAge?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class EduShieldScheduleRequest implements IEduShieldScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    occupation?: string | undefined;
    genderId?: string | undefined;
    maritalStatusId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    lgaId?: string | undefined;
    paymentFrequency?: string | undefined;
    durationOfCover?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    schoolName?: string | undefined;
    studentName?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    referralCode?: string | undefined;
    isSuccessful?: boolean | undefined;

    constructor(data?: IEduShieldScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.occupation = _data["occupation"];
            this.genderId = _data["genderId"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.lgaId = _data["lgaId"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.durationOfCover = _data["durationOfCover"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.schoolName = _data["schoolName"];
            this.studentName = _data["studentName"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.branchId = _data["branchId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.referralCode = _data["referralCode"];
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any, _mappings?: any): EduShieldScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EduShieldScheduleRequest>(data, _mappings, EduShieldScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["occupation"] = this.occupation;
        data["genderId"] = this.genderId;
        data["maritalStatusId"] = this.maritalStatusId;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["lgaId"] = this.lgaId;
        data["paymentFrequency"] = this.paymentFrequency;
        data["durationOfCover"] = this.durationOfCover;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["schoolName"] = this.schoolName;
        data["studentName"] = this.studentName;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["branchId"] = this.branchId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IEduShieldScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    occupation?: string | undefined;
    genderId?: string | undefined;
    maritalStatusId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    lgaId?: string | undefined;
    paymentFrequency?: string | undefined;
    durationOfCover?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    schoolName?: string | undefined;
    studentName?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    referralCode?: string | undefined;
    isSuccessful?: boolean | undefined;
}

export class MobileUserLoginDetails implements IMobileUserLoginDetails {
    emailAddress?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    isActive?: boolean | undefined;
    fullName?: string | undefined;
    lastLoginTime?: string | undefined;
    creationTime?: string | undefined;
    flexRoleName?: string | undefined;
    token?: string | undefined;
    id?: number | undefined;
    telephone?: string | undefined;
    address?: string | undefined;
    agentCode?: string | undefined;
    agentType?: string | undefined;
    accountType?: string | undefined;
    agentDashboard?: AgentDashboardDto | undefined;
    dob?: string | undefined;
    countryId?: string | undefined;
    genderId?: string | undefined;
    maritalStatusId?: string | undefined;
    titleId?: string | undefined;

    constructor(data?: IMobileUserLoginDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"];
            this.creationTime = _data["creationTime"];
            this.flexRoleName = _data["flexRoleName"];
            this.token = _data["token"];
            this.id = _data["id"];
            this.telephone = _data["telephone"];
            this.address = _data["address"];
            this.agentCode = _data["agentCode"];
            this.agentType = _data["agentType"];
            this.accountType = _data["accountType"];
            this.agentDashboard = _data["agentDashboard"] ? AgentDashboardDto.fromJS(_data["agentDashboard"], _mappings) : <any>undefined;
            this.dob = _data["dob"];
            this.countryId = _data["countryId"];
            this.genderId = _data["genderId"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.titleId = _data["titleId"];
        }
    }

    static fromJS(data: any, _mappings?: any): MobileUserLoginDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MobileUserLoginDetails>(data, _mappings, MobileUserLoginDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime;
        data["creationTime"] = this.creationTime;
        data["flexRoleName"] = this.flexRoleName;
        data["token"] = this.token;
        data["id"] = this.id;
        data["telephone"] = this.telephone;
        data["address"] = this.address;
        data["agentCode"] = this.agentCode;
        data["agentType"] = this.agentType;
        data["accountType"] = this.accountType;
        data["agentDashboard"] = this.agentDashboard ? this.agentDashboard.toJSON() : <any>undefined;
        data["dob"] = this.dob;
        data["countryId"] = this.countryId;
        data["genderId"] = this.genderId;
        data["maritalStatusId"] = this.maritalStatusId;
        data["titleId"] = this.titleId;
        return data;
    }
}

export interface IMobileUserLoginDetails {
    emailAddress?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    isActive?: boolean | undefined;
    fullName?: string | undefined;
    lastLoginTime?: string | undefined;
    creationTime?: string | undefined;
    flexRoleName?: string | undefined;
    token?: string | undefined;
    id?: number | undefined;
    telephone?: string | undefined;
    address?: string | undefined;
    agentCode?: string | undefined;
    agentType?: string | undefined;
    accountType?: string | undefined;
    agentDashboard?: AgentDashboardDto | undefined;
    dob?: string | undefined;
    countryId?: string | undefined;
    genderId?: string | undefined;
    maritalStatusId?: string | undefined;
    titleId?: string | undefined;
}

export class AgentDashboardDto implements IAgentDashboardDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentDashboardModel?: AgentDashboardModel | undefined;

    constructor(data?: IAgentDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.agentDashboardModel = _data["agentDashboardModel"] ? AgentDashboardModel.fromJS(_data["agentDashboardModel"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): AgentDashboardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentDashboardDto>(data, _mappings, AgentDashboardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["agentDashboardModel"] = this.agentDashboardModel ? this.agentDashboardModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgentDashboardDto {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentDashboardModel?: AgentDashboardModel | undefined;
}

export class AgentDashboardModel implements IAgentDashboardModel {
    agenT_CODE?: string | undefined;
    agN_CODE?: string | undefined;
    agenT_NAME?: string | undefined;
    joineD_YEAR?: string | undefined;
    datE_OF_CODING?: string | undefined;
    cellphonE_NO?: string | undefined;
    agN_EMAIL_ADDRESS?: string | undefined;
    agenT_LOCATION?: string | undefined;
    namE_OF_UNT_MGR?: string | undefined;
    uniT_MANAGER_CODE?: string | undefined;
    namE_OF_AGENCY_MGR?: string | undefined;
    agencY_MANAGER_CODE?: string | undefined;
    submitteD_BUSINESS?: string | undefined;
    firsT_YEAR_PREM_ISSUED_MTH?: string | undefined;
    premium?: string | undefined;
    sbmtD_FIRST_YEAR_COMM_MTH?: string | undefined;
    poL_COUNT_YEAR?: string | undefined;
    firsT_YEAR_PREMIUM_YEAR?: string | undefined;
    renewaL_COMM_PAID?: string | undefined;
    vintagE_MONTHS?: string | undefined;

    constructor(data?: IAgentDashboardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agenT_CODE = _data["agenT_CODE"];
            this.agN_CODE = _data["agN_CODE"];
            this.agenT_NAME = _data["agenT_NAME"];
            this.joineD_YEAR = _data["joineD_YEAR"];
            this.datE_OF_CODING = _data["datE_OF_CODING"];
            this.cellphonE_NO = _data["cellphonE_NO"];
            this.agN_EMAIL_ADDRESS = _data["agN_EMAIL_ADDRESS"];
            this.agenT_LOCATION = _data["agenT_LOCATION"];
            this.namE_OF_UNT_MGR = _data["namE_OF_UNT_MGR"];
            this.uniT_MANAGER_CODE = _data["uniT_MANAGER_CODE"];
            this.namE_OF_AGENCY_MGR = _data["namE_OF_AGENCY_MGR"];
            this.agencY_MANAGER_CODE = _data["agencY_MANAGER_CODE"];
            this.submitteD_BUSINESS = _data["submitteD_BUSINESS"];
            this.firsT_YEAR_PREM_ISSUED_MTH = _data["firsT_YEAR_PREM_ISSUED_MTH"];
            this.premium = _data["premium"];
            this.sbmtD_FIRST_YEAR_COMM_MTH = _data["sbmtD_FIRST_YEAR_COMM_MTH"];
            this.poL_COUNT_YEAR = _data["poL_COUNT_YEAR"];
            this.firsT_YEAR_PREMIUM_YEAR = _data["firsT_YEAR_PREMIUM_YEAR"];
            this.renewaL_COMM_PAID = _data["renewaL_COMM_PAID"];
            this.vintagE_MONTHS = _data["vintagE_MONTHS"];
        }
    }

    static fromJS(data: any, _mappings?: any): AgentDashboardModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentDashboardModel>(data, _mappings, AgentDashboardModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenT_CODE"] = this.agenT_CODE;
        data["agN_CODE"] = this.agN_CODE;
        data["agenT_NAME"] = this.agenT_NAME;
        data["joineD_YEAR"] = this.joineD_YEAR;
        data["datE_OF_CODING"] = this.datE_OF_CODING;
        data["cellphonE_NO"] = this.cellphonE_NO;
        data["agN_EMAIL_ADDRESS"] = this.agN_EMAIL_ADDRESS;
        data["agenT_LOCATION"] = this.agenT_LOCATION;
        data["namE_OF_UNT_MGR"] = this.namE_OF_UNT_MGR;
        data["uniT_MANAGER_CODE"] = this.uniT_MANAGER_CODE;
        data["namE_OF_AGENCY_MGR"] = this.namE_OF_AGENCY_MGR;
        data["agencY_MANAGER_CODE"] = this.agencY_MANAGER_CODE;
        data["submitteD_BUSINESS"] = this.submitteD_BUSINESS;
        data["firsT_YEAR_PREM_ISSUED_MTH"] = this.firsT_YEAR_PREM_ISSUED_MTH;
        data["premium"] = this.premium;
        data["sbmtD_FIRST_YEAR_COMM_MTH"] = this.sbmtD_FIRST_YEAR_COMM_MTH;
        data["poL_COUNT_YEAR"] = this.poL_COUNT_YEAR;
        data["firsT_YEAR_PREMIUM_YEAR"] = this.firsT_YEAR_PREMIUM_YEAR;
        data["renewaL_COMM_PAID"] = this.renewaL_COMM_PAID;
        data["vintagE_MONTHS"] = this.vintagE_MONTHS;
        return data;
    }
}

export interface IAgentDashboardModel {
    agenT_CODE?: string | undefined;
    agN_CODE?: string | undefined;
    agenT_NAME?: string | undefined;
    joineD_YEAR?: string | undefined;
    datE_OF_CODING?: string | undefined;
    cellphonE_NO?: string | undefined;
    agN_EMAIL_ADDRESS?: string | undefined;
    agenT_LOCATION?: string | undefined;
    namE_OF_UNT_MGR?: string | undefined;
    uniT_MANAGER_CODE?: string | undefined;
    namE_OF_AGENCY_MGR?: string | undefined;
    agencY_MANAGER_CODE?: string | undefined;
    submitteD_BUSINESS?: string | undefined;
    firsT_YEAR_PREM_ISSUED_MTH?: string | undefined;
    premium?: string | undefined;
    sbmtD_FIRST_YEAR_COMM_MTH?: string | undefined;
    poL_COUNT_YEAR?: string | undefined;
    firsT_YEAR_PREMIUM_YEAR?: string | undefined;
    renewaL_COMM_PAID?: string | undefined;
    vintagE_MONTHS?: string | undefined;
}

export class RoleDto implements IRoleDto {
    name!: string;
    displayName!: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    isStatic?: boolean | undefined;
    permissions?: string[] | undefined;
    id?: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): RoleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RoleDto>(data, _mappings, RoleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    isStatic?: boolean | undefined;
    permissions?: string[] | undefined;
    id?: number | undefined;
}

export class MultipleNewBusinessDto implements IMultipleNewBusinessDto {
    agentCode!: string;
    agentEmail!: string;
    agentPhoneNumber!: string;
    paymentMode?: string | undefined;
    paymentName?: string | undefined;
    nameOfBank?: string | undefined;
    accountNumber!: string;
    slipNumber!: string;
    typeOfBusiness!: string;
    typeOfPayment!: string;
    dateOfDeposit!: Date;
    policyHolderList?: PolicyHolderList[] | undefined;

    constructor(data?: IMultipleNewBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agentCode = _data["agentCode"];
            this.agentEmail = _data["agentEmail"];
            this.agentPhoneNumber = _data["agentPhoneNumber"];
            this.paymentMode = _data["paymentMode"];
            this.paymentName = _data["paymentName"];
            this.nameOfBank = _data["nameOfBank"];
            this.accountNumber = _data["accountNumber"];
            this.slipNumber = _data["slipNumber"];
            this.typeOfBusiness = _data["typeOfBusiness"];
            this.typeOfPayment = _data["typeOfPayment"];
            this.dateOfDeposit = _data["dateOfDeposit"] ? new Date(_data["dateOfDeposit"].toString()) : <any>undefined;
            if (Array.isArray(_data["policyHolderList"])) {
                this.policyHolderList = [] as any;
                for (let item of _data["policyHolderList"])
                    this.policyHolderList!.push(PolicyHolderList.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MultipleNewBusinessDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MultipleNewBusinessDto>(data, _mappings, MultipleNewBusinessDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentCode"] = this.agentCode;
        data["agentEmail"] = this.agentEmail;
        data["agentPhoneNumber"] = this.agentPhoneNumber;
        data["paymentMode"] = this.paymentMode;
        data["paymentName"] = this.paymentName;
        data["nameOfBank"] = this.nameOfBank;
        data["accountNumber"] = this.accountNumber;
        data["slipNumber"] = this.slipNumber;
        data["typeOfBusiness"] = this.typeOfBusiness;
        data["typeOfPayment"] = this.typeOfPayment;
        data["dateOfDeposit"] = this.dateOfDeposit ? this.dateOfDeposit.toISOString() : <any>undefined;
        if (Array.isArray(this.policyHolderList)) {
            data["policyHolderList"] = [];
            for (let item of this.policyHolderList)
                data["policyHolderList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleNewBusinessDto {
    agentCode: string;
    agentEmail: string;
    agentPhoneNumber: string;
    paymentMode?: string | undefined;
    paymentName?: string | undefined;
    nameOfBank?: string | undefined;
    accountNumber: string;
    slipNumber: string;
    typeOfBusiness: string;
    typeOfPayment: string;
    dateOfDeposit: Date;
    policyHolderList?: PolicyHolderList[] | undefined;
}

export class PolicyHolderList implements IPolicyHolderList {
    policyholderName?: string | undefined;
    policyholderPhoneNo?: string | undefined;
    policyholderEmail?: string | undefined;
    proposalNo?: string | undefined;
    amount?: number | undefined;

    constructor(data?: IPolicyHolderList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyholderName = _data["policyholderName"];
            this.policyholderPhoneNo = _data["policyholderPhoneNo"];
            this.policyholderEmail = _data["policyholderEmail"];
            this.proposalNo = _data["proposalNo"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyHolderList | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyHolderList>(data, _mappings, PolicyHolderList);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyholderName"] = this.policyholderName;
        data["policyholderPhoneNo"] = this.policyholderPhoneNo;
        data["policyholderEmail"] = this.policyholderEmail;
        data["proposalNo"] = this.proposalNo;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPolicyHolderList {
    policyholderName?: string | undefined;
    policyholderPhoneNo?: string | undefined;
    policyholderEmail?: string | undefined;
    proposalNo?: string | undefined;
    amount?: number | undefined;
}

export class ConfirmResponseDto implements IConfirmResponseDto {
    success?: boolean | undefined;
    failed?: boolean | undefined;
    message?: string | undefined;
    confirmPaySuccesses?: ConfirmPaySuccess[] | undefined;

    constructor(data?: IConfirmResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.success = _data["success"];
            this.failed = _data["failed"];
            this.message = _data["message"];
            if (Array.isArray(_data["confirmPaySuccesses"])) {
                this.confirmPaySuccesses = [] as any;
                for (let item of _data["confirmPaySuccesses"])
                    this.confirmPaySuccesses!.push(ConfirmPaySuccess.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmResponseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmResponseDto>(data, _mappings, ConfirmResponseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["failed"] = this.failed;
        data["message"] = this.message;
        if (Array.isArray(this.confirmPaySuccesses)) {
            data["confirmPaySuccesses"] = [];
            for (let item of this.confirmPaySuccesses)
                data["confirmPaySuccesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfirmResponseDto {
    success?: boolean | undefined;
    failed?: boolean | undefined;
    message?: string | undefined;
    confirmPaySuccesses?: ConfirmPaySuccess[] | undefined;
}

export class ConfirmPaySuccess implements IConfirmPaySuccess {
    transactionId?: string | undefined;
    transactionRef?: string | undefined;
    clientId?: number | undefined;
    policyNumber?: string | undefined;

    constructor(data?: IConfirmPaySuccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.transactionRef = _data["transactionRef"];
            this.clientId = _data["clientId"];
            this.policyNumber = _data["policyNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmPaySuccess | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmPaySuccess>(data, _mappings, ConfirmPaySuccess);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["transactionRef"] = this.transactionRef;
        data["clientId"] = this.clientId;
        data["policyNumber"] = this.policyNumber;
        return data;
    }
}

export interface IConfirmPaySuccess {
    transactionId?: string | undefined;
    transactionRef?: string | undefined;
    clientId?: number | undefined;
    policyNumber?: string | undefined;
}

export class SingleBusinessDto implements ISingleBusinessDto {
    agentCode!: string;
    agentEmail!: string;
    agentPhoneNumber?: string | undefined;
    policyholderPhoneNo?: string | undefined;
    policyholderEmail!: string;
    paymentMode?: string | undefined;
    paymentName?: string | undefined;
    nameOfBank?: string | undefined;
    accountNumber!: string;
    slipNumber!: string;
    typeOfBusiness?: string | undefined;
    typeOfPayment?: string | undefined;
    dateOfDeposit?: Date | undefined;
    policyholderName?: string | undefined;
    proposalNo?: string | undefined;
    amount?: number | undefined;

    constructor(data?: ISingleBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agentCode = _data["agentCode"];
            this.agentEmail = _data["agentEmail"];
            this.agentPhoneNumber = _data["agentPhoneNumber"];
            this.policyholderPhoneNo = _data["policyholderPhoneNo"];
            this.policyholderEmail = _data["policyholderEmail"];
            this.paymentMode = _data["paymentMode"];
            this.paymentName = _data["paymentName"];
            this.nameOfBank = _data["nameOfBank"];
            this.accountNumber = _data["accountNumber"];
            this.slipNumber = _data["slipNumber"];
            this.typeOfBusiness = _data["typeOfBusiness"];
            this.typeOfPayment = _data["typeOfPayment"];
            this.dateOfDeposit = _data["dateOfDeposit"] ? new Date(_data["dateOfDeposit"].toString()) : <any>undefined;
            this.policyholderName = _data["policyholderName"];
            this.proposalNo = _data["proposalNo"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): SingleBusinessDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SingleBusinessDto>(data, _mappings, SingleBusinessDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentCode"] = this.agentCode;
        data["agentEmail"] = this.agentEmail;
        data["agentPhoneNumber"] = this.agentPhoneNumber;
        data["policyholderPhoneNo"] = this.policyholderPhoneNo;
        data["policyholderEmail"] = this.policyholderEmail;
        data["paymentMode"] = this.paymentMode;
        data["paymentName"] = this.paymentName;
        data["nameOfBank"] = this.nameOfBank;
        data["accountNumber"] = this.accountNumber;
        data["slipNumber"] = this.slipNumber;
        data["typeOfBusiness"] = this.typeOfBusiness;
        data["typeOfPayment"] = this.typeOfPayment;
        data["dateOfDeposit"] = this.dateOfDeposit ? this.dateOfDeposit.toISOString() : <any>undefined;
        data["policyholderName"] = this.policyholderName;
        data["proposalNo"] = this.proposalNo;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ISingleBusinessDto {
    agentCode: string;
    agentEmail: string;
    agentPhoneNumber?: string | undefined;
    policyholderPhoneNo?: string | undefined;
    policyholderEmail: string;
    paymentMode?: string | undefined;
    paymentName?: string | undefined;
    nameOfBank?: string | undefined;
    accountNumber: string;
    slipNumber: string;
    typeOfBusiness?: string | undefined;
    typeOfPayment?: string | undefined;
    dateOfDeposit?: Date | undefined;
    policyholderName?: string | undefined;
    proposalNo?: string | undefined;
    amount?: number | undefined;
}

export class ClientPaymentHistory implements IClientPaymentHistory {
    policyNo?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionRef?: string | undefined;
    transactionType?: string | undefined;
    amount?: number | undefined;
    customerName?: string | undefined;
    polledToTQ?: boolean | undefined;
    clientCode?: string | undefined;

    constructor(data?: IClientPaymentHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.transactionDate = _data["transactionDate"];
            this.transactionRef = _data["transactionRef"];
            this.transactionType = _data["transactionType"];
            this.amount = _data["amount"];
            this.customerName = _data["customerName"];
            this.polledToTQ = _data["polledToTQ"];
            this.clientCode = _data["clientCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPaymentHistory | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPaymentHistory>(data, _mappings, ClientPaymentHistory);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["transactionDate"] = this.transactionDate;
        data["transactionRef"] = this.transactionRef;
        data["transactionType"] = this.transactionType;
        data["amount"] = this.amount;
        data["customerName"] = this.customerName;
        data["polledToTQ"] = this.polledToTQ;
        data["clientCode"] = this.clientCode;
        return data;
    }
}

export interface IClientPaymentHistory {
    policyNo?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionRef?: string | undefined;
    transactionType?: string | undefined;
    amount?: number | undefined;
    customerName?: string | undefined;
    polledToTQ?: boolean | undefined;
    clientCode?: string | undefined;
}

export class AgentListPoliciesByEmail implements IAgentListPoliciesByEmail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    renewalPayment?: RenewalPaymentForCurrentModel | undefined;
    agentPolicyListByEmailModels?: AgentPolicyByEmailModel[] | undefined;

    constructor(data?: IAgentListPoliciesByEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.renewalPayment = _data["renewalPayment"] ? RenewalPaymentForCurrentModel.fromJS(_data["renewalPayment"], _mappings) : <any>undefined;
            if (Array.isArray(_data["agentPolicyListByEmailModels"])) {
                this.agentPolicyListByEmailModels = [] as any;
                for (let item of _data["agentPolicyListByEmailModels"])
                    this.agentPolicyListByEmailModels!.push(AgentPolicyByEmailModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AgentListPoliciesByEmail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentListPoliciesByEmail>(data, _mappings, AgentListPoliciesByEmail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["renewalPayment"] = this.renewalPayment ? this.renewalPayment.toJSON() : <any>undefined;
        if (Array.isArray(this.agentPolicyListByEmailModels)) {
            data["agentPolicyListByEmailModels"] = [];
            for (let item of this.agentPolicyListByEmailModels)
                data["agentPolicyListByEmailModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentListPoliciesByEmail {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    renewalPayment?: RenewalPaymentForCurrentModel | undefined;
    agentPolicyListByEmailModels?: AgentPolicyByEmailModel[] | undefined;
}

export class RenewalPaymentForCurrentModel implements IRenewalPaymentForCurrentModel {
    isSuccessful?: boolean | undefined;
    agenctCode?: string | undefined;
    renewalPremiumMonth?: string | undefined;
    renewalPremiumAmount?: string | undefined;
    readonly responseMessage?: string | undefined;

    constructor(data?: IRenewalPaymentForCurrentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.agenctCode = _data["agenctCode"];
            this.renewalPremiumMonth = _data["renewalPremiumMonth"];
            this.renewalPremiumAmount = _data["renewalPremiumAmount"];
            (<any>this).responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): RenewalPaymentForCurrentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RenewalPaymentForCurrentModel>(data, _mappings, RenewalPaymentForCurrentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["agenctCode"] = this.agenctCode;
        data["renewalPremiumMonth"] = this.renewalPremiumMonth;
        data["renewalPremiumAmount"] = this.renewalPremiumAmount;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IRenewalPaymentForCurrentModel {
    isSuccessful?: boolean | undefined;
    agenctCode?: string | undefined;
    renewalPremiumMonth?: string | undefined;
    renewalPremiumAmount?: string | undefined;
    responseMessage?: string | undefined;
}

export class AgentPolicyByEmailModel implements IAgentPolicyByEmailModel {
    agN_CODE?: string | undefined;
    agN_SHT_DESC?: string | undefined;
    agN_NAME?: string | undefined;
    prP_CODE?: string | undefined;
    prP_CLNT_CODE?: string | undefined;
    prP_SHT_DESC?: string | undefined;
    prP_TITLE?: string | undefined;
    prP_SURNAME?: string | undefined;
    prP_OTHER_NAMES?: string | undefined;
    prP_SEX?: string | undefined;
    prP_BUSINESS?: string | undefined;
    prP_PHYSICAL_ADDR?: string | undefined;
    prP_MARITAL_STATUS?: string | undefined;
    prP_DOB?: string | undefined;
    poL_NO?: string | undefined;
    proD_DESC?: string | undefined;
    totaL_PREM?: string | undefined;
    poL_TERM?: string | undefined;
    poL_MATURITY_DATE?: string | undefined;
    poL_EFFECTIVE_DATE?: string | undefined;
    poL_PAID_TO_DATE?: string | undefined;
    poL_CURRENT_SA?: string | undefined;
    pol_status?: string | undefined;
    prP_TEL?: string | undefined;
    prP_CLNT_SMS_TEL?: string | undefined;
    prP_EMAIL?: string | undefined;
    agN_EMAIL_ADDRESS?: string | undefined;
    isSuccessful?: boolean | undefined;
    poL_DUE_TO_DATE?: string | undefined;
    poL_INSTLMT_PREM?: string | undefined;
    poL_TOT_INSTLMT?: string | undefined;
    poL_PAID_INSTLMT_NO?: string | undefined;
    poL_OS_PREM_BAL_AMT?: string | undefined;

    constructor(data?: IAgentPolicyByEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agN_CODE = _data["agN_CODE"];
            this.agN_SHT_DESC = _data["agN_SHT_DESC"];
            this.agN_NAME = _data["agN_NAME"];
            this.prP_CODE = _data["prP_CODE"];
            this.prP_CLNT_CODE = _data["prP_CLNT_CODE"];
            this.prP_SHT_DESC = _data["prP_SHT_DESC"];
            this.prP_TITLE = _data["prP_TITLE"];
            this.prP_SURNAME = _data["prP_SURNAME"];
            this.prP_OTHER_NAMES = _data["prP_OTHER_NAMES"];
            this.prP_SEX = _data["prP_SEX"];
            this.prP_BUSINESS = _data["prP_BUSINESS"];
            this.prP_PHYSICAL_ADDR = _data["prP_PHYSICAL_ADDR"];
            this.prP_MARITAL_STATUS = _data["prP_MARITAL_STATUS"];
            this.prP_DOB = _data["prP_DOB"];
            this.poL_NO = _data["poL_NO"];
            this.proD_DESC = _data["proD_DESC"];
            this.totaL_PREM = _data["totaL_PREM"];
            this.poL_TERM = _data["poL_TERM"];
            this.poL_MATURITY_DATE = _data["poL_MATURITY_DATE"];
            this.poL_EFFECTIVE_DATE = _data["poL_EFFECTIVE_DATE"];
            this.poL_PAID_TO_DATE = _data["poL_PAID_TO_DATE"];
            this.poL_CURRENT_SA = _data["poL_CURRENT_SA"];
            this.pol_status = _data["pol_status"];
            this.prP_TEL = _data["prP_TEL"];
            this.prP_CLNT_SMS_TEL = _data["prP_CLNT_SMS_TEL"];
            this.prP_EMAIL = _data["prP_EMAIL"];
            this.agN_EMAIL_ADDRESS = _data["agN_EMAIL_ADDRESS"];
            this.isSuccessful = _data["isSuccessful"];
            this.poL_DUE_TO_DATE = _data["poL_DUE_TO_DATE"];
            this.poL_INSTLMT_PREM = _data["poL_INSTLMT_PREM"];
            this.poL_TOT_INSTLMT = _data["poL_TOT_INSTLMT"];
            this.poL_PAID_INSTLMT_NO = _data["poL_PAID_INSTLMT_NO"];
            this.poL_OS_PREM_BAL_AMT = _data["poL_OS_PREM_BAL_AMT"];
        }
    }

    static fromJS(data: any, _mappings?: any): AgentPolicyByEmailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentPolicyByEmailModel>(data, _mappings, AgentPolicyByEmailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agN_CODE"] = this.agN_CODE;
        data["agN_SHT_DESC"] = this.agN_SHT_DESC;
        data["agN_NAME"] = this.agN_NAME;
        data["prP_CODE"] = this.prP_CODE;
        data["prP_CLNT_CODE"] = this.prP_CLNT_CODE;
        data["prP_SHT_DESC"] = this.prP_SHT_DESC;
        data["prP_TITLE"] = this.prP_TITLE;
        data["prP_SURNAME"] = this.prP_SURNAME;
        data["prP_OTHER_NAMES"] = this.prP_OTHER_NAMES;
        data["prP_SEX"] = this.prP_SEX;
        data["prP_BUSINESS"] = this.prP_BUSINESS;
        data["prP_PHYSICAL_ADDR"] = this.prP_PHYSICAL_ADDR;
        data["prP_MARITAL_STATUS"] = this.prP_MARITAL_STATUS;
        data["prP_DOB"] = this.prP_DOB;
        data["poL_NO"] = this.poL_NO;
        data["proD_DESC"] = this.proD_DESC;
        data["totaL_PREM"] = this.totaL_PREM;
        data["poL_TERM"] = this.poL_TERM;
        data["poL_MATURITY_DATE"] = this.poL_MATURITY_DATE;
        data["poL_EFFECTIVE_DATE"] = this.poL_EFFECTIVE_DATE;
        data["poL_PAID_TO_DATE"] = this.poL_PAID_TO_DATE;
        data["poL_CURRENT_SA"] = this.poL_CURRENT_SA;
        data["pol_status"] = this.pol_status;
        data["prP_TEL"] = this.prP_TEL;
        data["prP_CLNT_SMS_TEL"] = this.prP_CLNT_SMS_TEL;
        data["prP_EMAIL"] = this.prP_EMAIL;
        data["agN_EMAIL_ADDRESS"] = this.agN_EMAIL_ADDRESS;
        data["isSuccessful"] = this.isSuccessful;
        data["poL_DUE_TO_DATE"] = this.poL_DUE_TO_DATE;
        data["poL_INSTLMT_PREM"] = this.poL_INSTLMT_PREM;
        data["poL_TOT_INSTLMT"] = this.poL_TOT_INSTLMT;
        data["poL_PAID_INSTLMT_NO"] = this.poL_PAID_INSTLMT_NO;
        data["poL_OS_PREM_BAL_AMT"] = this.poL_OS_PREM_BAL_AMT;
        return data;
    }
}

export interface IAgentPolicyByEmailModel {
    agN_CODE?: string | undefined;
    agN_SHT_DESC?: string | undefined;
    agN_NAME?: string | undefined;
    prP_CODE?: string | undefined;
    prP_CLNT_CODE?: string | undefined;
    prP_SHT_DESC?: string | undefined;
    prP_TITLE?: string | undefined;
    prP_SURNAME?: string | undefined;
    prP_OTHER_NAMES?: string | undefined;
    prP_SEX?: string | undefined;
    prP_BUSINESS?: string | undefined;
    prP_PHYSICAL_ADDR?: string | undefined;
    prP_MARITAL_STATUS?: string | undefined;
    prP_DOB?: string | undefined;
    poL_NO?: string | undefined;
    proD_DESC?: string | undefined;
    totaL_PREM?: string | undefined;
    poL_TERM?: string | undefined;
    poL_MATURITY_DATE?: string | undefined;
    poL_EFFECTIVE_DATE?: string | undefined;
    poL_PAID_TO_DATE?: string | undefined;
    poL_CURRENT_SA?: string | undefined;
    pol_status?: string | undefined;
    prP_TEL?: string | undefined;
    prP_CLNT_SMS_TEL?: string | undefined;
    prP_EMAIL?: string | undefined;
    agN_EMAIL_ADDRESS?: string | undefined;
    isSuccessful?: boolean | undefined;
    poL_DUE_TO_DATE?: string | undefined;
    poL_INSTLMT_PREM?: string | undefined;
    poL_TOT_INSTLMT?: string | undefined;
    poL_PAID_INSTLMT_NO?: string | undefined;
    poL_OS_PREM_BAL_AMT?: string | undefined;
}

export class ConfirmFinalizeModel implements IConfirmFinalizeModel {
    amountPaid?: number | undefined;
    debitNote?: string | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;
    accountNumber?: string | undefined;
    hash?: string | undefined;
    paymentRef?: string | undefined;
    paymentDetails?: any | undefined;
    isGtPay?: boolean | undefined;
    agentEmail?: string | undefined;

    constructor(data?: IConfirmFinalizeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amountPaid = _data["amountPaid"];
            this.debitNote = _data["debitNote"];
            this.transactionRef = _data["transactionRef"];
            this.partnerReference = _data["partnerReference"];
            this.accountNumber = _data["accountNumber"];
            this.hash = _data["hash"];
            this.paymentRef = _data["paymentRef"];
            this.paymentDetails = _data["paymentDetails"];
            this.isGtPay = _data["isGtPay"];
            this.agentEmail = _data["agentEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmFinalizeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmFinalizeModel>(data, _mappings, ConfirmFinalizeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPaid"] = this.amountPaid;
        data["debitNote"] = this.debitNote;
        data["transactionRef"] = this.transactionRef;
        data["partnerReference"] = this.partnerReference;
        data["accountNumber"] = this.accountNumber;
        data["hash"] = this.hash;
        data["paymentRef"] = this.paymentRef;
        data["paymentDetails"] = this.paymentDetails;
        data["isGtPay"] = this.isGtPay;
        data["agentEmail"] = this.agentEmail;
        return data;
    }
}

export interface IConfirmFinalizeModel {
    amountPaid?: number | undefined;
    debitNote?: string | undefined;
    transactionRef?: string | undefined;
    partnerReference?: string | undefined;
    accountNumber?: string | undefined;
    hash?: string | undefined;
    paymentRef?: string | undefined;
    paymentDetails?: any | undefined;
    isGtPay?: boolean | undefined;
    agentEmail?: string | undefined;
}

export class GadgetScheduleRequest implements IGadgetScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    premiumAmount?: number | undefined;
    gadgetAmount?: number | undefined;
    amount?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    deviceNumber?: string | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wet?: Date | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    isSuccessful?: boolean | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;

    constructor(data?: IGadgetScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.premiumAmount = _data["premiumAmount"];
            this.gadgetAmount = _data["gadgetAmount"];
            this.amount = _data["amount"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.deviceNumber = _data["deviceNumber"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.receiptUrl = _data["receiptUrl"];
            this.imageUrl = _data["imageUrl"];
            this.backImageUrl = _data["backImageUrl"];
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.branchId = _data["branchId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.clientId = _data["clientId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.isSuccessful = _data["isSuccessful"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
        }
    }

    static fromJS(data: any, _mappings?: any): GadgetScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GadgetScheduleRequest>(data, _mappings, GadgetScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["genderId"] = this.genderId;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["premiumAmount"] = this.premiumAmount;
        data["gadgetAmount"] = this.gadgetAmount;
        data["amount"] = this.amount;
        data["make"] = this.make;
        data["model"] = this.model;
        data["deviceNumber"] = this.deviceNumber;
        data["agentShortDescription"] = this.agentShortDescription;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["receiptUrl"] = this.receiptUrl;
        data["imageUrl"] = this.imageUrl;
        data["backImageUrl"] = this.backImageUrl;
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["branchId"] = this.branchId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["clientId"] = this.clientId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["isSuccessful"] = this.isSuccessful;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        return data;
    }
}

export interface IGadgetScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    premiumAmount?: number | undefined;
    gadgetAmount?: number | undefined;
    amount?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    deviceNumber?: string | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wet?: Date | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    isSuccessful?: boolean | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
}

export class ViewGadgetTransactionsViewModel implements IViewGadgetTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    gadgetAmount?: number | undefined;
    coverType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    durationOfCover?: number | undefined;
    premiumRate?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewGadgetTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.gadgetAmount = _data["gadgetAmount"];
            this.coverType = _data["coverType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.unit = _data["unit"];
            this.accountNumber = _data["accountNumber"];
            this.occupation = _data["occupation"];
            this.durationOfCover = _data["durationOfCover"];
            this.premiumRate = _data["premiumRate"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.receiptUrl = _data["receiptUrl"];
            this.imageUrl = _data["imageUrl"];
            this.backImageUrl = _data["backImageUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewGadgetTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewGadgetTransactionsViewModel>(data, _mappings, ViewGadgetTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentFrequency"] = this.paymentFrequency;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["gadgetAmount"] = this.gadgetAmount;
        data["coverType"] = this.coverType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["unit"] = this.unit;
        data["accountNumber"] = this.accountNumber;
        data["occupation"] = this.occupation;
        data["durationOfCover"] = this.durationOfCover;
        data["premiumRate"] = this.premiumRate;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["receiptUrl"] = this.receiptUrl;
        data["imageUrl"] = this.imageUrl;
        data["backImageUrl"] = this.backImageUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewGadgetTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    gadgetAmount?: number | undefined;
    coverType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    durationOfCover?: number | undefined;
    premiumRate?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class GadgetTransactionResponse implements IGadgetTransactionResponse {
    gadgetTransactionsViewModel?: ViewGadgetTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IGadgetTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.gadgetTransactionsViewModel = _data["gadgetTransactionsViewModel"] ? ViewGadgetTransactionsViewModel.fromJS(_data["gadgetTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): GadgetTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GadgetTransactionResponse>(data, _mappings, GadgetTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gadgetTransactionsViewModel"] = this.gadgetTransactionsViewModel ? this.gadgetTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IGadgetTransactionResponse {
    gadgetTransactionsViewModel?: ViewGadgetTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class CovidScheduleRequest implements ICovidScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    paymentFrequency?: string | undefined;
    unit?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isSuccessful?: boolean | undefined;

    constructor(data?: ICovidScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.unit = _data["unit"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.branchId = _data["branchId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any, _mappings?: any): CovidScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CovidScheduleRequest>(data, _mappings, CovidScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["genderId"] = this.genderId;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["paymentFrequency"] = this.paymentFrequency;
        data["unit"] = this.unit;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["agentShortDescription"] = this.agentShortDescription;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["branchId"] = this.branchId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface ICovidScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    paymentFrequency?: string | undefined;
    unit?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isSuccessful?: boolean | undefined;
}

export class ViewCovidTransactionsViewModel implements IViewCovidTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewCovidTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.unit = _data["unit"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewCovidTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewCovidTransactionsViewModel>(data, _mappings, ViewCovidTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentFrequency"] = this.paymentFrequency;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["unit"] = this.unit;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewCovidTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class CovidTransactionResponse implements ICovidTransactionResponse {
    covidTransactionsViewModel?: ViewCovidTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: ICovidTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.covidTransactionsViewModel = _data["covidTransactionsViewModel"] ? ViewCovidTransactionsViewModel.fromJS(_data["covidTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): CovidTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CovidTransactionResponse>(data, _mappings, CovidTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["covidTransactionsViewModel"] = this.covidTransactionsViewModel ? this.covidTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface ICovidTransactionResponse {
    covidTransactionsViewModel?: ViewCovidTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class HospitalCashScheduleRequest implements IHospitalCashScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    accountNumber?: number | undefined;
    bankName?: string | undefined;
    occupation?: string | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    paymentFrequency?: string | undefined;
    durationOfCover?: number | undefined;
    unit?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    premiumRate?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    marketer?: string | undefined;
    hospital?: string | undefined;
    maritalStatusId?: string | undefined;
    lgaId?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    referralCode?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    paystackPublicKey?: string | undefined;
    paystackSubaccount?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isSuccessful?: boolean | undefined;

    constructor(data?: IHospitalCashScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.accountNumber = _data["accountNumber"];
            this.bankName = _data["bankName"];
            this.occupation = _data["occupation"];
            this.genderId = _data["genderId"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.durationOfCover = _data["durationOfCover"];
            this.unit = _data["unit"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.premiumRate = _data["premiumRate"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.marketer = _data["marketer"];
            this.hospital = _data["hospital"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.lgaId = _data["lgaId"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.transactionRef = _data["transactionRef"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.referralCode = _data["referralCode"];
            this.branchId = _data["branchId"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any, _mappings?: any): HospitalCashScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HospitalCashScheduleRequest>(data, _mappings, HospitalCashScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["accountNumber"] = this.accountNumber;
        data["bankName"] = this.bankName;
        data["occupation"] = this.occupation;
        data["genderId"] = this.genderId;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["paymentFrequency"] = this.paymentFrequency;
        data["durationOfCover"] = this.durationOfCover;
        data["unit"] = this.unit;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["premiumRate"] = this.premiumRate;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["marketer"] = this.marketer;
        data["hospital"] = this.hospital;
        data["maritalStatusId"] = this.maritalStatusId;
        data["lgaId"] = this.lgaId;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["transactionRef"] = this.transactionRef;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["referralCode"] = this.referralCode;
        data["branchId"] = this.branchId;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IHospitalCashScheduleRequest {
    titleId?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: Date | undefined;
    accountNumber?: number | undefined;
    bankName?: string | undefined;
    occupation?: string | undefined;
    genderId?: string | undefined;
    address?: string | undefined;
    countryId?: string | undefined;
    paymentFrequency?: string | undefined;
    durationOfCover?: number | undefined;
    unit?: number | undefined;
    effectiveDate?: Date | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    premiumRate?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    marketer?: string | undefined;
    hospital?: string | undefined;
    maritalStatusId?: string | undefined;
    lgaId?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    transactionRef?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    referralCode?: string | undefined;
    branchId?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    isSuccessful?: boolean | undefined;
}

export class ViewHospitalCashTransactionsViewModel implements IViewHospitalCashTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    durationOfCover?: number | undefined;
    premiumRate?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;

    constructor(data?: IViewHospitalCashTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payee = _data["payee"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.policyNumber = _data["policyNumber"];
            this.unit = _data["unit"];
            this.accountNumber = _data["accountNumber"];
            this.occupation = _data["occupation"];
            this.durationOfCover = _data["durationOfCover"];
            this.premiumRate = _data["premiumRate"];
            this.description = _data["description"];
            this.policyDuration = _data["policyDuration"];
            this.rowCount = _data["rowCount"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.resellerLink = _data["resellerLink"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
            this.intermediaryName = _data["intermediaryName"];
            this.intermediaryResellerName = _data["intermediaryResellerName"];
            this.intermediaryId = _data["intermediaryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewHospitalCashTransactionsViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewHospitalCashTransactionsViewModel>(data, _mappings, ViewHospitalCashTransactionsViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payee"] = this.payee;
        data["paymentFrequency"] = this.paymentFrequency;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["policyNumber"] = this.policyNumber;
        data["unit"] = this.unit;
        data["accountNumber"] = this.accountNumber;
        data["occupation"] = this.occupation;
        data["durationOfCover"] = this.durationOfCover;
        data["premiumRate"] = this.premiumRate;
        data["description"] = this.description;
        data["policyDuration"] = this.policyDuration;
        data["rowCount"] = this.rowCount;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["resellerLink"] = this.resellerLink;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        data["intermediaryName"] = this.intermediaryName;
        data["intermediaryResellerName"] = this.intermediaryResellerName;
        data["intermediaryId"] = this.intermediaryId;
        return data;
    }
}

export interface IViewHospitalCashTransactionsViewModel {
    id?: string | undefined;
    payee?: string | undefined;
    paymentFrequency?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    unit?: number | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    durationOfCover?: number | undefined;
    premiumRate?: number | undefined;
    description?: string | undefined;
    policyDuration?: string | undefined;
    rowCount?: number | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    resellerLink?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
    intermediaryName?: string | undefined;
    intermediaryResellerName?: string | undefined;
    intermediaryId?: string | undefined;
}

export class HospitalCashTransactionResponse implements IHospitalCashTransactionResponse {
    hospitalCashTransactionsViewModel?: ViewHospitalCashTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;

    constructor(data?: IHospitalCashTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hospitalCashTransactionsViewModel = _data["hospitalCashTransactionsViewModel"] ? ViewHospitalCashTransactionsViewModel.fromJS(_data["hospitalCashTransactionsViewModel"], _mappings) : <any>undefined;
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): HospitalCashTransactionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HospitalCashTransactionResponse>(data, _mappings, HospitalCashTransactionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hospitalCashTransactionsViewModel"] = this.hospitalCashTransactionsViewModel ? this.hospitalCashTransactionsViewModel.toJSON() : <any>undefined;
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IHospitalCashTransactionResponse {
    hospitalCashTransactionsViewModel?: ViewHospitalCashTransactionsViewModel | undefined;
    paymentDetails?: any | undefined;
}

export class HomeScheduleRequestForMobile implements IHomeScheduleRequestForMobile {
    homeScheduleRequest?: HomeScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IHomeScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.homeScheduleRequest = _data["homeScheduleRequest"] ? HomeScheduleRequest.fromJS(_data["homeScheduleRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): HomeScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HomeScheduleRequestForMobile>(data, _mappings, HomeScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeScheduleRequest"] = this.homeScheduleRequest ? this.homeScheduleRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHomeScheduleRequestForMobile {
    homeScheduleRequest?: HomeScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class InitiatePaymentDto implements IInitiatePaymentDto {
    pbfPubKey?: string | undefined;
    cardno?: string | undefined;
    cvv?: string | undefined;
    expirymonth?: string | undefined;
    expiryyear?: string | undefined;
    currency?: string | undefined;
    country?: string | undefined;
    amount?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    ip?: string | undefined;
    txRef?: string | undefined;
    meta?: Meta[] | undefined;
    redirect_url?: string | undefined;
    device_fingerprint?: string | undefined;
    suggested_auth?: string | undefined;
    pin?: string | undefined;

    constructor(data?: IInitiatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.pbfPubKey = _data["pbfPubKey"];
            this.cardno = _data["cardno"];
            this.cvv = _data["cvv"];
            this.expirymonth = _data["expirymonth"];
            this.expiryyear = _data["expiryyear"];
            this.currency = _data["currency"];
            this.country = _data["country"];
            this.amount = _data["amount"];
            this.email = _data["email"];
            this.phonenumber = _data["phonenumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.ip = _data["ip"];
            this.txRef = _data["txRef"];
            if (Array.isArray(_data["meta"])) {
                this.meta = [] as any;
                for (let item of _data["meta"])
                    this.meta!.push(Meta.fromJS(item, _mappings));
            }
            this.redirect_url = _data["redirect_url"];
            this.device_fingerprint = _data["device_fingerprint"];
            this.suggested_auth = _data["suggested_auth"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any, _mappings?: any): InitiatePaymentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InitiatePaymentDto>(data, _mappings, InitiatePaymentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pbfPubKey"] = this.pbfPubKey;
        data["cardno"] = this.cardno;
        data["cvv"] = this.cvv;
        data["expirymonth"] = this.expirymonth;
        data["expiryyear"] = this.expiryyear;
        data["currency"] = this.currency;
        data["country"] = this.country;
        data["amount"] = this.amount;
        data["email"] = this.email;
        data["phonenumber"] = this.phonenumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["ip"] = this.ip;
        data["txRef"] = this.txRef;
        if (Array.isArray(this.meta)) {
            data["meta"] = [];
            for (let item of this.meta)
                data["meta"].push(item.toJSON());
        }
        data["redirect_url"] = this.redirect_url;
        data["device_fingerprint"] = this.device_fingerprint;
        data["suggested_auth"] = this.suggested_auth;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IInitiatePaymentDto {
    pbfPubKey?: string | undefined;
    cardno?: string | undefined;
    cvv?: string | undefined;
    expirymonth?: string | undefined;
    expiryyear?: string | undefined;
    currency?: string | undefined;
    country?: string | undefined;
    amount?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    ip?: string | undefined;
    txRef?: string | undefined;
    meta?: Meta[] | undefined;
    redirect_url?: string | undefined;
    device_fingerprint?: string | undefined;
    suggested_auth?: string | undefined;
    pin?: string | undefined;
}

export class Meta implements IMeta {
    metaname?: string | undefined;
    metavalue?: string | undefined;

    constructor(data?: IMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.metaname = _data["metaname"];
            this.metavalue = _data["metavalue"];
        }
    }

    static fromJS(data: any, _mappings?: any): Meta | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Meta>(data, _mappings, Meta);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaname"] = this.metaname;
        data["metavalue"] = this.metavalue;
        return data;
    }
}

export interface IMeta {
    metaname?: string | undefined;
    metavalue?: string | undefined;
}

export class Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: EncryptResponsePayload | undefined;
    readonly item2?: SuccessfulCardChargeResponse | undefined;
    readonly item3?: string | undefined;

    constructor(data?: ITuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? EncryptResponsePayload.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"] ? SuccessfulCardChargeResponse.fromJS(_data["item2"], _mappings) : <any>undefined;
            (<any>this).item3 = _data["item3"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3;
        return data;
    }
}

export interface ITuple_3OfOfEncryptResponsePayloadAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: EncryptResponsePayload | undefined;
    item2?: SuccessfulCardChargeResponse | undefined;
    item3?: string | undefined;
}

export class EncryptResponsePayload implements IEncryptResponsePayload {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data | undefined;

    constructor(data?: IEncryptResponsePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? Data.fromJS(_data["data"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): EncryptResponsePayload | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EncryptResponsePayload>(data, _mappings, EncryptResponsePayload);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEncryptResponsePayload {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data | undefined;
}

export class SuccessfulCardChargeResponse implements ISuccessfulCardChargeResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data2 | undefined;

    constructor(data?: ISuccessfulCardChargeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? Data2.fromJS(_data["data"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): SuccessfulCardChargeResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuccessfulCardChargeResponse>(data, _mappings, SuccessfulCardChargeResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISuccessfulCardChargeResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data2 | undefined;
}

export class Data implements IData {
    suggested_auth?: string | undefined;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.suggested_auth = _data["suggested_auth"];
        }
    }

    static fromJS(data: any, _mappings?: any): Data | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Data>(data, _mappings, Data);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggested_auth"] = this.suggested_auth;
        return data;
    }
}

export interface IData {
    suggested_auth?: string | undefined;
}

export class Data2 implements IData2 {
    id?: number | undefined;
    txRef?: string | undefined;
    orderRef?: string | undefined;
    flwRef?: string | undefined;
    redirectUrl?: string | undefined;
    device_fingerprint?: string | undefined;
    settlement_token?: any | undefined;
    cycle?: string | undefined;
    amount?: number | undefined;
    charged_amount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    merchantbearsfee?: number | undefined;
    chargeResponseCode?: string | undefined;
    raveRef?: string | undefined;
    chargeResponseMessage?: string | undefined;
    authModelUsed?: string | undefined;
    currency?: string | undefined;
    iP?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    modalauditid?: string | undefined;
    vbvrespmessage?: string | undefined;
    authurl?: string | undefined;
    vbvrespcode?: string | undefined;
    acctvalrespmsg?: any | undefined;
    acctvalrespcode?: any | undefined;
    paymentType?: string | undefined;
    paymentPlan?: any | undefined;
    paymentPage?: any | undefined;
    paymentId?: string | undefined;
    fraud_status?: string | undefined;
    charge_type?: string | undefined;
    is_live?: number | undefined;
    retry_attempt?: any | undefined;
    getpaidBatchId?: any | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: any | undefined;
    customerId?: number | undefined;
    accountId?: number | undefined;
    customer?: Customer | undefined;
    customercandosubsequentnoauth?: boolean | undefined;

    constructor(data?: IData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.txRef = _data["txRef"];
            this.orderRef = _data["orderRef"];
            this.flwRef = _data["flwRef"];
            this.redirectUrl = _data["redirectUrl"];
            this.device_fingerprint = _data["device_fingerprint"];
            this.settlement_token = _data["settlement_token"];
            this.cycle = _data["cycle"];
            this.amount = _data["amount"];
            this.charged_amount = _data["charged_amount"];
            this.appfee = _data["appfee"];
            this.merchantfee = _data["merchantfee"];
            this.merchantbearsfee = _data["merchantbearsfee"];
            this.chargeResponseCode = _data["chargeResponseCode"];
            this.raveRef = _data["raveRef"];
            this.chargeResponseMessage = _data["chargeResponseMessage"];
            this.authModelUsed = _data["authModelUsed"];
            this.currency = _data["currency"];
            this.iP = _data["IP"];
            this.narration = _data["narration"];
            this.status = _data["status"];
            this.modalauditid = _data["modalauditid"];
            this.vbvrespmessage = _data["vbvrespmessage"];
            this.authurl = _data["authurl"];
            this.vbvrespcode = _data["vbvrespcode"];
            this.acctvalrespmsg = _data["acctvalrespmsg"];
            this.acctvalrespcode = _data["acctvalrespcode"];
            this.paymentType = _data["paymentType"];
            this.paymentPlan = _data["paymentPlan"];
            this.paymentPage = _data["paymentPage"];
            this.paymentId = _data["paymentId"];
            this.fraud_status = _data["fraud_status"];
            this.charge_type = _data["charge_type"];
            this.is_live = _data["is_live"];
            this.retry_attempt = _data["retry_attempt"];
            this.getpaidBatchId = _data["getpaidBatchId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"];
            this.customerId = _data["customerId"];
            this.accountId = _data["AccountId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"], _mappings) : <any>undefined;
            this.customercandosubsequentnoauth = _data["customercandosubsequentnoauth"];
        }
    }

    static fromJS(data: any, _mappings?: any): Data2 | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Data2>(data, _mappings, Data2);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["txRef"] = this.txRef;
        data["orderRef"] = this.orderRef;
        data["flwRef"] = this.flwRef;
        data["redirectUrl"] = this.redirectUrl;
        data["device_fingerprint"] = this.device_fingerprint;
        data["settlement_token"] = this.settlement_token;
        data["cycle"] = this.cycle;
        data["amount"] = this.amount;
        data["charged_amount"] = this.charged_amount;
        data["appfee"] = this.appfee;
        data["merchantfee"] = this.merchantfee;
        data["merchantbearsfee"] = this.merchantbearsfee;
        data["chargeResponseCode"] = this.chargeResponseCode;
        data["raveRef"] = this.raveRef;
        data["chargeResponseMessage"] = this.chargeResponseMessage;
        data["authModelUsed"] = this.authModelUsed;
        data["currency"] = this.currency;
        data["IP"] = this.iP;
        data["narration"] = this.narration;
        data["status"] = this.status;
        data["modalauditid"] = this.modalauditid;
        data["vbvrespmessage"] = this.vbvrespmessage;
        data["authurl"] = this.authurl;
        data["vbvrespcode"] = this.vbvrespcode;
        data["acctvalrespmsg"] = this.acctvalrespmsg;
        data["acctvalrespcode"] = this.acctvalrespcode;
        data["paymentType"] = this.paymentType;
        data["paymentPlan"] = this.paymentPlan;
        data["paymentPage"] = this.paymentPage;
        data["paymentId"] = this.paymentId;
        data["fraud_status"] = this.fraud_status;
        data["charge_type"] = this.charge_type;
        data["is_live"] = this.is_live;
        data["retry_attempt"] = this.retry_attempt;
        data["getpaidBatchId"] = this.getpaidBatchId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt;
        data["customerId"] = this.customerId;
        data["AccountId"] = this.accountId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customercandosubsequentnoauth"] = this.customercandosubsequentnoauth;
        return data;
    }
}

export interface IData2 {
    id?: number | undefined;
    txRef?: string | undefined;
    orderRef?: string | undefined;
    flwRef?: string | undefined;
    redirectUrl?: string | undefined;
    device_fingerprint?: string | undefined;
    settlement_token?: any | undefined;
    cycle?: string | undefined;
    amount?: number | undefined;
    charged_amount?: number | undefined;
    appfee?: number | undefined;
    merchantfee?: number | undefined;
    merchantbearsfee?: number | undefined;
    chargeResponseCode?: string | undefined;
    raveRef?: string | undefined;
    chargeResponseMessage?: string | undefined;
    authModelUsed?: string | undefined;
    currency?: string | undefined;
    iP?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    modalauditid?: string | undefined;
    vbvrespmessage?: string | undefined;
    authurl?: string | undefined;
    vbvrespcode?: string | undefined;
    acctvalrespmsg?: any | undefined;
    acctvalrespcode?: any | undefined;
    paymentType?: string | undefined;
    paymentPlan?: any | undefined;
    paymentPage?: any | undefined;
    paymentId?: string | undefined;
    fraud_status?: string | undefined;
    charge_type?: string | undefined;
    is_live?: number | undefined;
    retry_attempt?: any | undefined;
    getpaidBatchId?: any | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: any | undefined;
    customerId?: number | undefined;
    accountId?: number | undefined;
    customer?: Customer | undefined;
    customercandosubsequentnoauth?: boolean | undefined;
}

export class Customer implements ICustomer {
    id?: number | undefined;
    phone?: string | undefined;
    fullName?: string | undefined;
    customertoken?: any | undefined;
    email?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: any | undefined;
    accountId?: number | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phone = _data["phone"];
            this.fullName = _data["fullName"];
            this.customertoken = _data["customertoken"];
            this.email = _data["email"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.deletedAt = _data["deletedAt"];
            this.accountId = _data["AccountId"];
        }
    }

    static fromJS(data: any, _mappings?: any): Customer | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Customer>(data, _mappings, Customer);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        data["customertoken"] = this.customertoken;
        data["email"] = this.email;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["deletedAt"] = this.deletedAt;
        data["AccountId"] = this.accountId;
        return data;
    }
}

export interface ICustomer {
    id?: number | undefined;
    phone?: string | undefined;
    fullName?: string | undefined;
    customertoken?: any | undefined;
    email?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: any | undefined;
    accountId?: number | undefined;
}

export class CreateIntermediaryDto implements ICreateIntermediaryDto {
    id?: string | undefined;
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;

    constructor(data?: ICreateIntermediaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : <any>undefined;
            this.userId = _data["userId"];
            this.physicalAddress = _data["physicalAddress"];
            this.fullName = _data["fullName"];
            this.agentType = _data["agentType"];
            this.tqSysCode = _data["tqSysCode"];
            this.accountType = _data["accountType"];
            this.agentCode = _data["agentCode"];
            this.tel1 = _data["tel1"];
            this.email = _data["email"];
            this.creditLimit = _data["creditLimit"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.referralCode = _data["referralCode"];
            this.walletBalance = _data["walletBalance"];
            this.commissionBalance = _data["commissionBalance"];
            this.resellerLink = _data["resellerLink"];
            if (Array.isArray(_data["productCommissions"])) {
                this.productCommissions = [] as any;
                for (let item of _data["productCommissions"])
                    this.productCommissions!.push(IntermediaryProductCommission.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateIntermediaryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateIntermediaryDto>(data, _mappings, CreateIntermediaryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["physicalAddress"] = this.physicalAddress;
        data["fullName"] = this.fullName;
        data["agentType"] = this.agentType;
        data["tqSysCode"] = this.tqSysCode;
        data["accountType"] = this.accountType;
        data["agentCode"] = this.agentCode;
        data["tel1"] = this.tel1;
        data["email"] = this.email;
        data["creditLimit"] = this.creditLimit;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["walletBalance"] = this.walletBalance;
        data["commissionBalance"] = this.commissionBalance;
        data["resellerLink"] = this.resellerLink;
        if (Array.isArray(this.productCommissions)) {
            data["productCommissions"] = [];
            for (let item of this.productCommissions)
                data["productCommissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateIntermediaryDto {
    id?: string | undefined;
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;
}

export class MessageOut implements IMessageOut {
    message?: string | undefined;
    title?: string | undefined;
    success?: boolean | undefined;
    failed?: boolean | undefined;

    constructor(data?: IMessageOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.message = _data["message"];
            this.title = _data["title"];
            this.success = _data["success"];
            this.failed = _data["failed"];
        }
    }

    static fromJS(data: any, _mappings?: any): MessageOut | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MessageOut>(data, _mappings, MessageOut);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["title"] = this.title;
        data["success"] = this.success;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IMessageOut {
    message?: string | undefined;
    title?: string | undefined;
    success?: boolean | undefined;
    failed?: boolean | undefined;
}

export class IntermediaryDto implements IIntermediaryDto {
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;
    id?: string | undefined;

    constructor(data?: IIntermediaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : <any>undefined;
            this.userId = _data["userId"];
            this.physicalAddress = _data["physicalAddress"];
            this.fullName = _data["fullName"];
            this.agentType = _data["agentType"];
            this.tqSysCode = _data["tqSysCode"];
            this.accountType = _data["accountType"];
            this.agentCode = _data["agentCode"];
            this.tel1 = _data["tel1"];
            this.email = _data["email"];
            this.creditLimit = _data["creditLimit"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.referralCode = _data["referralCode"];
            this.walletBalance = _data["walletBalance"];
            this.commissionBalance = _data["commissionBalance"];
            this.resellerLink = _data["resellerLink"];
            if (Array.isArray(_data["productCommissions"])) {
                this.productCommissions = [] as any;
                for (let item of _data["productCommissions"])
                    this.productCommissions!.push(IntermediaryProductCommission.fromJS(item, _mappings));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryDto>(data, _mappings, IntermediaryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["physicalAddress"] = this.physicalAddress;
        data["fullName"] = this.fullName;
        data["agentType"] = this.agentType;
        data["tqSysCode"] = this.tqSysCode;
        data["accountType"] = this.accountType;
        data["agentCode"] = this.agentCode;
        data["tel1"] = this.tel1;
        data["email"] = this.email;
        data["creditLimit"] = this.creditLimit;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["walletBalance"] = this.walletBalance;
        data["commissionBalance"] = this.commissionBalance;
        data["resellerLink"] = this.resellerLink;
        if (Array.isArray(this.productCommissions)) {
            data["productCommissions"] = [];
            for (let item of this.productCommissions)
                data["productCommissions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IIntermediaryDto {
    user?: User | undefined;
    userId?: number | undefined;
    physicalAddress?: string | undefined;
    fullName?: string | undefined;
    agentType?: string | undefined;
    tqSysCode?: string | undefined;
    accountType?: string | undefined;
    agentCode?: string | undefined;
    tel1?: string | undefined;
    email?: string | undefined;
    creditLimit?: number | undefined;
    isActive?: boolean | undefined;
    createdDate?: Date | undefined;
    referralCode?: string | undefined;
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
    resellerLink?: string | undefined;
    productCommissions?: IntermediaryProductCommission[] | undefined;
    id?: string | undefined;
}

export class IntermediaryWalletModel implements IIntermediaryWalletModel {
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;

    constructor(data?: IIntermediaryWalletModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.walletBalance = _data["walletBalance"];
            this.commissionBalance = _data["commissionBalance"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryWalletModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryWalletModel>(data, _mappings, IntermediaryWalletModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletBalance"] = this.walletBalance;
        data["commissionBalance"] = this.commissionBalance;
        return data;
    }
}

export interface IIntermediaryWalletModel {
    walletBalance?: number | undefined;
    commissionBalance?: number | undefined;
}

export class AgentVerificationLinkModel implements IAgentVerificationLinkModel {
    user?: User | undefined;
    resellerLink?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IAgentVerificationLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : <any>undefined;
            this.resellerLink = _data["resellerLink"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AgentVerificationLinkModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentVerificationLinkModel>(data, _mappings, AgentVerificationLinkModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["resellerLink"] = this.resellerLink;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IAgentVerificationLinkModel {
    user?: User | undefined;
    resellerLink?: string | undefined;
    roles?: string[] | undefined;
}

export class IntermediaryTypeDto implements IIntermediaryTypeDto {
    name?: string | undefined;
    desc?: string | undefined;
    wthTaxRate?: number | undefined;
    commRate?: number | undefined;
    serialFormat?: string | undefined;
    id?: string | undefined;

    constructor(data?: IIntermediaryTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.desc = _data["desc"];
            this.wthTaxRate = _data["wthTaxRate"];
            this.commRate = _data["commRate"];
            this.serialFormat = _data["serialFormat"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryTypeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryTypeDto>(data, _mappings, IntermediaryTypeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["desc"] = this.desc;
        data["wthTaxRate"] = this.wthTaxRate;
        data["commRate"] = this.commRate;
        data["serialFormat"] = this.serialFormat;
        data["id"] = this.id;
        return data;
    }
}

export interface IIntermediaryTypeDto {
    name?: string | undefined;
    desc?: string | undefined;
    wthTaxRate?: number | undefined;
    commRate?: number | undefined;
    serialFormat?: string | undefined;
    id?: string | undefined;
}

export class TitleDto implements ITitleDto {
    titleName?: string | undefined;
    id?: string | undefined;

    constructor(data?: ITitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.titleName = _data["titleName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): TitleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TitleDto>(data, _mappings, TitleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleName"] = this.titleName;
        data["id"] = this.id;
        return data;
    }
}

export interface ITitleDto {
    titleName?: string | undefined;
    id?: string | undefined;
}

export class IntermediaryDetailsModel implements IIntermediaryDetailsModel {
    intermediaryFullName?: string | undefined;
    intermediaryCode?: string | undefined;

    constructor(data?: IIntermediaryDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.intermediaryFullName = _data["intermediaryFullName"];
            this.intermediaryCode = _data["intermediaryCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryDetailsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryDetailsModel>(data, _mappings, IntermediaryDetailsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediaryFullName"] = this.intermediaryFullName;
        data["intermediaryCode"] = this.intermediaryCode;
        return data;
    }
}

export interface IIntermediaryDetailsModel {
    intermediaryFullName?: string | undefined;
    intermediaryCode?: string | undefined;
}

export class IntermediaryTransactionModelNew implements IIntermediaryTransactionModelNew {
    intermediaryId?: string | undefined;
    transactionRef?: string | undefined;
    transactionType?: string | undefined;
    paymentChannel?: string | undefined;
    amount?: number | undefined;

    constructor(data?: IIntermediaryTransactionModelNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.intermediaryId = _data["intermediaryId"];
            this.transactionRef = _data["transactionRef"];
            this.transactionType = _data["transactionType"];
            this.paymentChannel = _data["paymentChannel"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryTransactionModelNew | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryTransactionModelNew>(data, _mappings, IntermediaryTransactionModelNew);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediaryId"] = this.intermediaryId;
        data["transactionRef"] = this.transactionRef;
        data["transactionType"] = this.transactionType;
        data["paymentChannel"] = this.paymentChannel;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIntermediaryTransactionModelNew {
    intermediaryId?: string | undefined;
    transactionRef?: string | undefined;
    transactionType?: string | undefined;
    paymentChannel?: string | undefined;
    amount?: number | undefined;
}

export class Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: IntermediaryTransactionResponseModel | undefined;
    readonly item2?: string | undefined;

    constructor(data?: ITuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? IntermediaryTransactionResponseModel.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfOfIntermediaryTransactionResponseModelAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: IntermediaryTransactionResponseModel | undefined;
    item2?: string | undefined;
}

export class IntermediaryTransactionResponseModel implements IIntermediaryTransactionResponseModel {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transactionDate?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    amount?: string | undefined;
    customerName?: string | undefined;
    transStatus?: string | undefined;
    transMessage?: string | undefined;
    currency?: string | undefined;
    isSuccessful?: boolean | undefined;
    intermediaryLedger?: IntermediaryLedger | undefined;

    constructor(data?: IIntermediaryTransactionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseDesc = _data["responseDesc"];
            this.transactionDate = _data["transactionDate"];
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.amount = _data["amount"];
            this.customerName = _data["customerName"];
            this.transStatus = _data["transStatus"];
            this.transMessage = _data["transMessage"];
            this.currency = _data["currency"];
            this.isSuccessful = _data["isSuccessful"];
            this.intermediaryLedger = _data["intermediaryLedger"] ? IntermediaryLedger.fromJS(_data["intermediaryLedger"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryTransactionResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryTransactionResponseModel>(data, _mappings, IntermediaryTransactionResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseDesc"] = this.responseDesc;
        data["transactionDate"] = this.transactionDate;
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["amount"] = this.amount;
        data["customerName"] = this.customerName;
        data["transStatus"] = this.transStatus;
        data["transMessage"] = this.transMessage;
        data["currency"] = this.currency;
        data["isSuccessful"] = this.isSuccessful;
        data["intermediaryLedger"] = this.intermediaryLedger ? this.intermediaryLedger.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIntermediaryTransactionResponseModel {
    responseCode?: string | undefined;
    responseDesc?: string | undefined;
    transactionDate?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    amount?: string | undefined;
    customerName?: string | undefined;
    transStatus?: string | undefined;
    transMessage?: string | undefined;
    currency?: string | undefined;
    isSuccessful?: boolean | undefined;
    intermediaryLedger?: IntermediaryLedger | undefined;
}

export class IntermediaryTransactionModel implements IIntermediaryTransactionModel {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    narration?: string | undefined;
    paymentMode?: string | undefined;
    transactionType?: string | undefined;
    transactionRef?: string | undefined;
    crossReference?: string | undefined;
    credit?: number | undefined;
    debit?: number | undefined;

    constructor(data?: IIntermediaryTransactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.narration = _data["narration"];
            this.paymentMode = _data["paymentMode"];
            this.transactionType = _data["transactionType"];
            this.transactionRef = _data["transactionRef"];
            this.crossReference = _data["crossReference"];
            this.credit = _data["credit"];
            this.debit = _data["debit"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntermediaryTransactionModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntermediaryTransactionModel>(data, _mappings, IntermediaryTransactionModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["narration"] = this.narration;
        data["paymentMode"] = this.paymentMode;
        data["transactionType"] = this.transactionType;
        data["transactionRef"] = this.transactionRef;
        data["crossReference"] = this.crossReference;
        data["credit"] = this.credit;
        data["debit"] = this.debit;
        return data;
    }
}

export interface IIntermediaryTransactionModel {
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    narration?: string | undefined;
    paymentMode?: string | undefined;
    transactionType?: string | undefined;
    transactionRef?: string | undefined;
    crossReference?: string | undefined;
    credit?: number | undefined;
    debit?: number | undefined;
}

export class Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: boolean | undefined;
    readonly item2?: string | undefined;

    constructor(data?: ITuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"];
            (<any>this).item2 = _data["item2"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfOfBooleanAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: boolean | undefined;
    item2?: string | undefined;
}

export class CheckCommissionStatusByPolicyByDateDto implements ICheckCommissionStatusByPolicyByDateDto {
    month?: string | undefined;
    year?: string | undefined;
    agentCode?: string | undefined;
    policyNo?: string | undefined;

    constructor(data?: ICheckCommissionStatusByPolicyByDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.agentCode = _data["agentCode"];
            this.policyNo = _data["policyNo"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckCommissionStatusByPolicyByDateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckCommissionStatusByPolicyByDateDto>(data, _mappings, CheckCommissionStatusByPolicyByDateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["agentCode"] = this.agentCode;
        data["policyNo"] = this.policyNo;
        return data;
    }
}

export interface ICheckCommissionStatusByPolicyByDateDto {
    month?: string | undefined;
    year?: string | undefined;
    agentCode?: string | undefined;
    policyNo?: string | undefined;
}

export class AgentCommissionResponses implements IAgentCommissionResponses {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentCommissionModels?: AgentCommissionModel[] | undefined;

    constructor(data?: IAgentCommissionResponses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["agentCommissionModels"])) {
                this.agentCommissionModels = [] as any;
                for (let item of _data["agentCommissionModels"])
                    this.agentCommissionModels!.push(AgentCommissionModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AgentCommissionResponses | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentCommissionResponses>(data, _mappings, AgentCommissionResponses);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.agentCommissionModels)) {
            data["agentCommissionModels"] = [];
            for (let item of this.agentCommissionModels)
                data["agentCommissionModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentCommissionResponses {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentCommissionModels?: AgentCommissionModel[] | undefined;
}

export class AgentCommissionModel implements IAgentCommissionModel {
    agentName?: string | undefined;
    policyNo?: string | undefined;
    receiptDate?: string | undefined;
    receiptNo?: string | undefined;
    paymentStatus?: string | undefined;
    pensContributionAllocation?: string | undefined;
    lifeAllocation?: string | undefined;
    policyStatus?: string | undefined;
    oprAmount?: string | undefined;
    rate?: string | undefined;
    agentCommission?: string | undefined;
    unitMgrOverrideRate?: string | undefined;
    unitMgrOverrideAmount?: string | undefined;
    agencyMgrOverrideRate?: string | undefined;
    agencyMgrOverrideAmount?: string | undefined;
    agnCode?: string | undefined;
    premiumWhen?: string | undefined;
    agentstatus?: string | undefined;
    receiptCount?: string | undefined;
    agency?: string | undefined;
    agencyName?: string | undefined;
    unit?: string | undefined;
    unitName?: string | undefined;
    readonly agentCommissionRate?: string | undefined;
    readonly policyMonths?: string | undefined;
    readonly policyHolder?: string | undefined;
    readonly modalPremium?: string | undefined;
    readonly creditAmount?: string | undefined;
    readonly debitAmount?: string | undefined;
    readonly rates?: string | undefined;
    readonly grossCommission?: string | undefined;
    readonly agentNPF?: string | undefined;
    readonly monthTax?: string | undefined;
    readonly netPayable?: string | undefined;

    constructor(data?: IAgentCommissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agentName = _data["agentName"];
            this.policyNo = _data["policyNo"];
            this.receiptDate = _data["receiptDate"];
            this.receiptNo = _data["receiptNo"];
            this.paymentStatus = _data["paymentStatus"];
            this.pensContributionAllocation = _data["pensContributionAllocation"];
            this.lifeAllocation = _data["lifeAllocation"];
            this.policyStatus = _data["policyStatus"];
            this.oprAmount = _data["oprAmount"];
            this.rate = _data["rate"];
            this.agentCommission = _data["agentCommission"];
            this.unitMgrOverrideRate = _data["unitMgrOverrideRate"];
            this.unitMgrOverrideAmount = _data["unitMgrOverrideAmount"];
            this.agencyMgrOverrideRate = _data["agencyMgrOverrideRate"];
            this.agencyMgrOverrideAmount = _data["agencyMgrOverrideAmount"];
            this.agnCode = _data["agnCode"];
            this.premiumWhen = _data["premiumWhen"];
            this.agentstatus = _data["agentstatus"];
            this.receiptCount = _data["receiptCount"];
            this.agency = _data["agency"];
            this.agencyName = _data["agencyName"];
            this.unit = _data["unit"];
            this.unitName = _data["unitName"];
            (<any>this).agentCommissionRate = _data["agentCommissionRate"];
            (<any>this).policyMonths = _data["policyMonths"];
            (<any>this).policyHolder = _data["policyHolder"];
            (<any>this).modalPremium = _data["modalPremium"];
            (<any>this).creditAmount = _data["creditAmount"];
            (<any>this).debitAmount = _data["debitAmount"];
            (<any>this).rates = _data["rates"];
            (<any>this).grossCommission = _data["grossCommission"];
            (<any>this).agentNPF = _data["agentNPF"];
            (<any>this).monthTax = _data["monthTax"];
            (<any>this).netPayable = _data["netPayable"];
        }
    }

    static fromJS(data: any, _mappings?: any): AgentCommissionModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentCommissionModel>(data, _mappings, AgentCommissionModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentName"] = this.agentName;
        data["policyNo"] = this.policyNo;
        data["receiptDate"] = this.receiptDate;
        data["receiptNo"] = this.receiptNo;
        data["paymentStatus"] = this.paymentStatus;
        data["pensContributionAllocation"] = this.pensContributionAllocation;
        data["lifeAllocation"] = this.lifeAllocation;
        data["policyStatus"] = this.policyStatus;
        data["oprAmount"] = this.oprAmount;
        data["rate"] = this.rate;
        data["agentCommission"] = this.agentCommission;
        data["unitMgrOverrideRate"] = this.unitMgrOverrideRate;
        data["unitMgrOverrideAmount"] = this.unitMgrOverrideAmount;
        data["agencyMgrOverrideRate"] = this.agencyMgrOverrideRate;
        data["agencyMgrOverrideAmount"] = this.agencyMgrOverrideAmount;
        data["agnCode"] = this.agnCode;
        data["premiumWhen"] = this.premiumWhen;
        data["agentstatus"] = this.agentstatus;
        data["receiptCount"] = this.receiptCount;
        data["agency"] = this.agency;
        data["agencyName"] = this.agencyName;
        data["unit"] = this.unit;
        data["unitName"] = this.unitName;
        data["agentCommissionRate"] = this.agentCommissionRate;
        data["policyMonths"] = this.policyMonths;
        data["policyHolder"] = this.policyHolder;
        data["modalPremium"] = this.modalPremium;
        data["creditAmount"] = this.creditAmount;
        data["debitAmount"] = this.debitAmount;
        data["rates"] = this.rates;
        data["grossCommission"] = this.grossCommission;
        data["agentNPF"] = this.agentNPF;
        data["monthTax"] = this.monthTax;
        data["netPayable"] = this.netPayable;
        return data;
    }
}

export interface IAgentCommissionModel {
    agentName?: string | undefined;
    policyNo?: string | undefined;
    receiptDate?: string | undefined;
    receiptNo?: string | undefined;
    paymentStatus?: string | undefined;
    pensContributionAllocation?: string | undefined;
    lifeAllocation?: string | undefined;
    policyStatus?: string | undefined;
    oprAmount?: string | undefined;
    rate?: string | undefined;
    agentCommission?: string | undefined;
    unitMgrOverrideRate?: string | undefined;
    unitMgrOverrideAmount?: string | undefined;
    agencyMgrOverrideRate?: string | undefined;
    agencyMgrOverrideAmount?: string | undefined;
    agnCode?: string | undefined;
    premiumWhen?: string | undefined;
    agentstatus?: string | undefined;
    receiptCount?: string | undefined;
    agency?: string | undefined;
    agencyName?: string | undefined;
    unit?: string | undefined;
    unitName?: string | undefined;
    agentCommissionRate?: string | undefined;
    policyMonths?: string | undefined;
    policyHolder?: string | undefined;
    modalPremium?: string | undefined;
    creditAmount?: string | undefined;
    debitAmount?: string | undefined;
    rates?: string | undefined;
    grossCommission?: string | undefined;
    agentNPF?: string | undefined;
    monthTax?: string | undefined;
    netPayable?: string | undefined;
}

export class AgentProfillingDetailCader implements IAgentProfillingDetailCader {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentDetailByEmails?: AgentDetailByEmailModel[] | undefined;

    constructor(data?: IAgentProfillingDetailCader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            if (Array.isArray(_data["agentDetailByEmails"])) {
                this.agentDetailByEmails = [] as any;
                for (let item of _data["agentDetailByEmails"])
                    this.agentDetailByEmails!.push(AgentDetailByEmailModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AgentProfillingDetailCader | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AgentProfillingDetailCader>(data, _mappings, AgentProfillingDetailCader);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        if (Array.isArray(this.agentDetailByEmails)) {
            data["agentDetailByEmails"] = [];
            for (let item of this.agentDetailByEmails)
                data["agentDetailByEmails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentProfillingDetailCader {
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    agentDetailByEmails?: AgentDetailByEmailModel[] | undefined;
}

export class ChangePasswordWithOtp implements IChangePasswordWithOtp {
    userId?: string | undefined;
    username?: string | undefined;
    otpNumber?: string | undefined;
    password?: string | undefined;

    constructor(data?: IChangePasswordWithOtp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.otpNumber = _data["otpNumber"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangePasswordWithOtp | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangePasswordWithOtp>(data, _mappings, ChangePasswordWithOtp);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["otpNumber"] = this.otpNumber;
        data["password"] = this.password;
        return data;
    }
}

export interface IChangePasswordWithOtp {
    userId?: string | undefined;
    username?: string | undefined;
    otpNumber?: string | undefined;
    password?: string | undefined;
}

export class PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: IntermediaryDto[] | undefined;

    constructor(data?: IPagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntermediaryDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, PagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDto_1OfOfIntermediaryDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: IntermediaryDto[] | undefined;
}

export class SelectListItem implements ISelectListItem {
    disabled?: boolean | undefined;
    group?: SelectListGroup | undefined;
    selected?: boolean | undefined;
    text?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.group = _data["group"] ? SelectListGroup.fromJS(_data["group"], _mappings) : <any>undefined;
            this.selected = _data["selected"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): SelectListItem | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SelectListItem>(data, _mappings, SelectListItem);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["selected"] = this.selected;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }
}

export interface ISelectListItem {
    disabled?: boolean | undefined;
    group?: SelectListGroup | undefined;
    selected?: boolean | undefined;
    text?: string | undefined;
    value?: string | undefined;
}

export class SelectListGroup implements ISelectListGroup {
    disabled?: boolean | undefined;
    name?: string | undefined;

    constructor(data?: ISelectListGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): SelectListGroup | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SelectListGroup>(data, _mappings, SelectListGroup);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["name"] = this.name;
        return data;
    }
}

export interface ISelectListGroup {
    disabled?: boolean | undefined;
    name?: string | undefined;
}

export class NameValueModelList implements INameValueModelList {
    loanList?: NameValueModelNew[] | undefined;
    isSuccessful?: boolean | undefined;

    constructor(data?: INameValueModelList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["loanList"])) {
                this.loanList = [] as any;
                for (let item of _data["loanList"])
                    this.loanList!.push(NameValueModelNew.fromJS(item, _mappings));
            }
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueModelList | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueModelList>(data, _mappings, NameValueModelList);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loanList)) {
            data["loanList"] = [];
            for (let item of this.loanList)
                data["loanList"].push(item.toJSON());
        }
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface INameValueModelList {
    loanList?: NameValueModelNew[] | undefined;
    isSuccessful?: boolean | undefined;
}

export class NameValueModelNew implements INameValueModelNew {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: INameValueModelNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueModelNew | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueModelNew>(data, _mappings, NameValueModelNew);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INameValueModelNew {
    id?: string | undefined;
    name?: string | undefined;
}

export class LifePolicyDetails implements ILifePolicyDetails {
    isSuccessful?: boolean | undefined;
    productName?: string | undefined;
    policyStatus?: string | undefined;
    policyNumber?: string | undefined;
    policyShortDescription?: string | undefined;
    term?: string | undefined;
    policyTypeNo?: string | undefined;
    effectiveDate?: string | undefined;
    paidToDate?: string | undefined;
    maturityDate?: string | undefined;
    premium?: string | undefined;
    paymentFrequency?: string | undefined;
    outStandingPremium?: string | undefined;

    constructor(data?: ILifePolicyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.productName = _data["productName"];
            this.policyStatus = _data["policyStatus"];
            this.policyNumber = _data["policyNumber"];
            this.policyShortDescription = _data["policyShortDescription"];
            this.term = _data["term"];
            this.policyTypeNo = _data["policyTypeNo"];
            this.effectiveDate = _data["effectiveDate"];
            this.paidToDate = _data["paidToDate"];
            this.maturityDate = _data["maturityDate"];
            this.premium = _data["premium"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.outStandingPremium = _data["outStandingPremium"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifePolicyDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifePolicyDetails>(data, _mappings, LifePolicyDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["productName"] = this.productName;
        data["policyStatus"] = this.policyStatus;
        data["policyNumber"] = this.policyNumber;
        data["policyShortDescription"] = this.policyShortDescription;
        data["term"] = this.term;
        data["policyTypeNo"] = this.policyTypeNo;
        data["effectiveDate"] = this.effectiveDate;
        data["paidToDate"] = this.paidToDate;
        data["maturityDate"] = this.maturityDate;
        data["premium"] = this.premium;
        data["paymentFrequency"] = this.paymentFrequency;
        data["outStandingPremium"] = this.outStandingPremium;
        return data;
    }
}

export interface ILifePolicyDetails {
    isSuccessful?: boolean | undefined;
    productName?: string | undefined;
    policyStatus?: string | undefined;
    policyNumber?: string | undefined;
    policyShortDescription?: string | undefined;
    term?: string | undefined;
    policyTypeNo?: string | undefined;
    effectiveDate?: string | undefined;
    paidToDate?: string | undefined;
    maturityDate?: string | undefined;
    premium?: string | undefined;
    paymentFrequency?: string | undefined;
    outStandingPremium?: string | undefined;
}

export class RemittaDirectDebitMandateDto implements IRemittaDirectDebitMandateDto {
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    policyNumber?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    isMandateActive?: boolean | undefined;
    remitaTransRef?: string | undefined;
    id?: string | undefined;

    constructor(data?: IRemittaDirectDebitMandateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.hash = _data["hash"];
            this.payerName = _data["payerName"];
            this.payerEmail = _data["payerEmail"];
            this.payerPhone = _data["payerPhone"];
            this.payerBankCode = _data["payerBankCode"];
            this.policyNumber = _data["policyNumber"];
            this.payerAccount = _data["payerAccount"];
            this.requestId = _data["requestId"];
            this.amount = _data["amount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.mandateType = _data["mandateType"];
            this.frequency = _data["frequency"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.mandateId = _data["mandateId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.isMandateActive = _data["isMandateActive"];
            this.remitaTransRef = _data["remitaTransRef"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): RemittaDirectDebitMandateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemittaDirectDebitMandateDto>(data, _mappings, RemittaDirectDebitMandateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["hash"] = this.hash;
        data["payerName"] = this.payerName;
        data["payerEmail"] = this.payerEmail;
        data["payerPhone"] = this.payerPhone;
        data["payerBankCode"] = this.payerBankCode;
        data["policyNumber"] = this.policyNumber;
        data["payerAccount"] = this.payerAccount;
        data["requestId"] = this.requestId;
        data["amount"] = this.amount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["mandateType"] = this.mandateType;
        data["frequency"] = this.frequency;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["mandateId"] = this.mandateId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["isMandateActive"] = this.isMandateActive;
        data["remitaTransRef"] = this.remitaTransRef;
        data["id"] = this.id;
        return data;
    }
}

export interface IRemittaDirectDebitMandateDto {
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    policyNumber?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    isMandateActive?: boolean | undefined;
    remitaTransRef?: string | undefined;
    id?: string | undefined;
}

export class ViewDirectDebitMandateViewModel implements IViewDirectDebitMandateViewModel {
    id?: string | undefined;
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    policyNumber?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    isMandateActive?: boolean | undefined;
    remitaTransRef?: string | undefined;
    rowCount?: number | undefined;

    constructor(data?: IViewDirectDebitMandateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.hash = _data["hash"];
            this.payerName = _data["payerName"];
            this.payerEmail = _data["payerEmail"];
            this.payerPhone = _data["payerPhone"];
            this.payerBankCode = _data["payerBankCode"];
            this.policyNumber = _data["policyNumber"];
            this.payerAccount = _data["payerAccount"];
            this.requestId = _data["requestId"];
            this.amount = _data["amount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.mandateType = _data["mandateType"];
            this.frequency = _data["frequency"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.mandateId = _data["mandateId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.isMandateActive = _data["isMandateActive"];
            this.remitaTransRef = _data["remitaTransRef"];
            this.rowCount = _data["rowCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ViewDirectDebitMandateViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ViewDirectDebitMandateViewModel>(data, _mappings, ViewDirectDebitMandateViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["hash"] = this.hash;
        data["payerName"] = this.payerName;
        data["payerEmail"] = this.payerEmail;
        data["payerPhone"] = this.payerPhone;
        data["payerBankCode"] = this.payerBankCode;
        data["policyNumber"] = this.policyNumber;
        data["payerAccount"] = this.payerAccount;
        data["requestId"] = this.requestId;
        data["amount"] = this.amount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["mandateType"] = this.mandateType;
        data["frequency"] = this.frequency;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["mandateId"] = this.mandateId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["isMandateActive"] = this.isMandateActive;
        data["remitaTransRef"] = this.remitaTransRef;
        data["rowCount"] = this.rowCount;
        return data;
    }
}

export interface IViewDirectDebitMandateViewModel {
    id?: string | undefined;
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    policyNumber?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    isMandateActive?: boolean | undefined;
    remitaTransRef?: string | undefined;
    rowCount?: number | undefined;
}

export class CreateRemittaDirectDebitMandateDto implements ICreateRemittaDirectDebitMandateDto {
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    policyNumber?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    clientEmail?: string | undefined;

    constructor(data?: ICreateRemittaDirectDebitMandateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.hash = _data["hash"];
            this.payerName = _data["payerName"];
            this.payerEmail = _data["payerEmail"];
            this.payerPhone = _data["payerPhone"];
            this.payerBankCode = _data["payerBankCode"];
            this.payerAccount = _data["payerAccount"];
            this.requestId = _data["requestId"];
            this.policyNumber = _data["policyNumber"];
            this.amount = _data["amount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.mandateType = _data["mandateType"];
            this.frequency = _data["frequency"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.mandateId = _data["mandateId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.clientEmail = _data["clientEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRemittaDirectDebitMandateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRemittaDirectDebitMandateDto>(data, _mappings, CreateRemittaDirectDebitMandateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["hash"] = this.hash;
        data["payerName"] = this.payerName;
        data["payerEmail"] = this.payerEmail;
        data["payerPhone"] = this.payerPhone;
        data["payerBankCode"] = this.payerBankCode;
        data["payerAccount"] = this.payerAccount;
        data["requestId"] = this.requestId;
        data["policyNumber"] = this.policyNumber;
        data["amount"] = this.amount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["mandateType"] = this.mandateType;
        data["frequency"] = this.frequency;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["mandateId"] = this.mandateId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["clientEmail"] = this.clientEmail;
        return data;
    }
}

export interface ICreateRemittaDirectDebitMandateDto {
    merchantId?: string | undefined;
    serviceTypeId?: string | undefined;
    hash?: string | undefined;
    payerName?: string | undefined;
    payerEmail?: string | undefined;
    payerPhone?: string | undefined;
    payerBankCode?: string | undefined;
    payerAccount?: string | undefined;
    requestId?: string | undefined;
    policyNumber?: string | undefined;
    amount?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    mandateType?: string | undefined;
    frequency?: string | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    mandateId?: string | undefined;
    createdOn?: Date | undefined;
    clientEmail?: string | undefined;
}

export class RemittaMandateResponseModel implements IRemittaMandateResponseModel {
    status?: string | undefined;
    statuscode?: string | undefined;
    mandateId?: string | undefined;
    requestId?: string | undefined;

    constructor(data?: IRemittaMandateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statuscode = _data["statuscode"];
            this.mandateId = _data["mandateId"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RemittaMandateResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemittaMandateResponseModel>(data, _mappings, RemittaMandateResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statuscode"] = this.statuscode;
        data["mandateId"] = this.mandateId;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IRemittaMandateResponseModel {
    status?: string | undefined;
    statuscode?: string | undefined;
    mandateId?: string | undefined;
    requestId?: string | undefined;
}

export class RemittaActivateResponseOtpModel implements IRemittaActivateResponseOtpModel {
    statuscode?: string | undefined;
    authParams?: AuthParam[] | undefined;
    requestId?: string | undefined;
    mandateId?: string | undefined;
    remitaTransRef?: string | undefined;
    status?: string | undefined;

    constructor(data?: IRemittaActivateResponseOtpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            if (Array.isArray(_data["authParams"])) {
                this.authParams = [] as any;
                for (let item of _data["authParams"])
                    this.authParams!.push(AuthParam.fromJS(item, _mappings));
            }
            this.requestId = _data["requestId"];
            this.mandateId = _data["mandateId"];
            this.remitaTransRef = _data["remitaTransRef"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any, _mappings?: any): RemittaActivateResponseOtpModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemittaActivateResponseOtpModel>(data, _mappings, RemittaActivateResponseOtpModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        if (Array.isArray(this.authParams)) {
            data["authParams"] = [];
            for (let item of this.authParams)
                data["authParams"].push(item.toJSON());
        }
        data["requestId"] = this.requestId;
        data["mandateId"] = this.mandateId;
        data["remitaTransRef"] = this.remitaTransRef;
        data["status"] = this.status;
        return data;
    }
}

export interface IRemittaActivateResponseOtpModel {
    statuscode?: string | undefined;
    authParams?: AuthParam[] | undefined;
    requestId?: string | undefined;
    mandateId?: string | undefined;
    remitaTransRef?: string | undefined;
    status?: string | undefined;
}

export class AuthParam implements IAuthParam {
    description2?: string | undefined;
    param1?: string | undefined;
    description1?: string | undefined;
    param2?: string | undefined;

    constructor(data?: IAuthParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.description2 = _data["description2"];
            this.param1 = _data["param1"];
            this.description1 = _data["description1"];
            this.param2 = _data["param2"];
        }
    }

    static fromJS(data: any, _mappings?: any): AuthParam | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AuthParam>(data, _mappings, AuthParam);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description2"] = this.description2;
        data["param1"] = this.param1;
        data["description1"] = this.description1;
        data["param2"] = this.param2;
        return data;
    }
}

export interface IAuthParam {
    description2?: string | undefined;
    param1?: string | undefined;
    description1?: string | undefined;
    param2?: string | undefined;
}

export class RemittaMandateNotificationRequestModel implements IRemittaMandateNotificationRequestModel {
    notificationType?: string | undefined;
    lineItems?: LineItem[] | undefined;

    constructor(data?: IRemittaMandateNotificationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LineItem.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RemittaMandateNotificationRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemittaMandateNotificationRequestModel>(data, _mappings, RemittaMandateNotificationRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRemittaMandateNotificationRequestModel {
    notificationType?: string | undefined;
    lineItems?: LineItem[] | undefined;
}

export class LineItem implements ILineItem {
    mandateId?: string | undefined;
    activationDate?: string | undefined;
    requestId?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    amount?: number | undefined;
    setupRequestId?: string | undefined;
    debitDate?: string | undefined;

    constructor(data?: ILineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.mandateId = _data["mandateId"];
            this.activationDate = _data["activationDate"];
            this.requestId = _data["requestId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.amount = _data["amount"];
            this.setupRequestId = _data["setupRequestId"];
            this.debitDate = _data["debitDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): LineItem | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LineItem>(data, _mappings, LineItem);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandateId"] = this.mandateId;
        data["activationDate"] = this.activationDate;
        data["requestId"] = this.requestId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["amount"] = this.amount;
        data["setupRequestId"] = this.setupRequestId;
        data["debitDate"] = this.debitDate;
        return data;
    }
}

export interface ILineItem {
    mandateId?: string | undefined;
    activationDate?: string | undefined;
    requestId?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    amount?: number | undefined;
    setupRequestId?: string | undefined;
    debitDate?: string | undefined;
}

export class LifeRenewalScheduleRequestForMobile implements ILifeRenewalScheduleRequestForMobile {
    lifeRenewalTranRequest?: LifeRenewalTran | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: ILifeRenewalScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.lifeRenewalTranRequest = _data["lifeRenewalTranRequest"] ? LifeRenewalTran.fromJS(_data["lifeRenewalTranRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalScheduleRequestForMobile>(data, _mappings, LifeRenewalScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lifeRenewalTranRequest"] = this.lifeRenewalTranRequest ? this.lifeRenewalTranRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILifeRenewalScheduleRequestForMobile {
    lifeRenewalTranRequest?: LifeRenewalTran | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class MoneywiseRateRequest implements IMoneywiseRateRequest {
    customerName?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: string | undefined;
    policyTerm?: number | undefined;
    premiumPaymentFrequency?: string | undefined;
    targetType?: string | undefined;
    mainCoverSumAssured?: number | undefined;
    cashBackOption?: number | undefined;
    additionalAccidentDeathCover?: boolean | undefined;
    disabilityCover?: boolean | undefined;
    disabilityCoverAmount?: number | undefined;
    criticalIllnessCover?: boolean | undefined;
    criticalIllnessCoverAmount?: number | undefined;
    waiverOfPremiumOnDisabilityRider?: boolean | undefined;

    constructor(data?: IMoneywiseRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.policyTerm = _data["policyTerm"];
            this.premiumPaymentFrequency = _data["premiumPaymentFrequency"];
            this.targetType = _data["targetType"];
            this.mainCoverSumAssured = _data["mainCoverSumAssured"];
            this.cashBackOption = _data["cashBackOption"];
            this.additionalAccidentDeathCover = _data["additionalAccidentDeathCover"];
            this.disabilityCover = _data["disabilityCover"];
            this.disabilityCoverAmount = _data["disabilityCoverAmount"];
            this.criticalIllnessCover = _data["criticalIllnessCover"];
            this.criticalIllnessCoverAmount = _data["criticalIllnessCoverAmount"];
            this.waiverOfPremiumOnDisabilityRider = _data["waiverOfPremiumOnDisabilityRider"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoneywiseRateRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoneywiseRateRequest>(data, _mappings, MoneywiseRateRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["policyTerm"] = this.policyTerm;
        data["premiumPaymentFrequency"] = this.premiumPaymentFrequency;
        data["targetType"] = this.targetType;
        data["mainCoverSumAssured"] = this.mainCoverSumAssured;
        data["cashBackOption"] = this.cashBackOption;
        data["additionalAccidentDeathCover"] = this.additionalAccidentDeathCover;
        data["disabilityCover"] = this.disabilityCover;
        data["disabilityCoverAmount"] = this.disabilityCoverAmount;
        data["criticalIllnessCover"] = this.criticalIllnessCover;
        data["criticalIllnessCoverAmount"] = this.criticalIllnessCoverAmount;
        data["waiverOfPremiumOnDisabilityRider"] = this.waiverOfPremiumOnDisabilityRider;
        return data;
    }
}

export interface IMoneywiseRateRequest {
    customerName?: string | undefined;
    dateOfBirth?: Date | undefined;
    gender?: string | undefined;
    policyTerm?: number | undefined;
    premiumPaymentFrequency?: string | undefined;
    targetType?: string | undefined;
    mainCoverSumAssured?: number | undefined;
    cashBackOption?: number | undefined;
    additionalAccidentDeathCover?: boolean | undefined;
    disabilityCover?: boolean | undefined;
    disabilityCoverAmount?: number | undefined;
    criticalIllnessCover?: boolean | undefined;
    criticalIllnessCoverAmount?: number | undefined;
    waiverOfPremiumOnDisabilityRider?: boolean | undefined;
}

export class MoneywiseRateResponse implements IMoneywiseRateResponse {
    customerName?: string | undefined;
    dateOfBirth?: Date | undefined;
    ageNextBirthday?: number | undefined;
    gender?: string | undefined;
    policyTerm?: number | undefined;
    premiumPaymentFrequency?: string | undefined;
    targetType?: string | undefined;
    mainCoverSumAssured?: number | undefined;
    cashBackOption?: number | undefined;
    additionalAccidentDeathCover?: boolean | undefined;
    disabilityCover?: boolean | undefined;
    disabilityCoverAmount?: number | undefined;
    criticalIllnessCover?: boolean | undefined;
    criticalIllnessCoverAmount?: number | undefined;
    waiverOfPremiumOnDisabilityRider?: boolean | undefined;
    cashBackBenefit?: number | undefined;
    targetSumAssured?: number | undefined;
    disabilitySumAssured?: number | undefined;
    criticalIllnessDeathTargetSumAssured?: number | undefined;
    accidentalDeath?: number | undefined;
    expensePremium?: number | undefined;
    riskPremium?: number | undefined;
    accidentalDeathPremium?: number | undefined;
    disabilityCoverPremium?: number | undefined;
    waiverOfPremiumOnDisabilityPremium?: number | undefined;
    criticalIllnessPremium?: number | undefined;
    nameValueDetails?: MoneywiseNameValuePair[] | undefined;
    expensePremiumsCoverType?: number | undefined;
    deathPremiumsCoverType?: number | undefined;
    moneywisePremiumsCoverType?: number | undefined;
    criticalIllnessPremiumsCoverType?: number | undefined;
    waiverOfPremiumOnDisabilityPremiumsCoverType?: number | undefined;
    accidentalDeathPremiumsCoverType?: number | undefined;
    disabilityRiderBenefitPremiumsCoverType?: number | undefined;

    constructor(data?: IMoneywiseRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.ageNextBirthday = _data["ageNextBirthday"];
            this.gender = _data["gender"];
            this.policyTerm = _data["policyTerm"];
            this.premiumPaymentFrequency = _data["premiumPaymentFrequency"];
            this.targetType = _data["targetType"];
            this.mainCoverSumAssured = _data["mainCoverSumAssured"];
            this.cashBackOption = _data["cashBackOption"];
            this.additionalAccidentDeathCover = _data["additionalAccidentDeathCover"];
            this.disabilityCover = _data["disabilityCover"];
            this.disabilityCoverAmount = _data["disabilityCoverAmount"];
            this.criticalIllnessCover = _data["criticalIllnessCover"];
            this.criticalIllnessCoverAmount = _data["criticalIllnessCoverAmount"];
            this.waiverOfPremiumOnDisabilityRider = _data["waiverOfPremiumOnDisabilityRider"];
            this.cashBackBenefit = _data["cashBackBenefit"];
            this.targetSumAssured = _data["targetSumAssured"];
            this.disabilitySumAssured = _data["disabilitySumAssured"];
            this.criticalIllnessDeathTargetSumAssured = _data["criticalIllnessDeathTargetSumAssured"];
            this.accidentalDeath = _data["accidentalDeath"];
            this.expensePremium = _data["expensePremium"];
            this.riskPremium = _data["riskPremium"];
            this.accidentalDeathPremium = _data["accidentalDeathPremium"];
            this.disabilityCoverPremium = _data["disabilityCoverPremium"];
            this.waiverOfPremiumOnDisabilityPremium = _data["waiverOfPremiumOnDisabilityPremium"];
            this.criticalIllnessPremium = _data["criticalIllnessPremium"];
            if (Array.isArray(_data["nameValueDetails"])) {
                this.nameValueDetails = [] as any;
                for (let item of _data["nameValueDetails"])
                    this.nameValueDetails!.push(MoneywiseNameValuePair.fromJS(item, _mappings));
            }
            this.expensePremiumsCoverType = _data["expensePremiumsCoverType"];
            this.deathPremiumsCoverType = _data["deathPremiumsCoverType"];
            this.moneywisePremiumsCoverType = _data["moneywisePremiumsCoverType"];
            this.criticalIllnessPremiumsCoverType = _data["criticalIllnessPremiumsCoverType"];
            this.waiverOfPremiumOnDisabilityPremiumsCoverType = _data["waiverOfPremiumOnDisabilityPremiumsCoverType"];
            this.accidentalDeathPremiumsCoverType = _data["accidentalDeathPremiumsCoverType"];
            this.disabilityRiderBenefitPremiumsCoverType = _data["disabilityRiderBenefitPremiumsCoverType"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoneywiseRateResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoneywiseRateResponse>(data, _mappings, MoneywiseRateResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["ageNextBirthday"] = this.ageNextBirthday;
        data["gender"] = this.gender;
        data["policyTerm"] = this.policyTerm;
        data["premiumPaymentFrequency"] = this.premiumPaymentFrequency;
        data["targetType"] = this.targetType;
        data["mainCoverSumAssured"] = this.mainCoverSumAssured;
        data["cashBackOption"] = this.cashBackOption;
        data["additionalAccidentDeathCover"] = this.additionalAccidentDeathCover;
        data["disabilityCover"] = this.disabilityCover;
        data["disabilityCoverAmount"] = this.disabilityCoverAmount;
        data["criticalIllnessCover"] = this.criticalIllnessCover;
        data["criticalIllnessCoverAmount"] = this.criticalIllnessCoverAmount;
        data["waiverOfPremiumOnDisabilityRider"] = this.waiverOfPremiumOnDisabilityRider;
        data["cashBackBenefit"] = this.cashBackBenefit;
        data["targetSumAssured"] = this.targetSumAssured;
        data["disabilitySumAssured"] = this.disabilitySumAssured;
        data["criticalIllnessDeathTargetSumAssured"] = this.criticalIllnessDeathTargetSumAssured;
        data["accidentalDeath"] = this.accidentalDeath;
        data["expensePremium"] = this.expensePremium;
        data["riskPremium"] = this.riskPremium;
        data["accidentalDeathPremium"] = this.accidentalDeathPremium;
        data["disabilityCoverPremium"] = this.disabilityCoverPremium;
        data["waiverOfPremiumOnDisabilityPremium"] = this.waiverOfPremiumOnDisabilityPremium;
        data["criticalIllnessPremium"] = this.criticalIllnessPremium;
        if (Array.isArray(this.nameValueDetails)) {
            data["nameValueDetails"] = [];
            for (let item of this.nameValueDetails)
                data["nameValueDetails"].push(item.toJSON());
        }
        data["expensePremiumsCoverType"] = this.expensePremiumsCoverType;
        data["deathPremiumsCoverType"] = this.deathPremiumsCoverType;
        data["moneywisePremiumsCoverType"] = this.moneywisePremiumsCoverType;
        data["criticalIllnessPremiumsCoverType"] = this.criticalIllnessPremiumsCoverType;
        data["waiverOfPremiumOnDisabilityPremiumsCoverType"] = this.waiverOfPremiumOnDisabilityPremiumsCoverType;
        data["accidentalDeathPremiumsCoverType"] = this.accidentalDeathPremiumsCoverType;
        data["disabilityRiderBenefitPremiumsCoverType"] = this.disabilityRiderBenefitPremiumsCoverType;
        return data;
    }
}

export interface IMoneywiseRateResponse {
    customerName?: string | undefined;
    dateOfBirth?: Date | undefined;
    ageNextBirthday?: number | undefined;
    gender?: string | undefined;
    policyTerm?: number | undefined;
    premiumPaymentFrequency?: string | undefined;
    targetType?: string | undefined;
    mainCoverSumAssured?: number | undefined;
    cashBackOption?: number | undefined;
    additionalAccidentDeathCover?: boolean | undefined;
    disabilityCover?: boolean | undefined;
    disabilityCoverAmount?: number | undefined;
    criticalIllnessCover?: boolean | undefined;
    criticalIllnessCoverAmount?: number | undefined;
    waiverOfPremiumOnDisabilityRider?: boolean | undefined;
    cashBackBenefit?: number | undefined;
    targetSumAssured?: number | undefined;
    disabilitySumAssured?: number | undefined;
    criticalIllnessDeathTargetSumAssured?: number | undefined;
    accidentalDeath?: number | undefined;
    expensePremium?: number | undefined;
    riskPremium?: number | undefined;
    accidentalDeathPremium?: number | undefined;
    disabilityCoverPremium?: number | undefined;
    waiverOfPremiumOnDisabilityPremium?: number | undefined;
    criticalIllnessPremium?: number | undefined;
    nameValueDetails?: MoneywiseNameValuePair[] | undefined;
    expensePremiumsCoverType?: number | undefined;
    deathPremiumsCoverType?: number | undefined;
    moneywisePremiumsCoverType?: number | undefined;
    criticalIllnessPremiumsCoverType?: number | undefined;
    waiverOfPremiumOnDisabilityPremiumsCoverType?: number | undefined;
    accidentalDeathPremiumsCoverType?: number | undefined;
    disabilityRiderBenefitPremiumsCoverType?: number | undefined;
}

export class MoneywiseNameValuePair implements IMoneywiseNameValuePair {
    name?: string | undefined;
    value?: number | undefined;

    constructor(data?: IMoneywiseNameValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoneywiseNameValuePair | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoneywiseNameValuePair>(data, _mappings, MoneywiseNameValuePair);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IMoneywiseNameValuePair {
    name?: string | undefined;
    value?: number | undefined;
}

export class MoneywiseRateDto implements IMoneywiseRateDto {
    ordtCode?: string | undefined;
    ageNextBirthday?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    rate?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;

    constructor(data?: IMoneywiseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ordtCode = _data["ordtCode"];
            this.ageNextBirthday = _data["ageNextBirthday"];
            this.yearsTerm = _data["yearsTerm"];
            this.premiumFrequency = _data["premiumFrequency"];
            this.coverType = _data["coverType"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoneywiseRateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoneywiseRateDto>(data, _mappings, MoneywiseRateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordtCode"] = this.ordtCode;
        data["ageNextBirthday"] = this.ageNextBirthday;
        data["yearsTerm"] = this.yearsTerm;
        data["premiumFrequency"] = this.premiumFrequency;
        data["coverType"] = this.coverType;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IMoneywiseRateDto {
    ordtCode?: string | undefined;
    ageNextBirthday?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    rate?: number | undefined;
    isActive?: boolean | undefined;
    id?: string | undefined;
}

export class PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: MoneywiseRateDto[] | undefined;

    constructor(data?: IPagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MoneywiseRateDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, PagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDto_1OfOfMoneywiseRateDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: MoneywiseRateDto[] | undefined;
}

export class CreateMoneywiseRateDto implements ICreateMoneywiseRateDto {
    ordtCode?: string | undefined;
    ageNextBirthday?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    rate?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ICreateMoneywiseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ordtCode = _data["ordtCode"];
            this.ageNextBirthday = _data["ageNextBirthday"];
            this.yearsTerm = _data["yearsTerm"];
            this.premiumFrequency = _data["premiumFrequency"];
            this.coverType = _data["coverType"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMoneywiseRateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMoneywiseRateDto>(data, _mappings, CreateMoneywiseRateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordtCode"] = this.ordtCode;
        data["ageNextBirthday"] = this.ageNextBirthday;
        data["yearsTerm"] = this.yearsTerm;
        data["premiumFrequency"] = this.premiumFrequency;
        data["coverType"] = this.coverType;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateMoneywiseRateDto {
    ordtCode?: string | undefined;
    ageNextBirthday?: number | undefined;
    yearsTerm?: number | undefined;
    premiumFrequency?: string | undefined;
    coverType?: string | undefined;
    rate?: number | undefined;
    isActive?: boolean | undefined;
}

export class MotorScheduleRequestForMobile implements IMotorScheduleRequestForMobile {
    motorScheduleRequest?: MotorScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IMotorScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.motorScheduleRequest = _data["motorScheduleRequest"] ? MotorScheduleRequest.fromJS(_data["motorScheduleRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): MotorScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MotorScheduleRequestForMobile>(data, _mappings, MotorScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motorScheduleRequest"] = this.motorScheduleRequest ? this.motorScheduleRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMotorScheduleRequestForMobile {
    motorScheduleRequest?: MotorScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class AutoRenewalDetails implements IAutoRenewalDetails {
    isSuccessful?: boolean | undefined;
    policyNumber?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    renewalDate?: string | undefined;
    customerName?: string | undefined;
    smsTel?: string | undefined;
    email?: string | undefined;
    premium?: string | undefined;
    productDescription?: string | undefined;
    registrationNumber?: string | undefined;
    vehicleName?: string | undefined;
    bodyType?: string | undefined;
    rate?: string | undefined;
    chasisNumber?: string | undefined;
    engineNumber?: string | undefined;
    color?: string | undefined;
    year?: string | undefined;
    amount?: string | undefined;
    coverType?: string | undefined;

    constructor(data?: IAutoRenewalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.policyNumber = _data["policyNumber"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.renewalDate = _data["renewalDate"];
            this.customerName = _data["customerName"];
            this.smsTel = _data["smsTel"];
            this.email = _data["email"];
            this.premium = _data["premium"];
            this.productDescription = _data["productDescription"];
            this.registrationNumber = _data["registrationNumber"];
            this.vehicleName = _data["vehicleName"];
            this.bodyType = _data["bodyType"];
            this.rate = _data["rate"];
            this.chasisNumber = _data["chasisNumber"];
            this.engineNumber = _data["engineNumber"];
            this.color = _data["color"];
            this.year = _data["year"];
            this.amount = _data["amount"];
            this.coverType = _data["coverType"];
        }
    }

    static fromJS(data: any, _mappings?: any): AutoRenewalDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AutoRenewalDetails>(data, _mappings, AutoRenewalDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["policyNumber"] = this.policyNumber;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["renewalDate"] = this.renewalDate;
        data["customerName"] = this.customerName;
        data["smsTel"] = this.smsTel;
        data["email"] = this.email;
        data["premium"] = this.premium;
        data["productDescription"] = this.productDescription;
        data["registrationNumber"] = this.registrationNumber;
        data["vehicleName"] = this.vehicleName;
        data["bodyType"] = this.bodyType;
        data["rate"] = this.rate;
        data["chasisNumber"] = this.chasisNumber;
        data["engineNumber"] = this.engineNumber;
        data["color"] = this.color;
        data["year"] = this.year;
        data["amount"] = this.amount;
        data["coverType"] = this.coverType;
        return data;
    }
}

export interface IAutoRenewalDetails {
    isSuccessful?: boolean | undefined;
    policyNumber?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    renewalDate?: string | undefined;
    customerName?: string | undefined;
    smsTel?: string | undefined;
    email?: string | undefined;
    premium?: string | undefined;
    productDescription?: string | undefined;
    registrationNumber?: string | undefined;
    vehicleName?: string | undefined;
    bodyType?: string | undefined;
    rate?: string | undefined;
    chasisNumber?: string | undefined;
    engineNumber?: string | undefined;
    color?: string | undefined;
    year?: string | undefined;
    amount?: string | undefined;
    coverType?: string | undefined;
}

export class EmbassyLetter implements IEmbassyLetter {
    polName?: string | undefined;
    polProdShtDesc?: string | undefined;
    polPolicyNumber?: string | undefined;
    polEffectiveDate?: string | undefined;
    polLastPremDueDate?: string | undefined;
    polMaturityDate?: string | undefined;
    polCurrentSa?: string | undefined;
    polTerm?: string | undefined;
    polOsPremBalAmt?: string | undefined;
    polStatus?: string | undefined;
    polInstlmtPrem?: string | undefined;
    polPaidToDate?: string | undefined;
    polFreqOfPayment?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    address?: string | undefined;
    isStatus?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    isEmail?: boolean | undefined;

    constructor(data?: IEmbassyLetter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.polName = _data["polName"];
            this.polProdShtDesc = _data["polProdShtDesc"];
            this.polPolicyNumber = _data["polPolicyNumber"];
            this.polEffectiveDate = _data["polEffectiveDate"];
            this.polLastPremDueDate = _data["polLastPremDueDate"];
            this.polMaturityDate = _data["polMaturityDate"];
            this.polCurrentSa = _data["polCurrentSa"];
            this.polTerm = _data["polTerm"];
            this.polOsPremBalAmt = _data["polOsPremBalAmt"];
            this.polStatus = _data["polStatus"];
            this.polInstlmtPrem = _data["polInstlmtPrem"];
            this.polPaidToDate = _data["polPaidToDate"];
            this.polFreqOfPayment = _data["polFreqOfPayment"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.isStatus = _data["isStatus"];
            this.isSuccessful = _data["isSuccessful"];
            this.isEmail = _data["isEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmbassyLetter | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmbassyLetter>(data, _mappings, EmbassyLetter);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polName"] = this.polName;
        data["polProdShtDesc"] = this.polProdShtDesc;
        data["polPolicyNumber"] = this.polPolicyNumber;
        data["polEffectiveDate"] = this.polEffectiveDate;
        data["polLastPremDueDate"] = this.polLastPremDueDate;
        data["polMaturityDate"] = this.polMaturityDate;
        data["polCurrentSa"] = this.polCurrentSa;
        data["polTerm"] = this.polTerm;
        data["polOsPremBalAmt"] = this.polOsPremBalAmt;
        data["polStatus"] = this.polStatus;
        data["polInstlmtPrem"] = this.polInstlmtPrem;
        data["polPaidToDate"] = this.polPaidToDate;
        data["polFreqOfPayment"] = this.polFreqOfPayment;
        data["email"] = this.email;
        data["country"] = this.country;
        data["state"] = this.state;
        data["address"] = this.address;
        data["isStatus"] = this.isStatus;
        data["isSuccessful"] = this.isSuccessful;
        data["isEmail"] = this.isEmail;
        return data;
    }
}

export interface IEmbassyLetter {
    polName?: string | undefined;
    polProdShtDesc?: string | undefined;
    polPolicyNumber?: string | undefined;
    polEffectiveDate?: string | undefined;
    polLastPremDueDate?: string | undefined;
    polMaturityDate?: string | undefined;
    polCurrentSa?: string | undefined;
    polTerm?: string | undefined;
    polOsPremBalAmt?: string | undefined;
    polStatus?: string | undefined;
    polInstlmtPrem?: string | undefined;
    polPaidToDate?: string | undefined;
    polFreqOfPayment?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    address?: string | undefined;
    isStatus?: boolean | undefined;
    isSuccessful?: boolean | undefined;
    isEmail?: boolean | undefined;
}

export class PolicyPayment implements IPolicyPayment {
    policyNumber?: string | undefined;
    amount?: number | undefined;
    phoneNumber?: string | undefined;
    message?: string | undefined;

    constructor(data?: IPolicyPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.amount = _data["amount"];
            this.phoneNumber = _data["phoneNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): PolicyPayment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PolicyPayment>(data, _mappings, PolicyPayment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["amount"] = this.amount;
        data["phoneNumber"] = this.phoneNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface IPolicyPayment {
    policyNumber?: string | undefined;
    amount?: number | undefined;
    phoneNumber?: string | undefined;
    message?: string | undefined;
}

export class ValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: TravelSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? TravelSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfTravelScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: TravelSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class ClientPolicyMailModel implements IClientPolicyMailModel {
    amountPaid?: number | undefined;
    paymentChannel?: string | undefined;
    paymentReference?: string | undefined;
    transactionRef?: string | undefined;
    responseCode?: string | undefined;
    responseText?: string | undefined;
    cardHolderName?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    maskedCardNumber?: string | undefined;
    cardType?: string | undefined;
    paymentDate?: string | undefined;
    agentShortDescription?: string | undefined;
    amountInWords?: string | undefined;
    narration?: string | undefined;
    originatingBranchAgency?: string | undefined;
    cashChequeNumber?: string | undefined;
    receivedBy?: string | undefined;
    clientId?: string | undefined;
    isLoan?: boolean | undefined;
    isTermLifeActive?: boolean | undefined;

    constructor(data?: IClientPolicyMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isTermLifeActive = false;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amountPaid = _data["amountPaid"];
            this.paymentChannel = _data["paymentChannel"];
            this.paymentReference = _data["paymentReference"];
            this.transactionRef = _data["transactionRef"];
            this.responseCode = _data["responseCode"];
            this.responseText = _data["responseText"];
            this.cardHolderName = _data["cardHolderName"];
            this.clientName = _data["clientName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.maskedCardNumber = _data["maskedCardNumber"];
            this.cardType = _data["cardType"];
            this.paymentDate = _data["paymentDate"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.amountInWords = _data["amountInWords"];
            this.narration = _data["narration"];
            this.originatingBranchAgency = _data["originatingBranchAgency"];
            this.cashChequeNumber = _data["cashChequeNumber"];
            this.receivedBy = _data["receivedBy"];
            this.clientId = _data["clientId"];
            this.isLoan = _data["isLoan"];
            this.isTermLifeActive = _data["isTermLifeActive"] !== undefined ? _data["isTermLifeActive"] : false;
        }
    }

    static fromJS(data: any, _mappings?: any): ClientPolicyMailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientPolicyMailModel>(data, _mappings, ClientPolicyMailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPaid"] = this.amountPaid;
        data["paymentChannel"] = this.paymentChannel;
        data["paymentReference"] = this.paymentReference;
        data["transactionRef"] = this.transactionRef;
        data["responseCode"] = this.responseCode;
        data["responseText"] = this.responseText;
        data["cardHolderName"] = this.cardHolderName;
        data["clientName"] = this.clientName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["maskedCardNumber"] = this.maskedCardNumber;
        data["cardType"] = this.cardType;
        data["paymentDate"] = this.paymentDate;
        data["agentShortDescription"] = this.agentShortDescription;
        data["amountInWords"] = this.amountInWords;
        data["narration"] = this.narration;
        data["originatingBranchAgency"] = this.originatingBranchAgency;
        data["cashChequeNumber"] = this.cashChequeNumber;
        data["receivedBy"] = this.receivedBy;
        data["clientId"] = this.clientId;
        data["isLoan"] = this.isLoan;
        data["isTermLifeActive"] = this.isTermLifeActive;
        return data;
    }
}

export interface IClientPolicyMailModel {
    amountPaid?: number | undefined;
    paymentChannel?: string | undefined;
    paymentReference?: string | undefined;
    transactionRef?: string | undefined;
    responseCode?: string | undefined;
    responseText?: string | undefined;
    cardHolderName?: string | undefined;
    clientName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    maskedCardNumber?: string | undefined;
    cardType?: string | undefined;
    paymentDate?: string | undefined;
    agentShortDescription?: string | undefined;
    amountInWords?: string | undefined;
    narration?: string | undefined;
    originatingBranchAgency?: string | undefined;
    cashChequeNumber?: string | undefined;
    receivedBy?: string | undefined;
    clientId?: string | undefined;
    isLoan?: boolean | undefined;
    isTermLifeActive?: boolean | undefined;
}

export class LifeRenewalMailModel implements ILifeRenewalMailModel {
    verificationLink?: string | undefined;
    email?: string[] | undefined;
    receiptNumber?: string | undefined;
    amount?: string | undefined;
    policyNumber?: string | undefined;
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    paymentDate?: string | undefined;
    policyStatus?: string | undefined;
    serverBaseUrl?: string | undefined;
    linkName?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    paymentChannel?: string | undefined;
    isNewClient?: boolean | undefined;
    agentShortDescription?: string | undefined;
    amountInWords?: string | undefined;
    narration?: string | undefined;
    originatingBranchAgency?: string | undefined;
    cashChequeNumber?: string | undefined;
    receivedBy?: string | undefined;
    clientId?: string | undefined;
    isLoan?: boolean | undefined;
    beneficiaryActive?: boolean | undefined;
    transactionDetails?: ClientPolicyMailModel | undefined;

    constructor(data?: ILifeRenewalMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.verificationLink = _data["verificationLink"];
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(item);
            }
            this.receiptNumber = _data["receiptNumber"];
            this.amount = _data["amount"];
            this.policyNumber = _data["policyNumber"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.paymentDate = _data["paymentDate"];
            this.policyStatus = _data["policyStatus"];
            this.serverBaseUrl = _data["serverBaseUrl"];
            this.linkName = _data["linkName"];
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
            this.paymentChannel = _data["paymentChannel"];
            this.isNewClient = _data["isNewClient"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.amountInWords = _data["amountInWords"];
            this.narration = _data["narration"];
            this.originatingBranchAgency = _data["originatingBranchAgency"];
            this.cashChequeNumber = _data["cashChequeNumber"];
            this.receivedBy = _data["receivedBy"];
            this.clientId = _data["clientId"];
            this.isLoan = _data["isLoan"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.transactionDetails = _data["transactionDetails"] ? ClientPolicyMailModel.fromJS(_data["transactionDetails"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): LifeRenewalMailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeRenewalMailModel>(data, _mappings, LifeRenewalMailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationLink"] = this.verificationLink;
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item);
        }
        data["receiptNumber"] = this.receiptNumber;
        data["amount"] = this.amount;
        data["policyNumber"] = this.policyNumber;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["paymentDate"] = this.paymentDate;
        data["policyStatus"] = this.policyStatus;
        data["serverBaseUrl"] = this.serverBaseUrl;
        data["linkName"] = this.linkName;
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        data["paymentChannel"] = this.paymentChannel;
        data["isNewClient"] = this.isNewClient;
        data["agentShortDescription"] = this.agentShortDescription;
        data["amountInWords"] = this.amountInWords;
        data["narration"] = this.narration;
        data["originatingBranchAgency"] = this.originatingBranchAgency;
        data["cashChequeNumber"] = this.cashChequeNumber;
        data["receivedBy"] = this.receivedBy;
        data["clientId"] = this.clientId;
        data["isLoan"] = this.isLoan;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["transactionDetails"] = this.transactionDetails ? this.transactionDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILifeRenewalMailModel {
    verificationLink?: string | undefined;
    email?: string[] | undefined;
    receiptNumber?: string | undefined;
    amount?: string | undefined;
    policyNumber?: string | undefined;
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    paymentDate?: string | undefined;
    policyStatus?: string | undefined;
    serverBaseUrl?: string | undefined;
    linkName?: string | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
    paymentChannel?: string | undefined;
    isNewClient?: boolean | undefined;
    agentShortDescription?: string | undefined;
    amountInWords?: string | undefined;
    narration?: string | undefined;
    originatingBranchAgency?: string | undefined;
    cashChequeNumber?: string | undefined;
    receivedBy?: string | undefined;
    clientId?: string | undefined;
    isLoan?: boolean | undefined;
    beneficiaryActive?: boolean | undefined;
    transactionDetails?: ClientPolicyMailModel | undefined;
}

export class ValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: MotorSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? MotorSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfMotorScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: MotorSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class ValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: ShopSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? ShopSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfShopScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: ShopSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class ShopSchedule implements IShopSchedule {
    typeOfShop?: string | undefined;
    natureOfStructure?: string | undefined;
    natureOfStock?: string | undefined;
    stockTakingMode?: string | undefined;
    address?: string | undefined;
    keepsStockBook?: boolean | undefined;
    keepsStockBookInSafePlace?: boolean | undefined;
    stockAmount?: number | undefined;
    declearation?: string | undefined;
    natureOfBusiness?: string | undefined;
    premiumAmount?: number | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IShopSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.typeOfShop = _data["typeOfShop"];
            this.natureOfStructure = _data["natureOfStructure"];
            this.natureOfStock = _data["natureOfStock"];
            this.stockTakingMode = _data["stockTakingMode"];
            this.address = _data["address"];
            this.keepsStockBook = _data["keepsStockBook"];
            this.keepsStockBookInSafePlace = _data["keepsStockBookInSafePlace"];
            this.stockAmount = _data["stockAmount"];
            this.declearation = _data["declearation"];
            this.natureOfBusiness = _data["natureOfBusiness"];
            this.premiumAmount = _data["premiumAmount"];
            this.lga = _data["lga"] ? Lga.fromJS(_data["lga"], _mappings) : <any>undefined;
            this.lgaId = _data["lgaId"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShopSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShopSchedule>(data, _mappings, ShopSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfShop"] = this.typeOfShop;
        data["natureOfStructure"] = this.natureOfStructure;
        data["natureOfStock"] = this.natureOfStock;
        data["stockTakingMode"] = this.stockTakingMode;
        data["address"] = this.address;
        data["keepsStockBook"] = this.keepsStockBook;
        data["keepsStockBookInSafePlace"] = this.keepsStockBookInSafePlace;
        data["stockAmount"] = this.stockAmount;
        data["declearation"] = this.declearation;
        data["natureOfBusiness"] = this.natureOfBusiness;
        data["premiumAmount"] = this.premiumAmount;
        data["lga"] = this.lga ? this.lga.toJSON() : <any>undefined;
        data["lgaId"] = this.lgaId;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IShopSchedule {
    typeOfShop?: string | undefined;
    natureOfStructure?: string | undefined;
    natureOfStock?: string | undefined;
    stockTakingMode?: string | undefined;
    address?: string | undefined;
    keepsStockBook?: boolean | undefined;
    keepsStockBookInSafePlace?: boolean | undefined;
    stockAmount?: number | undefined;
    declearation?: string | undefined;
    natureOfBusiness?: string | undefined;
    premiumAmount?: number | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: OfficeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? OfficeSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfOfficeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: OfficeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class ValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: HomeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? HomeSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfHomeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: HomeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class ValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: PersonalAccidentSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? PersonalAccidentSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfPersonalAccidentScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: PersonalAccidentSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class PersonalAccidentSchedule implements IPersonalAccidentSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    isDomesticTravel?: boolean | undefined;
    recordId?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IPersonalAccidentSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"];
            this.relationship = _data["relationship"];
            this.premium = _data["premium"];
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.premiumAmount = _data["premiumAmount"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.unit = _data["unit"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.isDomesticTravel = _data["isDomesticTravel"];
            this.recordId = _data["recordId"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonalAccidentSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonalAccidentSchedule>(data, _mappings, PersonalAccidentSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary;
        data["relationship"] = this.relationship;
        data["premium"] = this.premium;
        data["inceptionDate"] = this.inceptionDate ? this.inceptionDate.toISOString() : <any>undefined;
        data["premiumAmount"] = this.premiumAmount;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["unit"] = this.unit;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["isDomesticTravel"] = this.isDomesticTravel;
        data["recordId"] = this.recordId;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonalAccidentSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    isDomesticTravel?: boolean | undefined;
    recordId?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: CovidSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? CovidSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfCovidScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: CovidSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class CovidSchedule implements ICovidSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    frequency?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ICovidSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"];
            this.relationship = _data["relationship"];
            this.premium = _data["premium"];
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.premiumAmount = _data["premiumAmount"];
            this.frequency = _data["frequency"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.unit = _data["unit"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryRelationship = _data["beneficiaryRelationship"];
            this.beneficiaryAddress = _data["beneficiaryAddress"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): CovidSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CovidSchedule>(data, _mappings, CovidSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary;
        data["relationship"] = this.relationship;
        data["premium"] = this.premium;
        data["inceptionDate"] = this.inceptionDate ? this.inceptionDate.toISOString() : <any>undefined;
        data["premiumAmount"] = this.premiumAmount;
        data["frequency"] = this.frequency;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["unit"] = this.unit;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryRelationship"] = this.beneficiaryRelationship;
        data["beneficiaryAddress"] = this.beneficiaryAddress;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ICovidSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    frequency?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: HospitalCashSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? HospitalCashSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfHospitalCashScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: HospitalCashSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class HospitalCashSchedule implements IHospitalCashSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    premiumRate?: number | undefined;
    durationOfCover?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    frequency?: string | undefined;
    bankName?: string | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    marketer?: string | undefined;
    hospital?: string | undefined;
    maritalStatus?: MaritalStatus | undefined;
    maritalStatusId?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IHospitalCashSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"];
            this.relationship = _data["relationship"];
            this.premium = _data["premium"];
            this.premiumRate = _data["premiumRate"];
            this.durationOfCover = _data["durationOfCover"];
            this.inceptionDate = _data["inceptionDate"] ? new Date(_data["inceptionDate"].toString()) : <any>undefined;
            this.premiumAmount = _data["premiumAmount"];
            this.sumAssured = _data["sumAssured"];
            this.frequency = _data["frequency"];
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.occupation = _data["occupation"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.unit = _data["unit"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryRelationship = _data["beneficiaryRelationship"];
            this.beneficiaryAddress = _data["beneficiaryAddress"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.marketer = _data["marketer"];
            this.hospital = _data["hospital"];
            this.maritalStatus = _data["maritalStatus"] ? MaritalStatus.fromJS(_data["maritalStatus"], _mappings) : <any>undefined;
            this.maritalStatusId = _data["maritalStatusId"];
            this.lga = _data["lga"] ? Lga.fromJS(_data["lga"], _mappings) : <any>undefined;
            this.lgaId = _data["lgaId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): HospitalCashSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HospitalCashSchedule>(data, _mappings, HospitalCashSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary;
        data["relationship"] = this.relationship;
        data["premium"] = this.premium;
        data["premiumRate"] = this.premiumRate;
        data["durationOfCover"] = this.durationOfCover;
        data["inceptionDate"] = this.inceptionDate ? this.inceptionDate.toISOString() : <any>undefined;
        data["premiumAmount"] = this.premiumAmount;
        data["sumAssured"] = this.sumAssured;
        data["frequency"] = this.frequency;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["occupation"] = this.occupation;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["unit"] = this.unit;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryRelationship"] = this.beneficiaryRelationship;
        data["beneficiaryAddress"] = this.beneficiaryAddress;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["marketer"] = this.marketer;
        data["hospital"] = this.hospital;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["maritalStatusId"] = this.maritalStatusId;
        data["lga"] = this.lga ? this.lga.toJSON() : <any>undefined;
        data["lgaId"] = this.lgaId;
        data["id"] = this.id;
        return data;
    }
}

export interface IHospitalCashSchedule {
    beneficiary?: string | undefined;
    relationship?: string | undefined;
    premium?: number | undefined;
    premiumRate?: number | undefined;
    durationOfCover?: number | undefined;
    inceptionDate?: Date | undefined;
    premiumAmount?: number | undefined;
    sumAssured?: number | undefined;
    frequency?: string | undefined;
    bankName?: string | undefined;
    accountNumber?: number | undefined;
    occupation?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    unit?: number | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    marketer?: string | undefined;
    hospital?: string | undefined;
    maritalStatus?: MaritalStatus | undefined;
    maritalStatusId?: string | undefined;
    lga?: Lga | undefined;
    lgaId?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: TermLifeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? TermLifeSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfTermLifeScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: TermLifeSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class TermLifeSchedule implements ITermLifeSchedule {
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premium?: number | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    agentShortDescription?: string | undefined;
    isRenewal?: boolean | undefined;
    renewedTransaction?: string | undefined;
    id?: string | undefined;

    constructor(data?: ITermLifeSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isRenewal = false;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.premium = _data["premium"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.agentShortDescription = _data["agentShortDescription"];
            this.isRenewal = _data["isRenewal"] !== undefined ? _data["isRenewal"] : false;
            this.renewedTransaction = _data["renewedTransaction"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): TermLifeSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TermLifeSchedule>(data, _mappings, TermLifeSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["premium"] = this.premium;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["agentShortDescription"] = this.agentShortDescription;
        data["isRenewal"] = this.isRenewal;
        data["renewedTransaction"] = this.renewedTransaction;
        data["id"] = this.id;
        return data;
    }
}

export interface ITermLifeSchedule {
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premium?: number | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    agentShortDescription?: string | undefined;
    isRenewal?: boolean | undefined;
    renewedTransaction?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: GadgetSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? GadgetSchedule.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfGadgetScheduleAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: GadgetSchedule | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class GadgetSchedule implements IGadgetSchedule {
    make?: string | undefined;
    model?: string | undefined;
    deviceNumber?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premiumAmount?: number | undefined;
    gadgetAmount?: number | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IGadgetSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.make = _data["make"];
            this.model = _data["model"];
            this.deviceNumber = _data["deviceNumber"];
            this.subclassSectCovtype = _data["subclassSectCovtype"] ? SubclassSectCovtype.fromJS(_data["subclassSectCovtype"], _mappings) : <any>undefined;
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.clientApplication = _data["clientApplication"] ? ClientApplication.fromJS(_data["clientApplication"], _mappings) : <any>undefined;
            this.clientApplicationId = _data["clientApplicationId"];
            this.intermediary = _data["intermediary"] ? Intermediary.fromJS(_data["intermediary"], _mappings) : <any>undefined;
            this.intermediaryId = _data["intermediaryId"];
            this.premiumAmount = _data["premiumAmount"];
            this.gadgetAmount = _data["gadgetAmount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"], _mappings) : <any>undefined;
            this.productId = _data["productId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"], _mappings) : <any>undefined;
            this.branchId = _data["branchId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : <any>undefined;
            this.clientId = _data["clientId"];
            this.transactionRef = _data["transactionRef"];
            this.policy = _data["policy"] ? Policy.fromJS(_data["policy"], _mappings) : <any>undefined;
            this.policyId = _data["policyId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.receiptUrl = _data["receiptUrl"];
            this.imageUrl = _data["imageUrl"];
            this.backImageUrl = _data["backImageUrl"];
            this.polledToTQ = _data["polledToTQ"];
            this.failureOrSuccessReason = _data["failureOrSuccessReason"];
            this.polledToNiid = _data["polledToNiid"];
            this.paymentChannel = _data["paymentChannel"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.referralCode = _data["referralCode"];
            this.beneficiaryActive = _data["beneficiaryActive"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryRelationship = _data["beneficiaryRelationship"];
            this.beneficiaryAddress = _data["beneficiaryAddress"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): GadgetSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GadgetSchedule>(data, _mappings, GadgetSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["make"] = this.make;
        data["model"] = this.model;
        data["deviceNumber"] = this.deviceNumber;
        data["subclassSectCovtype"] = this.subclassSectCovtype ? this.subclassSectCovtype.toJSON() : <any>undefined;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["clientApplication"] = this.clientApplication ? this.clientApplication.toJSON() : <any>undefined;
        data["clientApplicationId"] = this.clientApplicationId;
        data["intermediary"] = this.intermediary ? this.intermediary.toJSON() : <any>undefined;
        data["intermediaryId"] = this.intermediaryId;
        data["premiumAmount"] = this.premiumAmount;
        data["gadgetAmount"] = this.gadgetAmount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["transactionRef"] = this.transactionRef;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["policyId"] = this.policyId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["receiptUrl"] = this.receiptUrl;
        data["imageUrl"] = this.imageUrl;
        data["backImageUrl"] = this.backImageUrl;
        data["polledToTQ"] = this.polledToTQ;
        data["failureOrSuccessReason"] = this.failureOrSuccessReason;
        data["polledToNiid"] = this.polledToNiid;
        data["paymentChannel"] = this.paymentChannel;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["referralCode"] = this.referralCode;
        data["beneficiaryActive"] = this.beneficiaryActive;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryRelationship"] = this.beneficiaryRelationship;
        data["beneficiaryAddress"] = this.beneficiaryAddress;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IGadgetSchedule {
    make?: string | undefined;
    model?: string | undefined;
    deviceNumber?: string | undefined;
    subclassSectCovtype?: SubclassSectCovtype | undefined;
    subclassSectCovtypeId?: string | undefined;
    clientApplication?: ClientApplication | undefined;
    clientApplicationId?: string | undefined;
    intermediary?: Intermediary | undefined;
    intermediaryId?: string | undefined;
    premiumAmount?: number | undefined;
    gadgetAmount?: number | undefined;
    transactionDate?: Date | undefined;
    product?: Product | undefined;
    productId?: string | undefined;
    branch?: Branch | undefined;
    branchId?: string | undefined;
    client?: Client | undefined;
    clientId?: string | undefined;
    transactionRef?: string | undefined;
    policy?: Policy | undefined;
    policyId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
    status?: string | undefined;
    statusCode?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    receiptUrl?: string | undefined;
    imageUrl?: string | undefined;
    backImageUrl?: string | undefined;
    polledToTQ?: boolean | undefined;
    failureOrSuccessReason?: string | undefined;
    polledToNiid?: boolean | undefined;
    paymentChannel?: string | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    referralCode?: string | undefined;
    beneficiaryActive?: boolean | undefined;
    beneficiaryFullName?: string | undefined;
    beneficiaryPhoneNumber?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryAddress?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: NcspTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? NcspTransaction.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfNcspTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: NcspTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class NcspTransaction implements INcspTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: INcspTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalNumber = _data["proposalNumber"];
            this.policyNumber = _data["policyNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.rateCode = _data["rateCode"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.term = _data["term"];
            this.policyFee = _data["policyFee"];
            this.agentCode = _data["agentCode"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.effectiveDate = _data["effectiveDate"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): NcspTransaction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NcspTransaction>(data, _mappings, NcspTransaction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalNumber"] = this.proposalNumber;
        data["policyNumber"] = this.policyNumber;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["rateCode"] = this.rateCode;
        data["paymentFrequency"] = this.paymentFrequency;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["term"] = this.term;
        data["policyFee"] = this.policyFee;
        data["agentCode"] = this.agentCode;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["effectiveDate"] = this.effectiveDate;
        data["clientShortDescription"] = this.clientShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface INcspTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: LtaTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? LtaTransaction.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfLtaTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: LtaTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class LtaTransaction implements ILtaTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ILtaTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalNumber = _data["proposalNumber"];
            this.policyNumber = _data["policyNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.rateCode = _data["rateCode"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.term = _data["term"];
            this.policyFee = _data["policyFee"];
            this.agentCode = _data["agentCode"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.effectiveDate = _data["effectiveDate"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): LtaTransaction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LtaTransaction>(data, _mappings, LtaTransaction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalNumber"] = this.proposalNumber;
        data["policyNumber"] = this.policyNumber;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["rateCode"] = this.rateCode;
        data["paymentFrequency"] = this.paymentFrequency;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["term"] = this.term;
        data["policyFee"] = this.policyFee;
        data["agentCode"] = this.agentCode;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["effectiveDate"] = this.effectiveDate;
        data["clientShortDescription"] = this.clientShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ILtaTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: FepTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? FepTransaction.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfFepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: FepTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class FepTransaction implements IFepTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: IFepTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalNumber = _data["proposalNumber"];
            this.policyNumber = _data["policyNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.rateCode = _data["rateCode"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.term = _data["term"];
            this.policyFee = _data["policyFee"];
            this.agentCode = _data["agentCode"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.effectiveDate = _data["effectiveDate"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): FepTransaction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FepTransaction>(data, _mappings, FepTransaction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalNumber"] = this.proposalNumber;
        data["policyNumber"] = this.policyNumber;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["rateCode"] = this.rateCode;
        data["paymentFrequency"] = this.paymentFrequency;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["term"] = this.term;
        data["policyFee"] = this.policyFee;
        data["agentCode"] = this.agentCode;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["effectiveDate"] = this.effectiveDate;
        data["clientShortDescription"] = this.clientShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IFepTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: CepTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? CepTransaction.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfCepTransactionAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: CepTransaction | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
}

export class CepTransaction implements ICepTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;

    constructor(data?: ICepTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalNumber = _data["proposalNumber"];
            this.policyNumber = _data["policyNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.rateCode = _data["rateCode"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.term = _data["term"];
            this.policyFee = _data["policyFee"];
            this.agentCode = _data["agentCode"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            this.effectiveDate = _data["effectiveDate"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): CepTransaction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CepTransaction>(data, _mappings, CepTransaction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalNumber"] = this.proposalNumber;
        data["policyNumber"] = this.policyNumber;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["rateCode"] = this.rateCode;
        data["paymentFrequency"] = this.paymentFrequency;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["term"] = this.term;
        data["policyFee"] = this.policyFee;
        data["agentCode"] = this.agentCode;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        data["effectiveDate"] = this.effectiveDate;
        data["clientShortDescription"] = this.clientShortDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ICepTransaction {
    proposalNumber?: string | undefined;
    policyNumber?: string | undefined;
    transactionDate?: Date | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentCode?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    effectiveDate?: string | undefined;
    clientShortDescription?: string | undefined;
    id?: string | undefined;
}

export class ValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: LifeRenewalTran | undefined;
    item2?: User | undefined;
    item3?: ClientPolicyMailModel | undefined;

    constructor(data?: IValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? LifeRenewalTran.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? User.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? ClientPolicyMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_3OfOfLifeRenewalTranAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    item1?: LifeRenewalTran | undefined;
    item2?: User | undefined;
    item3?: ClientPolicyMailModel | undefined;
}

export class ValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements IValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | undefined;
    item2?: Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined;

    constructor(data?: IValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["item2"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, ValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValueTuple_2OfOfAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | undefined;
    item2?: Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined;
}

export class Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements IAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly method?: MethodInfo | undefined;
    readonly target?: any | undefined;

    constructor(data?: IAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).method = _data["method"] ? MethodInfo.fromJS(_data["method"], _mappings) : <any>undefined;
            (<any>this).target = _data["target"];
        }
    }

    static fromJS(data: any, _mappings?: any): Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Action_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["target"] = this.target;
        return data;
    }
}

export interface IAction_1OfOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    method?: MethodInfo | undefined;
    target?: any | undefined;
}

export class Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    readonly method?: MethodInfo | undefined;
    readonly target?: any | undefined;

    constructor(data?: IAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).method = _data["method"] ? MethodInfo.fromJS(_data["method"], _mappings) : <any>undefined;
            (<any>this).target = _data["target"];
        }
    }

    static fromJS(data: any, _mappings?: any): Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, Action_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["target"] = this.target;
        return data;
    }
}

export interface IAction_1OfOfConnectionErrorAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    method?: MethodInfo | undefined;
    target?: any | undefined;
}

export class MethodInfo implements IMethodInfo {
    readonly memberType?: MethodInfoMemberType | undefined;
    readonly returnParameter?: ParameterInfo | undefined;
    readonly returnType?: string | undefined;
    readonly returnTypeCustomAttributes?: ICustomAttributeProvider | undefined;
    readonly attributes?: MethodInfoAttributes | undefined;
    readonly methodImplementationFlags?: MethodInfoMethodImplementationFlags | undefined;
    readonly callingConvention?: MethodInfoCallingConvention | undefined;
    readonly isAbstract?: boolean | undefined;
    readonly isConstructor?: boolean | undefined;
    readonly isFinal?: boolean | undefined;
    readonly isHideBySig?: boolean | undefined;
    readonly isSpecialName?: boolean | undefined;
    readonly isStatic?: boolean | undefined;
    readonly isVirtual?: boolean | undefined;
    readonly isAssembly?: boolean | undefined;
    readonly isFamily?: boolean | undefined;
    readonly isFamilyAndAssembly?: boolean | undefined;
    readonly isFamilyOrAssembly?: boolean | undefined;
    readonly isPrivate?: boolean | undefined;
    readonly isPublic?: boolean | undefined;
    readonly isConstructedGenericMethod?: boolean | undefined;
    readonly isGenericMethod?: boolean | undefined;
    readonly isGenericMethodDefinition?: boolean | undefined;
    readonly containsGenericParameters?: boolean | undefined;
    readonly methodHandle?: RuntimeMethodHandle | undefined;
    readonly isSecurityCritical?: boolean | undefined;
    readonly isSecuritySafeCritical?: boolean | undefined;
    readonly isSecurityTransparent?: boolean | undefined;
    readonly name?: string | undefined;
    readonly declaringType?: string | undefined;
    readonly reflectedType?: string | undefined;
    readonly module?: Module | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number | undefined;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"], _mappings) : <any>undefined;
            (<any>this).returnType = _data["returnType"];
            (<any>this).returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"], _mappings) : <any>undefined;
            (<any>this).attributes = _data["attributes"];
            (<any>this).methodImplementationFlags = _data["methodImplementationFlags"];
            (<any>this).callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"], _mappings) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"], _mappings) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): MethodInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MethodInfo>(data, _mappings, MethodInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMethodInfo {
    memberType?: MethodInfoMemberType | undefined;
    returnParameter?: ParameterInfo | undefined;
    returnType?: string | undefined;
    returnTypeCustomAttributes?: ICustomAttributeProvider | undefined;
    attributes?: MethodInfoAttributes | undefined;
    methodImplementationFlags?: MethodInfoMethodImplementationFlags | undefined;
    callingConvention?: MethodInfoCallingConvention | undefined;
    isAbstract?: boolean | undefined;
    isConstructor?: boolean | undefined;
    isFinal?: boolean | undefined;
    isHideBySig?: boolean | undefined;
    isSpecialName?: boolean | undefined;
    isStatic?: boolean | undefined;
    isVirtual?: boolean | undefined;
    isAssembly?: boolean | undefined;
    isFamily?: boolean | undefined;
    isFamilyAndAssembly?: boolean | undefined;
    isFamilyOrAssembly?: boolean | undefined;
    isPrivate?: boolean | undefined;
    isPublic?: boolean | undefined;
    isConstructedGenericMethod?: boolean | undefined;
    isGenericMethod?: boolean | undefined;
    isGenericMethodDefinition?: boolean | undefined;
    containsGenericParameters?: boolean | undefined;
    methodHandle?: RuntimeMethodHandle | undefined;
    isSecurityCritical?: boolean | undefined;
    isSecuritySafeCritical?: boolean | undefined;
    isSecurityTransparent?: boolean | undefined;
    name?: string | undefined;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module?: Module | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number | undefined;
}

export class ParameterInfo implements IParameterInfo {
    readonly attributes?: ParameterInfoAttributes | undefined;
    readonly member?: MemberInfo | undefined;
    readonly name?: string | undefined;
    readonly parameterType?: string | undefined;
    readonly position?: number | undefined;
    readonly isIn?: boolean | undefined;
    readonly isLcid?: boolean | undefined;
    readonly isOptional?: boolean | undefined;
    readonly isOut?: boolean | undefined;
    readonly isRetval?: boolean | undefined;
    readonly defaultValue?: any | undefined;
    readonly rawDefaultValue?: any | undefined;
    readonly hasDefaultValue?: boolean | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number | undefined;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).attributes = _data["attributes"];
            (<any>this).member = _data["member"] ? MemberInfo.fromJS(_data["member"], _mappings) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).parameterType = _data["parameterType"];
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): ParameterInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ParameterInfo>(data, _mappings, ParameterInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterInfoAttributes | undefined;
    member?: MemberInfo | undefined;
    name?: string | undefined;
    parameterType?: string | undefined;
    position?: number | undefined;
    isIn?: boolean | undefined;
    isLcid?: boolean | undefined;
    isOptional?: boolean | undefined;
    isOut?: boolean | undefined;
    isRetval?: boolean | undefined;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number | undefined;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): ICustomAttributeProvider | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ICustomAttributeProvider>(data, _mappings, ICustomAttributeProvider);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    readonly value?: any | undefined;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): RuntimeMethodHandle | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RuntimeMethodHandle>(data, _mappings, RuntimeMethodHandle);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value?: any | undefined;
}

export class Module implements IModule {
    readonly assembly?: Assembly | undefined;
    readonly fullyQualifiedName?: string | undefined;
    readonly name?: string | undefined;
    readonly mdStreamVersion?: number | undefined;
    readonly moduleVersionId?: string | undefined;
    readonly scopeName?: string | undefined;
    readonly moduleHandle?: ModuleHandle | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number | undefined;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"], _mappings) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            (<any>this).moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"], _mappings) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): Module | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Module>(data, _mappings, Module);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly?: Assembly | undefined;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion?: number | undefined;
    moduleVersionId?: string | undefined;
    scopeName?: string | undefined;
    moduleHandle?: ModuleHandle | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number | undefined;
}

export class CustomAttributeData implements ICustomAttributeData {
    readonly attributeType?: string | undefined;
    readonly constructor_?: ConstructorInfo | undefined;
    readonly constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).attributeType = _data["attributeType"];
            (<any>this).constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"], _mappings) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CustomAttributeData | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CustomAttributeData>(data, _mappings, CustomAttributeData);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: string | undefined;
    constructor_?: ConstructorInfo | undefined;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export class MemberInfo implements IMemberInfo {
    readonly memberType?: MemberInfoMemberType | undefined;
    readonly name?: string | undefined;
    readonly declaringType?: string | undefined;
    readonly reflectedType?: string | undefined;
    readonly module?: Module | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number | undefined;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"], _mappings) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): MemberInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MemberInfo>(data, _mappings, MemberInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType?: MemberInfoMemberType | undefined;
    name?: string | undefined;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module?: Module | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number | undefined;
}

export class Assembly implements IAssembly {
    readonly definedTypes?: string[] | undefined;
    readonly exportedTypes?: string[] | undefined;
    readonly codeBase?: string | undefined;
    readonly entryPoint?: MethodInfo | undefined;
    readonly fullName?: string | undefined;
    readonly imageRuntimeVersion?: string | undefined;
    readonly isDynamic?: boolean | undefined;
    readonly location?: string | undefined;
    readonly reflectionOnly?: boolean | undefined;
    readonly isFullyTrusted?: boolean | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly escapedCodeBase?: string | undefined;
    readonly manifestModule?: Module | undefined;
    readonly modules?: Module[] | undefined;
    readonly globalAssemblyCache?: boolean | undefined;
    readonly hostContext?: number | undefined;
    readonly securityRuleSet?: AssemblySecurityRuleSet | undefined;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(item);
            }
            (<any>this).codeBase = _data["codeBase"];
            (<any>this).entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"], _mappings) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            (<any>this).manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"], _mappings) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item, _mappings));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            (<any>this).securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any, _mappings?: any): Assembly | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Assembly>(data, _mappings, Assembly);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: string[] | undefined;
    exportedTypes?: string[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic?: boolean | undefined;
    location?: string | undefined;
    reflectionOnly?: boolean | undefined;
    isFullyTrusted?: boolean | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module | undefined;
    modules?: Module[] | undefined;
    globalAssemblyCache?: boolean | undefined;
    hostContext?: number | undefined;
    securityRuleSet?: AssemblySecurityRuleSet | undefined;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion?: number | undefined;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any, _mappings?: any): ModuleHandle | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ModuleHandle>(data, _mappings, ModuleHandle);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly memberType?: ConstructorInfoMemberType | undefined;
    readonly attributes?: ConstructorInfoAttributes | undefined;
    readonly methodImplementationFlags?: ConstructorInfoMethodImplementationFlags | undefined;
    readonly callingConvention?: ConstructorInfoCallingConvention | undefined;
    readonly isAbstract?: boolean | undefined;
    readonly isConstructor?: boolean | undefined;
    readonly isFinal?: boolean | undefined;
    readonly isHideBySig?: boolean | undefined;
    readonly isSpecialName?: boolean | undefined;
    readonly isStatic?: boolean | undefined;
    readonly isVirtual?: boolean | undefined;
    readonly isAssembly?: boolean | undefined;
    readonly isFamily?: boolean | undefined;
    readonly isFamilyAndAssembly?: boolean | undefined;
    readonly isFamilyOrAssembly?: boolean | undefined;
    readonly isPrivate?: boolean | undefined;
    readonly isPublic?: boolean | undefined;
    readonly isConstructedGenericMethod?: boolean | undefined;
    readonly isGenericMethod?: boolean | undefined;
    readonly isGenericMethodDefinition?: boolean | undefined;
    readonly containsGenericParameters?: boolean | undefined;
    readonly methodHandle?: RuntimeMethodHandle | undefined;
    readonly isSecurityCritical?: boolean | undefined;
    readonly isSecuritySafeCritical?: boolean | undefined;
    readonly isSecurityTransparent?: boolean | undefined;
    readonly name?: string | undefined;
    readonly declaringType?: string | undefined;
    readonly reflectedType?: string | undefined;
    readonly module?: Module | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number | undefined;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).attributes = _data["attributes"];
            (<any>this).methodImplementationFlags = _data["methodImplementationFlags"];
            (<any>this).callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"], _mappings) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"], _mappings) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item, _mappings));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConstructorInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConstructorInfo>(data, _mappings, ConstructorInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IConstructorInfo {
    memberType?: ConstructorInfoMemberType | undefined;
    attributes?: ConstructorInfoAttributes | undefined;
    methodImplementationFlags?: ConstructorInfoMethodImplementationFlags | undefined;
    callingConvention?: ConstructorInfoCallingConvention | undefined;
    isAbstract?: boolean | undefined;
    isConstructor?: boolean | undefined;
    isFinal?: boolean | undefined;
    isHideBySig?: boolean | undefined;
    isSpecialName?: boolean | undefined;
    isStatic?: boolean | undefined;
    isVirtual?: boolean | undefined;
    isAssembly?: boolean | undefined;
    isFamily?: boolean | undefined;
    isFamilyAndAssembly?: boolean | undefined;
    isFamilyOrAssembly?: boolean | undefined;
    isPrivate?: boolean | undefined;
    isPublic?: boolean | undefined;
    isConstructedGenericMethod?: boolean | undefined;
    isGenericMethod?: boolean | undefined;
    isGenericMethodDefinition?: boolean | undefined;
    containsGenericParameters?: boolean | undefined;
    methodHandle?: RuntimeMethodHandle | undefined;
    isSecurityCritical?: boolean | undefined;
    isSecuritySafeCritical?: boolean | undefined;
    isSecurityTransparent?: boolean | undefined;
    name?: string | undefined;
    declaringType?: string | undefined;
    reflectedType?: string | undefined;
    module?: Module | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number | undefined;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    readonly argumentType?: string | undefined;
    readonly value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).argumentType = _data["argumentType"];
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): CustomAttributeTypedArgument | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CustomAttributeTypedArgument>(data, _mappings, CustomAttributeTypedArgument);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: string | undefined;
    value?: any | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    readonly memberInfo?: MemberInfo | undefined;
    readonly typedValue?: CustomAttributeTypedArgument | undefined;
    readonly memberName?: string | undefined;
    readonly isField?: boolean | undefined;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"], _mappings) : <any>undefined;
            (<any>this).typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"], _mappings) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any, _mappings?: any): CustomAttributeNamedArgument | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CustomAttributeNamedArgument>(data, _mappings, CustomAttributeNamedArgument);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo | undefined;
    typedValue?: CustomAttributeTypedArgument | undefined;
    memberName?: string | undefined;
    isField?: boolean | undefined;
}

export class ValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements IValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: User | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
    item4?: any | undefined;

    constructor(data?: IValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? User.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            this.item3 = _data["item3"] ? LifeRenewalMailModel.fromJS(_data["item3"], _mappings) : <any>undefined;
            this.item4 = _data["item4"];
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, ValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        data["item3"] = this.item3 ? this.item3.toJSON() : <any>undefined;
        data["item4"] = this.item4;
        return data;
    }
}

export interface IValueTuple_4OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfLifeRenewalMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfObjectAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: User | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: LifeRenewalMailModel | undefined;
    item4?: any | undefined;
}

export class ValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements IValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: User | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: string[] | undefined;

    constructor(data?: IValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? User.fromJS(_data["item1"], _mappings) : <any>undefined;
            this.item2 = _data["item2"] ? ClientPolicyMailModel.fromJS(_data["item2"], _mappings) : <any>undefined;
            if (Array.isArray(_data["item3"])) {
                this.item3 = [] as any;
                for (let item of _data["item3"])
                    this.item3!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, ValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        if (Array.isArray(this.item3)) {
            data["item3"] = [];
            for (let item of this.item3)
                data["item3"].push(item);
        }
        return data;
    }
}

export interface IValueTuple_3OfOfUserAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfClientPolicyMailModelAndNotificationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringOfAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: User | undefined;
    item2?: ClientPolicyMailModel | undefined;
    item3?: string[] | undefined;
}

export class OfficeScheduleRequestForMobile implements IOfficeScheduleRequestForMobile {
    officeScheduleRequest?: OfficeScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IOfficeScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.officeScheduleRequest = _data["officeScheduleRequest"] ? OfficeScheduleRequest.fromJS(_data["officeScheduleRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): OfficeScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OfficeScheduleRequestForMobile>(data, _mappings, OfficeScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeScheduleRequest"] = this.officeScheduleRequest ? this.officeScheduleRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOfficeScheduleRequestForMobile {
    officeScheduleRequest?: OfficeScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class PayArenaCatalog implements IPayArenaCatalog {
    canChangePrice?: boolean | undefined;
    price?: number | undefined;
    standardPrices?: string | undefined;
    notify?: boolean | undefined;
    verifyParameters?: boolean | undefined;
    parameters?: Parameter[] | undefined;
    amountFromVendor?: boolean | undefined;
    name?: string | undefined;
    code?: string | undefined;
    parameterLabel?: string | undefined;
    parameterRegEx?: string | undefined;
    group?: string | undefined;
    order?: number | undefined;

    constructor(data?: IPayArenaCatalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.canChangePrice = _data["canChangePrice"];
            this.price = _data["price"];
            this.standardPrices = _data["standardPrices"];
            this.notify = _data["notify"];
            this.verifyParameters = _data["verifyParameters"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(Parameter.fromJS(item, _mappings));
            }
            this.amountFromVendor = _data["amountFromVendor"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.parameterLabel = _data["parameterLabel"];
            this.parameterRegEx = _data["parameterRegEx"];
            this.group = _data["group"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaCatalog | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaCatalog>(data, _mappings, PayArenaCatalog);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canChangePrice"] = this.canChangePrice;
        data["price"] = this.price;
        data["standardPrices"] = this.standardPrices;
        data["notify"] = this.notify;
        data["verifyParameters"] = this.verifyParameters;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["amountFromVendor"] = this.amountFromVendor;
        data["name"] = this.name;
        data["code"] = this.code;
        data["parameterLabel"] = this.parameterLabel;
        data["parameterRegEx"] = this.parameterRegEx;
        data["group"] = this.group;
        data["order"] = this.order;
        return data;
    }
}

export interface IPayArenaCatalog {
    canChangePrice?: boolean | undefined;
    price?: number | undefined;
    standardPrices?: string | undefined;
    notify?: boolean | undefined;
    verifyParameters?: boolean | undefined;
    parameters?: Parameter[] | undefined;
    amountFromVendor?: boolean | undefined;
    name?: string | undefined;
    code?: string | undefined;
    parameterLabel?: string | undefined;
    parameterRegEx?: string | undefined;
    group?: string | undefined;
    order?: number | undefined;
}

export class Parameter implements IParameter {
    label?: string | undefined;
    key?: string | undefined;
    regEx?: string | undefined;
    isRequired?: boolean | undefined;
    sendToSwitch?: boolean | undefined;
    order?: number | undefined;
    replaceAmount?: boolean | undefined;
    options?: string | undefined;

    constructor(data?: IParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.key = _data["key"];
            this.regEx = _data["regEx"];
            this.isRequired = _data["isRequired"];
            this.sendToSwitch = _data["sendToSwitch"];
            this.order = _data["order"];
            this.replaceAmount = _data["replaceAmount"];
            this.options = _data["options"];
        }
    }

    static fromJS(data: any, _mappings?: any): Parameter | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Parameter>(data, _mappings, Parameter);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["key"] = this.key;
        data["regEx"] = this.regEx;
        data["isRequired"] = this.isRequired;
        data["sendToSwitch"] = this.sendToSwitch;
        data["order"] = this.order;
        data["replaceAmount"] = this.replaceAmount;
        data["options"] = this.options;
        return data;
    }
}

export interface IParameter {
    label?: string | undefined;
    key?: string | undefined;
    regEx?: string | undefined;
    isRequired?: boolean | undefined;
    sendToSwitch?: boolean | undefined;
    order?: number | undefined;
    replaceAmount?: boolean | undefined;
    options?: string | undefined;
}

export class PayArenaVerifyRequest implements IPayArenaVerifyRequest {
    name?: string | undefined;
    code?: string | undefined;
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    transactionRef?: string | undefined;
    amount?: number | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    validityPeriod?: string | undefined;
    countryId?: string | undefined;
    passportUrl?: string | undefined;
    passportNumber?: string | undefined;
    travelParty?: string | undefined;
    travelPurpose?: string | undefined;
    preMedical?: string | undefined;
    medical?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;

    constructor(data?: IPayArenaVerifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.regNo = _data["regNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.cubicCap = _data["cubicCap"];
            this.yrManft = _data["yrManft"];
            this.carryCap = _data["carryCap"];
            this.bodyType = _data["bodyType"];
            this.engineNo = _data["engineNo"];
            this.chasisNo = _data["chasisNo"];
            this.color = _data["color"];
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.premiumAmount = _data["premiumAmount"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.validityPeriod = _data["validityPeriod"];
            this.countryId = _data["countryId"];
            this.passportUrl = _data["passportUrl"];
            this.passportNumber = _data["passportNumber"];
            this.travelParty = _data["travelParty"];
            this.travelPurpose = _data["travelPurpose"];
            this.preMedical = _data["preMedical"];
            this.medical = _data["medical"];
            this.vehicleLicenseUrl = _data["vehicleLicenseUrl"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.domiciledCountry = _data["domiciledCountry"];
            this.dlNo = _data["dlNo"];
            this.dlIssueDate = _data["dlIssueDate"] ? new Date(_data["dlIssueDate"].toString()) : <any>undefined;
            this.yearsOfDrvExperience = _data["yearsOfDrvExperience"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.townId = _data["townId"];
            this.productId = _data["productId"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaVerifyRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaVerifyRequest>(data, _mappings, PayArenaVerifyRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["regNo"] = this.regNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["cubicCap"] = this.cubicCap;
        data["yrManft"] = this.yrManft;
        data["carryCap"] = this.carryCap;
        data["bodyType"] = this.bodyType;
        data["engineNo"] = this.engineNo;
        data["chasisNo"] = this.chasisNo;
        data["color"] = this.color;
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["premiumAmount"] = this.premiumAmount;
        data["vehicleAmount"] = this.vehicleAmount;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["validityPeriod"] = this.validityPeriod;
        data["countryId"] = this.countryId;
        data["passportUrl"] = this.passportUrl;
        data["passportNumber"] = this.passportNumber;
        data["travelParty"] = this.travelParty;
        data["travelPurpose"] = this.travelPurpose;
        data["preMedical"] = this.preMedical;
        data["medical"] = this.medical;
        data["vehicleLicenseUrl"] = this.vehicleLicenseUrl;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["domiciledCountry"] = this.domiciledCountry;
        data["dlNo"] = this.dlNo;
        data["dlIssueDate"] = this.dlIssueDate ? this.dlIssueDate.toISOString() : <any>undefined;
        data["yearsOfDrvExperience"] = this.yearsOfDrvExperience;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["townId"] = this.townId;
        data["productId"] = this.productId;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayArenaVerifyRequest {
    name?: string | undefined;
    code?: string | undefined;
    regNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    cubicCap?: string | undefined;
    yrManft?: string | undefined;
    carryCap?: string | undefined;
    bodyType?: string | undefined;
    engineNo?: string | undefined;
    chasisNo?: string | undefined;
    color?: string | undefined;
    transactionRef?: string | undefined;
    amount?: number | undefined;
    premiumAmount?: number | undefined;
    vehicleAmount?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    validityPeriod?: string | undefined;
    countryId?: string | undefined;
    passportUrl?: string | undefined;
    passportNumber?: string | undefined;
    travelParty?: string | undefined;
    travelPurpose?: string | undefined;
    preMedical?: string | undefined;
    medical?: string | undefined;
    vehicleLicenseUrl?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    domiciledCountry?: string | undefined;
    dlNo?: string | undefined;
    dlIssueDate?: Date | undefined;
    yearsOfDrvExperience?: number | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    townId?: string | undefined;
    productId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
}

export class PayArenaVerificationResponse implements IPayArenaVerificationResponse {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    transactionRef?: string | undefined;
    amount?: number | undefined;
    premiumAmount?: number | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;

    constructor(data?: IPayArenaVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.transactionRef = _data["transactionRef"];
            this.amount = _data["amount"];
            this.premiumAmount = _data["premiumAmount"];
            this.wefDt = _data["wefDt"] ? new Date(_data["wefDt"].toString()) : <any>undefined;
            this.wetDt = _data["wetDt"] ? new Date(_data["wetDt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaVerificationResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaVerificationResponse>(data, _mappings, PayArenaVerificationResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["transactionRef"] = this.transactionRef;
        data["amount"] = this.amount;
        data["premiumAmount"] = this.premiumAmount;
        data["wefDt"] = this.wefDt ? this.wefDt.toISOString() : <any>undefined;
        data["wetDt"] = this.wetDt ? this.wetDt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayArenaVerificationResponse {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    transactionRef?: string | undefined;
    amount?: number | undefined;
    premiumAmount?: number | undefined;
    wefDt?: Date | undefined;
    wetDt?: Date | undefined;
}

export class PayArenaNotification implements IPayArenaNotification {
    amountPaid?: number | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;

    constructor(data?: IPayArenaNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amountPaid = _data["amountPaid"];
            this.transactionRef = _data["transactionRef"];
            this.paymentRef = _data["paymentRef"];
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaNotification | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaNotification>(data, _mappings, PayArenaNotification);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPaid"] = this.amountPaid;
        data["transactionRef"] = this.transactionRef;
        data["paymentRef"] = this.paymentRef;
        return data;
    }
}

export interface IPayArenaNotification {
    amountPaid?: number | undefined;
    transactionRef?: string | undefined;
    paymentRef?: string | undefined;
}

export class PayArenaPolicyDetails implements IPayArenaPolicyDetails {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    fullName?: string | undefined;
    agentName?: string | undefined;
    policies?: string | undefined;
    clientAddress?: string | undefined;
    clientEmail?: string | undefined;
    clientPhoneNumber?: string | undefined;
    wef?: string | undefined;
    wet?: string | undefined;
    totalAmount?: string | undefined;
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    hash?: string | undefined;
    responseMessage?: string | undefined;
    responseCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;

    constructor(data?: IPayArenaPolicyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.polledToTQ = false;
            this.isLoan = false;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.fullName = _data["fullName"];
            this.agentName = _data["agentName"];
            this.policies = _data["policies"];
            this.clientAddress = _data["clientAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhoneNumber = _data["clientPhoneNumber"];
            this.wef = _data["wef"];
            this.wet = _data["wet"];
            this.totalAmount = _data["totalAmount"];
            this.printPolicyUrl = _data["printPolicyUrl"];
            this.printReceiptUrl = _data["printReceiptUrl"];
            this.hash = _data["hash"];
            this.responseMessage = _data["responseMessage"];
            this.responseCode = _data["responseCode"];
            this.polledToTQ = _data["polledToTQ"] !== undefined ? _data["polledToTQ"] : false;
            this.isLoan = _data["isLoan"] !== undefined ? _data["isLoan"] : false;
        }
    }

    static fromJS(data: any, _mappings?: any): PayArenaPolicyDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PayArenaPolicyDetails>(data, _mappings, PayArenaPolicyDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["fullName"] = this.fullName;
        data["agentName"] = this.agentName;
        data["policies"] = this.policies;
        data["clientAddress"] = this.clientAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhoneNumber"] = this.clientPhoneNumber;
        data["wef"] = this.wef;
        data["wet"] = this.wet;
        data["totalAmount"] = this.totalAmount;
        data["printPolicyUrl"] = this.printPolicyUrl;
        data["printReceiptUrl"] = this.printReceiptUrl;
        data["hash"] = this.hash;
        data["responseMessage"] = this.responseMessage;
        data["responseCode"] = this.responseCode;
        data["polledToTQ"] = this.polledToTQ;
        data["isLoan"] = this.isLoan;
        return data;
    }
}

export interface IPayArenaPolicyDetails {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
    fullName?: string | undefined;
    agentName?: string | undefined;
    policies?: string | undefined;
    clientAddress?: string | undefined;
    clientEmail?: string | undefined;
    clientPhoneNumber?: string | undefined;
    wef?: string | undefined;
    wet?: string | undefined;
    totalAmount?: string | undefined;
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    hash?: string | undefined;
    responseMessage?: string | undefined;
    responseCode?: string | undefined;
    polledToTQ?: boolean | undefined;
    isLoan?: boolean | undefined;
}

export class DomesticTravelScheduleRequest implements IDomesticTravelScheduleRequest {
    flights?: Flight[] | undefined;
    passengers?: PassengerRequest[] | undefined;

    constructor(data?: IDomesticTravelScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(Flight.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerRequest.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DomesticTravelScheduleRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DomesticTravelScheduleRequest>(data, _mappings, DomesticTravelScheduleRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item.toJSON());
        }
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDomesticTravelScheduleRequest {
    flights?: Flight[] | undefined;
    passengers?: PassengerRequest[] | undefined;
}

export class Flight implements IFlight {
    flightNumber?: string | undefined;
    flightRoute?: string | undefined;
    travelDate?: Date | undefined;
    eta?: Date | undefined;

    constructor(data?: IFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.flightNumber = _data["flightNumber"];
            this.flightRoute = _data["flightRoute"];
            this.travelDate = _data["travelDate"] ? new Date(_data["travelDate"].toString()) : <any>undefined;
            this.eta = _data["eta"] ? new Date(_data["eta"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): Flight | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Flight>(data, _mappings, Flight);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightNumber"] = this.flightNumber;
        data["flightRoute"] = this.flightRoute;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : <any>undefined;
        data["eta"] = this.eta ? this.eta.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlight {
    flightNumber?: string | undefined;
    flightRoute?: string | undefined;
    travelDate?: Date | undefined;
    eta?: Date | undefined;
}

export class PassengerRequest implements IPassengerRequest {
    title?: string | undefined;
    recordId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;
    physicalAddress?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ticketNumber?: string | undefined;
    paymentRef?: string | undefined;
    premiumAmount?: number | undefined;
    beneficiary?: string | undefined;

    constructor(data?: IPassengerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.recordId = _data["recordId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.physicalAddress = _data["physicalAddress"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ticketNumber = _data["ticketNumber"];
            this.paymentRef = _data["paymentRef"];
            this.premiumAmount = _data["premiumAmount"];
            this.beneficiary = _data["beneficiary"];
        }
    }

    static fromJS(data: any, _mappings?: any): PassengerRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PassengerRequest>(data, _mappings, PassengerRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["recordId"] = this.recordId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["physicalAddress"] = this.physicalAddress;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ticketNumber"] = this.ticketNumber;
        data["paymentRef"] = this.paymentRef;
        data["premiumAmount"] = this.premiumAmount;
        data["beneficiary"] = this.beneficiary;
        return data;
    }
}

export interface IPassengerRequest {
    title?: string | undefined;
    recordId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;
    physicalAddress?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ticketNumber?: string | undefined;
    paymentRef?: string | undefined;
    premiumAmount?: number | undefined;
    beneficiary?: string | undefined;
}

export class DomesticTravelScheduleResponse implements IDomesticTravelScheduleResponse {
    flights?: Flight[] | undefined;
    passengers?: PassengerResponse[] | undefined;

    constructor(data?: IDomesticTravelScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(Flight.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerResponse.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DomesticTravelScheduleResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DomesticTravelScheduleResponse>(data, _mappings, DomesticTravelScheduleResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item.toJSON());
        }
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDomesticTravelScheduleResponse {
    flights?: Flight[] | undefined;
    passengers?: PassengerResponse[] | undefined;
}

export class PassengerResponse implements IPassengerResponse {
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    transactionRef?: string | undefined;
    title?: string | undefined;
    recordId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;
    physicalAddress?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ticketNumber?: string | undefined;
    paymentRef?: string | undefined;
    premiumAmount?: number | undefined;
    beneficiary?: string | undefined;

    constructor(data?: IPassengerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.printPolicyUrl = _data["printPolicyUrl"];
            this.printReceiptUrl = _data["printReceiptUrl"];
            this.transactionRef = _data["transactionRef"];
            this.title = _data["title"];
            this.recordId = _data["recordId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.physicalAddress = _data["physicalAddress"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ticketNumber = _data["ticketNumber"];
            this.paymentRef = _data["paymentRef"];
            this.premiumAmount = _data["premiumAmount"];
            this.beneficiary = _data["beneficiary"];
        }
    }

    static fromJS(data: any, _mappings?: any): PassengerResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PassengerResponse>(data, _mappings, PassengerResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printPolicyUrl"] = this.printPolicyUrl;
        data["printReceiptUrl"] = this.printReceiptUrl;
        data["transactionRef"] = this.transactionRef;
        data["title"] = this.title;
        data["recordId"] = this.recordId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["physicalAddress"] = this.physicalAddress;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ticketNumber"] = this.ticketNumber;
        data["paymentRef"] = this.paymentRef;
        data["premiumAmount"] = this.premiumAmount;
        data["beneficiary"] = this.beneficiary;
        return data;
    }
}

export interface IPassengerResponse {
    printPolicyUrl?: string | undefined;
    printReceiptUrl?: string | undefined;
    transactionRef?: string | undefined;
    title?: string | undefined;
    recordId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    email?: string | undefined;
    physicalAddress?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ticketNumber?: string | undefined;
    paymentRef?: string | undefined;
    premiumAmount?: number | undefined;
    beneficiary?: string | undefined;
}

export class PersonalAccidentScheduleForMobile implements IPersonalAccidentScheduleForMobile {
    accidentSchedule?: PersonalAccidentScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IPersonalAccidentScheduleForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accidentSchedule = _data["accidentSchedule"] ? PersonalAccidentScheduleRequest.fromJS(_data["accidentSchedule"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): PersonalAccidentScheduleForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonalAccidentScheduleForMobile>(data, _mappings, PersonalAccidentScheduleForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accidentSchedule"] = this.accidentSchedule ? this.accidentSchedule.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonalAccidentScheduleForMobile {
    accidentSchedule?: PersonalAccidentScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class AllPolicy implements IAllPolicy {
    policyNo?: string | undefined;
    insured?: string | undefined;
    policyWithEffectTo?: string | undefined;
    sumInsured?: string | undefined;
    premium?: string | undefined;
    futureAnnumPremium?: string | undefined;
    currency?: string | undefined;
    risk_passport_no_vehicle_no?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IAllPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNo = _data["policyNo"];
            this.insured = _data["insured"];
            this.policyWithEffectTo = _data["policyWithEffectTo"];
            this.sumInsured = _data["sumInsured"];
            this.premium = _data["premium"];
            this.futureAnnumPremium = _data["futureAnnumPremium"];
            this.currency = _data["currency"];
            this.risk_passport_no_vehicle_no = _data["risk/passport_no/vehicle_no"];
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): AllPolicy | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AllPolicy>(data, _mappings, AllPolicy);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNo"] = this.policyNo;
        data["insured"] = this.insured;
        data["policyWithEffectTo"] = this.policyWithEffectTo;
        data["sumInsured"] = this.sumInsured;
        data["premium"] = this.premium;
        data["futureAnnumPremium"] = this.futureAnnumPremium;
        data["currency"] = this.currency;
        data["risk/passport_no/vehicle_no"] = this.risk_passport_no_vehicle_no;
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IAllPolicy {
    policyNo?: string | undefined;
    insured?: string | undefined;
    policyWithEffectTo?: string | undefined;
    sumInsured?: string | undefined;
    premium?: string | undefined;
    futureAnnumPremium?: string | undefined;
    currency?: string | undefined;
    risk_passport_no_vehicle_no?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
}

export class LifeProductDto implements ILifeProductDto {
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productCoverTypeName?: string | undefined;

    constructor(data?: ILifeProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.productCoverTypeName = _data["productCoverTypeName"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeProductDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeProductDto>(data, _mappings, LifeProductDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productCoverTypeName"] = this.productCoverTypeName;
        return data;
    }
}

export interface ILifeProductDto {
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productCoverTypeName?: string | undefined;
}

export class LifeProductListDto implements ILifeProductListDto {
    lifeProductDto?: LifeProductDto[] | undefined;
    productOptionsDto?: LifeProductDto | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;

    constructor(data?: ILifeProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["lifeProductDto"])) {
                this.lifeProductDto = [] as any;
                for (let item of _data["lifeProductDto"])
                    this.lifeProductDto!.push(LifeProductDto.fromJS(item, _mappings));
            }
            this.productOptionsDto = _data["productOptionsDto"] ? LifeProductDto.fromJS(_data["productOptionsDto"], _mappings) : <any>undefined;
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): LifeProductListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LifeProductListDto>(data, _mappings, LifeProductListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lifeProductDto)) {
            data["lifeProductDto"] = [];
            for (let item of this.lifeProductDto)
                data["lifeProductDto"].push(item.toJSON());
        }
        data["productOptionsDto"] = this.productOptionsDto ? this.productOptionsDto.toJSON() : <any>undefined;
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ILifeProductListDto {
    lifeProductDto?: LifeProductDto[] | undefined;
    productOptionsDto?: LifeProductDto | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
    amount?: number | undefined;
}

export class ProductParams implements IProductParams {
    productCode!: number;
    productOptionsCode!: number;
    productCoverTypes!: string[];
    gender!: string;
    frequencyOfPayment!: string;
    effectiveDate!: Date;
    readonly life_Rider?: string | undefined;
    dateofBirth!: Date;
    productMethods!: string;
    sumInsurance!: number;
    pctCode?: number | undefined;
    pctCvtCode?: number | undefined;
    pctCvtName?: string | undefined;
    term?: number | undefined;

    constructor(data?: IProductParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productCoverTypes = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productOptionsCode = _data["productOptionsCode"];
            if (Array.isArray(_data["productCoverTypes"])) {
                this.productCoverTypes = [] as any;
                for (let item of _data["productCoverTypes"])
                    this.productCoverTypes!.push(item);
            }
            this.gender = _data["gender"];
            this.frequencyOfPayment = _data["frequencyOfPayment"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            (<any>this).life_Rider = _data["life_Rider"];
            this.dateofBirth = _data["dateofBirth"] ? new Date(_data["dateofBirth"].toString()) : <any>undefined;
            this.productMethods = _data["productMethods"];
            this.sumInsurance = _data["sumInsurance"];
            this.pctCode = _data["pctCode"];
            this.pctCvtCode = _data["pctCvtCode"];
            this.pctCvtName = _data["pctCvtName"];
            this.term = _data["term"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductParams | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductParams>(data, _mappings, ProductParams);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productOptionsCode"] = this.productOptionsCode;
        if (Array.isArray(this.productCoverTypes)) {
            data["productCoverTypes"] = [];
            for (let item of this.productCoverTypes)
                data["productCoverTypes"].push(item);
        }
        data["gender"] = this.gender;
        data["frequencyOfPayment"] = this.frequencyOfPayment;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["life_Rider"] = this.life_Rider;
        data["dateofBirth"] = this.dateofBirth ? this.dateofBirth.toISOString() : <any>undefined;
        data["productMethods"] = this.productMethods;
        data["sumInsurance"] = this.sumInsurance;
        data["pctCode"] = this.pctCode;
        data["pctCvtCode"] = this.pctCvtCode;
        data["pctCvtName"] = this.pctCvtName;
        data["term"] = this.term;
        return data;
    }
}

export interface IProductParams {
    productCode: number;
    productOptionsCode: number;
    productCoverTypes: string[];
    gender: string;
    frequencyOfPayment: string;
    effectiveDate: Date;
    life_Rider?: string | undefined;
    dateofBirth: Date;
    productMethods: string;
    sumInsurance: number;
    pctCode?: number | undefined;
    pctCvtCode?: number | undefined;
    pctCvtName?: string | undefined;
    term?: number | undefined;
}

export class CalculatedResult implements ICalculatedResult {
    isSuccessful?: boolean | undefined;
    amount?: string | undefined;
    responseMessage?: string | undefined;
    policyFee?: string | undefined;
    totalWithApplyFee?: string | undefined;
    totalWithoutApplyFee?: string | undefined;
    calculatedCoverTypes?: CalculatedCoverType[] | undefined;

    constructor(data?: ICalculatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.amount = _data["amount"];
            this.responseMessage = _data["responseMessage"];
            this.policyFee = _data["policyFee"];
            this.totalWithApplyFee = _data["totalWithApplyFee"];
            this.totalWithoutApplyFee = _data["totalWithoutApplyFee"];
            if (Array.isArray(_data["calculatedCoverTypes"])) {
                this.calculatedCoverTypes = [] as any;
                for (let item of _data["calculatedCoverTypes"])
                    this.calculatedCoverTypes!.push(CalculatedCoverType.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CalculatedResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalculatedResult>(data, _mappings, CalculatedResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["amount"] = this.amount;
        data["responseMessage"] = this.responseMessage;
        data["policyFee"] = this.policyFee;
        data["totalWithApplyFee"] = this.totalWithApplyFee;
        data["totalWithoutApplyFee"] = this.totalWithoutApplyFee;
        if (Array.isArray(this.calculatedCoverTypes)) {
            data["calculatedCoverTypes"] = [];
            for (let item of this.calculatedCoverTypes)
                data["calculatedCoverTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculatedResult {
    isSuccessful?: boolean | undefined;
    amount?: string | undefined;
    responseMessage?: string | undefined;
    policyFee?: string | undefined;
    totalWithApplyFee?: string | undefined;
    totalWithoutApplyFee?: string | undefined;
    calculatedCoverTypes?: CalculatedCoverType[] | undefined;
}

export class CalculatedCoverType implements ICalculatedCoverType {
    coverTypeAmount?: string | undefined;

    constructor(data?: ICalculatedCoverType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.coverTypeAmount = _data["coverTypeAmount"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalculatedCoverType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalculatedCoverType>(data, _mappings, CalculatedCoverType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coverTypeAmount"] = this.coverTypeAmount;
        return data;
    }
}

export interface ICalculatedCoverType {
    coverTypeAmount?: string | undefined;
}

export class ProposalRequest implements IProposalRequest {
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    beneficiaries?: BeneficiaryModel[] | undefined;

    constructor(data?: IProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.rateCode = _data["rateCode"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.effectiveDate = _data["effectiveDate"];
            this.sumAssured = _data["sumAssured"];
            this.premium = _data["premium"];
            this.term = _data["term"];
            this.policyFee = _data["policyFee"];
            this.agentShortDescription = _data["agentShortDescription"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.nextOfKinName = _data["nextOfKinName"];
            this.nextOfKinPhone = _data["nextOfKinPhone"];
            this.nextOfKinRelationship = _data["nextOfKinRelationship"];
            this.nextOfKinAddress = _data["nextOfKinAddress"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(BeneficiaryModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProposalRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProposalRequest>(data, _mappings, ProposalRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["rateCode"] = this.rateCode;
        data["paymentFrequency"] = this.paymentFrequency;
        data["effectiveDate"] = this.effectiveDate;
        data["sumAssured"] = this.sumAssured;
        data["premium"] = this.premium;
        data["term"] = this.term;
        data["policyFee"] = this.policyFee;
        data["agentShortDescription"] = this.agentShortDescription;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["nextOfKinName"] = this.nextOfKinName;
        data["nextOfKinPhone"] = this.nextOfKinPhone;
        data["nextOfKinRelationship"] = this.nextOfKinRelationship;
        data["nextOfKinAddress"] = this.nextOfKinAddress;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProposalRequest {
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    rateCode?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    sumAssured?: string | undefined;
    premium?: string | undefined;
    term?: number | undefined;
    policyFee?: number | undefined;
    agentShortDescription?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    nextOfKinName?: string | undefined;
    nextOfKinPhone?: string | undefined;
    nextOfKinRelationship?: string | undefined;
    nextOfKinAddress?: string | undefined;
    beneficiaries?: BeneficiaryModel[] | undefined;
}

export class BeneficiaryModel implements IBeneficiaryModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    relationship?: string | undefined;
    address?: string | undefined;

    constructor(data?: IBeneficiaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.relationship = _data["relationship"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any, _mappings?: any): BeneficiaryModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BeneficiaryModel>(data, _mappings, BeneficiaryModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["relationship"] = this.relationship;
        data["address"] = this.address;
        return data;
    }
}

export interface IBeneficiaryModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    relationship?: string | undefined;
    address?: string | undefined;
}

export class ProposalDto implements IProposalDto {
    proposalNumber?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalNumber = _data["proposalNumber"];
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProposalDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProposalDto>(data, _mappings, ProposalDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalNumber"] = this.proposalNumber;
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IProposalDto {
    proposalNumber?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
}

export class BranchDto implements IBranchDto {
    branchCode?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.branchCode = _data["branchCode"];
            this.isSuccessful = _data["isSuccessful"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): BranchDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BranchDto>(data, _mappings, BranchDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchCode"] = this.branchCode;
        data["isSuccessful"] = this.isSuccessful;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IBranchDto {
    branchCode?: string | undefined;
    isSuccessful?: boolean | undefined;
    responseMessage?: string | undefined;
}

export class NcspCalculatedRequest implements INcspCalculatedRequest {
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    premiumOrSumAssured?: number | undefined;
    investmentAmount?: number | undefined;
    targetType?: string | undefined;
    term?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: INcspCalculatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.effectiveDate = _data["effectiveDate"];
            this.premiumOrSumAssured = _data["premiumOrSumAssured"];
            this.investmentAmount = _data["investmentAmount"];
            this.targetType = _data["targetType"];
            this.term = _data["term"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): NcspCalculatedRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NcspCalculatedRequest>(data, _mappings, NcspCalculatedRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["paymentFrequency"] = this.paymentFrequency;
        data["effectiveDate"] = this.effectiveDate;
        data["premiumOrSumAssured"] = this.premiumOrSumAssured;
        data["investmentAmount"] = this.investmentAmount;
        data["targetType"] = this.targetType;
        data["term"] = this.term;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface INcspCalculatedRequest {
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    premiumOrSumAssured?: number | undefined;
    investmentAmount?: number | undefined;
    targetType?: string | undefined;
    term?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
}

export class NcspCalculatedResult implements INcspCalculatedResult {
    isSuccessful?: boolean | undefined;
    message?: string | undefined;
    totalBenefit?: number | undefined;
    amountToPay?: number | undefined;
    annualPremium?: number | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    premiumOrSumAssured?: number | undefined;
    investmentAmount?: number | undefined;
    targetType?: string | undefined;
    term?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: INcspCalculatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.message = _data["message"];
            this.totalBenefit = _data["totalBenefit"];
            this.amountToPay = _data["amountToPay"];
            this.annualPremium = _data["annualPremium"];
            this.title = _data["title"];
            this.surName = _data["surName"];
            this.otherNames = _data["otherNames"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.dob = _data["dob"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.paymentFrequency = _data["paymentFrequency"];
            this.effectiveDate = _data["effectiveDate"];
            this.premiumOrSumAssured = _data["premiumOrSumAssured"];
            this.investmentAmount = _data["investmentAmount"];
            this.targetType = _data["targetType"];
            this.term = _data["term"];
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): NcspCalculatedResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NcspCalculatedResult>(data, _mappings, NcspCalculatedResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["message"] = this.message;
        data["totalBenefit"] = this.totalBenefit;
        data["amountToPay"] = this.amountToPay;
        data["annualPremium"] = this.annualPremium;
        data["title"] = this.title;
        data["surName"] = this.surName;
        data["otherNames"] = this.otherNames;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["dob"] = this.dob;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["paymentFrequency"] = this.paymentFrequency;
        data["effectiveDate"] = this.effectiveDate;
        data["premiumOrSumAssured"] = this.premiumOrSumAssured;
        data["investmentAmount"] = this.investmentAmount;
        data["targetType"] = this.targetType;
        data["term"] = this.term;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface INcspCalculatedResult {
    isSuccessful?: boolean | undefined;
    message?: string | undefined;
    totalBenefit?: number | undefined;
    amountToPay?: number | undefined;
    annualPremium?: number | undefined;
    title?: string | undefined;
    surName?: string | undefined;
    otherNames?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    dob?: string | undefined;
    gender?: string | undefined;
    address?: string | undefined;
    paymentFrequency?: string | undefined;
    effectiveDate?: string | undefined;
    premiumOrSumAssured?: number | undefined;
    investmentAmount?: number | undefined;
    targetType?: string | undefined;
    term?: number | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
}

export class QuoteMailModel implements IQuoteMailModel {
    customerName?: string | undefined;
    customerEmail?: string | undefined;
    productName?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: string | undefined;
    ageAtEntry?: string | undefined;
    productType?: string | undefined;
    duration?: string | undefined;
    premium?: string | undefined;
    premiumFrequency?: string | undefined;
    sumAssured?: string | undefined;
    paymentLink?: string | undefined;
    agentName?: string | undefined;
    agentNumber?: string | undefined;

    constructor(data?: IQuoteMailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.customerEmail = _data["customerEmail"];
            this.productName = _data["productName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.age = _data["age"];
            this.ageAtEntry = _data["ageAtEntry"];
            this.productType = _data["productType"];
            this.duration = _data["duration"];
            this.premium = _data["premium"];
            this.premiumFrequency = _data["premiumFrequency"];
            this.sumAssured = _data["sumAssured"];
            this.paymentLink = _data["paymentLink"];
            this.agentName = _data["agentName"];
            this.agentNumber = _data["agentNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): QuoteMailModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<QuoteMailModel>(data, _mappings, QuoteMailModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerEmail"] = this.customerEmail;
        data["productName"] = this.productName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["age"] = this.age;
        data["ageAtEntry"] = this.ageAtEntry;
        data["productType"] = this.productType;
        data["duration"] = this.duration;
        data["premium"] = this.premium;
        data["premiumFrequency"] = this.premiumFrequency;
        data["sumAssured"] = this.sumAssured;
        data["paymentLink"] = this.paymentLink;
        data["agentName"] = this.agentName;
        data["agentNumber"] = this.agentNumber;
        return data;
    }
}

export interface IQuoteMailModel {
    customerName?: string | undefined;
    customerEmail?: string | undefined;
    productName?: string | undefined;
    dateOfBirth?: string | undefined;
    age?: string | undefined;
    ageAtEntry?: string | undefined;
    productType?: string | undefined;
    duration?: string | undefined;
    premium?: string | undefined;
    premiumFrequency?: string | undefined;
    sumAssured?: string | undefined;
    paymentLink?: string | undefined;
    agentName?: string | undefined;
    agentNumber?: string | undefined;
}

export class NscpScheduleRequestForMobile implements INscpScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: INscpScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): NscpScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NscpScheduleRequestForMobile>(data, _mappings, NscpScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface INscpScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class FepScheduleRequestForMobile implements IFepScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IFepScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): FepScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FepScheduleRequestForMobile>(data, _mappings, FepScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFepScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class CepScheduleRequestForMobile implements ICepScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: ICepScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): CepScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CepScheduleRequestForMobile>(data, _mappings, CepScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICepScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class DapScheduleRequestForMobile implements IDapScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IDapScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): DapScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DapScheduleRequestForMobile>(data, _mappings, DapScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDapScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class LtaScheduleRequestForMobile implements ILtaScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: ILtaScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): LtaScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LtaScheduleRequestForMobile>(data, _mappings, LtaScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILtaScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class MwScheduleRequestForMobile implements IMwScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IMwScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proposalRequest = _data["proposalRequest"] ? ProposalRequest.fromJS(_data["proposalRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): MwScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MwScheduleRequestForMobile>(data, _mappings, MwScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalRequest"] = this.proposalRequest ? this.proposalRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMwScheduleRequestForMobile {
    proposalRequest?: ProposalRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: SuccessfulCardChargeResponse | undefined;
    readonly item2?: string | undefined;

    constructor(data?: ITuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? SuccessfulCardChargeResponse.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfOfSuccessfulCardChargeResponseAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: SuccessfulCardChargeResponse | undefined;
    item2?: string | undefined;
}

export class ValidatechargeInput implements IValidatechargeInput {
    pbfPubKey?: string | undefined;
    flwRef!: string;
    transRef!: string;
    otp!: number;

    constructor(data?: IValidatechargeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.pbfPubKey = _data["pbfPubKey"];
            this.flwRef = _data["flwRef"];
            this.transRef = _data["transRef"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any, _mappings?: any): ValidatechargeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValidatechargeInput>(data, _mappings, ValidatechargeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pbfPubKey"] = this.pbfPubKey;
        data["flwRef"] = this.flwRef;
        data["transRef"] = this.transRef;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IValidatechargeInput {
    pbfPubKey?: string | undefined;
    flwRef: string;
    transRef: string;
    otp: number;
}

export class Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ITuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    readonly item1?: PolicyDetails | undefined;
    readonly item2?: string | undefined;

    constructor(data?: ITuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] ? PolicyDetails.fromJS(_data["item1"], _mappings) : <any>undefined;
            (<any>this).item2 = _data["item2"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(data, _mappings, Tuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITuple_2OfOfPolicyDetailsAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_nullAndOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    item1?: PolicyDetails | undefined;
    item2?: string | undefined;
}

export class RenewalInputModel implements IRenewalInputModel {
    policyNumber?: string | undefined;
    authCode?: string | undefined;

    constructor(data?: IRenewalInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.authCode = _data["authCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): RenewalInputModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RenewalInputModel>(data, _mappings, RenewalInputModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["authCode"] = this.authCode;
        return data;
    }
}

export interface IRenewalInputModel {
    policyNumber?: string | undefined;
    authCode?: string | undefined;
}

export class RenewalDtoViewModel implements IRenewalDtoViewModel {
    policy?: string | undefined;
    fail?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    lifeRenewalDetails?: LifeRenewalDetails | undefined;
    flutterWavePubKey?: string | undefined;
    flutterWaveSecKey?: string | undefined;

    constructor(data?: IRenewalDtoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.policy = _data["policy"];
            this.fail = _data["fail"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.lifeRenewalDetails = _data["lifeRenewalDetails"] ? LifeRenewalDetails.fromJS(_data["lifeRenewalDetails"], _mappings) : <any>undefined;
            this.flutterWavePubKey = _data["flutterWavePubKey"];
            this.flutterWaveSecKey = _data["flutterWaveSecKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): RenewalDtoViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RenewalDtoViewModel>(data, _mappings, RenewalDtoViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy"] = this.policy;
        data["fail"] = this.fail;
        data["success"] = this.success;
        data["message"] = this.message;
        data["lifeRenewalDetails"] = this.lifeRenewalDetails ? this.lifeRenewalDetails.toJSON() : <any>undefined;
        data["flutterWavePubKey"] = this.flutterWavePubKey;
        data["flutterWaveSecKey"] = this.flutterWaveSecKey;
        return data;
    }
}

export interface IRenewalDtoViewModel {
    policy?: string | undefined;
    fail?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    lifeRenewalDetails?: LifeRenewalDetails | undefined;
    flutterWavePubKey?: string | undefined;
    flutterWaveSecKey?: string | undefined;
}

export class PostLifeRenewalViewModel implements IPostLifeRenewalViewModel {
    fail?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    lifeRenewalTran?: LifeRenewalTran | undefined;

    constructor(data?: IPostLifeRenewalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fail = _data["fail"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.lifeRenewalTran = _data["lifeRenewalTran"] ? LifeRenewalTran.fromJS(_data["lifeRenewalTran"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): PostLifeRenewalViewModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PostLifeRenewalViewModel>(data, _mappings, PostLifeRenewalViewModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fail"] = this.fail;
        data["success"] = this.success;
        data["message"] = this.message;
        data["lifeRenewalTran"] = this.lifeRenewalTran ? this.lifeRenewalTran.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPostLifeRenewalViewModel {
    fail?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    lifeRenewalTran?: LifeRenewalTran | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    isStatic?: boolean | undefined;
    permissions?: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRoleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRoleDto>(data, _mappings, CreateRoleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    isStatic?: boolean | undefined;
    permissions?: string[] | undefined;
}

export class ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: PermissionDto[] | undefined;

    constructor(data?: IListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDto_1OfOfPermissionDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): PermissionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PermissionDto>(data, _mappings, PermissionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IPermissionDto {
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
}

export class PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: RoleDto[] | undefined;

    constructor(data?: IPagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, PagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: RoleDto[] | undefined;
}

export class ShopScheduleRequestForMobile implements IShopScheduleRequestForMobile {
    shopScheduleRequest?: ShopScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: IShopScheduleRequestForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shopScheduleRequest = _data["shopScheduleRequest"] ? ShopScheduleRequest.fromJS(_data["shopScheduleRequest"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ShopScheduleRequestForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShopScheduleRequestForMobile>(data, _mappings, ShopScheduleRequestForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopScheduleRequest"] = this.shopScheduleRequest ? this.shopScheduleRequest.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShopScheduleRequestForMobile {
    shopScheduleRequest?: ShopScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class BeneficiaryUpdateModel implements IBeneficiaryUpdateModel {
    fullName?: string | undefined;
    clientId?: string | undefined;
    policyNo?: string | undefined;
    transactionRef!: string;
    email?: string | undefined;
    beneficiaryFullName!: string;
    beneficiaryPhoneNumber!: string;
    beneficiaryDateOfBirth?: Date | undefined;

    constructor(data?: IBeneficiaryUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.clientId = _data["clientId"];
            this.policyNo = _data["policyNo"];
            this.transactionRef = _data["transactionRef"];
            this.email = _data["email"];
            this.beneficiaryFullName = _data["beneficiaryFullName"];
            this.beneficiaryPhoneNumber = _data["beneficiaryPhoneNumber"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): BeneficiaryUpdateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BeneficiaryUpdateModel>(data, _mappings, BeneficiaryUpdateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["clientId"] = this.clientId;
        data["policyNo"] = this.policyNo;
        data["transactionRef"] = this.transactionRef;
        data["email"] = this.email;
        data["beneficiaryFullName"] = this.beneficiaryFullName;
        data["beneficiaryPhoneNumber"] = this.beneficiaryPhoneNumber;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBeneficiaryUpdateModel {
    fullName?: string | undefined;
    clientId?: string | undefined;
    policyNo?: string | undefined;
    transactionRef: string;
    email?: string | undefined;
    beneficiaryFullName: string;
    beneficiaryPhoneNumber: string;
    beneficiaryDateOfBirth?: Date | undefined;
}

export class TermLifeRequest implements ITermLifeRequest {
    transactionRef?: string | undefined;
    premium?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    policyNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    countryId?: string | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;

    constructor(data?: ITermLifeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionRef = _data["transactionRef"];
            this.premium = _data["premium"];
            this.partnerReference = _data["partnerReference"];
            this.hash = _data["hash"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.policyNumber = _data["policyNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.pryEmail = _data["pryEmail"];
            this.branchId = _data["branchId"];
            this.countryId = _data["countryId"];
            this.physicalAddrs = _data["physicalAddrs"];
            this.smsTel = _data["smsTel"];
            this.productId = _data["productId"];
            this.intermediaryId = _data["intermediaryId"];
            this.subclassSectCovtypeId = _data["subclassSectCovtypeId"];
            this.titleId = _data["titleId"];
            this.genderId = _data["genderId"];
            this.clientCategoryId = _data["clientCategoryId"];
            this.clientId = _data["clientId"];
            this.wef = _data["wef"] ? new Date(_data["wef"].toString()) : <any>undefined;
            this.wet = _data["wet"] ? new Date(_data["wet"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.ravePublicKey = _data["ravePublicKey"];
            this.interswitchMacKey = _data["interswitchMacKey"];
            this.interswitchPaymentUrl = _data["interswitchPaymentUrl"];
            this.interswitchProductId = _data["interswitchProductId"];
            this.interswitchProductItemId = _data["interswitchProductItemId"];
            this.wemaBankMacKey = _data["wemaBankMacKey"];
            this.wemaBankPaymentUrl = _data["wemaBankPaymentUrl"];
            this.referralCode = _data["referralCode"];
            this.paymentChannel = _data["paymentChannel"];
            this.beneficiaryFullname = _data["beneficiaryFullname"];
            this.beneficiaryPhone = _data["beneficiaryPhone"];
            this.beneficiaryDateOfBirth = _data["beneficiaryDateOfBirth"] ? new Date(_data["beneficiaryDateOfBirth"].toString()) : <any>undefined;
            this.clientShortDescription = _data["clientShortDescription"];
            this.agentShortDescription = _data["agentShortDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): TermLifeRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TermLifeRequest>(data, _mappings, TermLifeRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionRef"] = this.transactionRef;
        data["premium"] = this.premium;
        data["partnerReference"] = this.partnerReference;
        data["hash"] = this.hash;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["policyNumber"] = this.policyNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["pryEmail"] = this.pryEmail;
        data["branchId"] = this.branchId;
        data["countryId"] = this.countryId;
        data["physicalAddrs"] = this.physicalAddrs;
        data["smsTel"] = this.smsTel;
        data["productId"] = this.productId;
        data["intermediaryId"] = this.intermediaryId;
        data["subclassSectCovtypeId"] = this.subclassSectCovtypeId;
        data["titleId"] = this.titleId;
        data["genderId"] = this.genderId;
        data["clientCategoryId"] = this.clientCategoryId;
        data["clientId"] = this.clientId;
        data["wef"] = this.wef ? this.wef.toISOString() : <any>undefined;
        data["wet"] = this.wet ? this.wet.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["ravePublicKey"] = this.ravePublicKey;
        data["interswitchMacKey"] = this.interswitchMacKey;
        data["interswitchPaymentUrl"] = this.interswitchPaymentUrl;
        data["interswitchProductId"] = this.interswitchProductId;
        data["interswitchProductItemId"] = this.interswitchProductItemId;
        data["wemaBankMacKey"] = this.wemaBankMacKey;
        data["wemaBankPaymentUrl"] = this.wemaBankPaymentUrl;
        data["referralCode"] = this.referralCode;
        data["paymentChannel"] = this.paymentChannel;
        data["beneficiaryFullname"] = this.beneficiaryFullname;
        data["beneficiaryPhone"] = this.beneficiaryPhone;
        data["beneficiaryDateOfBirth"] = this.beneficiaryDateOfBirth ? this.beneficiaryDateOfBirth.toISOString() : <any>undefined;
        data["clientShortDescription"] = this.clientShortDescription;
        data["agentShortDescription"] = this.agentShortDescription;
        return data;
    }
}

export interface ITermLifeRequest {
    transactionRef?: string | undefined;
    premium?: number | undefined;
    partnerReference?: string | undefined;
    hash?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    policyNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    pryEmail?: string | undefined;
    branchId?: string | undefined;
    countryId?: string | undefined;
    physicalAddrs?: string | undefined;
    smsTel?: string | undefined;
    productId?: string | undefined;
    intermediaryId?: string | undefined;
    subclassSectCovtypeId?: string | undefined;
    titleId?: string | undefined;
    genderId?: string | undefined;
    clientCategoryId?: string | undefined;
    clientId?: string | undefined;
    wef?: Date | undefined;
    wet?: Date | undefined;
    userId?: number | undefined;
    ravePublicKey?: string | undefined;
    interswitchMacKey?: string | undefined;
    interswitchPaymentUrl?: string | undefined;
    interswitchProductId?: string | undefined;
    interswitchProductItemId?: string | undefined;
    wemaBankMacKey?: string | undefined;
    wemaBankPaymentUrl?: string | undefined;
    referralCode?: string | undefined;
    paymentChannel?: string | undefined;
    beneficiaryFullname?: string | undefined;
    beneficiaryPhone?: string | undefined;
    beneficiaryDateOfBirth?: Date | undefined;
    clientShortDescription?: string | undefined;
    agentShortDescription?: string | undefined;
}

export class TermLifeTransaction implements ITermLifeTransaction {
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    policyNumber?: string | undefined;
    coverType?: string | undefined;
    policyDuration?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;

    constructor(data?: ITermLifeTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.payee = _data["payee"];
            this.paymentReference = _data["paymentReference"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.channelName = _data["channelName"];
            this.dateOfPolicy = _data["dateOfPolicy"];
            this.channelOfPayment = _data["channelOfPayment"];
            this.policyType = _data["policyType"];
            this.status = _data["status"];
            this.policyNumber = _data["policyNumber"];
            this.coverType = _data["coverType"];
            this.policyDuration = _data["policyDuration"];
            this.utilityBillName = _data["utilityBillName"];
            this.utilityBillUrl = _data["utilityBillUrl"];
            this.identificationName = _data["identificationName"];
            this.identificationUrl = _data["identificationUrl"];
            this.referralCode = _data["referralCode"];
            this.benName = _data["benName"];
            this.benPhoneNumber = _data["benPhoneNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): TermLifeTransaction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TermLifeTransaction>(data, _mappings, TermLifeTransaction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payee"] = this.payee;
        data["paymentReference"] = this.paymentReference;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["channelName"] = this.channelName;
        data["dateOfPolicy"] = this.dateOfPolicy;
        data["channelOfPayment"] = this.channelOfPayment;
        data["policyType"] = this.policyType;
        data["status"] = this.status;
        data["policyNumber"] = this.policyNumber;
        data["coverType"] = this.coverType;
        data["policyDuration"] = this.policyDuration;
        data["utilityBillName"] = this.utilityBillName;
        data["utilityBillUrl"] = this.utilityBillUrl;
        data["identificationName"] = this.identificationName;
        data["identificationUrl"] = this.identificationUrl;
        data["referralCode"] = this.referralCode;
        data["benName"] = this.benName;
        data["benPhoneNumber"] = this.benPhoneNumber;
        return data;
    }
}

export interface ITermLifeTransaction {
    payee?: string | undefined;
    paymentReference?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    totalAmountPaid?: number | undefined;
    channelName?: string | undefined;
    dateOfPolicy?: string | undefined;
    channelOfPayment?: string | undefined;
    policyType?: string | undefined;
    status?: string | undefined;
    policyNumber?: string | undefined;
    coverType?: string | undefined;
    policyDuration?: string | undefined;
    utilityBillName?: string | undefined;
    utilityBillUrl?: string | undefined;
    identificationName?: string | undefined;
    identificationUrl?: string | undefined;
    referralCode?: string | undefined;
    benName?: string | undefined;
    benPhoneNumber?: string | undefined;
}

export class ThirdPartyServicesDto implements IThirdPartyServicesDto {
    cqR_REF?: string | undefined;
    amount?: string | undefined;
    actiono!: string;
    cqR_NARRATIVE?: string | undefined;
    cqR_PAYEE?: string | undefined;
    policy?: string | undefined;
    dataFrom?: string | undefined;
    policyType?: string | undefined;

    constructor(data?: IThirdPartyServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cqR_REF = _data["cqR_REF"];
            this.amount = _data["amount"];
            this.actiono = _data["actiono"];
            this.cqR_NARRATIVE = _data["cqR_NARRATIVE"];
            this.cqR_PAYEE = _data["cqR_PAYEE"];
            this.policy = _data["policy"];
            this.dataFrom = _data["dataFrom"];
            this.policyType = _data["policyType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ThirdPartyServicesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ThirdPartyServicesDto>(data, _mappings, ThirdPartyServicesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cqR_REF"] = this.cqR_REF;
        data["amount"] = this.amount;
        data["actiono"] = this.actiono;
        data["cqR_NARRATIVE"] = this.cqR_NARRATIVE;
        data["cqR_PAYEE"] = this.cqR_PAYEE;
        data["policy"] = this.policy;
        data["dataFrom"] = this.dataFrom;
        data["policyType"] = this.policyType;
        return data;
    }
}

export interface IThirdPartyServicesDto {
    cqR_REF?: string | undefined;
    amount?: string | undefined;
    actiono: string;
    cqR_NARRATIVE?: string | undefined;
    cqR_PAYEE?: string | undefined;
    policy?: string | undefined;
    dataFrom?: string | undefined;
    policyType?: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient?: boolean | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any, _mappings?: any): AuthenticateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AuthenticateModel>(data, _mappings, AuthenticateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient?: boolean | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    userId?: number | undefined;
    userLoginDetails?: MobileUserLoginDetails | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.userLoginDetails = _data["userLoginDetails"] ? MobileUserLoginDetails.fromJS(_data["userLoginDetails"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): AuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AuthenticateResultModel>(data, _mappings, AuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["userLoginDetails"] = this.userLoginDetails ? this.userLoginDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    userId?: number | undefined;
    userLoginDetails?: MobileUserLoginDetails | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name?: string | undefined;
    clientId?: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalLoginProviderInfoModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalLoginProviderInfoModel>(data, _mappings, ExternalLoginProviderInfoModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name?: string | undefined;
    clientId?: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalAuthenticateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalAuthenticateModel>(data, _mappings, ExternalAuthenticateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    waitingForActivation?: boolean | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalAuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalAuthenticateResultModel>(data, _mappings, ExternalAuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken?: string | undefined;
    encryptedAccessToken?: string | undefined;
    expireInSeconds?: number | undefined;
    waitingForActivation?: boolean | undefined;
}

export class TravelTermAssurance implements ITravelTermAssurance {
    sumAssured?: number | undefined;
    policyNo?: string | undefined;
    term?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: ITravelTermAssurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sumAssured = _data["sumAssured"];
            this.policyNo = _data["policyNo"];
            this.term = _data["term"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TravelTermAssurance | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelTermAssurance>(data, _mappings, TravelTermAssurance);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sumAssured"] = this.sumAssured;
        data["policyNo"] = this.policyNo;
        data["term"] = this.term;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ITravelTermAssurance {
    sumAssured?: number | undefined;
    policyNo?: string | undefined;
    term?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    fullName?: string | undefined;
}

export class TravelScheduleForMobile implements ITravelScheduleForMobile {
    travelSchedule?: TravelScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;

    constructor(data?: ITravelScheduleForMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.travelSchedule = _data["travelSchedule"] ? TravelScheduleRequest.fromJS(_data["travelSchedule"], _mappings) : <any>undefined;
            this.initiatePayment = _data["initiatePayment"] ? InitiatePaymentDto.fromJS(_data["initiatePayment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): TravelScheduleForMobile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TravelScheduleForMobile>(data, _mappings, TravelScheduleForMobile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelSchedule"] = this.travelSchedule ? this.travelSchedule.toJSON() : <any>undefined;
        data["initiatePayment"] = this.initiatePayment ? this.initiatePayment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITravelScheduleForMobile {
    travelSchedule?: TravelScheduleRequest | undefined;
    initiatePayment?: InitiatePaymentDto | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName?: string | undefined;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive?: boolean | undefined;
    roles?: string[] | undefined;
    password?: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUserDto>(data, _mappings, CreateUserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateUserDto {
    userName?: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    isActive?: boolean | undefined;
    roles?: string[] | undefined;
    password?: string | undefined;
}

export class UserDto implements IUserDto {
    userName!: string;
    name!: string;
    surname!: string;
    emailAddress!: string;
    isActive?: boolean | undefined;
    fullName?: string | undefined;
    lastLoginTime?: Date | undefined;
    creationTime?: Date | undefined;
    roles?: string[] | undefined;
    roleNames?: any | undefined;
    readonly phoneNumber?: string | undefined;
    id?: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? new Date(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.roleNames = _data["roleNames"];
            (<any>this).phoneNumber = _data["phoneNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserDto>(data, _mappings, UserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["roleNames"] = this.roleNames;
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive?: boolean | undefined;
    fullName?: string | undefined;
    lastLoginTime?: Date | undefined;
    creationTime?: Date | undefined;
    roles?: string[] | undefined;
    roleNames?: any | undefined;
    phoneNumber?: string | undefined;
    id?: number | undefined;
}

export class ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: RoleDto[] | undefined;

    constructor(data?: IListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDto_1OfOfRoleDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: RoleDto[] | undefined;
}

export class ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: UserDto[] | undefined;

    constructor(data?: IListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, ListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: UserDto[] | undefined;
}

export class PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: UserDto[] | undefined;

    constructor(data?: IPagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(data, _mappings, PagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDto_1OfOfUserDtoAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null {
    totalCount?: number | undefined;
    items?: UserDto[] | undefined;
}

export class NewBusinessDto implements INewBusinessDto {
    firstname?: string | undefined;
    surname?: string | undefined;
    telephone?: string | undefined;
    engineno?: string | undefined;
    chassisno?: string | undefined;
    regno?: string | undefined;
    micode?: string | undefined;
    vehciletype?: string | undefined;
    amount?: string | undefined;
    bankcode?: string | undefined;
    module?: string | undefined;

    constructor(data?: INewBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.surname = _data["surname"];
            this.telephone = _data["telephone"];
            this.engineno = _data["engineno"];
            this.chassisno = _data["chassisno"];
            this.regno = _data["regno"];
            this.micode = _data["micode"];
            this.vehciletype = _data["vehciletype"];
            this.amount = _data["amount"];
            this.bankcode = _data["bankcode"];
            this.module = _data["module"];
        }
    }

    static fromJS(data: any, _mappings?: any): NewBusinessDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NewBusinessDto>(data, _mappings, NewBusinessDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["surname"] = this.surname;
        data["telephone"] = this.telephone;
        data["engineno"] = this.engineno;
        data["chassisno"] = this.chassisno;
        data["regno"] = this.regno;
        data["micode"] = this.micode;
        data["vehciletype"] = this.vehciletype;
        data["amount"] = this.amount;
        data["bankcode"] = this.bankcode;
        data["module"] = this.module;
        return data;
    }
}

export interface INewBusinessDto {
    firstname?: string | undefined;
    surname?: string | undefined;
    telephone?: string | undefined;
    engineno?: string | undefined;
    chassisno?: string | undefined;
    regno?: string | undefined;
    micode?: string | undefined;
    vehciletype?: string | undefined;
    amount?: string | undefined;
    bankcode?: string | undefined;
    module?: string | undefined;
}

export class PaymentDto implements IPaymentDto {
    module?: string | undefined;
    transactionref?: string | undefined;
    amount?: string | undefined;
    eclientid?: string | undefined;
    emerchants?: string | undefined;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.module = _data["module"];
            this.transactionref = _data["transactionref"];
            this.amount = _data["amount"];
            this.eclientid = _data["eclientid"];
            this.emerchants = _data["emerchants"];
        }
    }

    static fromJS(data: any, _mappings?: any): PaymentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PaymentDto>(data, _mappings, PaymentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["transactionref"] = this.transactionref;
        data["amount"] = this.amount;
        data["eclientid"] = this.eclientid;
        data["emerchants"] = this.emerchants;
        return data;
    }
}

export interface IPaymentDto {
    module?: string | undefined;
    transactionref?: string | undefined;
    amount?: string | undefined;
    eclientid?: string | undefined;
    emerchants?: string | undefined;
}

export class OminicomWebhook implements IOminicomWebhook {
    miCode?: string | undefined;
    transactionRef?: string | undefined;
    firstName?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number | undefined;
    lastName?: string | undefined;
    paid?: boolean | undefined;
    paymentRef?: string | undefined;
    chasisNumber?: string | undefined;
    vehicleNumber?: string | undefined;
    engineNumber?: string | undefined;

    constructor(data?: IOminicomWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.miCode = _data["miCode"];
            this.transactionRef = _data["transactionRef"];
            this.firstName = _data["firstName"];
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.lastName = _data["lastName"];
            this.paid = _data["paid"];
            this.paymentRef = _data["paymentRef"];
            this.chasisNumber = _data["chasisNumber"];
            this.vehicleNumber = _data["vehicleNumber"];
            this.engineNumber = _data["engineNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): OminicomWebhook | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OminicomWebhook>(data, _mappings, OminicomWebhook);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["miCode"] = this.miCode;
        data["transactionRef"] = this.transactionRef;
        data["firstName"] = this.firstName;
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["lastName"] = this.lastName;
        data["paid"] = this.paid;
        data["paymentRef"] = this.paymentRef;
        data["chasisNumber"] = this.chasisNumber;
        data["vehicleNumber"] = this.vehicleNumber;
        data["engineNumber"] = this.engineNumber;
        return data;
    }
}

export interface IOminicomWebhook {
    miCode?: string | undefined;
    transactionRef?: string | undefined;
    firstName?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number | undefined;
    lastName?: string | undefined;
    paid?: boolean | undefined;
    paymentRef?: string | undefined;
    chasisNumber?: string | undefined;
    vehicleNumber?: string | undefined;
    engineNumber?: string | undefined;
}

export enum PaymentChannel {
    FLUTTERWAVE = "FLUTTERWAVE",
    FLUTTERWAVE_NON_LIFE = "FLUTTERWAVE_NON_LIFE",
    UNIONBANK = "UNIONBANK",
    INTERSWITCH = "INTERSWITCH",
    INTERSWITCH_NON_LIFE = "INTERSWITCH_NON_LIFE",
    NIBSS = "NIBSS",
    AUTOGENIUS = "AUTOGENIUS",
    AIICO = "AIICO",
    TRAVELTOUR = "TRAVELTOUR",
    GRANDEXPRESS = "GRANDEXPRESS",
    SESBYTRAVEL = "SESBYTRAVEL",
    ZENITHTOUR = "ZENITHTOUR",
    OMNICOM = "OMNICOM",
    UNIONBANKDEMO = "UNIONBANKDEMO",
    PAYDIRECT = "PAYDIRECT",
    QUICKTELLER = "QUICKTELLER",
    GTPAY = "GTPAY",
    GTPAY_NON_LIFE = "GTPAY_NON_LIFE",
    WEMABANK = "WEMABANK",
    WEMABANK_NON_LIFE = "WEMABANK_NON_LIFE",
    AGENTWALLET = "AGENTWALLET",
    CONFIRMPAY = "CONFIRMPAY",
    ARIK = "ARIK",
    AERO = "AERO",
    QPAY = "QPAY",
    ALAT = "ALAT",
    POS = "POS",
    BOFF = "BOFF",
    PADDYCOVER = "PADDYCOVER",
    REMITA = "REMITA",
    NETOP = "NETOP",
    TRANSBOXX = "TRANSBOXX",
    PAYARENA = "PAYARENA",
}

export enum SearchBy {
    PolicyNumber = "PolicyNumber",
    PassportNumber = "PassportNumber",
    CertificateNumber = "CertificateNumber",
    ClientName = "ClientName",
    DestinationCountry = "DestinationCountry",
}

export enum SearchBy2 {
    PolicyNumber = "PolicyNumber",
    PassportNumber = "PassportNumber",
    CertificateNumber = "CertificateNumber",
    ClientName = "ClientName",
    DestinationCountry = "DestinationCountry",
}

export enum SearchBy3 {
    PolicyNumber = "PolicyNumber",
    PassportNumber = "PassportNumber",
    CertificateNumber = "CertificateNumber",
    ClientName = "ClientName",
    DestinationCountry = "DestinationCountry",
}

export enum SearchBy4 {
    PolicyNumber = "PolicyNumber",
    PassportNumber = "PassportNumber",
    CertificateNumber = "CertificateNumber",
    ClientName = "ClientName",
    DestinationCountry = "DestinationCountry",
}

export enum PaymentChannel2 {
    FLUTTERWAVE = "FLUTTERWAVE",
    FLUTTERWAVE_NON_LIFE = "FLUTTERWAVE_NON_LIFE",
    UNIONBANK = "UNIONBANK",
    INTERSWITCH = "INTERSWITCH",
    INTERSWITCH_NON_LIFE = "INTERSWITCH_NON_LIFE",
    NIBSS = "NIBSS",
    AUTOGENIUS = "AUTOGENIUS",
    AIICO = "AIICO",
    TRAVELTOUR = "TRAVELTOUR",
    GRANDEXPRESS = "GRANDEXPRESS",
    SESBYTRAVEL = "SESBYTRAVEL",
    ZENITHTOUR = "ZENITHTOUR",
    OMNICOM = "OMNICOM",
    UNIONBANKDEMO = "UNIONBANKDEMO",
    PAYDIRECT = "PAYDIRECT",
    QUICKTELLER = "QUICKTELLER",
    GTPAY = "GTPAY",
    GTPAY_NON_LIFE = "GTPAY_NON_LIFE",
    WEMABANK = "WEMABANK",
    WEMABANK_NON_LIFE = "WEMABANK_NON_LIFE",
    AGENTWALLET = "AGENTWALLET",
    CONFIRMPAY = "CONFIRMPAY",
    ARIK = "ARIK",
    AERO = "AERO",
    QPAY = "QPAY",
    ALAT = "ALAT",
    POS = "POS",
    BOFF = "BOFF",
    PADDYCOVER = "PADDYCOVER",
    REMITA = "REMITA",
    NETOP = "NETOP",
    TRANSBOXX = "TRANSBOXX",
    PAYARENA = "PAYARENA",
}

export enum PolicySearchModelSearchBy {
    PolicyNumber = "PolicyNumber",
    PassportNumber = "PassportNumber",
    CertificateNumber = "CertificateNumber",
    ClientName = "ClientName",
    DestinationCountry = "DestinationCountry",
}

export enum MethodInfoMemberType {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export enum MethodInfoAttributes {
    ReuseSlot = "ReuseSlot",
    PrivateScope = "PrivateScope",
    Private = "Private",
    FamANDAssem = "FamANDAssem",
    Assembly = "Assembly",
    Family = "Family",
    FamORAssem = "FamORAssem",
    Public = "Public",
    MemberAccessMask = "MemberAccessMask",
    UnmanagedExport = "UnmanagedExport",
    Static = "Static",
    Final = "Final",
    Virtual = "Virtual",
    HideBySig = "HideBySig",
    NewSlot = "NewSlot",
    VtableLayoutMask = "VtableLayoutMask",
    CheckAccessOnOverride = "CheckAccessOnOverride",
    Abstract = "Abstract",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    PinvokeImpl = "PinvokeImpl",
    HasSecurity = "HasSecurity",
    RequireSecObject = "RequireSecObject",
    ReservedMask = "ReservedMask",
}

export enum MethodInfoMethodImplementationFlags {
    Managed = "Managed",
    IL = "IL",
    Native = "Native",
    OPTIL = "OPTIL",
    Runtime = "Runtime",
    CodeTypeMask = "CodeTypeMask",
    Unmanaged = "Unmanaged",
    ManagedMask = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export enum MethodInfoCallingConvention {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export enum ParameterInfoAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export enum MemberInfoMemberType {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export enum AssemblySecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export enum ConstructorInfoMemberType {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export enum ConstructorInfoAttributes {
    ReuseSlot = "ReuseSlot",
    PrivateScope = "PrivateScope",
    Private = "Private",
    FamANDAssem = "FamANDAssem",
    Assembly = "Assembly",
    Family = "Family",
    FamORAssem = "FamORAssem",
    Public = "Public",
    MemberAccessMask = "MemberAccessMask",
    UnmanagedExport = "UnmanagedExport",
    Static = "Static",
    Final = "Final",
    Virtual = "Virtual",
    HideBySig = "HideBySig",
    NewSlot = "NewSlot",
    VtableLayoutMask = "VtableLayoutMask",
    CheckAccessOnOverride = "CheckAccessOnOverride",
    Abstract = "Abstract",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    PinvokeImpl = "PinvokeImpl",
    HasSecurity = "HasSecurity",
    RequireSecObject = "RequireSecObject",
    ReservedMask = "ReservedMask",
}

export enum ConstructorInfoMethodImplementationFlags {
    Managed = "Managed",
    IL = "IL",
    Native = "Native",
    OPTIL = "OPTIL",
    Runtime = "Runtime",
    CodeTypeMask = "CodeTypeMask",
    Unmanaged = "Unmanaged",
    ManagedMask = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export enum ConstructorInfoCallingConvention {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;

        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }

        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
